const predatorList = [{
    id: 1,
    label: 'Lion',
    value: 'Lion'
},
{
    id: 2,
    label: 'Leopard',
    value: 'Leopard'
},
{
    id: 3,
    label: 'Wild Dog',
    value: 'Wild Dog'
},
{
    id: 4,

    label: 'Cheetah',
    value: 'Cheetah'
},
{
    id: 5,
    label: 'Spotted Hyena',
    value: 'Spotted Hyena'
},
{
    id: 26,
    label: "Black backed Jackal",
    value: "Black backed Jackal",
},
]

const nonPredatorList = [
    {
        id: 6,

        label: 'Elephant',
        value: 'Elephant'
    },
    {
        id: 7,
        label: 'Buffalo',
        value: 'Buffalo'
    },
    {
        id: 8,
        label: 'Giraffe',
        value: 'Giraffe'
    },
    {
        id: 9,
        label: 'Impala',
        value: 'Impala'
    },
    {
        id: 10,
        label: 'Kudu',
        value: 'Kudu'
    },
    {
        id: 11,
        label: "Burchell's Zebra",
        value: "Burchell's Zebra"
    },
    {
        id: 12,
        label: 'Sable Antelope',
        value: 'Sable Antelope'
    },
    {
        id: 27,
        label: 'Hippopotamus',
        value: 'Hippopotamus'
    },
]

const birdsOfPreyList = [
    {
        id: 11,
        label: 'Vulture',
        value: 'Vulture'
    },
    {
        id: 12,
        label: "Verreaux's Eagle Owl",
        value: "Verreaux's Eagle Owl"
    },
    {
        id: 13,
        label: 'African Fish Eagle',
        value: 'African Fish Eagle'
    },
    {
        id: 14,
        label: 'Tawny Eagle',
        value: 'Tawny Eagle'
    },
    {
        id: 15,
        label: "Brown Snake Eagle",
        value: "Brown Snake Eagle"
    },
    {
        id: 16,
        label: 'Bateleur',
        value: 'Bateleur'
    },
]

const sceneryList = [
    {
        id: 16,
        label: 'Sunrise',
        value: 'Sunrise'
    },
    {
        id: 17,
        label: 'Sunset',
        value: 'Sunset'
    },
    {
        id: 18,
        label: 'Tree',
        value: 'Tree'
    },
    {
        id: 19,
        label: 'Landscape',
        value: 'Landscape'
    },
    {
        id: 20,
        label: "Flower",
        value: 'Flower'
    }
]

const nonBirdsOfPreyList = [
    {
        id: 21,
        label: 'Southern Ground Hornbill',
        value: 'Southern Ground Hornbill'
    },
    {
        id: 22,
        label: 'Lilac Breasted Roller',
        value: 'Lilac Breasted Roller'
    },
    {
        id: 23,
        label: 'Southern Yellow billed Hornbill',
        value: 'Southern Yellow billed Hornbill'
    },
    {
        id: 24,
        label: 'Woodland Kingfisher',
        value: 'Woodland Kingfisher'
    },
    {
        id: 25,
        label: "Saddle billed Stork",
        value: 'Saddle billed Stork'
    }
]

const reptileList = [
    {
        id: 28,
        label: 'Snake',
        value: 'Snake'
    },
    {
        id: 29,
        label: 'Crocodile',
        value: 'Crocodile'
    },
    {
        id: 30,
        label: 'Tortoise',
        value: 'Tortoise'
    },
    {
        id: 31,
        label: 'Chameleon',
        value: 'Chameleon'
    },
    {
        id: 32,
        label: "Rock Monitor",
        value: 'Rock Monitor'
    }
]

const fullAnimalList = [
    {
        id: 1,
        label: "(Eastern) Bearded Scrub Robin",
        value: "(Eastern) Bearded Scrub Robin",
        category: "NonBirdsOfPrey",
        plural: "(Eastern) Bearded Scrub Robins",
        quickAdd: ['Kruger National Park']
    },
    {
        id: 2,
        label: "(European) Marsh Warbler",
        value: "(European) Marsh Warbler",
        category: "NonBirdsOfPrey",
        plural: "(European) Marsh Warblers",
        quickAdd: []
    },
    {
        id: 3,
        label: "Aardvark",
        value: "Aardvark",
        category: "Nonpredator",
        plural: "Aardvarks",
        quickAdd: ['Kruger National Park']
    },
    {
        id: 4,
        label: "Aardwolf",
        value: "Aardwolf",
        category: "Predator",
        plural: "Aardwolves",
        quickAdd: ['Kruger National Park']
    },
    {
        id: 5,
        label: "Abdim's Stork",
        value: "Abdim's Stork",
        category: "NonBirdsOfPrey",
        plural: "Abdim's Storks",
        quickAdd: []
    },
    {
        id: 6,
        label: "Acacia Pied Barbet",
        value: "Acacia Pied Barbet",
        category: "NonBirdsOfPrey",
        plural: "Acacia Pied Barbets",
        quickAdd: []
    },
    {
        id: 7,
        label: "African (Blue billed) Firefinch",
        value: "African (Blue billed) Firefinch",
        category: "NonBirdsOfPrey",
        plural: "African (Blue billed) Firefinches",
        quickAdd: []
    },
    {
        id: 8,
        label: "African (Ethiopian) Snipe",
        value: "African (Ethiopian) Snipe",
        category: "NonBirdsOfPrey",
        plural: "African (Ethiopian) Snipes",
        quickAdd: []
    },
    {
        id: 9,
        label: "African Barred Owl",
        value: "African Barred Owl",
        category: "BirdsOfPrey",
        plural: "African Barred Owls",
        quickAdd: ['Kruger National Park']
    },
    {
        id: 10,
        label: "African Barred Wren warbler",
        value: "African Barred Wren warbler",
        category: "NonBirdsOfPrey",
        plural: "African Barred Wren warblers",
        quickAdd: []
    },
    {
        id: 11,
        label: "African Black Duck",
        value: "African Black Duck",
        category: "NonBirdsOfPrey",
        plural: "African Black Ducks",
        quickAdd: []
    },
    {
        id: 12,
        label: "African Black Swift",
        value: "African Black Swift",
        category: "NonBirdsOfPrey",
        plural: "African Black Swifts",
        quickAdd: []
    },
    {
        id: 13,
        label: "African Bullfrog",
        value: "African Bullfrog",
        category: "Amphibian",
        plural: "African Bullfrogs",
        quickAdd: []
    },
    {
        id: 14,
        label: "African Civet",
        value: "African Civet",
        category: "Predator",
        plural: "African Civets",
        quickAdd: []
    },
    {
        id: 15,
        label: "African Comb Duck",
        value: "African Comb Duck",
        category: "NonBirdsOfPrey",
        plural: "African Comb Ducks",
        quickAdd: []
    },
    {
        id: 16,
        label: "African Crake",
        value: "African Crake",
        category: "NonBirdsOfPrey",
        plural: "African Crakes",
        quickAdd: []
    },
    {
        id: 17,
        label: "African Crowned Eagle",
        value: "African Crowned Eagle",
        category: "BirdsOfPrey",
        plural: "African Crowned Eagles",
        quickAdd: []
    },
    {
        id: 18,
        label: "African Cuckoo",
        value: "African Cuckoo",
        category: "NonBirdsOfPrey",
        plural: "African Cuckoos",
        quickAdd: []
    },
    {
        id: 19,
        label: "African Cuckoo hawk",
        value: "African Cuckoo hawk",
        category: "BirdsOfPrey",
        plural: "African Cuckoo hawks",
        quickAdd: []
    },
    {
        id: 20,
        label: "African Darter",
        value: "African Darter",
        category: "NonBirdsOfPrey",
        plural: "African Darters",
        quickAdd: []
    },
    {
        id: 21,
        label: "African Dusky Flycatcher",
        value: "African Dusky Flycatcher",
        category: "NonBirdsOfPrey",
        plural: "African Dusky Flycatchers",
        quickAdd: []
    },
    {
        id: 22,
        label: "African Finfoot",
        value: "African Finfoot",
        category: "NonBirdsOfPrey",
        plural: "African Finfoots",
        quickAdd: []
    },
    {
        id: 23,
        label: "African Firefinch",
        value: "African Firefinch",
        category: "NonBirdsOfPrey",
        plural: "African Firefinches",
        quickAdd: []
    },
    {
        id: 24,
        label: "African Fish Eagle",
        value: "African Fish Eagle",
        category: "BirdsOfPrey",
        plural: "African Fish Eagles",
        quickAdd: []
    },
    {
        id: 25,
        label: "African Golden Oriole",
        value: "African Golden Oriole",
        category: "NonBirdsOfPrey",
        plural: "African Golden Orioles",
        quickAdd: []
    },
    {
        id: 26,
        label: "African Goshawk",
        value: "African Goshawk",
        category: "BirdsOfPrey",
        plural: "African Goshawks",
        quickAdd: []
    },
    {
        id: 27,
        label: "African Grass Owl",
        value: "African Grass Owl",
        category: "BirdsOfPrey",
        plural: "African Grass Owls",
        quickAdd: []
    },
    {
        id: 28,
        label: "African Green Pigeon",
        value: "African Green Pigeon",
        category: "NonBirdsOfPrey",
        plural: "African Green Pigeons",
        quickAdd: []
    },
    {
        id: 29,
        label: "African Grey Hornbill",
        value: "African Grey Hornbill",
        category: "NonBirdsOfPrey",
        plural: "African Grey Hornbills",
        quickAdd: []
    },
    {
        id: 30,
        label: "African Harrier hawk",
        value: "African Harrier hawk",
        category: "BirdsOfPrey",
        plural: "African Harrier hawks",
        quickAdd: []
    },
    {
        id: 31,
        label: "African Hawk Eagle",
        value: "African Hawk Eagle",
        category: "BirdsOfPrey",
        plural: "African Hawk Eagles",
        quickAdd: []
    },
    {
        id: 32,
        label: "African Hoopoe",
        value: "African Hoopoe",
        category: "NonBirdsOfPrey",
        plural: "African Hoopoes",
        quickAdd: []
    },
    {
        id: 33,
        label: "African Jacana",
        value: "African Jacana",
        category: "NonBirdsOfPrey",
        plural: "African Jacanas",
        quickAdd: []
    },
    {
        id: 34,
        label: "African Marsh Rat",
        value: "African Marsh Rat",
        category: "Nonpredator",
        plural: "African Marsh Rats",
        quickAdd: []
    },
    {
        id: 35,
        label: "African Marsh Harrier",
        value: "African Marsh Harrier",
        category: "BirdsOfPrey",
        plural: "African Marsh Harriers",
        quickAdd: []
    },
    {
        id: 36,
        label: "African Morning Dove",
        value: "African Morning Dove",
        category: "NonBirdsOfPrey",
        plural: "African Morning Doves",
        quickAdd: []
    },
    {
        id: 37,
        label: "African Olive Pigeon",
        value: "African Olive Pigeon",
        category: "NonBirdsOfPrey",
        plural: "African Olive Pigeons",
        quickAdd: []
    },
    {
        id: 38,
        label: "African Openbill",
        value: "African Openbill",
        category: "NonBirdsOfPrey",
        plural: "African Openbills",
        quickAdd: []
    },
    {
        id: 39,
        label: "African Palm swift",
        value: "African Palm swift",
        category: "NonBirdsOfPrey",
        plural: "African Palm swifts",
        quickAdd: []
    },
    {
        id: 40,
        label: "African Paradise Flycatcher",
        value: "African Paradise Flycatcher",
        category: "NonBirdsOfPrey",
        plural: "African Paradise Flycatchers",
        quickAdd: []
    },
    {
        id: 41,
        label: "African Pied Wagtail",
        value: "African Pied Wagtail",
        category: "NonBirdsOfPrey",
        plural: "African Pied Wagtails",
        quickAdd: []
    },
    {
        id: 42,
        label: "African Pipit",
        value: "African Pipit",
        category: "NonBirdsOfPrey",
        plural: "African Pipits",
        quickAdd: []
    },
    {
        id: 43,
        label: "African Pitta",
        value: "African Pitta",
        category: "NonBirdsOfPrey",
        plural: "African Pittas",
        quickAdd: []
    },
    {
        id: 44,
        label: "African Purple Swamphen",
        value: "African Purple Swamphen",
        category: "NonBirdsOfPrey",
        plural: "African Purple Swamphens",
        quickAdd: []
    },
    {
        id: 45,
        label: "African Pygmy Goose",
        value: "African Pygmy Goose",
        category: "NonBirdsOfPrey",
        plural: "African Pygmy Geese",
        quickAdd: []
    },
    {
        id: 46,
        label: "African Rail",
        value: "African Rail",
        category: "NonBirdsOfPrey",
        plural: "African Rails",
        quickAdd: []
    },
    {
        id: 47,
        label: "African Red eyed Bulbul",
        value: "African Red eyed Bulbul",
        category: "NonBirdsOfPrey",
        plural: "African Red eyed Bulbuls",
        quickAdd: []
    },
    {
        id: 48,
        label: "African Rock Python",
        value: "African Rock Python",
        category: "Reptile",
        plural: "African Rock Pythons",
        quickAdd: ['Kruger National Park']
    },
    {
        id: 49,
        label: "African Scops Owl",
        value: "African Scops Owl",
        category: "BirdsOfPrey",
        plural: "African Scops Owls",
        quickAdd: []
    },
    {
        id: 50,
        label: "African Skimmer",
        value: "African Skimmer",
        category: "NonBirdsOfPrey",
        plural: "African Skimmers",
        quickAdd: []
    },
    {
        id: 51,
        label: "African Snipe",
        value: "African Snipe",
        category: "NonBirdsOfPrey",
        plural: "African Snipes",
        quickAdd: []
    },
    {
        id: 52,
        label: "African Spoonbill",
        value: "African Spoonbill",
        category: "NonBirdsOfPrey",
        plural: "African Spoonbills",
        quickAdd: []
    },
    {
        id: 53,
        label: "African Stonechat",
        value: "African Stonechat",
        category: "NonBirdsOfPrey",
        plural: "African Stonechats",
        quickAdd: []
    },
    {
        id: 54,
        label: "African Wattled Lapwing",
        value: "African Wattled Lapwing",
        category: "NonBirdsOfPrey",
        plural: "African Wattled Lapwings",
        quickAdd: []
    },
    {
        id: 55,
        label: "African Wild Cat",
        value: "African Wild Cat",
        category: "Predator",
        plural: "African Wild Cats",
        quickAdd: []
    },
    {
        id: 56,
        label: "African Wood Owl",
        value: "African Wood Owl",
        category: "BirdsOfPrey",
        plural: "African Wood Owls",
        quickAdd: []
    },
    {
        id: 57,
        label: "African Yellow (Yellow bellied house) Bat",
        value: "African Yellow (Yellow bellied house) Bat",
        category: "Nonpredator",
        plural: "African Yellow (Yellow bellied house) Bats",
        quickAdd: []
    },
    {
        id: 58,
        label: "Allen's (Lesser) Gallinule",
        value: "Allen's (Lesser) Gallinule",
        category: "NonBirdsOfPrey",
        plural: "Allen's (Lesser) Gallinules",
        quickAdd: []
    },
    {
        id: 59,
        label: "Alpine Swift",
        value: "Alpine Swift",
        category: "NonBirdsOfPrey",
        plural: "Alpine Swifts",
        quickAdd: []
    },
    {
        id: 60,
        label: "Amethyst (African Black) Sunbird",
        value: "Amethyst (African Black) Sunbird",
        category: "NonBirdsOfPrey",
        plural: "Amethyst (African Black) Sunbirds",
        quickAdd: []
    },
    {
        id: 61,
        label: "Amur Falcon",
        value: "Amur Falcon",
        category: "BirdsOfPrey",
        plural: "Amur Falcons",
        quickAdd: []
    },
    {
        id: 62,
        label: "Angolan Free Tailed Bat",
        value: "Angolan Free Tailed Bat",
        category: "Nonpredator",
        plural: "Angolan Free Tailed Bats",
        quickAdd: []
    },
    {
        id: 63,
        label: "Anteater",
        value: "Anteater",
        category: "Nonpredator",
        plural: "Anteaters",
        quickAdd: []
    },
    {
        id: 64,
        label: "Armadillo",
        value: "Armadillo",
        category: "Nonpredator",
        plural: "Armadillos",
        quickAdd: []
    },
    {
        id: 65,
        label: "Arnot's Chat",
        value: "Arnot's Chat",
        category: "NonBirdsOfPrey",
        plural: "Arnot's Chats",
        quickAdd: []
    },
    {
        id: 66,
        label: "Arrow marked Babbler",
        value: "Arrow marked Babbler",
        category: "NonBirdsOfPrey",
        plural: "Arrow marked Babblers",
        quickAdd: []
    },
    {
        id: 67,
        label: "Ashy Flycatcher",
        value: "Ashy Flycatcher",
        category: "NonBirdsOfPrey",
        plural: "Ashy Flycatchers",
        quickAdd: []
    },
    {
        id: 68,
        label: "Aurora House Snake",
        value: "Aurora House Snake",
        category: "Reptile",
        plural: "Aurora House Snakes",
        quickAdd: []
    },
    {
        id: 69,
        label: "Ayres's Hawk Eagle",
        value: "Ayres's Hawk Eagle",
        category: "BirdsOfPrey",
        plural: "Ayres's Hawk Eagles",
        quickAdd: []
    },
    {
        id: 70,
        label: "Baillon's Crake",
        value: "Baillon's Crake",
        category: "NonBirdsOfPrey",
        plural: "Baillon's Crakes",
        quickAdd: []
    },
    {
        id: 71,
        label: "Baird's Sandpiper",
        value: "Baird's Sandpiper",
        category: "NonBirdsOfPrey",
        plural: "Baird's Sandpipers",
        quickAdd: []
    },
    {
        id: 72,
        label: "Banded Martin",
        value: "Banded Martin",
        category: "NonBirdsOfPrey",
        plural: "Banded Martins",
        quickAdd: []
    },
    {
        id: 73,
        label: "Banded Mongoose",
        value: "Banded Mongoose",
        category: "Nonpredator",
        plural: "Banded Mongooses",
        quickAdd: []
    },
    {
        id: 74,
        label: "Banded Rubber Frog",
        value: "Banded Rubber Frog",
        category: "Amphibian",
        plural: "Banded Rubber Frogs",
        quickAdd: []
    },
    {
        id: 75,
        label: "Barn Owl",
        value: "Barn Owl",
        category: "BirdsOfPrey",
        plural: "Barn Owls",
        quickAdd: []
    },
    {
        id: 76,
        label: "Barn Swallow",
        value: "Barn Swallow",
        category: "NonBirdsOfPrey",
        plural: "Barn Swallows",
        quickAdd: []
    },
    {
        id: 77,
        label: "Bar throated Apalis",
        value: "Bar throated Apalis",
        category: "NonBirdsOfPrey",
        plural: "Bar throated Apalis",
        quickAdd: []
    },
    {
        id: 78,
        label: "Bat Hawk",
        value: "Bat Hawk",
        category: "BirdsOfPrey",
        plural: "Bat Hawks",
        quickAdd: []
    },
    {
        id: 79,
        label: "Bat eared Fox",
        value: "Bat eared Fox",
        category: "Predator",
        plural: "Bat eared Foxes",
        quickAdd: []
    },
    {
        id: 80,
        label: "Bateleur",
        value: "Bateleur",
        category: "BirdsOfPrey",
        plural: "Bateleurs",
        quickAdd: []
    },
    {
        id: 81,
        label: "Bearded Scrub robin",
        value: "Bearded Scrub robin",
        category: "NonBirdsOfPrey",
        plural: "Bearded Scrub robins",
        quickAdd: []
    },
    {
        id: 82,
        label: "Bearded Woodpecker",
        value: "Bearded Woodpecker",
        category: "NonBirdsOfPrey",
        plural: "Bearded Woodpeckers",
        quickAdd: []
    },
    {
        id: 83,
        label: "Beaver",
        value: "Beaver",
        category: "Nonpredator",
        plural: "Beavers",
        quickAdd: []
    },
    {
        id: 84,
        label: "Bennet's Woodpecker",
        value: "Bennet's Woodpecker",
        category: "NonBirdsOfPrey",
        plural: "Bennet's Woodpeckers",
        quickAdd: []
    },
    {
        id: 85,
        label: "Bibron's Blind Snake",
        value: "Bibron's Blind Snake",
        category: "Reptile",
        plural: "Bibron's Blind Snakes",
        quickAdd: []
    },
    {
        id: 86,
        label: "Bibron's Burrowing Asp",
        value: "Bibron's Burrowing Asp",
        category: "Reptile",
        plural: "Bibron's Burrowing Asp",
        quickAdd: []
    },
    {
        id: 87,
        label: "Bird",
        value: "Bird",
        category: "NonBirdsOfPrey",
        plural: "Birds",
        quickAdd: []
    },
    {
        id: 88,
        label: "Black Coucal",
        value: "Black Coucal",
        category: "NonBirdsOfPrey",
        plural: "Black Coucals",
        quickAdd: []
    },
    {
        id: 89,
        label: "Black Crake",
        value: "Black Crake",
        category: "NonBirdsOfPrey",
        plural: "Black Crakes",
        quickAdd: []
    },
    {
        id: 90,
        label: "Black Cuckoo",
        value: "Black Cuckoo",
        category: "NonBirdsOfPrey",
        plural: "Black Cuckoos  ",
        quickAdd: []
    },
    {
        id: 91,
        label: "Black Cuckooshrike",
        value: "Black Cuckooshrike",
        category: "NonBirdsOfPrey",
        plural: "Black Cuckooshrikes",
        quickAdd: []
    },
    {
        id: 92,
        label: "Black File Snake",
        value: "Black File Snake",
        category: "Reptile",
        plural: "Black File Snakes",
        quickAdd: []
    },
    {
        id: 93,
        label: "Black Flycatcher",
        value: "Black Flycatcher",
        category: "NonBirdsOfPrey",
        plural: "Black Flycatchers",
        quickAdd: []
    },
    {
        id: 94,
        label: "Black Footed Cat",
        value: "Black Footed Cat",
        category: "Predator",
        plural: "Black Footed Cats",
        quickAdd: []
    },
    {
        id: 95,
        label: "Black Headed Oriole",
        value: "Black Headed Oriole",
        category: "NonBirdsOfPrey",
        plural: "Black Headed Orioles",
        quickAdd: []
    },
    {
        id: 96,
        label: "Black Heron",
        value: "Black Heron",
        category: "NonBirdsOfPrey",
        plural: "Black Herons",
        quickAdd: []
    },
    {
        id: 97,
        label: "Black Kite",
        value: "Black Kite",
        category: "BirdsOfPrey",
        plural: "Black Kites",
        quickAdd: []
    },
    {
        id: 98,
        label: "Black Mamba",
        value: "Black Mamba",
        category: "Reptile",
        plural: "Black Mambas",
        quickAdd: []
    },
    {
        id: 99,
        label: "Black Panther",
        value: "Black Panther",
        category: "Predator",
        plural: "Black Panthers",
        quickAdd: []
    },
    {
        id: 100,
        label: "Black Shouldered Kite",
        value: "Black Shouldered Kite",
        category: "BirdsOfPrey",
        plural: "Black Shouldered Kites",
        quickAdd: []
    },
    {
        id: 101,
        label: "Black Sparrowhawk",
        value: "Black Sparrowhawk",
        category: "BirdsOfPrey",
        plural: "Black Sparrowhawks",
        quickAdd: []
    },
    {
        id: 102,
        label: "Black Stork",
        value: "Black Stork",
        category: "NonBirdsOfPrey",
        plural: "Black Storks",
        quickAdd: []
    },
    {
        id: 103,
        label: "Black backed Jackal",
        value: "Black backed Jackal",
        category: "Predator",
        plural: "Black backed Jackals",
        quickAdd: []
    },
    {
        id: 104,
        label: "Black backed Puffback",
        value: "Black backed Puffback",
        category: "NonBirdsOfPrey",
        plural: "Black backed Puffbacks",
        quickAdd: []
    },
    {
        id: 105,
        label: "Black bellied Bustard",
        value: "Black bellied Bustard",
        category: "NonBirdsOfPrey",
        plural: "Black bellied Bustards",
        quickAdd: []
    },
    {
        id: 106,
        label: "Black breasted Snake Eagle",
        value: "Black breasted Snake Eagle",
        category: "BirdsOfPrey",
        plural: "Black breasted Snake Eagles",
        quickAdd: []
    },
    {
        id: 107,
        label: "Black cheeked Waxbill",
        value: "Black cheeked Waxbill",
        category: "NonBirdsOfPrey",
        plural: "Black cheeked Waxbills",
        quickAdd: []
    },
    {
        id: 108,
        label: "Black chested Prinia",
        value: "Black chested Prinia",
        category: "NonBirdsOfPrey",
        plural: "Black chested Prinias",
        quickAdd: []
    },
    {
        id: 109,
        label: "Black collared Barbet",
        value: "Black collared Barbet",
        category: "NonBirdsOfPrey",
        plural: "Black collared Barbets",
        quickAdd: []
    },
    {
        id: 110,
        label: "Black crowned night heron",
        value: "Black crowned night heron",
        category: "NonBirdsOfPrey",
        plural: "Black crowned night herons",
        quickAdd: []
    },
    {
        id: 111,
        label: "Black crowned Tchagra",
        value: "Black crowned Tchagra",
        category: "NonBirdsOfPrey",
        plural: "Black crowned Tchagras",
        quickAdd: []
    },
    {
        id: 112,
        label: "Black headed Heron",
        value: "Black headed Heron",
        category: "NonBirdsOfPrey",
        plural: "Black headed Herons",
        quickAdd: []
    },
    {
        id: 113,
        label: "Blacksmith Lapwing",
        value: "Blacksmith Lapwing",
        category: "NonBirdsOfPrey",
        plural: "Blacksmith Lapwings",
        quickAdd: []
    },
    {
        id: 114,
        label: "Black throated Canary",
        value: "Black throated Canary",
        category: "NonBirdsOfPrey",
        plural: "Black throated Canaries",
        quickAdd: []
    },
    {
        id: 115,
        label: "Black winged Stilt",
        value: "Black winged Stilt",
        category: "NonBirdsOfPrey",
        plural: "Black winged Stilts",
        quickAdd: []
    },
    {
        id: 116,
        label: "Blesbok",
        value: "Blesbok",
        category: "Nonpredator",
        plural: "Blesboks",
        quickAdd: []
    },
    {
        id: 117,
        label: "Blue Crane",
        value: "Blue Crane",
        category: "NonBirdsOfPrey",
        plural: "Blue Cranes",
        quickAdd: []
    },
    {
        id: 118,
        label: "Blue Waxbill",
        value: "Blue Waxbill",
        category: "NonBirdsOfPrey",
        plural: "Blue Waxbills",
        quickAdd: []
    },
    {
        id: 119,
        label: "Blue Whale",
        value: "Blue Whale",
        category: "Nonpredator",
        plural: "Blue Whales",
        quickAdd: []
    },
    {
        id: 120,
        label: "Blue Wildebeest",
        value: "Blue Wildebeest",
        category: "Nonpredator",
        plural: "Blue Wildebeests",
        quickAdd: []
    },
    {
        id: 121,
        label: "Blue cheeked Bee eater",
        value: "Blue cheeked Bee eater",
        category: "NonBirdsOfPrey",
        plural: "Blue cheeked Bee eaters",
        quickAdd: []
    },
    {
        id: 122,
        label: "Blue mantled Flycatcher",
        value: "Blue mantled Flycatcher",
        category: "NonBirdsOfPrey",
        plural: "Blue mantled Flycatchers",
        quickAdd: []
    },
    {
        id: 123,
        label: "Bohm's Spinetail",
        value: "Bohm's Spinetail",
        category: "NonBirdsOfPrey",
        plural: "Bohm's Spinetails",
        quickAdd: []
    },
    {
        id: 124,
        label: "Boomslang",
        value: "Boomslang",
        category: "Reptile",
        plural: "Boomslangs",
        quickAdd: []
    },
    {
        id: 125,
        label: "Booted Eagle",
        value: "Booted Eagle",
        category: "BirdsOfPrey",
        plural: "Booted Eagles",
        quickAdd: []
    },
    {
        id: 126,
        label: "Boulenger's Garter Snake",
        value: "Boulenger's Garter Snake",
        category: "Reptile",
        plural: "Boulenger's Garter Snakes",
        quickAdd: []
    },
    {
        id: 127,
        label: "Brimstone Canary",
        value: "Brimstone Canary",
        category: "NonBirdsOfPrey",
        plural: "Brimstone Canaries",
        quickAdd: []
    },
    {
        id: 128,
        label: "Broad banded Grass Frog",
        value: "Broad banded Grass Frog",
        category: "Amphibian",
        plural: "Broad banded Grass Frogs",
        quickAdd: []
    },
    {
        id: 129,
        label: "Broad billed Roller",
        value: "Broad billed Roller",
        category: "NonBirdsOfPrey",
        plural: "Broad billed Rollers",
        quickAdd: []
    },
    {
        id: 130,
        label: "Bronze Mannikin",
        value: "Bronze Mannikin",
        category: "NonBirdsOfPrey",
        plural: "Bronze Mannikins",
        quickAdd: []
    },
    {
        id: 131,
        label: "Bronze winged Courser",
        value: "Bronze winged Courser",
        category: "NonBirdsOfPrey",
        plural: "Bronze winged Coursers",
        quickAdd: []
    },
    {
        id: 132,
        label: "Brown Headed Parrot",
        value: "Brown Headed Parrot",
        category: "NonBirdsOfPrey",
        plural: "Brown Headed Parrots",
        quickAdd: []
    },
    {
        id: 133,
        label: "Brown House Snake",
        value: "Brown House Snake",
        category: "Reptile",
        plural: "Brown House Snakes",
        quickAdd: []
    },
    {
        id: 134,
        label: "Brown Hyena",
        value: "Brown Hyena",
        category: "Predator",
        plural: "Brown Hyenas",
        quickAdd: []
    },
    {
        id: 135,
        label: "Brown Snake Eagle",
        value: "Brown Snake Eagle",
        category: "BirdsOfPrey",
        plural: "Brown Snake Eagles",
        quickAdd: []
    },
    {
        id: 136,
        label: "Brown backed Honeybird (Sharp billed Honeyguide)",
        value: "Brown backed Honeybird (Sharp billed Honeyguide)",
        category: "NonBirdsOfPrey",
        plural: "Brown backed Honeybirds (Sharp billed Honeyguides)",
        quickAdd: []
    },
    {
        id: 137,
        label: "Brown backed Tree Frog",
        value: "Brown backed Tree Frog",
        category: "Amphibian",
        plural: "Brown backed Tree Frogs",
        quickAdd: []
    },
    {
        id: 138,
        label: "Brown hooded Kingfisher",
        value: "Brown hooded Kingfisher",
        category: "NonBirdsOfPrey",
        plural: "Brown hooded Kingfishers",
        quickAdd: []
    },
    {
        id: 139,
        label: "Brubru",
        value: "Brubru",
        category: "NonBirdsOfPrey",
        plural: "Brubrus",
        quickAdd: []
    },
    {
        id: 140,
        label: "Bubbling Kassina",
        value: "Bubbling Kassina",
        category: "Amphibian",
        plural: "Bubbling Kassinas",
        quickAdd: []
    },
    {
        id: 141,
        label: "Buffalo",
        value: "Buffalo",
        category: "Nonpredator",
        plural: "Buffaloes",
        quickAdd: []
    },
    {
        id: 142,
        label: "Buff spotted Flufftail",
        value: "Buff spotted Flufftail",
        category: "NonBirdsOfPrey",
        plural: "Buff spotted Flufftails",
        quickAdd: []
    },
    {
        id: 143,
        label: "Buffy Pipit",
        value: "Buffy Pipit",
        category: "NonBirdsOfPrey",
        plural: "Buffy Pipits",
        quickAdd: []
    },
    {
        id: 144,
        label: "Burchell's Coucal",
        value: "Burchell's Coucal",
        category: "NonBirdsOfPrey",
        plural: "Burchell's Coucals",
        quickAdd: []
    },
    {
        id: 145,
        label: "Burchell's Sandgrouse",
        value: "Burchell's Sandgrouse",
        category: "NonBirdsOfPrey",
        plural: "Burchell's Sandgrouses",
        quickAdd: []
    },
    {
        id: 146,
        label: "Burchell's Starling",
        value: "Burchell's Starling",
        category: "NonBirdsOfPrey",
        plural: "Burchell's Starlings",
        quickAdd: []
    },
    {
        id: 147,
        label: "Burchell's Zebra",
        value: "Burchell's Zebra",
        category: "Nonpredator",
        plural: "Burchell's Zebras",
        quickAdd: []
    },
    {
        id: 148,
        label: "Burnt necked Eremomela",
        value: "Burnt necked Eremomela",
        category: "NonBirdsOfPrey",
        plural: "Burnt necked Eremomelas",
        quickAdd: []
    },
    {
        id: 149,
        label: "Bushbuck",
        value: "Bushbuck",
        category: "Nonpredator",
        plural: "Bushbucks",
        quickAdd: []
    },
    {
        id: 150,
        label: "Bushpig",
        value: "Bushpig",
        category: "Nonpredator",
        plural: "Bushpigs",
        quickAdd: []
    },
    {
        id: 151,
        label: "Bushveld Gerbil",
        value: "Bushveld Gerbil",
        category: "Nonpredator",
        plural: "Bushveld Gerbils",
        quickAdd: []
    },
    {
        id: 152,
        label: "Bushveld Pipit",
        value: "Bushveld Pipit",
        category: "NonBirdsOfPrey",
        plural: "Bushveld Pipits",
        quickAdd: []
    },
    {
        id: 153,
        label: "Bushveld Rain Frog",
        value: "Bushveld Rain Frog",
        category: "Amphibian",
        plural: "Bushveld Rain Frogs",
        quickAdd: []
    },
    {
        id: 154,
        label: "Cane Rat",
        value: "Cane Rat",
        category: "Nonpredator",
        plural: "Cane Rats",
        quickAdd: []
    },
    {
        id: 155,
        label: "Cape (Black) Crow",
        value: "Cape (Black) Crow",
        category: "NonBirdsOfPrey",
        plural: "Cape (Black) Crows",
        quickAdd: []
    },
    {
        id: 156,
        label: "Cape Batis",
        value: "Cape Batis",
        category: "NonBirdsOfPrey",
        plural: "Cape Batis",
        quickAdd: []
    },
    {
        id: 157,
        label: "Cape Bunting",
        value: "Cape Bunting",
        category: "NonBirdsOfPrey",
        plural: "Cape Buntings",
        quickAdd: []
    },
    {
        id: 158,
        label: "Cape Canary",
        value: "Cape Canary",
        category: "NonBirdsOfPrey",
        plural: "Cape Canaries",
        quickAdd: []
    },
    {
        id: 159,
        label: "Cape Centipede eater",
        value: "Cape Centipede eater",
        category: "Reptile",
        plural: "Cape Centipede eaters",
        quickAdd: []
    },
    {
        id: 160,
        label: "Cape Clawless Otter",
        value: "Cape Clawless Otter",
        category: "Predator",
        plural: "Cape Clawless Otters",
        quickAdd: []
    },
    {
        id: 161,
        label: "Cape Dwarf Gecko",
        value: "Cape Dwarf Gecko",
        category: "Reptile",
        plural: "Cape Dwarf Geckos",
        quickAdd: []
    },
    {
        id: 162,
        label: "Cape Eagle Owl",
        value: "Cape Eagle Owl",
        category: "BirdsOfPrey",
        plural: "Cape Eagle Owls",
        quickAdd: []
    },
    {
        id: 163,
        label: "Cape File Snake",
        value: "Cape File Snake",
        category: "Reptile",
        plural: "Cape File Snakes",
        quickAdd: []
    },
    {
        id: 164,
        label: "Cape Glossy Starling",
        value: "Cape Glossy Starling",
        category: "NonBirdsOfPrey",
        plural: "Cape Glossy Starlings",
        quickAdd: []
    },
    {
        id: 165,
        label: "Cape Grassbird",
        value: "Cape Grassbird",
        category: "NonBirdsOfPrey",
        plural: "Cape Grassbirds",
        quickAdd: []
    },
    {
        id: 166,
        label: "Cape Hare",
        value: "Cape Hare",
        category: "Nonpredator",
        plural: "Cape Hares",
        quickAdd: []
    },
    {
        id: 167,
        label: "Cape Longclaw",
        value: "Cape Longclaw",
        category: "NonBirdsOfPrey",
        plural: "Cape Longclaws",
        quickAdd: []
    },
    {
        id: 168,
        label: "Cape Penduline tit",
        value: "Cape Penduline tit",
        category: "NonBirdsOfPrey",
        plural: "Cape Penduline tits",
        quickAdd: []
    },
    {
        id: 169,
        label: "Cape Robin chat",
        value: "Cape Robin chat",
        category: "NonBirdsOfPrey",
        plural: "Cape Robin chats",
        quickAdd: []
    },
    {
        id: 170,
        label: "Cape Rock Thrush",
        value: "Cape Rock Thrush",
        category: "NonBirdsOfPrey",
        plural: "Cape Rock Thrushes",
        quickAdd: []
    },
    {
        id: 171,
        label: "Cape Shoveller",
        value: "Cape Shoveller",
        category: "NonBirdsOfPrey",
        plural: "Cape Shovellers",
        quickAdd: []
    },
    {
        id: 172,
        label: "Cape Skink",
        value: "Cape Skink",
        category: "Reptile",
        plural: "Cape Skinks",
        quickAdd: []
    },
    {
        id: 173,
        label: "Cape Sparrow",
        value: "Cape Sparrow",
        category: "NonBirdsOfPrey",
        plural: "Cape Sparrows",
        quickAdd: []
    },
    {
        id: 174,
        label: "Cape Teal",
        value: "Cape Teal",
        category: "NonBirdsOfPrey",
        plural: "Cape Teals",
        quickAdd: []
    },
    {
        id: 175,
        label: "Cape Turtle dove",
        value: "Cape Turtle dove",
        category: "NonBirdsOfPrey",
        plural: "Cape Turtle doves",
        quickAdd: []
    },
    {
        id: 176,
        label: "Cape Vulture",
        value: "Cape Vulture",
        category: "BirdsOfPrey",
        plural: "Cape Vultures",
        quickAdd: []
    },
    {
        id: 177,
        label: "Cape Wagtail",
        value: "Cape Wagtail",
        category: "NonBirdsOfPrey",
        plural: "Cape Wagtails",
        quickAdd: []
    },
    {
        id: 178,
        label: "Cape Weaver",
        value: "Cape Weaver",
        category: "NonBirdsOfPrey",
        plural: "Cape Weavers",
        quickAdd: []
    },
    {
        id: 179,
        label: "Cape White eye",
        value: "Cape White eye",
        category: "NonBirdsOfPrey",
        plural: "Cape White eyes",
        quickAdd: []
    },
    {
        id: 180,
        label: "Cape Wolf Snake",
        value: "Cape Wolf Snake",
        category: "Reptile",
        plural: "Cape Wolf Snakes",
        quickAdd: []
    },
    {
        id: 181,
        label: "Capped Wheatear",
        value: "Capped Wheatear",
        category: "NonBirdsOfPrey",
        plural: "Capped Wheatears",
        quickAdd: []
    },
    {
        id: 182,
        label: "Caracal",
        value: "Caracal",
        category: "Predator",
        plural: "Caracals",
        quickAdd: []
    },
    {
        id: 183,
        label: "Cardinal Woodpecker",
        value: "Cardinal Woodpecker",
        category: "NonBirdsOfPrey",
        plural: "Cardinal Woodpeckers",
        quickAdd: []
    },
    {
        id: 184,
        label: "Cattle Egret",
        value: "Cattle Egret",
        category: "NonBirdsOfPrey",
        plural: "Cattle Egrets",
        quickAdd: []
    },
    {
        id: 185,
        label: "Chacma Baboon",
        value: "Chacma Baboon",
        category: "Nonpredator",
        plural: "Chacma Baboons",
        quickAdd: []
    },
    {
        id: 186,
        label: "Cheetah",
        value: "Cheetah",
        category: "Predator",
        plural: "Cheetahs",
        quickAdd: []
    },
    {
        id: 187,
        label: "Chestnut backed Sparrowhawk",
        value: "Chestnut backed Sparrowhawk",
        category: "BirdsOfPrey",
        plural: "Chestnut backed Sparrowhawks",
        quickAdd: []
    },
    {
        id: 188,
        label: "Chestnut banded Plover",
        value: "Chestnut banded Plover",
        category: "NonBirdsOfPrey",
        plural: "Chestnut banded Plovers",
        quickAdd: []
    },
    {
        id: 189,
        label: "Chestnut vented Tit babbler",
        value: "Chestnut vented Tit babbler",
        category: "NonBirdsOfPrey",
        plural: "Chestnut vented Tit babblers",
        quickAdd: []
    },
    {
        id: 190,
        label: "Chinspot Batis",
        value: "Chinspot Batis",
        category: "NonBirdsOfPrey",
        plural: "Chinspot Batis",
        quickAdd: []
    },
    {
        id: 191,
        label: "Cinnamon breasted Bunting",
        value: "Cinnamon breasted Bunting",
        category: "NonBirdsOfPrey",
        plural: "Cinnamon breasted Buntings",
        quickAdd: []
    },
    {
        id: 192,
        label: "Cloud",
        value: "Cloud",
        category: "Scenery",
        plural: "Clouds",
        quickAdd: ['Kruger National Park']
    },
    {
        id: 193,
        label: "Collared (Red winged) Pratincola",
        value: "Collared (Red winged) Pratincola",
        category: "NonBirdsOfPrey",
        plural: "Collared (Red winged) Pratincolas",
        quickAdd: []
    },
    {
        id: 194,
        label: "Collared Palm thrush",
        value: "Collared Palm thrush",
        category: "NonBirdsOfPrey",
        plural: "Collared Palm thrushes",
        quickAdd: []
    },
    {
        id: 195,
        label: "Collared Pratincole",
        value: "Collared Pratincole",
        category: "NonBirdsOfPrey",
        plural: "Collared Pratincole",
        quickAdd: []
    },
    {
        id: 196,
        label: "Collared Sunbird",
        value: "Collared Sunbird",
        category: "NonBirdsOfPrey",
        plural: "Collared Sunbirds",
        quickAdd: []
    },
    {
        id: 197,
        label: "Common (European) Cuckoo",
        value: "Common (European) Cuckoo",
        category: "NonBirdsOfPrey",
        plural: "Common (European) Cuckoos",
        quickAdd: []
    },
    {
        id: 198,
        label: "Common (Greater) Scimitarbill",
        value: "Common (Greater) Scimitarbill",
        category: "NonBirdsOfPrey",
        plural: "Common (Greater) Scimitarbills",
        quickAdd: []
    },
    {
        id: 199,
        label: "Common Brown Water Snake",
        value: "Common Brown Water Snake",
        category: "Reptile",
        plural: "Common Brown Water Snakes",
        quickAdd: []
    },
    {
        id: 200,
        label: "Common Buzzard",
        value: "Common Buzzard",
        category: "BirdsOfPrey",
        plural: "Common Buzzards",
        quickAdd: ['Kruger National Park']
    },
    {
        id: 201,
        label: "Common Caco",
        value: "Common Caco",
        category: "Amphibian",
        plural: "Common Cacos",
        quickAdd: []
    },
    {
        id: 202,
        label: "Common Duiker",
        value: "Common Duiker",
        category: "Nonpredator",
        plural: "Common Duikers",
        quickAdd: []
    },
    {
        id: 203,
        label: "Common Egg eater",
        value: "Common Egg eater",
        category: "Reptile",
        plural: "Common Egg eaters",
        quickAdd: []
    },
    {
        id: 204,
        label: "Common Fiscal (Fiscal Shrike)",
        value: "Common Fiscal (Fiscal Shrike)",
        category: "NonBirdsOfPrey",
        plural: "Common Fiscals (Fiscal Shrikes)",
        quickAdd: []
    },
    {
        id: 205,
        label: "Common Flat Lizard",
        value: "Common Flat Lizard",
        category: "Reptile",
        plural: "Common Flat Lizards",
        quickAdd: []
    },
    {
        id: 206,
        label: "Common Greenshank",
        value: "Common Greenshank",
        category: "NonBirdsOfPrey",
        plural: "Common Greenshanks",
        quickAdd: []
    },
    {
        id: 207,
        label: "Common House Martin",
        value: "Common House Martin",
        category: "NonBirdsOfPrey",
        plural: "Common House Martins",
        quickAdd: []
    },
    {
        id: 208,
        label: "Common Moorhen",
        value: "Common Moorhen",
        category: "NonBirdsOfPrey",
        plural: "Common Moorhens",
        quickAdd: []
    },
    {
        id: 209,
        label: "Common Myna",
        value: "Common Myna",
        category: "NonBirdsOfPrey",
        plural: "Common Mynas",
        quickAdd: []
    },
    {
        id: 210,
        label: "Common Night Adder",
        value: "Common Night Adder",
        category: "Reptile",
        plural: "Common Night Adders",
        quickAdd: []
    },
    {
        id: 211,
        label: "Ostrich",
        value: "Ostrich",
        category: "NonBirdsOfPrey",
        plural: "Ostriches",
        quickAdd: []
    },
    {
        id: 212,
        label: "Common Platanna",
        value: "Common Platanna",
        category: "Amphibian",
        plural: "Common Platannas",
        quickAdd: []
    },
    {
        id: 213,
        label: "Common Purple glossed Snake",
        value: "Common Purple glossed Snake",
        category: "Reptile",
        plural: "Common Purple glossed Snakes",
        quickAdd: []
    },
    {
        id: 214,
        label: "Common Quail",
        value: "Common Quail",
        category: "NonBirdsOfPrey",
        plural: "Common Quails",
        quickAdd: []
    },
    {
        id: 215,
        label: "Common Reedbuck",
        value: "Common Reedbuck",
        category: "Nonpredator",
        plural: "Common Reedbucks",
        quickAdd: []
    },
    {
        id: 216,
        label: "Common Ringed Plover",
        value: "Common Ringed Plover",
        category: "NonBirdsOfPrey",
        plural: "Common Ringed Plovers",
        quickAdd: []
    },
    {
        id: 217,
        label: "Common River Frog",
        value: "Common River Frog",
        category: "Amphibian",
        plural: "Common River Frogs",
        quickAdd: []
    },
    {
        id: 218,
        label: "Common Sandpiper",
        value: "Common Sandpiper",
        category: "NonBirdsOfPrey",
        plural: "Common Sandpipers",
        quickAdd: []
    },
    {
        id: 219,
        label: "Common Swift",
        value: "Common Swift",
        category: "NonBirdsOfPrey",
        plural: "Common Swifts",
        quickAdd: []
    },
    {
        id: 220,
        label: "Common Tropical House Gecko",
        value: "Common Tropical House Gecko",
        category: "Reptile",
        plural: "Common Tropical House Geckos",
        quickAdd: []
    },
    {
        id: 221,
        label: "Common Waxbill",
        value: "Common Waxbill",
        category: "NonBirdsOfPrey",
        plural: "Common Waxbills",
        quickAdd: []
    },
    {
        id: 222,
        label: "Common Whitethroat",
        value: "Common Whitethroat",
        category: "NonBirdsOfPrey",
        plural: "Common Whitethroats",
        quickAdd: []
    },
    {
        id: 223,
        label: "Conqui Francolin",
        value: "Conqui Francolin",
        category: "NonBirdsOfPrey",
        plural: "Conqui Francolins",
        quickAdd: []
    },
    {
        id: 224,
        label: "Corncrake",
        value: "Corncrake",
        category: "NonBirdsOfPrey",
        plural: "Corncrakes",
        quickAdd: []
    },
    {
        id: 225,
        label: "Crab",
        value: "Crab",
        category: "Nonpredator",
        plural: "Crabs",
        quickAdd: []
    },
    {
        id: 226,
        label: "Crested Barbet",
        value: "Crested Barbet",
        category: "NonBirdsOfPrey",
        plural: "Crested Barbets",
        quickAdd: []
    },
    {
        id: 227,
        label: "Crested Francolin",
        value: "Crested Francolin",
        category: "NonBirdsOfPrey",
        plural: "Crested Francolins",
        quickAdd: []
    },
    {
        id: 228,
        label: "Crested Guineafowl",
        value: "Crested Guineafowl",
        category: "NonBirdsOfPrey",
        plural: "Crested Guineafowls",
        quickAdd: []
    },
    {
        id: 229,
        label: "Crimson breasted Shrike",
        value: "Crimson breasted Shrike",
        category: "NonBirdsOfPrey",
        plural: "Crimson breasted Shrikes",
        quickAdd: []
    },
    {
        id: 230,
        label: "Croaking Cisticola",
        value: "Croaking Cisticola",
        category: "NonBirdsOfPrey",
        plural: "Croaking Cisticolas",
        quickAdd: []
    },
    {
        id: 231,
        label: "Crocodile",
        value: "Crocodile",
        category: "Reptile",
        plural: "Crocodiles",
        quickAdd: []
    },
    {
        id: 232,
        label: "Crowned Hornbill",
        value: "Crowned Hornbill",
        category: "NonBirdsOfPrey",
        plural: "Crowned Hornbills",
        quickAdd: []
    },
    {
        id: 233,
        label: "Crowned Lapwing",
        value: "Crowned Lapwing",
        category: "NonBirdsOfPrey",
        plural: "Crowned Lapwings",
        quickAdd: []
    },
    {
        id: 234,
        label: "Cuckoo Finch",
        value: "Cuckoo Finch",
        category: "NonBirdsOfPrey",
        plural: "Cuckoo Finches",
        quickAdd: []
    },
    {
        id: 235,
        label: "Curlew Sandpiper",
        value: "Curlew Sandpiper",
        category: "NonBirdsOfPrey",
        plural: "Curlew Sandpipers",
        quickAdd: []
    },
    {
        id: 236,
        label: "Cut throat Finch",
        value: "Cut throat Finch",
        category: "NonBirdsOfPrey",
        plural: "Cut throat Finches",
        quickAdd: []
    },
    {
        id: 237,
        label: "Damara Tern",
        value: "Damara Tern",
        category: "NonBirdsOfPrey",
        plural: "Damara Terns",
        quickAdd: []
    },
    {
        id: 238,
        label: "Dark Chanting Goshawk",
        value: "Dark Chanting Goshawk",
        category: "BirdsOfPrey",
        plural: "Dark Chanting Goshawks",
        quickAdd: ['Kruger National Park']
    },
    {
        id: 239,
        label: "Dark capped Bulbul",
        value: "Dark capped Bulbul",
        category: "NonBirdsOfPrey",
        plural: "Dark capped Bulbuls",
        quickAdd: []
    },
    {
        id: 240,
        label: "Dark capped Yellow Warbler",
        value: "Dark capped Yellow Warbler",
        category: "NonBirdsOfPrey",
        plural: "Dark capped Yellow Warblers",
        quickAdd: []
    },
    {
        id: 241,
        label: "Delalande's Beaked Blind Snake",
        value: "Delalande's Beaked Blind Snake",
        category: "Reptile",
        plural: "Delalande's Beaked Blind Snakes",
        quickAdd: []
    },
    {
        id: 242,
        label: "Denham's Bustard",
        value: "Denham's Bustard",
        category: "NonBirdsOfPrey",
        plural: "Denham's Bustards",
        quickAdd: []
    },
    {
        id: 243,
        label: "Desert Cisticola",
        value: "Desert Cisticola",
        category: "NonBirdsOfPrey",
        plural: "Desert Cisticolas",
        quickAdd: []
    },
    {
        id: 244,
        label: "Dickinson's Kestrel",
        value: "Dickinson's Kestrel",
        category: "BirdsOfPrey",
        plural: "Dickinson's Kestrels",
        quickAdd: []
    },
    {
        id: 245,
        label: "Diderik Cuckoo",
        value: "Diderik Cuckoo",
        category: "NonBirdsOfPrey",
        plural: "Diderik Cuckoos",
        quickAdd: []
    },
    {
        id: 246,
        label: "Distant's Ground Agama",
        value: "Distant's Ground Agama",
        category: "Reptile",
        plural: "Distant's Ground Agamas",
        quickAdd: []
    },
    {
        id: 247,
        label: "Dolphin",
        value: "Dolphin",
        category: "Predator",
        plural: "Dolphins",
        quickAdd: []
    },
    {
        id: 248,
        label: "Double banded Sandgrouse",
        value: "Double banded Sandgrouse",
        category: "NonBirdsOfPrey",
        plural: "Double banded Sandgrouses",
        quickAdd: []
    },
    {
        id: 249,
        label: "Dusky Indigobird (Black Widowfinch)",
        value: "Dusky Indigobird (Black Widowfinch)",
        category: "NonBirdsOfPrey",
        plural: "Dusky Indigobirds (Black Widowfinches)",
        quickAdd: []
    },
    {
        id: 250,
        label: "Dusky Lark",
        value: "Dusky Lark",
        category: "NonBirdsOfPrey",
        plural: "Dusky Larks",
        quickAdd: []
    },
    {
        id: 251,
        label: "Dwarf Bittern",
        value: "Dwarf Bittern",
        category: "NonBirdsOfPrey",
        plural: "Dwarf Bitterns",
        quickAdd: []
    },
    {
        id: 252,
        label: "Dwarf Mongoose",
        value: "Dwarf Mongoose",
        category: "Nonpredator",
        plural: "Dwarf Mongooses",
        quickAdd: []
    },
    {
        id: 253,
        label: "Eastern (Yellow spotted) Nicator",
        value: "Eastern (Yellow spotted) Nicator",
        category: "NonBirdsOfPrey",
        plural: "Eastern (Yellow spotted) Nicators",
        quickAdd: []
    },
    {
        id: 254,
        label: "Eastern Bark Snake",
        value: "Eastern Bark Snake",
        category: "Reptile",
        plural: "Eastern Bark Snakes",
        quickAdd: []
    },
    {
        id: 255,
        label: "Eastern Olive Toad",
        value: "Eastern Olive Toad",
        category: "Amphibian",
        plural: "Eastern Olive Toads",
        quickAdd: []
    },
    {
        id: 256,
        label: "Eastern Tiger Snake",
        value: "Eastern Tiger Snake",
        category: "Reptile",
        plural: "Eastern Tiger Snakes",
        quickAdd: []
    },
    {
        id: 257,
        label: "Egyptian Goose",
        value: "Egyptian Goose",
        category: "NonBirdsOfPrey",
        plural: "Egyptian Geese",
        quickAdd: []
    },
    {
        id: 258,
        label: "Egyptian Vulture",
        value: "Egyptian Vulture",
        category: "BirdsOfPrey",
        plural: "Egyptian Vultures",
        quickAdd: []
    },
    {
        id: 259,
        label: "Eland",
        value: "Eland",
        category: "Nonpredator",
        plural: "Elands",
        quickAdd: []
    },
    {
        id: 260,
        label: "Elephant",
        value: "Elephant",
        category: "Nonpredator",
        plural: "Elephants",
        quickAdd: []
    },
    {
        id: 261,
        label: "Elephant Shrew",
        value: "Elephant Shrew",
        category: "Nonpredator",
        plural: "Elephant Shrews",
        quickAdd: []
    },
    {
        id: 262,
        label: "Emerald spotted (Green spotted) Wood Dove",
        value: "Emerald spotted (Green spotted) Wood Dove",
        category: "NonBirdsOfPrey",
        plural: "Emerald spotted (Green spotted) Wood Doves",
        quickAdd: []
    },
    {
        id: 263,
        label: "Eurasian Hobby",
        value: "Eurasian Hobby",
        category: "NonBirdsOfPrey",
        plural: "Eurasian Hobbies",
        quickAdd: []
    },
    {
        id: 264,
        label: "Eurasian Marsh Harrier",
        value: "Eurasian Marsh Harrier",
        category: "BirdsOfPrey",
        plural: "Eurasian Marsh Harriers",
        quickAdd: []
    },
    {
        id: 265,
        label: "European Bee eater",
        value: "European Bee eater",
        category: "NonBirdsOfPrey",
        plural: "European Bee eaters",
        quickAdd: []
    },
    {
        id: 266,
        label: "European Honey Buzzard",
        value: "European Honey Buzzard",
        category: "BirdsOfPrey",
        plural: "European Honey Buzzards",
        quickAdd: []
    },
    {
        id: 267,
        label: "European Nightjar",
        value: "European Nightjar",
        category: "NonBirdsOfPrey",
        plural: "European Nightjars",
        quickAdd: []
    },
    {
        id: 268,
        label: "European Roller",
        value: "European Roller",
        category: "NonBirdsOfPrey",
        plural: "European Rollers",
        quickAdd: []
    },
    {
        id: 269,
        label: "European Whinchat",
        value: "European Whinchat",
        category: "NonBirdsOfPrey",
        plural: "European Whinchats",
        quickAdd: []
    },
    {
        id: 270,
        label: "Fairy Flycatcher",
        value: "Fairy Flycatcher",
        category: "NonBirdsOfPrey",
        plural: "Fairy Flycatchers",
        quickAdd: []
    },
    {
        id: 271,
        label: "Familiar Chat",
        value: "Familiar Chat",
        category: "NonBirdsOfPrey",
        plural: "Familiar Chats",
        quickAdd: []
    },
    {
        id: 272,
        label: "Fawn coloured Lark",
        value: "Fawn coloured Lark",
        category: "NonBirdsOfPrey",
        plural: "Fawn coloured Larks",
        quickAdd: []
    },
    {
        id: 273,
        label: "Fiery necked Nightjar",
        value: "Fiery necked Nightjar",
        category: "NonBirdsOfPrey",
        plural: "Fiery necked Nightjars",
        quickAdd: []
    },
    {
        id: 274,
        label: "Fiscal Flycatcher",
        value: "Fiscal Flycatcher",
        category: "NonBirdsOfPrey",
        plural: "Fiscal Flycatchers",
        quickAdd: []
    },
    {
        id: 275,
        label: "Five lined (Rainbow) Skink",
        value: "Five lined (Rainbow) Skink",
        category: "Reptile",
        plural: "Five lined (Rainbow) Skinks",
        quickAdd: []
    },
    {
        id: 276,
        label: "Flap necked Chameleon",
        value: "Flap necked Chameleon",
        category: "Reptile",
        plural: "Flap necked Chameleons",
        quickAdd: []
    },
    {
        id: 277,
        label: "Flappet Lark",
        value: "Flappet Lark",
        category: "NonBirdsOfPrey",
        plural: "Flappet Larks",
        quickAdd: []
    },
    {
        id: 278,
        label: "Flat backed Toad",
        value: "Flat backed Toad",
        category: "Amphibian",
        plural: "Flat backed Toads",
        quickAdd: []
    },
    {
        id: 279,
        label: "Flower",
        value: "Flower",
        category: "Scenery",
        plural: "Flowers",
        quickAdd: []
    },
    {
        id: 280,
        label: "Flying Squirrel",
        value: "Flying Squirrel",
        category: "Nonpredator",
        plural: "Flying Squirrels",
        quickAdd: []
    },
    {
        id: 281,
        label: "Fork tailed Drongo",
        value: "Fork tailed Drongo",
        category: "NonBirdsOfPrey",
        plural: "Fork tailed Drongos",
        quickAdd: []
    },
    {
        id: 282,
        label: "Fulvous Duck",
        value: "Fulvous Duck",
        category: "NonBirdsOfPrey",
        plural: "Fulvous Ducks",
        quickAdd: []
    },
    {
        id: 283,
        label: "Gabar Goshawk",
        value: "Gabar Goshawk",
        category: "BirdsOfPrey",
        plural: "Gabar Goshawks",
        quickAdd: []
    },
    {
        id: 284,
        label: "Garden Warbler",
        value: "Garden Warbler",
        category: "NonBirdsOfPrey",
        plural: "Garden Warblers",
        quickAdd: []
    },
    {
        id: 285,
        label: "Gemsbok",
        value: "Gemsbok",
        category: "Nonpredator",
        plural: "Gemsboks",
        quickAdd: []
    },
    {
        id: 286,
        label: "Giant Bullfrog",
        value: "Giant Bullfrog",
        category: "Amphibian",
        plural: "Giant Bullfrogs",
        quickAdd: []
    },
    {
        id: 287,
        label: "Giant Kingfisher",
        value: "Giant Kingfisher",
        category: "NonBirdsOfPrey",
        plural: "Giant Kingfishers",
        quickAdd: []
    },
    {
        id: 288,
        label: "Giant Plated Lizard",
        value: "Giant Plated Lizard",
        category: "Reptile",
        plural: "Giant Plated Lizards",
        quickAdd: []
    },
    {
        id: 289,
        label: "Giraffe",
        value: "Giraffe",
        category: "Nonpredator",
        plural: "Giraffes",
        quickAdd: []
    },
    {
        id: 290,
        label: "Glossy Ibis",
        value: "Glossy Ibis",
        category: "NonBirdsOfPrey",
        plural: "Glossy Ibises",
        quickAdd: []
    },
    {
        id: 291,
        label: "Golden Jackal",
        value: "Golden Jackal",
        category: "Predator",
        plural: "Golden Jackals",
        quickAdd: []
    },
    {
        id: 292,
        label: "Golden Weaver",
        value: "Golden Weaver",
        category: "NonBirdsOfPrey",
        plural: "Golden Weavers",
        quickAdd: []
    },
    {
        id: 293,
        label: "Golden breasted Bunting",
        value: "Golden breasted Bunting",
        category: "NonBirdsOfPrey",
        plural: "Golden breasted Buntings",
        quickAdd: []
    },
    {
        id: 294,
        label: "Golden leaf Folding Frog",
        value: "Golden leaf Folding Frog",
        category: "Amphibian",
        plural: "Golden leaf Folding Frogs",
        quickAdd: []
    },
    {
        id: 295,
        label: "Golden tailed Woodpecker",
        value: "Golden tailed Woodpecker",
        category: "NonBirdsOfPrey",
        plural: "Golden tailed Woodpeckers",
        quickAdd: []
    },
    {
        id: 296,
        label: "Goliath Heron",
        value: "Goliath Heron",
        category: "NonBirdsOfPrey",
        plural: "Goliath Herons",
        quickAdd: []
    },
    {
        id: 297,
        label: "Gorgeous Bush Shrike",
        value: "Gorgeous Bush Shrike",
        category: "NonBirdsOfPrey",
        plural: "Gorgeous Bush Shrikes",
        quickAdd: []
    },
    {
        id: 298,
        label: "Great (White) Egret",
        value: "Great (White) Egret",
        category: "NonBirdsOfPrey",
        plural: "Great (White) Egrets",
        quickAdd: []
    },
    {
        id: 299,
        label: "Great Crested Grebe",
        value: "Great Crested Grebe",
        category: "NonBirdsOfPrey",
        plural: "Great Crested Grebes",
        quickAdd: []
    },
    {
        id: 300,
        label: "Great Reed warbler",
        value: "Great Reed warbler",
        category: "NonBirdsOfPrey",
        plural: "Great Reed warblers",
        quickAdd: []
    },
    {
        id: 301,
        label: "Great Sparrow",
        value: "Great Sparrow",
        category: "NonBirdsOfPrey",
        plural: "Great Sparrows",
        quickAdd: []
    },
    {
        id: 302,
        label: "Great Spotted Cuckoo",
        value: "Great Spotted Cuckoo",
        category: "NonBirdsOfPrey",
        plural: "Great Spotted Cuckoos",
        quickAdd: []
    },
    {
        id: 303,
        label: "Great White Pelican",
        value: "Great White Pelican",
        category: "NonBirdsOfPrey",
        plural: "Great White Pelicans",
        quickAdd: []
    },
    {
        id: 304,
        label: "Greater Blue eared Starling",
        value: "Greater Blue eared Starling",
        category: "NonBirdsOfPrey",
        plural: "Greater Blue eared Starlings",
        quickAdd: []
    },
    {
        id: 305,
        label: "Greater Double collared Sunbird",
        value: "Greater Double collared Sunbird",
        category: "NonBirdsOfPrey",
        plural: "Greater Double collared Sunbirds",
        quickAdd: []
    },
    {
        id: 306,
        label: "Greater Flamingo",
        value: "Greater Flamingo",
        category: "NonBirdsOfPrey",
        plural: "Greater Flamingos",
        quickAdd: []
    },
    {
        id: 307,
        label: "Greater Honeyguide",
        value: "Greater Honeyguide",
        category: "NonBirdsOfPrey",
        plural: "Greater Honeyguides",
        quickAdd: []
    },
    {
        id: 308,
        label: "Greater Kestrel",
        value: "Greater Kestrel",
        category: "BirdsOfPrey",
        plural: "Greater Kestrels",
        quickAdd: []
    },
    {
        id: 309,
        label: "Greater Striped Swallow",
        value: "Greater Striped Swallow",
        category: "NonBirdsOfPrey",
        plural: "Greater Striped Swallows",
        quickAdd: []
    },
    {
        id: 310,
        label: "Greater painted Snipe",
        value: "Greater painted Snipe",
        category: "NonBirdsOfPrey",
        plural: "Greater painted Snipes",
        quickAdd: []
    },
    {
        id: 311,
        label: "Green (Red billed) Wood Hoopoe",
        value: "Green (Red billed) Wood Hoopoe",
        category: "NonBirdsOfPrey",
        plural: "Green (Red billed) Wood Hoopoes",
        quickAdd: []
    },
    {
        id: 312,
        label: "Green Sandpiper",
        value: "Green Sandpiper",
        category: "NonBirdsOfPrey",
        plural: "Green Sandpipers",
        quickAdd: []
    },
    {
        id: 313,
        label: "Green Twinspot",
        value: "Green Twinspot",
        category: "NonBirdsOfPrey",
        plural: "Green Twinspots",
        quickAdd: []
    },
    {
        id: 314,
        label: "Green backed Heron",
        value: "Green backed Heron",
        category: "NonBirdsOfPrey",
        plural: "Green backed Herons",
        quickAdd: []
    },
    {
        id: 315,
        label: "Green capped Eremomela",
        value: "Green capped Eremomela",
        category: "NonBirdsOfPrey",
        plural: "Green capped Eremomelas",
        quickAdd: []
    },
    {
        id: 316,
        label: "Green winged Pytilia (Melba Finch)",
        value: "Green winged Pytilia (Melba Finch)",
        category: "NonBirdsOfPrey",
        plural: "Green winged Pytilias (Melba Finches)",
        quickAdd: []
    },
    {
        id: 317,
        label: "Grey Cuckooshrike",
        value: "Grey Cuckooshrike",
        category: "NonBirdsOfPrey",
        plural: "Grey Cuckooshrikes",
        quickAdd: []
    },
    {
        id: 318,
        label: "Grey Heron",
        value: "Grey Heron",
        category: "NonBirdsOfPrey",
        plural: "Grey Herons",
        quickAdd: []
    },
    {
        id: 319,
        label: "Grey Hornbill",
        value: "Grey Hornbill",
        category: "NonBirdsOfPrey",
        plural: "Grey Hornbills",
        quickAdd: []
    },
    {
        id: 320,
        label: "Grey Plover",
        value: "Grey Plover",
        category: "NonBirdsOfPrey",
        plural: "Grey Plovers",
        quickAdd: []
    },
    {
        id: 321,
        label: "Grey Rhebok",
        value: "Grey Rhebok",
        category: "Nonpredator",
        plural: "Grey Rheboks",
        quickAdd: []
    },
    {
        id: 322,
        label: "Grey backed Camaroptera",
        value: "Grey backed Camaroptera",
        category: "NonBirdsOfPrey",
        plural: "Grey backed Camaropteras",
        quickAdd: []
    },
    {
        id: 323,
        label: "Grey backed Sparrowhawk",
        value: "Grey backed Sparrowhawk",
        category: "BirdsOfPrey",
        plural: "Grey backed Sparrowhawks",
        quickAdd: []
    },
    {
        id: 324,
        label: "Grey headed Bush Shrike",
        value: "Grey headed Bush Shrike",
        category: "NonBirdsOfPrey",
        plural: "Grey headed Bush Shrikes",
        quickAdd: []
    },
    {
        id: 325,
        label: "Grey headed Gull",
        value: "Grey headed Gull",
        category: "NonBirdsOfPrey",
        plural: "Grey headed Gulls",
        quickAdd: []
    },
    {
        id: 326,
        label: "Grey headed Kingfisher",
        value: "Grey headed Kingfisher",
        category: "NonBirdsOfPrey",
        plural: "Grey headed Kingfishers",
        quickAdd: []
    },
    {
        id: 327,
        label: "Grey headed Parrot",
        value: "Grey headed Parrot",
        category: "NonBirdsOfPrey",
        plural: "Grey headed Parrots",
        quickAdd: []
    },
    {
        id: 328,
        label: "Grey rumped Swallow",
        value: "Grey rumped Swallow",
        category: "NonBirdsOfPrey",
        plural: "Grey rumped Swallows",
        quickAdd: []
    },
    {
        id: 329,
        label: "Groundscraper Thrush",
        value: "Groundscraper Thrush",
        category: "NonBirdsOfPrey",
        plural: "Groundscraper Thrushes",
        quickAdd: []
    },
    {
        id: 330,
        label: "Gurney's Sugarbird",
        value: "Gurney's Sugarbird",
        category: "NonBirdsOfPrey",
        plural: "Gurney's Sugarbirds",
        quickAdd: []
    },
    {
        id: 331,
        label: "Guttural Toad",
        value: "Guttural Toad",
        category: "Amphibian",
        plural: "Guttural Toads",
        quickAdd: []
    },
    {
        id: 332,
        label: "Hadeda",
        value: "Hadeda",
        category: "NonBirdsOfPrey",
        plural: "Hadedas",
        quickAdd: []
    },
    {
        id: 333,
        label: "Hail",
        value: "Hail",
        category: "Scenery",
        plural: "Hail",
        quickAdd: []
    },
    {
        id: 334,
        label: "Half collared Kingfisher",
        value: "Half collared Kingfisher",
        category: "NonBirdsOfPrey",
        plural: "Half collared Kingfishers",
        quickAdd: []
    },
    {
        id: 335,
        label: "Hamerkop",
        value: "Hamerkop",
        category: "NonBirdsOfPrey",
        plural: "Hamerkops",
        quickAdd: []
    },
    {
        id: 336,
        label: "Hare",
        value: "Hare",
        category: "Nonpredator",
        plural: "Hares",
        quickAdd: []
    },
    {
        id: 337,
        label: "Harlequin Quail",
        value: "Harlequin Quail",
        category: "NonBirdsOfPrey",
        plural: "Harlequin Quails",
        quickAdd: []
    },
    {
        id: 338,
        label: "Helmeted Guineafowl",
        value: "Helmeted Guineafowl",
        category: "NonBirdsOfPrey",
        plural: "Helmeted Guineafowls",
        quickAdd: []
    },
    {
        id: 339,
        label: "Highveld Garter Snake",
        value: "Highveld Garter Snake",
        category: "Reptile",
        plural: "Highveld Garter Snakes",
        quickAdd: []
    },
    {
        id: 340,
        label: "Hippopotamus",
        value: "Hippopotamus",
        category: "Nonpredator",
        plural: "Hippopotami",
        quickAdd: []
    },
    {
        id: 341,
        label: "Honey Badger",
        value: "Honey Badger",
        category: "Predator",
        plural: "Honey Badgers",
        quickAdd: []
    },
    {
        id: 342,
        label: "Hooded Vulture",
        value: "Hooded Vulture",
        category: "BirdsOfPrey",
        plural: "Hooded Vultures",
        quickAdd: []
    },
    {
        id: 343,
        label: "Horned Adder",
        value: "Horned Adder",
        category: "Reptile",
        plural: "Horned Adders",
        quickAdd: []
    },
    {
        id: 344,
        label: "Horus Swift",
        value: "Horus Swift",
        category: "NonBirdsOfPrey",
        plural: "Horus Swifts",
        quickAdd: []
    },
    {
        id: 345,
        label: "Hottentot Teal",
        value: "Hottentot Teal",
        category: "NonBirdsOfPrey",
        plural: "Hottentot Teals",
        quickAdd: []
    },
    {
        id: 346,
        label: "House Martin",
        value: "House Martin",
        category: "NonBirdsOfPrey",
        plural: "House Martins",
        quickAdd: []
    },
    {
        id: 347,
        label: "House Sparrow",
        value: "House Sparrow",
        category: "NonBirdsOfPrey",
        plural: "House Sparrows",
        quickAdd: []
    },
    {
        id: 348,
        label: "Howler Monkey",
        value: "Howler Monkey",
        category: "Nonpredator",
        plural: "Howler Monkeys",
        quickAdd: []
    },
    {
        id: 349,
        label: "Humpback Whale",
        value: "Humpback Whale",
        category: "Nonpredator",
        plural: "Humpback Whales",
        quickAdd: []
    },
    {
        id: 350,
        label: "Hyena",
        value: "Hyena",
        category: "Predator",
        plural: "Hyenas",
        quickAdd: []
    },
    {
        id: 351,
        label: "Icterine Warbler",
        value: "Icterine Warbler",
        category: "NonBirdsOfPrey",
        plural: "Icterine Warblers",
        quickAdd: []
    },
    {
        id: 352,
        label: "Impala",
        value: "Impala",
        category: "Nonpredator",
        plural: "Impalas",
        quickAdd: []
    },
    {
        id: 353,
        label: "Indian Elephant",
        value: "Indian Elephant",
        category: "Nonpredator",
        plural: "Indian Elephants",
        quickAdd: []
    },
    {
        id: 354,
        label: "Jackal Buzzard",
        value: "Jackal Buzzard",
        category: "BirdsOfPrey",
        plural: "Jackal Buzzards",
        quickAdd: []
    },
    {
        id: 355,
        label: "Jacobin Cuckoo",
        value: "Jacobin Cuckoo",
        category: "NonBirdsOfPrey",
        plural: "Jacobin Cuckoos",
        quickAdd: []
    },
    {
        id: 356,
        label: "Jameson's Firefinch",
        value: "Jameson's Firefinch",
        category: "NonBirdsOfPrey",
        plural: "Jameson's Firefinches",
        quickAdd: []
    },
    {
        id: 357,
        label: "Jungle Cat",
        value: "Jungle Cat",
        category: "Predator",
        plural: "Jungle Cats",
        quickAdd: []
    },
    {
        id: 358,
        label: "Kalahari Scrub robin",
        value: "Kalahari Scrub robin",
        category: "NonBirdsOfPrey",
        plural: "Kalahari Scrub robins",
        quickAdd: []
    },
    {
        id: 359,
        label: "Kangaroo",
        value: "Kangaroo",
        category: "Nonpredator",
        plural: "Kangaroos",
        quickAdd: []
    },
    {
        id: 360,
        label: "Karoo Thrush",
        value: "Karoo Thrush",
        category: "NonBirdsOfPrey",
        plural: "Karoo Thrushes",
        quickAdd: []
    },
    {
        id: 361,
        label: "Killer Whale",
        value: "Killer Whale",
        category: "Predator",
        plural: "Killer Whales",
        quickAdd: []
    },
    {
        id: 362,
        label: "Kittlitz's Plover",
        value: "Kittlitz's Plover",
        category: "NonBirdsOfPrey",
        plural: "Kittlitz's Plovers",
        quickAdd: []
    },
    {
        id: 363,
        label: "Klaas's Cuckoo",
        value: "Klaas's Cuckoo",
        category: "NonBirdsOfPrey",
        plural: "Klaas's Cuckoos",
        quickAdd: []
    },
    {
        id: 364,
        label: "Klipspringer",
        value: "Klipspringer",
        category: "Nonpredator",
        plural: "Klipspringers",
        quickAdd: []
    },
    {
        id: 365,
        label: "Knocking Sand Frog",
        value: "Knocking Sand Frog",
        category: "Amphibian",
        plural: "Knocking Sand Frogs",
        quickAdd: []
    },
    {
        id: 366,
        label: "Koala",
        value: "Koala",
        category: "Nonpredator",
        plural: "Koalas",
        quickAdd: []
    },
    {
        id: 367,
        label: "Kori Bustard",
        value: "Kori Bustard",
        category: "NonBirdsOfPrey",
        plural: "Kori Bustards",
        quickAdd: []
    },
    {
        id: 368,
        label: "Kudu",
        value: "Kudu",
        category: "Nonpredator",
        plural: "Kudus",
        quickAdd: []
    },
    {
        id: 369,
        label: "Kurrichane Buttonquail",
        value: "Kurrichane Buttonquail",
        category: "NonBirdsOfPrey",
        plural: "Kurrichane Buttonquails",
        quickAdd: []
    },
    {
        id: 370,
        label: "Kurrichane Thrush",
        value: "Kurrichane Thrush",
        category: "NonBirdsOfPrey",
        plural: "Kurrichane Thrushes",
        quickAdd: []
    },
    {
        id: 371,
        label: "Landscape",
        value: "Landscape",
        category: "Scenery",
        plural: "Landscape",
        quickAdd: []
    },
    {
        id: 372,
        label: "Lanner Falcon",
        value: "Lanner Falcon",
        category: "BirdsOfPrey",
        plural: "Lanner Falcons",
        quickAdd: []
    },
    {
        id: 373,
        label: "Lappet Faced Vulture",
        value: "Lappet Faced Vulture",
        category: "BirdsOfPrey",
        plural: "Lappet Faced Vultures",
        quickAdd: []
    },
    {
        id: 374,
        label: "Large spotted Genet",
        value: "Large spotted Genet",
        category: "Predator",
        plural: "Large spotted Genets",
        quickAdd: []
    },
    {
        id: 375,
        label: "Lark like Bunting",
        value: "Lark like Bunting",
        category: "NonBirdsOfPrey",
        plural: "Lark like Buntings",
        quickAdd: []
    },
    {
        id: 376,
        label: "Laughing Dove",
        value: "Laughing Dove",
        category: "NonBirdsOfPrey",
        plural: "Laughing Doves",
        quickAdd: []
    },
    {
        id: 377,
        label: "Lazy Cisticola",
        value: "Lazy Cisticola",
        category: "NonBirdsOfPrey",
        plural: "Lazy Cisticolas",
        quickAdd: []
    },
    {
        id: 378,
        label: "Lechwe",
        value: "Lechwe",
        category: "Nonpredator",
        plural: "Lechwes",
        quickAdd: []
    },
    {
        id: 379,
        label: "Lemon breasted Canary",
        value: "Lemon breasted Canary",
        category: "NonBirdsOfPrey",
        plural: "Lemon breasted Canaries",
        quickAdd: []
    },
    {
        id: 380,
        label: "Lemur",
        value: "Lemur",
        category: "Nonpredator",
        plural: "Lemurs",
        quickAdd: []
    },
    {
        id: 381,
        label: "Leopard",
        value: "Leopard",
        category: "Predator",
        plural: "Leopards",
        quickAdd: []
    },
    {
        id: 382,
        label: "Leopard Tortoise",
        value: "Leopard Tortoise",
        category: "Reptile",
        plural: "Leopard Tortoises",
        quickAdd: []
    },
    {
        id: 383,
        label: "Lesser Bushbaby",
        value: "Lesser Bushbaby",
        category: "Nonpredator",
        plural: "Lesser Bushbabies",
        quickAdd: []
    },
    {
        id: 384,
        label: "Lesser Flamingo",
        value: "Lesser Flamingo",
        category: "NonBirdsOfPrey",
        plural: "Lesser Flamingos",
        quickAdd: []
    },
    {
        id: 385,
        label: "Lesser Grey Shrike",
        value: "Lesser Grey Shrike",
        category: "NonBirdsOfPrey",
        plural: "Lesser Grey Shrikes",
        quickAdd: []
    },
    {
        id: 386,
        label: "Lesser Honeyguide",
        value: "Lesser Honeyguide",
        category: "NonBirdsOfPrey",
        plural: "Lesser Honeyguides",
        quickAdd: []
    },
    {
        id: 387,
        label: "Lesser Kestrel",
        value: "Lesser Kestrel",
        category: "BirdsOfPrey",
        plural: "Lesser Kestrels",
        quickAdd: []
    },
    {
        id: 388,
        label: "Lesser Masked weaver",
        value: "Lesser Masked weaver",
        category: "NonBirdsOfPrey",
        plural: "Lesser Masked weavers",
        quickAdd: []
    },
    {
        id: 389,
        label: "Lesser Moorhen",
        value: "Lesser Moorhen",
        category: "NonBirdsOfPrey",
        plural: "Lesser Moorhens",
        quickAdd: []
    },
    {
        id: 390,
        label: "Lesser Striped Swallow",
        value: "Lesser Striped Swallow",
        category: "NonBirdsOfPrey",
        plural: "Lesser Striped Swallows",
        quickAdd: []
    },
    {
        id: 391,
        label: "Lesser Swamp (Cape Reed) Warbler",
        value: "Lesser Swamp (Cape Reed) Warbler",
        category: "NonBirdsOfPrey",
        plural: "Lesser Swamp (Cape Reed) Warblers",
        quickAdd: []
    },
    {
        id: 392,
        label: "Levaillant's Cisticola",
        value: "Levaillant's Cisticola",
        category: "NonBirdsOfPrey",
        plural: "Levaillant's Cisticolas",
        quickAdd: []
    },
    {
        id: 393,
        label: "Lichtenstein's Hartebeest",
        value: "Lichtenstein's Hartebeest",
        category: "Nonpredator",
        plural: "Lichtenstein's Hartebeests",
        quickAdd: []
    },
    {
        id: 394,
        label: "Lilac breasted Roller",
        value: "Lilac breasted Roller",
        category: "NonBirdsOfPrey",
        plural: "Lilac breasted Rollers",
        quickAdd: []
    },
    {
        id: 395,
        label: "Lion",
        value: "Lion",
        category: "Predator",
        plural: "Lions",
        quickAdd: []
    },
    {
        id: 396,
        label: "Little Bee eater",
        value: "Little Bee eater",
        category: "NonBirdsOfPrey",
        plural: "Little Bee eaters",
        quickAdd: []
    },
    {
        id: 397,
        label: "Little Bittern",
        value: "Little Bittern",
        category: "NonBirdsOfPrey",
        plural: "Little Bitterns",
        quickAdd: []
    },
    {
        id: 398,
        label: "Little Egret",
        value: "Little Egret",
        category: "NonBirdsOfPrey",
        plural: "Little Egrets",
        quickAdd: []
    },
    {
        id: 399,
        label: "Little Grebe (Dabchick)",
        value: "Little Grebe (Dabchick)",
        category: "NonBirdsOfPrey",
        plural: "Little Grebes (Dabchicks)",
        quickAdd: []
    },
    {
        id: 400,
        label: "Little Rush warbler",
        value: "Little Rush warbler",
        category: "NonBirdsOfPrey",
        plural: "Little Rush warblers",
        quickAdd: []
    },
    {
        id: 401,
        label: "Little Sparrowhawk",
        value: "Little Sparrowhawk",
        category: "BirdsOfPrey",
        plural: "Little Sparrowhawks",
        quickAdd: []
    },
    {
        id: 402,
        label: "Little Swift",
        value: "Little Swift",
        category: "NonBirdsOfPrey",
        plural: "Little Swifts",
        quickAdd: []
    },
    {
        id: 403,
        label: "Little banded Goshawk",
        value: "Little banded Goshawk",
        category: "BirdsOfPrey",
        plural: "Little banded Goshawks",
        quickAdd: []
    },
    {
        id: 404,
        label: "Lizard Buzzard",
        value: "Lizard Buzzard",
        category: "BirdsOfPrey",
        plural: "Lizard Buzzards",
        quickAdd: []
    },
    {
        id: 405,
        label: "Lobatse Hinged Tortoise",
        value: "Lobatse Hinged Tortoise",
        category: "Reptile",
        plural: "Lobatse Hinged Tortoises",
        quickAdd: []
    },
    {
        id: 406,
        label: "Long billed Crombec",
        value: "Long billed Crombec",
        category: "NonBirdsOfPrey",
        plural: "Long billed Crombecs",
        quickAdd: []
    },
    {
        id: 407,
        label: "Long billed Pipit",
        value: "Long billed Pipit",
        category: "NonBirdsOfPrey",
        plural: "Long billed Pipits",
        quickAdd: []
    },
    {
        id: 408,
        label: "Long crested Eagle",
        value: "Long crested Eagle",
        category: "BirdsOfPrey",
        plural: "Long crested Eagles",
        quickAdd: []
    },
    {
        id: 409,
        label: "Long tailed Paradise Whydah",
        value: "Long tailed Paradise Whydah",
        category: "NonBirdsOfPrey",
        plural: "Long tailed Paradise Whydahs",
        quickAdd: []
    },
    {
        id: 410,
        label: "Long tailed Widowbird",
        value: "Long tailed Widowbird",
        category: "NonBirdsOfPrey",
        plural: "Long tailed Widowbirds",
        quickAdd: []
    },
    {
        id: 411,
        label: "Maccoa Duck",
        value: "Maccoa Duck",
        category: "NonBirdsOfPrey",
        plural: "Maccoa Ducks",
        quickAdd: []
    },
    {
        id: 412,
        label: "Magpie Shrike",
        value: "Magpie Shrike",
        category: "NonBirdsOfPrey",
        plural: "Magpie Shrikes",
        quickAdd: []
    },
    {
        id: 413,
        label: "Malachite Kingfisher",
        value: "Malachite Kingfisher",
        category: "NonBirdsOfPrey",
        plural: "Malachite Kingfishers",
        quickAdd: []
    },
    {
        id: 414,
        label: "Malachite Sunbird",
        value: "Malachite Sunbird",
        category: "NonBirdsOfPrey",
        plural: "Malachite Sunbirds",
        quickAdd: []
    },
    {
        id: 415,
        label: "Manatee",
        value: "Manatee",
        category: "Nonpredator",
        plural: "Manatees",
        quickAdd: []
    },
    {
        id: 416,
        label: "Marabou Stork",
        value: "Marabou Stork",
        category: "BirdsOfPrey",
        plural: "Marabou Storks",
        quickAdd: []
    },
    {
        id: 417,
        label: "Marico Flycatcher",
        value: "Marico Flycatcher",
        category: "NonBirdsOfPrey",
        plural: "Marico Flycatchers",
        quickAdd: []
    },
    {
        id: 418,
        label: "Marico Sunbird",
        value: "Marico Sunbird",
        category: "NonBirdsOfPrey",
        plural: "Marico Sunbirds",
        quickAdd: []
    },
    {
        id: 419,
        label: "Marsh (Helmeted) Terrapin",
        value: "Marsh (Helmeted) Terrapin",
        category: "Reptile",
        plural: "Marsh (Helmeted) Terrapins",
        quickAdd: []
    },
    {
        id: 420,
        label: "Marsh Owl",
        value: "Marsh Owl",
        category: "BirdsOfPrey",
        plural: "Marsh Owls",
        quickAdd: []
    },
    {
        id: 421,
        label: "Martial Eagle",
        value: "Martial Eagle",
        category: "BirdsOfPrey",
        plural: "Martial Eagles",
        quickAdd: []
    },
    {
        id: 422,
        label: "Mauritian Tomb Bat",
        value: "Mauritian Tomb Bat",
        category: "Nonpredator",
        plural: "Mauritian Tomb Bats",
        quickAdd: []
    },
    {
        id: 423,
        label: "Meerkat",
        value: "Meerkat",
        category: "Nonpredator",
        plural: "Meerkats",
        quickAdd: []
    },
    {
        id: 424,
        label: "Meves's Starling",
        value: "Meves's Starling",
        category: "NonBirdsOfPrey",
        plural: "Meves's Starlings",
        quickAdd: []
    },
    {
        id: 425,
        label: "Meyer's Parrot",
        value: "Meyer's Parrot",
        category: "NonBirdsOfPrey",
        plural: "Meyer's Parrots",
        quickAdd: []
    },
    {
        id: 426,
        label: "Minke Whale",
        value: "Minke Whale",
        category: "Nonpredator",
        plural: "Minke Whales",
        quickAdd: []
    },
    {
        id: 427,
        label: "Mocking Cliff Chat",
        value: "Mocking Cliff Chat",
        category: "NonBirdsOfPrey",
        plural: "Mocking Cliff Chats",
        quickAdd: []
    },
    {
        id: 428,
        label: "Mole Snake",
        value: "Mole Snake",
        category: "Reptile",
        plural: "Mole Snakes",
        quickAdd: []
    },
    {
        id: 429,
        label: "Monotonous Lark",
        value: "Monotonous Lark",
        category: "NonBirdsOfPrey",
        plural: "Monotonous Larks",
        quickAdd: []
    },
    {
        id: 430,
        label: "Montagu's Harrier",
        value: "Montagu's Harrier",
        category: "BirdsOfPrey",
        plural: "Montagu's Harriers",
        quickAdd: []
    },
    {
        id: 431,
        label: "Moon",
        value: "Moon",
        category: "Scenery",
        plural: "Moon",
        quickAdd: []
    },
    {
        id: 432,
        label: "Moose",
        value: "Moose",
        category: "Nonpredator",
        plural: "Moose",
        quickAdd: []
    },
    {
        id: 433,
        label: "Mosque Swallow",
        value: "Mosque Swallow",
        category: "NonBirdsOfPrey",
        plural: "Mosque Swallows",
        quickAdd: []
    },
    {
        id: 434,
        label: "Mottled Shovel nosed Frog",
        value: "Mottled Shovel nosed Frog",
        category: "Amphibian",
        plural: "Mottled Shovel nosed Frogs",
        quickAdd: []
    },
    {
        id: 435,
        label: "Mottled Spinetail",
        value: "Mottled Spinetail",
        category: "NonBirdsOfPrey",
        plural: "Mottled Spinetails",
        quickAdd: []
    },
    {
        id: 436,
        label: "Mountain Reedbuck",
        value: "Mountain Reedbuck",
        category: "Nonpredator",
        plural: "Mountain Reedbucks",
        quickAdd: []
    },
    {
        id: 437,
        label: "Mountain Wagtail",
        value: "Mountain Wagtail",
        category: "NonBirdsOfPrey",
        plural: "Mountain Wagtails",
        quickAdd: []
    },
    {
        id: 438,
        label: "Mountain Wheatear",
        value: "Mountain Wheatear",
        category: "NonBirdsOfPrey",
        plural: "Mountain Wheatears",
        quickAdd: []
    },
    {
        id: 439,
        label: "Mozambique Spitting Cobra",
        value: "Mozambique Spitting Cobra",
        category: "Reptile",
        plural: "Mozambique Spitting Cobras",
        quickAdd: []
    },
    {
        id: 440,
        label: "Namaqua Dove",
        value: "Namaqua Dove",
        category: "NonBirdsOfPrey",
        plural: "Namaqua Doves",
        quickAdd: []
    },
    {
        id: 441,
        label: "Narina Trogon",
        value: "Narina Trogon",
        category: "NonBirdsOfPrey",
        plural: "Narina Trogons",
        quickAdd: []
    },
    {
        id: 442,
        label: "Natal Red Rock Rabbit",
        value: "Natal Red Rock Rabbit",
        category: "Nonpredator",
        plural: "Natal Red Rock Rabbits",
        quickAdd: []
    },
    {
        id: 443,
        label: "Natal Sand Frog",
        value: "Natal Sand Frog",
        category: "Amphibian",
        plural: "Natal Sand Frogs",
        quickAdd: []
    },
    {
        id: 444,
        label: "Natal Spurfowl",
        value: "Natal Spurfowl",
        category: "NonBirdsOfPrey",
        plural: "Natal Spurfowls",
        quickAdd: []
    },
    {
        id: 445,
        label: "Neddicky",
        value: "Neddicky",
        category: "NonBirdsOfPrey",
        plural: "Neddickys",
        quickAdd: []
    },
    {
        id: 446,
        label: "Nile Crocodile",
        value: "Nile Crocodile",
        category: "Reptile",
        plural: "Nile Crocodiles",
        quickAdd: []
    },
    {
        id: 447,
        label: "Northern Black Korhaan",
        value: "Northern Black Korhaan",
        category: "NonBirdsOfPrey",
        plural: "Northern Black Korhaans",
        quickAdd: []
    },
    {
        id: 448,
        label: "Northern Pygmy Toad",
        value: "Northern Pygmy Toad",
        category: "Amphibian",
        plural: "Northern Pygmy Toads",
        quickAdd: []
    },
    {
        id: 449,
        label: "Northern Shoveller",
        value: "Northern Shoveller",
        category: "NonBirdsOfPrey",
        plural: "Northern Shovellers",
        quickAdd: []
    },
    {
        id: 450,
        label: "Nyala",
        value: "Nyala",
        category: "Nonpredator",
        plural: "Nyalas",
        quickAdd: []
    },
    {
        id: 451,
        label: "Olive Grass Snake",
        value: "Olive Grass Snake",
        category: "Reptile",
        plural: "Olive Grass Snakes",
        quickAdd: []
    },
    {
        id: 452,
        label: "Olive Thrush",
        value: "Olive Thrush",
        category: "NonBirdsOfPrey",
        plural: "Olive Thrushes",
        quickAdd: []
    },
    {
        id: 453,
        label: "Olive Whip Snake",
        value: "Olive Whip Snake",
        category: "Reptile",
        plural: "Olive Whip Snakes",
        quickAdd: []
    },
    {
        id: 454,
        label: "Orange breasted Bush Shrike",
        value: "Orange breasted Bush Shrike",
        category: "NonBirdsOfPrey",
        plural: "Orange breasted Bush Shrikes",
        quickAdd: []
    },
    {
        id: 455,
        label: "Orange breasted Waxbill",
        value: "Orange breasted Waxbill",
        category: "NonBirdsOfPrey",
        plural: "Orange breasted Waxbills",
        quickAdd: []
    },
    {
        id: 456,
        label: "Orange winged Pytilia",
        value: "Orange winged Pytilia",
        category: "NonBirdsOfPrey",
        plural: "Orange winged Pytilias",
        quickAdd: []
    },
    {
        id: 457,
        label: "Oribi",
        value: "Oribi",
        category: "Nonpredator",
        plural: "Oribis",
        quickAdd: []
    },
    {
        id: 458,
        label: "Ornate Frog",
        value: "Ornate Frog",
        category: "Amphibian",
        plural: "Ornate Frogs",
        quickAdd: []
    },
    {
        id: 459,
        label: "Ornate Rough scaled Lizard",
        value: "Ornate Rough scaled Lizard",
        category: "Reptile",
        plural: "Ornate Rough scaled Lizards",
        quickAdd: []
    },
    {
        id: 460,
        label: "Osprey",
        value: "Osprey",
        category: "BirdsOfPrey",
        plural: "Ospreys",
        quickAdd: []
    },
    {
        id: 461,
        label: "Ovambo Sparrowhawk",
        value: "Ovambo Sparrowhawk",
        category: "BirdsOfPrey",
        plural: "Ovambo Sparrowhawks",
        quickAdd: []
    },
    {
        id: 462,
        label: "Owston's Civet",
        value: "Owston's Civet",
        category: "Predator",
        plural: "Owston's Civets",
        quickAdd: []
    },
    {
        id: 463,
        label: "Painted Reed Frog",
        value: "Painted Reed Frog",
        category: "Amphibian",
        plural: "Painted Reed Frogs",
        quickAdd: []
    },
    {
        id: 464,
        label: "Pale Flycatcher",
        value: "Pale Flycatcher",
        category: "NonBirdsOfPrey",
        plural: "Pale Flycatchers",
        quickAdd: []
    },
    {
        id: 465,
        label: "Pallid Harrier",
        value: "Pallid Harrier",
        category: "BirdsOfPrey",
        plural: "Pallid Harriers",
        quickAdd: []
    },
    {
        id: 466,
        label: "Pangolin",
        value: "Pangolin",
        category: "Nonpredator",
        plural: "Pangolins",
        quickAdd: []
    },
    {
        id: 467,
        label: "Pearl breasted Swallow",
        value: "Pearl breasted Swallow",
        category: "NonBirdsOfPrey",
        plural: "Pearl breasted Swallows",
        quickAdd: []
    },
    {
        id: 468,
        label: "Pearl spotted Owl",
        value: "Pearl spotted Owl",
        category: "BirdsOfPrey",
        plural: "Pearl spotted Owls",
        quickAdd: []
    },
    {
        id: 469,
        label: "Pel's Fishing Owl",
        value: "Pel's Fishing Owl",
        category: "BirdsOfPrey",
        plural: "Pel's Fishing Owls",
        quickAdd: []
    },
    {
        id: 470,
        label: "Pen[]t winged Nightjar",
        value: "Pen[]t winged Nightjar",
        category: "NonBirdsOfPrey",
        plural: "Pen[]t winged Nightjars",
        quickAdd: []
    },
    {
        id: 471,
        label: "Peregrine Falcon",
        value: "Peregrine Falcon",
        category: "BirdsOfPrey",
        plural: "Peregrine Falcons",
        quickAdd: []
    },
    {
        id: 472,
        label: "Peter's Epauletted Fruit Bat",
        value: "Peter's Epauletted Fruit Bat",
        category: "Nonpredator",
        plural: "Peter's Epauletted Fruit Bats",
        quickAdd: []
    },
    {
        id: 473,
        label: "Peter's Thread Snake",
        value: "Peter's Thread Snake",
        category: "Reptile",
        plural: "Peter's Thread Snakes",
        quickAdd: []
    },
    {
        id: 474,
        label: "Pgymy Kingfisher",
        value: "Pgymy Kingfisher",
        category: "NonBirdsOfPrey",
        plural: "Pgymy Kingfisher",
        quickAdd: []
    },
    {
        id: 475,
        label: "Pied Avocet",
        value: "Pied Avocet",
        category: "NonBirdsOfPrey",
        plural: "Pied Avocets",
        quickAdd: []
    },
    {
        id: 476,
        label: "Pied Crow",
        value: "Pied Crow",
        category: "NonBirdsOfPrey",
        plural: "Pied Crows",
        quickAdd: []
    },
    {
        id: 477,
        label: "Pied Kingfisher",
        value: "Pied Kingfisher",
        category: "NonBirdsOfPrey",
        plural: "Pied Kingfishers",
        quickAdd: []
    },
    {
        id: 478,
        label: "Pink backed Pelican",
        value: "Pink backed Pelican",
        category: "NonBirdsOfPrey",
        plural: "Pink backed Pelicans",
        quickAdd: []
    },
    {
        id: 479,
        label: "Pin tailed Whydah",
        value: "Pin tailed Whydah",
        category: "NonBirdsOfPrey",
        plural: "Pin tailed Whydahs",
        quickAdd: []
    },
    {
        id: 480,
        label: "Plain backed Pipit",
        value: "Plain backed Pipit",
        category: "NonBirdsOfPrey",
        plural: "Plain backed Pipits",
        quickAdd: []
    },
    {
        id: 481,
        label: "Plum Coloured Starling",
        value: "Plum Coloured Starling",
        category: "NonBirdsOfPrey",
        plural: "Plum Coloured Starlings",
        quickAdd: []
    },
    {
        id: 482,
        label: "Porcupine",
        value: "Porcupine",
        category: "Nonpredator",
        plural: "Porcupines",
        quickAdd: []
    },
    {
        id: 483,
        label: "Puff Adder",
        value: "Puff Adder",
        category: "Reptile",
        plural: "Puff Adders",
        quickAdd: []
    },
    {
        id: 484,
        label: "Purple Crested Turaco",
        value: "Purple Crested Turaco",
        category: "NonBirdsOfPrey",
        plural: "Purple Crested Turacos",
        quickAdd: []
    },
    {
        id: 485,
        label: "Purple Heron",
        value: "Purple Heron",
        category: "NonBirdsOfPrey",
        plural: "Purple Herons",
        quickAdd: []
    },
    {
        id: 486,
        label: "Purple Indigobird",
        value: "Purple Indigobird",
        category: "NonBirdsOfPrey",
        plural: "Purple Indigobirds",
        quickAdd: []
    },
    {
        id: 487,
        label: "Purple Roller",
        value: "Purple Roller",
        category: "NonBirdsOfPrey",
        plural: "Purple Rollers",
        quickAdd: []
    },
    {
        id: 488,
        label: "Purple crested Turaco",
        value: "Purple crested Turaco",
        category: "NonBirdsOfPrey",
        plural: "Purple crested Turacos",
        quickAdd: []
    },
    {
        id: 489,
        label: "Pygmy Falcon",
        value: "Pygmy Falcon",
        category: "BirdsOfPrey",
        plural: "Pygmy Falcons",
        quickAdd: []
    },
    {
        id: 490,
        label: "Racket tailed Roller",
        value: "Racket tailed Roller",
        category: "NonBirdsOfPrey",
        plural: "Racket tailed Rollers",
        quickAdd: []
    },
    {
        id: 491,
        label: "Rainbow",
        value: "Rainbow",
        category: "Scenery",
        plural: "Rainbows",
        quickAdd: []
    },
    {
        id: 492,
        label: "Rattling Cisticola",
        value: "Rattling Cisticola",
        category: "NonBirdsOfPrey",
        plural: "Rattling Cisticolas",
        quickAdd: []
    },
    {
        id: 493,
        label: "Raucous Toad",
        value: "Raucous Toad",
        category: "Amphibian",
        plural: "Raucous Toads",
        quickAdd: []
    },
    {
        id: 494,
        label: "Red Duiker",
        value: "Red Duiker",
        category: "Nonpredator",
        plural: "Red Duikers",
        quickAdd: []
    },
    {
        id: 495,
        label: "Red Hartebeest",
        value: "Red Hartebeest",
        category: "Nonpredator",
        plural: "Red Hartebeests",
        quickAdd: []
    },
    {
        id: 496,
        label: "Red Lipped Snake",
        value: "Red Lipped Snake",
        category: "Reptile",
        plural: "Red Lipped Snake",
        quickAdd: []
    },
    {
        id: 497,
        label: "Red Toad",
        value: "Red Toad",
        category: "Amphibian",
        plural: "Red Toads",
        quickAdd: []
    },
    {
        id: 498,
        label: "Red backed Mannikin",
        value: "Red backed Mannikin",
        category: "NonBirdsOfPrey",
        plural: "Red backed Mannikins",
        quickAdd: []
    },
    {
        id: 499,
        label: "Red backed Shrike",
        value: "Red backed Shrike",
        category: "NonBirdsOfPrey",
        plural: "Red backed Shrikes",
        quickAdd: []
    },
    {
        id: 500,
        label: "Red billed Buffalo Weaver",
        value: "Red billed Buffalo Weaver",
        category: "NonBirdsOfPrey",
        plural: "Red billed Buffalo Weavers",
        quickAdd: []
    },
    {
        id: 501,
        label: "Red billed Firefinch",
        value: "Red billed Firefinch",
        category: "NonBirdsOfPrey",
        plural: "Red billed Firefinches",
        quickAdd: []
    },
    {
        id: 502,
        label: "Red billed Hornbill",
        value: "Red billed Hornbill",
        category: "NonBirdsOfPrey",
        plural: "Red billed Hornbills",
        quickAdd: []
    },
    {
        id: 503,
        label: "Red billed Oxpecker",
        value: "Red billed Oxpecker",
        category: "NonBirdsOfPrey",
        plural: "Red billed Oxpeckers",
        quickAdd: []
    },
    {
        id: 504,
        label: "Red billed Quelea",
        value: "Red billed Quelea",
        category: "NonBirdsOfPrey",
        plural: "Red billed Queleas",
        quickAdd: []
    },
    {
        id: 505,
        label: "Red billed Teal",
        value: "Red billed Teal",
        category: "NonBirdsOfPrey",
        plural: "Red billed Teals",
        quickAdd: []
    },
    {
        id: 506,
        label: "Red breasted Swallow",
        value: "Red breasted Swallow",
        category: "NonBirdsOfPrey",
        plural: "Red breasted Swallows",
        quickAdd: []
    },
    {
        id: 507,
        label: "Red capped Lark",
        value: "Red capped Lark",
        category: "NonBirdsOfPrey",
        plural: "Red capped Larks",
        quickAdd: []
    },
    {
        id: 508,
        label: "Red capped Robin Chat (Natal Robin)",
        value: "Red capped Robin Chat (Natal Robin)",
        category: "NonBirdsOfPrey",
        plural: "Red capped Robin Chats (Natal Robins)",
        quickAdd: []
    },
    {
        id: 509,
        label: "Red chested Flufftail",
        value: "Red chested Flufftail",
        category: "NonBirdsOfPrey",
        plural: "Red chested Flufftails",
        quickAdd: []
    },
    {
        id: 510,
        label: "Red crested Korhaan",
        value: "Red crested Korhaan",
        category: "NonBirdsOfPrey",
        plural: "Red crested Korhaans",
        quickAdd: []
    },
    {
        id: 511,
        label: "Red eyed Dove",
        value: "Red eyed Dove",
        category: "NonBirdsOfPrey",
        plural: "Red eyed Doves",
        quickAdd: []
    },
    {
        id: 512,
        label: "Red faced Cisticola",
        value: "Red faced Cisticola",
        category: "NonBirdsOfPrey",
        plural: "Red faced Cisticolas",
        quickAdd: []
    },
    {
        id: 513,
        label: "Red faced Mousebird",
        value: "Red faced Mousebird",
        category: "NonBirdsOfPrey",
        plural: "Red faced Mousebirds",
        quickAdd: []
    },
    {
        id: 514,
        label: "Red footed Falcon",
        value: "Red footed Falcon",
        category: "BirdsOfPrey",
        plural: "Red footed Falcons",
        quickAdd: []
    },
    {
        id: 515,
        label: "Red headed Finch",
        value: "Red headed Finch",
        category: "NonBirdsOfPrey",
        plural: "Red headed Finches",
        quickAdd: []
    },
    {
        id: 516,
        label: "Red headed Weaver",
        value: "Red headed Weaver",
        category: "NonBirdsOfPrey",
        plural: "Red headed Weavers",
        quickAdd: []
    },
    {
        id: 517,
        label: "Red knobbed Coot",
        value: "Red knobbed Coot",
        category: "NonBirdsOfPrey",
        plural: "Red knobbed Coots",
        quickAdd: []
    },
    {
        id: 518,
        label: "Red legged Kassina",
        value: "Red legged Kassina",
        category: "Amphibian",
        plural: "Red legged Kassinas",
        quickAdd: []
    },
    {
        id: 519,
        label: "Red lipped (Herald) Snake",
        value: "Red lipped (Herald) Snake",
        category: "Reptile",
        plural: "Red lipped (Herald) Snakes",
        quickAdd: []
    },
    {
        id: 520,
        label: "Red necked Falcon",
        value: "Red necked Falcon",
        category: "BirdsOfPrey",
        plural: "Red necked Falcons",
        quickAdd: []
    },
    {
        id: 521,
        label: "Red throated Wryneck",
        value: "Red throated Wryneck",
        category: "NonBirdsOfPrey",
        plural: "Red throated Wrynecks",
        quickAdd: []
    },
    {
        id: 522,
        label: "Red winged Starling",
        value: "Red winged Starling",
        category: "NonBirdsOfPrey",
        plural: "Red winged Starlings",
        quickAdd: []
    },
    {
        id: 523,
        label: "Reed Cormorant ",
        value: "Reed Cormorant ",
        category: "NonBirdsOfPrey",
        plural: "Reed Cormorants",
        quickAdd: []
    },
    {
        id: 524,
        label: "Retz's (Red billed) Helmet Shrike",
        value: "Retz's (Red billed) Helmet Shrike",
        category: "NonBirdsOfPrey",
        plural: "Retz's (Red billed) Helmet Shrikes",
        quickAdd: []
    },
    {
        id: 525,
        label: "Rinkhals",
        value: "Rinkhals",
        category: "Reptile",
        plural: "Rinkhals",
        quickAdd: []
    },
    {
        id: 526,
        label: "River Warbler",
        value: "River Warbler",
        category: "NonBirdsOfPrey",
        plural: "River Warblers",
        quickAdd: []
    },
    {
        id: 527,
        label: "Roan Antelope",
        value: "Roan Antelope",
        category: "Nonpredator",
        plural: "Roan Antelopes",
        quickAdd: []
    },
    {
        id: 528,
        label: "Rock Dassie",
        value: "Rock Dassie",
        category: "Nonpredator",
        plural: "Rock Dassies",
        quickAdd: []
    },
    {
        id: 529,
        label: "Rock Dove",
        value: "Rock Dove",
        category: "NonBirdsOfPrey",
        plural: "Rock Doves",
        quickAdd: []
    },
    {
        id: 530,
        label: "Rock Kestrel",
        value: "Rock Kestrel",
        category: "BirdsOfPrey",
        plural: "Rock Kestrels",
        quickAdd: []
    },
    {
        id: 531,
        label: "Rock Martin",
        value: "Rock Martin",
        category: "NonBirdsOfPrey",
        plural: "Rock Martins",
        quickAdd: []
    },
    {
        id: 532,
        label: "Rock Monitor",
        value: "Rock Monitor",
        category: "Reptile",
        plural: "Rock Monitors",
        quickAdd: []
    },
    {
        id: 533,
        label: "Rough scaled Plated Lizard",
        value: "Rough scaled Plated Lizard",
        category: "Reptile",
        plural: "Rough scaled Plated Lizards",
        quickAdd: []
    },
    {
        id: 534,
        label: "Rudd's Apalis",
        value: "Rudd's Apalis",
        category: "NonBirdsOfPrey",
        plural: "Rudd's Apalis",
        quickAdd: []
    },
    {
        id: 535,
        label: "Ruff",
        value: "Ruff",
        category: "NonBirdsOfPrey",
        plural: "Ruffs",
        quickAdd: []
    },
    {
        id: 536,
        label: "Rufous beaked Snake",
        value: "Rufous beaked Snake",
        category: "Reptile",
        plural: "Rufous beaked Snakes",
        quickAdd: []
    },
    {
        id: 537,
        label: "Rufous bellied Heron",
        value: "Rufous bellied Heron",
        category: "NonBirdsOfPrey",
        plural: "Rufous bellied Herons",
        quickAdd: []
    },
    {
        id: 538,
        label: "Rufous cheeked Nightjar",
        value: "Rufous cheeked Nightjar",
        category: "NonBirdsOfPrey",
        plural: "Rufous cheeked Nightjars",
        quickAdd: []
    },
    {
        id: 539,
        label: "Rufous chested Sparrowhawk",
        value: "Rufous chested Sparrowhawk",
        category: "BirdsOfPrey",
        plural: "Rufous chested Sparrowhawks",
        quickAdd: []
    },
    {
        id: 540,
        label: "Rufous naped Lark",
        value: "Rufous naped Lark",
        category: "NonBirdsOfPrey",
        plural: "Rufous naped Larks",
        quickAdd: []
    },
    {
        id: 541,
        label: "Ruppel's Griffon Vulture",
        value: "Ruppel's Griffon Vulture",
        category: "BirdsOfPrey",
        plural: "Ruppel's Griffon Vultures",
        quickAdd: []
    },
    {
        id: 542,
        label: "Sable Antelope",
        value: "Sable Antelope",
        category: "Nonpredator",
        plural: "Sable Antelopes",
        quickAdd: []
    },
    {
        id: 543,
        label: "Sabota Lark",
        value: "Sabota Lark",
        category: "NonBirdsOfPrey",
        plural: "Sabota Larks",
        quickAdd: []
    },
    {
        id: 544,
        label: "Sacred Ibis",
        value: "Sacred Ibis",
        category: "NonBirdsOfPrey",
        plural: "Sacred Ibises",
        quickAdd: []
    },
    {
        id: 545,
        label: "Saddle billed Stork",
        value: "Saddle billed Stork",
        category: "NonBirdsOfPrey",
        plural: "Saddle billed Storks",
        quickAdd: []
    },
    {
        id: 546,
        label: "Samango Monkey",
        value: "Samango Monkey",
        category: "Nonpredator",
        plural: "Samango Monkeys",
        quickAdd: []
    },
    {
        id: 547,
        label: "Sand Martin",
        value: "Sand Martin",
        category: "NonBirdsOfPrey",
        plural: "Sand Martins",
        quickAdd: []
    },
    {
        id: 548,
        label: "Sanderling",
        value: "Sanderling",
        category: "NonBirdsOfPrey",
        plural: "Sanderlings",
        quickAdd: []
    },
    {
        id: 549,
        label: "Scaly feathered Finch",
        value: "Scaly feathered Finch",
        category: "NonBirdsOfPrey",
        plural: "Scaly feathered Finches",
        quickAdd: []
    },
    {
        id: 550,
        label: "Scaly throated Honeyguide",
        value: "Scaly throated Honeyguide",
        category: "NonBirdsOfPrey",
        plural: "Scaly throated Honeyguides",
        quickAdd: []
    },
    {
        id: 551,
        label: "Scarlet chested Sunbird",
        value: "Scarlet chested Sunbird",
        category: "NonBirdsOfPrey",
        plural: "Scarlet chested Sunbirds",
        quickAdd: []
    },
    {
        id: 552,
        label: "Schlegel's Beaked Blind Snake",
        value: "Schlegel's Beaked Blind Snake",
        category: "Reptile",
        plural: "Schlegel's Beaked Blind Snakes",
        quickAdd: []
    },
    {
        id: 553,
        label: "Scrub Hare",
        value: "Scrub Hare",
        category: "Nonpredator",
        plural: "Scrub Hares",
        quickAdd: []
    },
    {
        id: 554,
        label: "Secretary Bird",
        value: "Secretary Bird",
        category: "BirdsOfPrey",
        plural: "Secretary Birds",
        quickAdd: []
    },
    {
        id: 555,
        label: "Sedge Warbler",
        value: "Sedge Warbler",
        category: "NonBirdsOfPrey",
        plural: "Sedge Warblers",
        quickAdd: []
    },
    {
        id: 556,
        label: "Senegal Coucal",
        value: "Senegal Coucal",
        category: "NonBirdsOfPrey",
        plural: "Senegal Coucals",
        quickAdd: []
    },
    {
        id: 557,
        label: "Senegal Lapwing (Lesser Black winged Plover)",
        value: "Senegal Lapwing (Lesser Black winged Plover)",
        category: "NonBirdsOfPrey",
        plural: "Senegal Lapwings (Lesser Black winged Plovers)",
        quickAdd: []
    },
    {
        id: 558,
        label: "Serrated Hinged Terrapin",
        value: "Serrated Hinged Terrapin",
        category: "Reptile",
        plural: "Serrated Hinged Terrapins",
        quickAdd: []
    },
    {
        id: 559,
        label: "Serval",
        value: "Serval",
        category: "Predator",
        plural: "Servals",
        quickAdd: []
    },
    {
        id: 560,
        label: "Shaft tailed Whydah",
        value: "Shaft tailed Whydah",
        category: "NonBirdsOfPrey",
        plural: "Shaft tailed Whydahs",
        quickAdd: []
    },
    {
        id: 561,
        label: "Sharpe's Grysbok",
        value: "Sharpe's Grysbok",
        category: "Nonpredator",
        plural: "Sharpe's Grysboks",
        quickAdd: []
    },
    {
        id: 562,
        label: "Shelduck",
        value: "Shelduck",
        category: "NonBirdsOfPrey",
        plural: "Shelducks",
        quickAdd: []
    },
    {
        id: 563,
        label: "Shelly's Francolin",
        value: "Shelly's Francolin",
        category: "NonBirdsOfPrey",
        plural: "Shelly's Francolins",
        quickAdd: []
    },
    {
        id: 564,
        label: "Shield nosed Cobra",
        value: "Shield nosed Cobra",
        category: "Reptile",
        plural: "Shield nosed Cobras",
        quickAdd: []
    },
    {
        id: 565,
        label: "Shikra (Little Banded Goshawk)",
        value: "Shikra (Little Banded Goshawk)",
        category: "BirdsOfPrey",
        plural: "Shikras (Little Banded Goshawks)",
        quickAdd: []
    },
    {
        id: 566,
        label: "Short clawed Lark",
        value: "Short clawed Lark",
        category: "NonBirdsOfPrey",
        plural: "Short clawed Larks",
        quickAdd: []
    },
    {
        id: 567,
        label: "Short snouted Grass Snake",
        value: "Short snouted Grass Snake",
        category: "Reptile",
        plural: "Short snouted Grass Snakes",
        quickAdd: []
    },
    {
        id: 568,
        label: "Side striped Jackal",
        value: "Side striped Jackal",
        category: "Predator",
        plural: "Side striped Jackals",
        quickAdd: []
    },
    {
        id: 569,
        label: "Sitatunga",
        value: "Sitatunga",
        category: "Nonpredator",
        plural: "Sitatungas",
        quickAdd: []
    },
    {
        id: 570,
        label: "Slaty Egret",
        value: "Slaty Egret",
        category: "NonBirdsOfPrey",
        plural: "Slaty Egrets",
        quickAdd: []
    },
    {
        id: 571,
        label: "Slender Mongoose",
        value: "Slender Mongoose",
        category: "Nonpredator",
        plural: "Slender Mongooses",
        quickAdd: []
    },
    {
        id: 572,
        label: "Small spotted Genet",
        value: "Small spotted Genet",
        category: "Predator",
        plural: "Small spotted Genets",
        quickAdd: []
    },
    {
        id: 573,
        label: "Snake",
        value: "Snake",
        category: "Reptile",
        plural: "Snakes",
        quickAdd: []
    },
    {
        id: 574,
        label: "Snoring Puddle Frog",
        value: "Snoring Puddle Frog",
        category: "Amphibian",
        plural: "Snoring Puddle Frogs",
        quickAdd: []
    },
    {
        id: 575,
        label: "Snouted Cobra",
        value: "Snouted Cobra",
        category: "Reptile",
        plural: "Snouted Cobras",
        quickAdd: []
    },
    {
        id: 576,
        label: "Snowy Owl",
        value: "Snowy Owl",
        category: "BirdsOfPrey",
        plural: "Snowy Owls",
        quickAdd: []
    },
    {
        id: 577,
        label: "Sombre Greenbul",
        value: "Sombre Greenbul",
        category: "NonBirdsOfPrey",
        plural: "Sombre Greenbuls",
        quickAdd: []
    },
    {
        id: 578,
        label: "Sooty Falcon",
        value: "Sooty Falcon",
        category: "BirdsOfPrey",
        plural: "Sooty Falcons",
        quickAdd: []
    },
    {
        id: 579,
        label: "South African Cliff swallow",
        value: "South African Cliff swallow",
        category: "NonBirdsOfPrey",
        plural: "South African Cliff swallows",
        quickAdd: []
    },
    {
        id: 580,
        label: "South African Hedgehog",
        value: "South African Hedgehog",
        category: "Nonpredator",
        plural: "South African Hedgehogs",
        quickAdd: []
    },
    {
        id: 581,
        label: "Southern ant eating Chat",
        value: "Southern ant eating Chat",
        category: "NonBirdsOfPrey",
        plural: "Southern ant eating Chats",
        quickAdd: []
    },
    {
        id: 582,
        label: "Southern Bald Ibis",
        value: "Southern Bald Ibis",
        category: "NonBirdsOfPrey",
        plural: "Southern Bald Ibises",
        quickAdd: []
    },
    {
        id: 583,
        label: "Southern Banded Snake Eagle",
        value: "Southern Banded Snake Eagle",
        category: "BirdsOfPrey",
        plural: "Southern Banded Snake Eagles",
        quickAdd: []
    },
    {
        id: 584,
        label: "Southern Black Flycatcher",
        value: "Southern Black Flycatcher",
        category: "NonBirdsOfPrey",
        plural: "Southern Black Flycatchers",
        quickAdd: []
    },
    {
        id: 585,
        label: "Southern Black Tit",
        value: "Southern Black Tit",
        category: "NonBirdsOfPrey",
        plural: "Southern Black Tits",
        quickAdd: []
    },
    {
        id: 586,
        label: "Southern Boubo",
        value: "Southern Boubo",
        category: "NonBirdsOfPrey",
        plural: "Southern Boubos",
        quickAdd: []
    },
    {
        id: 587,
        label: "Southern carmine Bee eater",
        value: "Southern carmine Bee eater",
        category: "NonBirdsOfPrey",
        plural: "Southern carmine Bee eaters",
        quickAdd: []
    },
    {
        id: 588,
        label: "Southern Foam Nest Frog",
        value: "Southern Foam Nest Frog",
        category: "Amphibian",
        plural: "Southern Foam Nest Frogs",
        quickAdd: []
    },
    {
        id: 589,
        label: "Southern Grey headed Sparrow",
        value: "Southern Grey headed Sparrow",
        category: "NonBirdsOfPrey",
        plural: "Southern Grey headed Sparrows",
        quickAdd: []
    },
    {
        id: 590,
        label: "Southern Masked Weaver",
        value: "Southern Masked Weaver",
        category: "NonBirdsOfPrey",
        plural: "Southern Masked Weavers",
        quickAdd: []
    },
    {
        id: 591,
        label: "Southern Pale Chanting Goshawk",
        value: "Southern Pale Chanting Goshawk",
        category: "BirdsOfPrey",
        plural: "Southern Pale Chanting Goshawks",
        quickAdd: []
    },
    {
        id: 592,
        label: "Southern Pied Babbler",
        value: "Southern Pied Babbler",
        category: "NonBirdsOfPrey",
        plural: "Southern Pied Babblers",
        quickAdd: []
    },
    {
        id: 593,
        label: "Southern Pochard",
        value: "Southern Pochard",
        category: "NonBirdsOfPrey",
        plural: "Southern Pochards",
        quickAdd: []
    },
    {
        id: 594,
        label: "Southern Red Bishop",
        value: "Southern Red Bishop",
        category: "NonBirdsOfPrey",
        plural: "Southern Red Bishops",
        quickAdd: []
    },
    {
        id: 595,
        label: "Southern Rock Agama",
        value: "Southern Rock Agama",
        category: "Reptile",
        plural: "Southern Rock Agamas",
        quickAdd: []
    },
    {
        id: 596,
        label: "Southern White crowned Shrike",
        value: "Southern White crowned Shrike",
        category: "NonBirdsOfPrey",
        plural: "Southern White crowned Shrikes",
        quickAdd: []
    },
    {
        id: 597,
        label: "Southern Yellow billed hornbill",
        value: "Southern Yellow billed hornbill",
        category: "NonBirdsOfPrey",
        plural: "Southern Yellow billed hornbills",
        quickAdd: []
    },
    {
        id: 598,
        label: "Southern double Collared Sunbird",
        value: "Southern double Collared Sunbird",
        category: "NonBirdsOfPrey",
        plural: "Southern double Collared Sunbirds",
        quickAdd: []
    },
    {
        id: 599,
        label: "Southern Ground hornbill",
        value: "Southern Ground hornbill",
        category: "NonBirdsOfPrey",
        plural: "Southern Ground hornbills",
        quickAdd: []
    },
    {
        id: 600,
        label: "Speckled Mousebird",
        value: "Speckled Mousebird",
        category: "NonBirdsOfPrey",
        plural: "Speckled Mousebirds",
        quickAdd: []
    },
    {
        id: 601,
        label: "Speckled Pigeon",
        value: "Speckled Pigeon",
        category: "NonBirdsOfPrey",
        plural: "Speckled Pigeons",
        quickAdd: []
    },
    {
        id: 602,
        label: "Spectacled Weaver",
        value: "Spectacled Weaver",
        category: "NonBirdsOfPrey",
        plural: "Spectacled Weavers",
        quickAdd: []
    },
    {
        id: 603,
        label: "Spekes Hinged Tortoise",
        value: "Spekes Hinged Tortoise",
        category: "Reptile",
        plural: "Spekes Hinged Tortoise",
        quickAdd: []
    },
    {
        id: 604,
        label: "Spotted Bush Snake",
        value: "Spotted Bush Snake",
        category: "Reptile",
        plural: "Spotted Bush Snakes",
        quickAdd: []
    },
    {
        id: 605,
        label: "Spotted Eagle Owl",
        value: "Spotted Eagle Owl",
        category: "BirdsOfPrey",
        plural: "Spotted Eagle Owls",
        quickAdd: []
    },
    {
        id: 606,
        label: "Spotted Flycatcher",
        value: "Spotted Flycatcher",
        category: "NonBirdsOfPrey",
        plural: "Spotted Flycatchers",
        quickAdd: []
    },
    {
        id: 607,
        label: "Spotted Grass Snake",
        value: "Spotted Grass Snake",
        category: "Reptile",
        plural: "Spotted Grass Snakes",
        quickAdd: []
    },
    {
        id: 608,
        label: "Spotted Harlequin Snake",
        value: "Spotted Harlequin Snake",
        category: "Reptile",
        plural: "Spotted Harlequin Snakes",
        quickAdd: []
    },
    {
        id: 609,
        label: "Spotted House Snake",
        value: "Spotted House Snake",
        category: "Reptile",
        plural: "Spotted House Snakes",
        quickAdd: []
    },
    {
        id: 610,
        label: "Spotted Hyena",
        value: "Spotted Hyena",
        category: "Predator",
        plural: "Spotted Hyenas",
        quickAdd: []
    },
    {
        id: 611,
        label: "Spotted Sandveld Lizard",
        value: "Spotted Sandveld Lizard",
        category: "Reptile",
        plural: "Spotted Sandveld Lizards",
        quickAdd: []
    },
    {
        id: 612,
        label: "Spotted Thick Toed Gecko",
        value: "Spotted Thick Toed Gecko",
        category: "Reptile",
        plural: "Spotted Thick Toed Geckos",
        quickAdd: []
    },
    {
        id: 613,
        label: "Spotted Thick knee",
        value: "Spotted Thick knee",
        category: "NonBirdsOfPrey",
        plural: "Spotted Thick knees",
        quickAdd: []
    },
    {
        id: 614,
        label: "Spotted neck Snake eyed Skink",
        value: "Spotted neck Snake eyed Skink",
        category: "Reptile",
        plural: "Spotted neck Snake eyed Skinks",
        quickAdd: []
    },
    {
        id: 615,
        label: "Springbok",
        value: "Springbok",
        category: "Nonpredator",
        plural: "Springboks",
        quickAdd: []
    },
    {
        id: 616,
        label: "Springhare",
        value: "Springhare",
        category: "Nonpredator",
        plural: "Springhares",
        quickAdd: []
    },
    {
        id: 617,
        label: "Spur winged Goose",
        value: "Spur winged Goose",
        category: "NonBirdsOfPrey",
        plural: "Spur winged Geese",
        quickAdd: []
    },
    {
        id: 618,
        label: "Squacco Heron",
        value: "Squacco Heron",
        category: "NonBirdsOfPrey",
        plural: "Squacco Herons",
        quickAdd: []
    },
    {
        id: 619,
        label: "Square tailed Nightjar",
        value: "Square tailed Nightjar",
        category: "NonBirdsOfPrey",
        plural: "Square tailed Nightjars",
        quickAdd: []
    },
    {
        id: 620,
        label: "Star",
        value: "Star",
        category: "Scenery",
        plural: "Stars",
        quickAdd: []
    },
    {
        id: 621,
        label: "Steenbok",
        value: "Steenbok",
        category: "Nonpredator",
        plural: "Steenboks",
        quickAdd: []
    },
    {
        id: 622,
        label: "Steppe Buzzard",
        value: "Steppe Buzzard",
        category: "BirdsOfPrey",
        plural: "Steppe Buzzards",
        quickAdd: []
    },
    {
        id: 623,
        label: "Stierling's Wren warbler",
        value: "Stierling's Wren warbler",
        category: "NonBirdsOfPrey",
        plural: "Stierling's Wren warblers",
        quickAdd: []
    },
    {
        id: 624,
        label: "Storm",
        value: "Storm",
        category: "Scenery",
        plural: "Storms",
        quickAdd: []
    },
    {
        id: 625,
        label: "Streaky headed Seedeater",
        value: "Streaky headed Seedeater",
        category: "NonBirdsOfPrey",
        plural: "Streaky headed Seedeaters",
        quickAdd: []
    },
    {
        id: 626,
        label: "Striped Crake",
        value: "Striped Crake",
        category: "NonBirdsOfPrey",
        plural: "Striped Crakes",
        quickAdd: []
    },
    {
        id: 627,
        label: "Striped Hyena",
        value: "Striped Hyena",
        category: "Predator",
        plural: "Striped Hyenas",
        quickAdd: []
    },
    {
        id: 628,
        label: "Striped Kingfisher",
        value: "Striped Kingfisher",
        category: "NonBirdsOfPrey",
        plural: "Striped Kingfishers",
        quickAdd: []
    },
    {
        id: 629,
        label: "Striped Mouse",
        value: "Striped Mouse",
        category: "Nonpredator",
        plural: "Striped Mice",
        quickAdd: []
    },
    {
        id: 630,
        label: "Striped Pipit",
        value: "Striped Pipit",
        category: "NonBirdsOfPrey",
        plural: "Striped Pipits",
        quickAdd: []
    },
    {
        id: 631,
        label: "Striped Polecat",
        value: "Striped Polecat",
        category: "Predator",
        plural: "Striped Polecats",
        quickAdd: []
    },
    {
        id: 632,
        label: "Striped Skink",
        value: "Striped Skink",
        category: "Reptile",
        plural: "Striped Skinks",
        quickAdd: []
    },
    {
        id: 633,
        label: "Sundevall's Roundleaf (Leaf nosed) Bat",
        value: "Sundevall's Roundleaf (Leaf nosed) Bat",
        category: "Nonpredator",
        plural: "Sundevall's Roundleaf (Leaf nosed) Bats",
        quickAdd: []
    },
    {
        id: 634,
        label: "Sundevall's Shovel Snout",
        value: "Sundevall's Shovel Snout",
        category: "Reptile",
        plural: "Sundevall's Shovel Snouts",
        quickAdd: []
    },
    {
        id: 635,
        label: "Sundevall's Writhing Skink",
        value: "Sundevall's Writhing Skink",
        category: "Reptile",
        plural: "Sundevall's Writhing Skinks",
        quickAdd: []
    },
    {
        id: 636,
        label: "Suni",
        value: "Suni",
        category: "Nonpredator",
        plural: "Sunis",
        quickAdd: []
    },
    {
        id: 637,
        label: "Sunrise",
        value: "Sunrise",
        category: "Scenery",
        plural: "Sunrise",
        quickAdd: []
    },
    {
        id: 638,
        label: "Sunset",
        value: "Sunset",
        category: "Scenery",
        plural: "Sunset",
        quickAdd: []
    },
    {
        id: 639,
        label: "Swainson's Spurfowl",
        value: "Swainson's Spurfowl",
        category: "NonBirdsOfPrey",
        plural: "Swainson's Spurfowls",
        quickAdd: []
    },
    {
        id: 640,
        label: "Swallow tailed Bee eater",
        value: "Swallow tailed Bee eater",
        category: "NonBirdsOfPrey",
        plural: "Swallow tailed Bee eaters",
        quickAdd: []
    },
    {
        id: 641,
        label: "Swee Waxbill",
        value: "Swee Waxbill",
        category: "NonBirdsOfPrey",
        plural: "Swee Waxbills",
        quickAdd: []
    },
    {
        id: 642,
        label: "Tambourine Dove",
        value: "Tambourine Dove",
        category: "NonBirdsOfPrey",
        plural: "Tambourine Doves",
        quickAdd: []
    },
    {
        id: 643,
        label: "Tawny Eagle",
        value: "Tawny Eagle",
        category: "BirdsOfPrey",
        plural: "Tawny Eagles",
        quickAdd: []
    },
    {
        id: 644,
        label: "Tawny flanked Prinia",
        value: "Tawny flanked Prinia",
        category: "NonBirdsOfPrey",
        plural: "Tawny flanked Prinias",
        quickAdd: []
    },
    {
        id: 645,
        label: "Temminck's Courser",
        value: "Temminck's Courser",
        category: "NonBirdsOfPrey",
        plural: "Temminck's Coursers",
        quickAdd: []
    },
    {
        id: 646,
        label: "Terrestrial Brownbul",
        value: "Terrestrial Brownbul",
        category: "NonBirdsOfPrey",
        plural: "Terrestrial Brownbuls",
        quickAdd: []
    },
    {
        id: 647,
        label: "Thick billed Cuckoo",
        value: "Thick billed Cuckoo",
        category: "NonBirdsOfPrey",
        plural: "Thick billed Cuckoos",
        quickAdd: []
    },
    {
        id: 648,
        label: "Thick billed Weaver",
        value: "Thick billed Weaver",
        category: "NonBirdsOfPrey",
        plural: "Thick billed Weavers",
        quickAdd: []
    },
    {
        id: 649,
        label: "Thick tailed bushbaby",
        value: "Thick tailed bushbaby",
        category: "Nonpredator",
        plural: "Thick tailed bushbabies",
        quickAdd: []
    },
    {
        id: 650,
        label: "Three banded Courser",
        value: "Three banded Courser",
        category: "NonBirdsOfPrey",
        plural: "Three banded Coursers",
        quickAdd: []
    },
    {
        id: 651,
        label: "Three banded Plover",
        value: "Three banded Plover",
        category: "NonBirdsOfPrey",
        plural: "Three banded Plovers",
        quickAdd: []
    },
    {
        id: 652,
        label: "Tiger",
        value: "Tiger",
        category: "Predator",
        plural: "Tigers",
        quickAdd: []
    },
    {
        id: 653,
        label: "Tinker Reed Frog",
        value: "Tinker Reed Frog",
        category: "Amphibian",
        plural: "Tinker Reed Frogs",
        quickAdd: []
    },
    {
        id: 654,
        label: "Tinkling Cisticola",
        value: "Tinkling Cisticola",
        category: "NonBirdsOfPrey",
        plural: "Tinkling Cisticolas",
        quickAdd: []
    },
    {
        id: 655,
        label: "Transvaal Gecko",
        value: "Transvaal Gecko",
        category: "Reptile",
        plural: "Transvaal Geckos",
        quickAdd: []
    },
    {
        id: 656,
        label: "Transvaal Girdled Lizard",
        value: "Transvaal Girdled Lizard",
        category: "Reptile",
        plural: "Transvaal Girdled Lizards",
        quickAdd: []
    },
    {
        id: 657,
        label: "Tree",
        value: "Tree",
        category: "Scenery",
        plural: "Trees",
        quickAdd: []
    },
    {
        id: 658,
        label: "Tree Agama",
        value: "Tree Agama",
        category: "Reptile",
        plural: "Tree Agamas",
        quickAdd: []
    },
    {
        id: 659,
        label: "Tree Pipit",
        value: "Tree Pipit",
        category: "NonBirdsOfPrey",
        plural: "Tree Pipits",
        quickAdd: []
    },
    {
        id: 660,
        label: "Tree Squirrel",
        value: "Tree Squirrel",
        category: "Nonpredator",
        plural: "Tree Squirrels",
        quickAdd: []
    },
    {
        id: 661,
        label: "Tremolo Sand Frog",
        value: "Tremolo Sand Frog",
        category: "Amphibian",
        plural: "Tremolo Sand Frogs",
        quickAdd: []
    },
    {
        id: 662,
        label: "Tropical Boubou",
        value: "Tropical Boubou",
        category: "NonBirdsOfPrey",
        plural: "Tropical Boubous",
        quickAdd: []
    },
    {
        id: 663,
        label: "Trumpeter Hornbill",
        value: "Trumpeter Hornbill",
        category: "NonBirdsOfPrey",
        plural: "Trumpeter Hornbills",
        quickAdd: []
    },
    {
        id: 664,
        label: "Tsessebe",
        value: "Tsessebe",
        category: "Nonpredator",
        plural: "Tsessebes",
        quickAdd: []
    },
    {
        id: 665,
        label: "Turner's Thick toed Gecko",
        value: "Turner's Thick toed Gecko",
        category: "Reptile",
        plural: "Turner's Thick toed Geckos",
        quickAdd: []
    },
    {
        id: 666,
        label: "Twig Snake",
        value: "Twig Snake",
        category: "Reptile",
        plural: "Twig Snakes",
        quickAdd: []
    },
    {
        id: 667,
        label: "Two striped Shovel snout",
        value: "Two striped Shovel snout",
        category: "Reptile",
        plural: "Two striped Shovel snouts",
        quickAdd: []
    },
    {
        id: 668,
        label: "Van Dam's Girdled Lizard",
        value: "Van Dam's Girdled Lizard",
        category: "Reptile",
        plural: "Van Dam's Girdled Lizards",
        quickAdd: []
    },
    {
        id: 669,
        label: "Variable Skink",
        value: "Variable Skink",
        category: "Reptile",
        plural: "Variable Skinks",
        quickAdd: []
    },
    {
        id: 670,
        label: "Verreaux's Eagle Owl",
        value: "Verreaux's Eagle Owl",
        category: "BirdsOfPrey",
        plural: "Verreaux's Eagle Owls",
        quickAdd: []
    },
    {
        id: 671,
        label: "Vervet Monkey",
        value: "Vervet Monkey",
        category: "Nonpredator",
        plural: "Vervet Monkeys",
        quickAdd: []
    },
    {
        id: 672,
        label: "Village (Spotted backed) Weaver",
        value: "Village (Spotted backed) Weaver",
        category: "NonBirdsOfPrey",
        plural: "Village (Spotted backed) Weavers",
        quickAdd: []
    },
    {
        id: 673,
        label: "Village Indigobird",
        value: "Village Indigobird",
        category: "NonBirdsOfPrey",
        plural: "Village Indigobirds",
        quickAdd: []
    },
    {
        id: 674,
        label: "Vine Snake",
        value: "Vine Snake",
        category: "Reptile",
        plural: "Vine Snakes",
        quickAdd: []
    },
    {
        id: 675,
        label: "Violet backed Starling",
        value: "Violet backed Starling",
        category: "NonBirdsOfPrey",
        plural: "Violet backed Starlings",
        quickAdd: []
    },
    {
        id: 676,
        label: "Violet eared Waxbill",
        value: "Violet eared Waxbill",
        category: "NonBirdsOfPrey",
        plural: "Violet eared Waxbills",
        quickAdd: []
    },
    {
        id: 677,
        label: "Wahlberg's Eagle",
        value: "Wahlberg's Eagle",
        category: "BirdsOfPrey",
        plural: "Wahlberg's Eagles",
        quickAdd: []
    },
    {
        id: 678,
        label: "Wahlberg's Epauletted Fruit Bat",
        value: "Wahlberg's Epauletted Fruit Bat",
        category: "Nonpredator",
        plural: "Wahlberg's Epauletted Fruit Bats",
        quickAdd: []
    },
    {
        id: 679,
        label: "Wahlberg's Snake eyed Skink",
        value: "Wahlberg's Snake eyed Skink",
        category: "Reptile",
        plural: "Wahlberg's Snake eyed Skinks",
        quickAdd: []
    },
    {
        id: 680,
        label: "Wahlbergs Velvet Gecko",
        value: "Wahlbergs Velvet Gecko",
        category: "Reptile",
        plural: "Wahlbergs Velvet Geckos",
        quickAdd: []
    },
    {
        id: 681,
        label: "Wailing Cisticola",
        value: "Wailing Cisticola",
        category: "NonBirdsOfPrey",
        plural: "Wailing Cisticolas",
        quickAdd: []
    },
    {
        id: 682,
        label: "Warthog",
        value: "Warthog",
        category: "Nonpredator",
        plural: "Warthogs",
        quickAdd: []
    },
    {
        id: 683,
        label: "Water Buffalo",
        value: "Water Buffalo",
        category: "Nonpredator",
        plural: "Water Buffaloes",
        quickAdd: []
    },
    {
        id: 684,
        label: "Water Mongoose",
        value: "Water Mongoose",
        category: "Nonpredator",
        plural: "Water Mongooses",
        quickAdd: []
    },
    {
        id: 685,
        label: "Water Monitor",
        value: "Water Monitor",
        category: "Reptile",
        plural: "Water Monitors",
        quickAdd: []
    },
    {
        id: 686,
        label: "Water Thick knee",
        value: "Water Thick knee",
        category: "NonBirdsOfPrey",
        plural: "Water Thick knees",
        quickAdd: []
    },
    {
        id: 687,
        label: "Waterberg Flat Lizard",
        value: "Waterberg Flat Lizard",
        category: "Reptile",
        plural: "Waterberg Flat Lizards",
        quickAdd: []
    },
    {
        id: 688,
        label: "Waterberg Girdled Lizard",
        value: "Waterberg Girdled Lizard",
        category: "Reptile",
        plural: "Waterberg Girdled Lizards",
        quickAdd: []
    },
    {
        id: 689,
        label: "Waterbuck",
        value: "Waterbuck",
        category: "Nonpredator",
        plural: "Waterbucks",
        quickAdd: []
    },
    {
        id: 690,
        label: "Wattled Starling",
        value: "Wattled Starling",
        category: "NonBirdsOfPrey",
        plural: "Wattled Starlings",
        quickAdd: []
    },
    {
        id: 691,
        label: "Western Stripe bellied Sand Snake",
        value: "Western Stripe bellied Sand Snake",
        category: "Reptile",
        plural: "Western Stripe bellied Sand Snakes",
        quickAdd: []
    },
    {
        id: 692,
        label: "Whiskered Tern",
        value: "Whiskered Tern",
        category: "NonBirdsOfPrey",
        plural: "Whiskered Terns",
        quickAdd: []
    },
    {
        id: 693,
        label: "White Stork",
        value: "White Stork",
        category: "NonBirdsOfPrey",
        plural: "White Storks",
        quickAdd: []
    },
    {
        id: 694,
        label: "White Throated Monitor",
        value: "White Throated Monitor",
        category: "Reptile",
        plural: "White Throated Monitors",
        quickAdd: []
    },
    {
        id: 695,
        label: "White backed Duck",
        value: "White backed Duck",
        category: "NonBirdsOfPrey",
        plural: "White backed Ducks",
        quickAdd: []
    },
    {
        id: 696,
        label: "White backed Mousebird",
        value: "White backed Mousebird",
        category: "NonBirdsOfPrey",
        plural: "White backed Mousebirds",
        quickAdd: []
    },
    {
        id: 697,
        label: "White backed night heron",
        value: "White backed night heron",
        category: "NonBirdsOfPrey",
        plural: "White backed night herons",
        quickAdd: []
    },
    {
        id: 698,
        label: "White backed Vulture",
        value: "White backed Vulture",
        category: "BirdsOfPrey",
        plural: "White backed Vultures",
        quickAdd: []
    },
    {
        id: 699,
        label: "White bellied Sunbird",
        value: "White bellied Sunbird",
        category: "NonBirdsOfPrey",
        plural: "White bellied Sunbirds",
        quickAdd: []
    },
    {
        id: 700,
        label: "White breasted Cormorant",
        value: "White breasted Cormorant",
        category: "NonBirdsOfPrey",
        plural: "White breasted Cormorants",
        quickAdd: []
    },
    {
        id: 701,
        label: "White breasted Cuckooshrike",
        value: "White breasted Cuckooshrike",
        category: "NonBirdsOfPrey",
        plural: "White breasted Cuckooshrikes",
        quickAdd: []
    },
    {
        id: 702,
        label: "White browed Scrub Robin",
        value: "White browed Scrub Robin",
        category: "NonBirdsOfPrey",
        plural: "White browed Scrub Robins",
        quickAdd: []
    },
    {
        id: 703,
        label: "White browed Sparrow weaver",
        value: "White browed Sparrow weaver",
        category: "NonBirdsOfPrey",
        plural: "White browed Sparrow weavers",
        quickAdd: []
    },
    {
        id: 704,
        label: "White crested Helmet Shrike",
        value: "White crested Helmet Shrike",
        category: "NonBirdsOfPrey",
        plural: "White crested Helmet Shrikes",
        quickAdd: []
    },
    {
        id: 705,
        label: "White crowned Shrike",
        value: "White crowned Shrike",
        category: "NonBirdsOfPrey",
        plural: "White crowned Shrikes",
        quickAdd: []
    },
    {
        id: 706,
        label: "White faced Duck",
        value: "White faced Duck",
        category: "NonBirdsOfPrey",
        plural: "White faced Ducks",
        quickAdd: []
    },
    {
        id: 707,
        label: "White fronted Bee eater",
        value: "White fronted Bee eater",
        category: "NonBirdsOfPrey",
        plural: "White fronted Bee eaters",
        quickAdd: []
    },
    {
        id: 708,
        label: "White fronted Plover",
        value: "White fronted Plover",
        category: "NonBirdsOfPrey",
        plural: "White fronted Plovers",
        quickAdd: []
    },
    {
        id: 709,
        label: "White headed Vulture",
        value: "White headed Vulture",
        category: "NonBirdsOfPrey",
        plural: "White headed Vultures",
        quickAdd: []
    },
    {
        id: 710,
        label: "White necked Raven",
        value: "White necked Raven",
        category: "NonBirdsOfPrey",
        plural: "White necked Ravens",
        quickAdd: []
    },
    {
        id: 711,
        label: "White rumped Swift",
        value: "White rumped Swift",
        category: "NonBirdsOfPrey",
        plural: "White rumped Swifts",
        quickAdd: []
    },
    {
        id: 712,
        label: "White tailed Mongoose",
        value: "White tailed Mongoose",
        category: "Nonpredator",
        plural: "White tailed Mongooses",
        quickAdd: []
    },
    {
        id: 713,
        label: "White throated Robin chat",
        value: "White throated Robin chat",
        category: "NonBirdsOfPrey",
        plural: "White throated Robin chats",
        quickAdd: []
    },
    {
        id: 714,
        label: "White throated Swallow",
        value: "White throated Swallow",
        category: "NonBirdsOfPrey",
        plural: "White throated Swallows",
        quickAdd: []
    },
    {
        id: 715,
        label: "White winged Tern",
        value: "White winged Tern",
        category: "NonBirdsOfPrey",
        plural: "White winged Terns",
        quickAdd: []
    },
    {
        id: 716,
        label: "White winged Widowbird",
        value: "White winged Widowbird",
        category: "NonBirdsOfPrey",
        plural: "White winged Widowbirds",
        quickAdd: []
    },
    {
        id: 717,
        label: "Wild Dog",
        value: "Wild Dog",
        category: "Predator",
        plural: "Wild Dogs",
        quickAdd: []
    },
    {
        id: 718,
        label: "Willow Warbler",
        value: "Willow Warbler",
        category: "NonBirdsOfPrey",
        plural: "Willow Warblers",
        quickAdd: []
    },
    {
        id: 719,
        label: "Wire tailed Swallow",
        value: "Wire tailed Swallow",
        category: "NonBirdsOfPrey",
        plural: "Wire tailed Swallows",
        quickAdd: []
    },
    {
        id: 720,
        label: "Wood Sandpiper",
        value: "Wood Sandpiper",
        category: "NonBirdsOfPrey",
        plural: "Wood Sandpipers",
        quickAdd: []
    },
    {
        id: 721,
        label: "Woodland Dormouse",
        value: "Woodland Dormouse",
        category: "Nonpredator",
        plural: "Woodland Dormice",
        quickAdd: []
    },
    {
        id: 722,
        label: "Woodland Kingfisher",
        value: "Woodland Kingfisher",
        category: "NonBirdsOfPrey",
        plural: "Woodland Kingfishers",
        quickAdd: []
    },
    {
        id: 723,
        label: "Woolly necked Stork",
        value: "Woolly necked Stork",
        category: "NonBirdsOfPrey",
        plural: "Woolly necked Storks",
        quickAdd: []
    },
    {
        id: 724,
        label: "Yellow Bishop",
        value: "Yellow Bishop",
        category: "NonBirdsOfPrey",
        plural: "Yellow Bishops",
        quickAdd: []
    },
    {
        id: 725,
        label: "Yellow Canary",
        value: "Yellow Canary",
        category: "NonBirdsOfPrey",
        plural: "Yellow Canaries",
        quickAdd: []
    },
    {
        id: 726,
        label: "Yellow Wagtail",
        value: "Yellow Wagtail",
        category: "NonBirdsOfPrey",
        plural: "Yellow Wagtails",
        quickAdd: []
    },
    {
        id: 727,
        label: "Yellow bellied Greenbul",
        value: "Yellow bellied Greenbul",
        category: "NonBirdsOfPrey",
        plural: "Yellow bellied Greenbuls",
        quickAdd: []
    },
    {
        id: 728,
        label: "Yellow billed (Intermediate) Egret",
        value: "Yellow billed (Intermediate) Egret",
        category: "NonBirdsOfPrey",
        plural: "Yellow billed (Intermediate) Egrets",
        quickAdd: []
    },
    {
        id: 729,
        label: "Yellow billed Duck",
        value: "Yellow billed Duck",
        category: "NonBirdsOfPrey",
        plural: "Yellow billed Ducks",
        quickAdd: []
    },
    {
        id: 730,
        label: "Yellow billed Eremomela",
        value: "Yellow billed Eremomela",
        category: "NonBirdsOfPrey",
        plural: "Yellow billed Eremomelas",
        quickAdd: []
    },
    {
        id: 731,
        label: "Yellow billed Hornbill",
        value: "Yellow billed Hornbill",
        category: "NonBirdsOfPrey",
        plural: "Yellow billed Hornbills",
        quickAdd: []
    },
    {
        id: 732,
        label: "Yellow billed Kite",
        value: "Yellow billed Kite",
        category: "BirdsOfPrey",
        plural: "Yellow billed Kites",
        quickAdd: []
    },
    {
        id: 733,
        label: "Yellow billed Oxpecker",
        value: "Yellow billed Oxpecker",
        category: "NonBirdsOfPrey",
        plural: "Yellow billed Oxpeckers",
        quickAdd: []
    },
    {
        id: 734,
        label: "Yellow Billed Stork",
        value: "Yellow Billed Stork",
        category: "NonBirdsOfPrey",
        plural: "Yellow Billed Storks",
        quickAdd: []
    },
    {
        id: 735,
        label: "Yellow breasted Apalis",
        value: "Yellow breasted Apalis",
        category: "NonBirdsOfPrey",
        plural: "Yellow breasted Apalis",
        quickAdd: []
    },
    {
        id: 736,
        label: "Yellow crowned (Golden) Bishop",
        value: "Yellow crowned (Golden) Bishop",
        category: "NonBirdsOfPrey",
        plural: "Yellow crowned (Golden) Bishops",
        quickAdd: []
    },
    {
        id: 737,
        label: "Yellow fronted (Yellow eyed) Canary",
        value: "Yellow fronted (Yellow eyed) Canary",
        category: "NonBirdsOfPrey",
        plural: "Yellow fronted (Yellow eyed) Canaries",
        quickAdd: []
    },
    {
        id: 738,
        label: "Yellow fronted Tinkerbird",
        value: "Yellow fronted Tinkerbird",
        category: "NonBirdsOfPrey",
        plural: "Yellow fronted Tinkerbirds",
        quickAdd: []
    },
    {
        id: 739,
        label: "Yellow rumped (Golden rumped) Tinkerbird",
        value: "Yellow rumped (Golden rumped) Tinkerbird",
        category: "NonBirdsOfPrey",
        plural: "Yellow rumped (Golden rumped) Tinkerbirds",
        quickAdd: []
    },
    {
        id: 740,
        label: "Yellow sppt Hyrax",
        value: "Yellow sppt Hyrax",
        category: "Nonpredator",
        plural: "Yellow sppt Hyraxes",
        quickAdd: []
    },
    {
        id: 741,
        label: "Yellow throated Longclaw",
        value: "Yellow throated Longclaw",
        category: "NonBirdsOfPrey",
        plural: "Yellow throated Longclaws",
        quickAdd: []
    },
    {
        id: 742,
        label: "Yellow throated Petronia",
        value: "Yellow throated Petronia",
        category: "NonBirdsOfPrey",
        plural: "Yellow throated Petronias",
        quickAdd: []
    },
    {
        id: 743,
        label: "Yellow throated Plated Lizard",
        value: "Yellow throated Plated Lizard",
        category: "Reptile",
        plural: "Yellow throated Plated Lizards",
        quickAdd: []
    },
    {
        id: 744,
        label: "Yellow throated Sandgrouse",
        value: "Yellow throated Sandgrouse",
        category: "NonBirdsOfPrey",
        plural: "Yellow throated Sandgrouses",
        quickAdd: []
    },
    {
        id: 745,
        label: "Zitting Cisticola",
        value: "Zitting Cisticola",
        category: "NonBirdsOfPrey",
        plural: "Zitting Cisticolas",
        quickAdd: []
    },
    {
        id: 746,
        label: "Vulture",
        value: "Vulture",
        category: "BirdsOfPrey",
        plural: "Vultures",
        quickAdd: []
    },
    {
        id: 747,
        label: "Zebra",
        value: "Zebra",
        category: "Nonpredator",
        plural: "Zebras",
        quickAdd: []
    },
    {
        id: 748,
        label: "Common Ostrich",
        value: "Common Ostrich",
        category: "NonBirdsOfPrey",
        plural: "Common Ostriches",
        quickAdd: []
    },
    {
        id: 749,
        label: "Ant",
        value: "Ant",
        category: "Insects",
        plural: "Ants",
        quickAdd: []
    },
    {
        id: 750,
        label: "Dung Beetle",
        value: "Dung Beetle",
        category: "Insects",
        plural: "Dung Beetles",
        quickAdd: []
    },
    {
        id: 751,
        label: "Spider",
        value: "Spider",
        category: "Insects",
        plural: "Spiders",
        quickAdd: []
    },
    {
        id: 752,
        label: "Beetle",
        value: "Beetle",
        category: "Insects",
        plural: "Beetles",
        quickAdd: []
    },
    {
        id: 753,
        label: "Butterfly",
        value: "Butterfly",
        category: "Insects",
        plural: "Butterflies",
        quickAdd: []
    },
    {
        id: 754,
        label: "Moth",
        value: "Moth",
        category: "Insects",
        plural: "Moths",
        quickAdd: []
    },
    {
        id: 755,
        label: "Bug",
        value: "Bug",
        category: "Insects",
        plural: "Bugs",
        quickAdd: []
    },
    {
        id: 756,
        label: "Scorpion",
        value: "Scorpion",
        category: "Insects",
        plural: "Scorpions",
        quickAdd: []
    },
    {
        id: 757,
        label: "Worm",
        value: "Worm",
        category: "Insects",
        plural: "Worms",
        quickAdd: []
    },
    {
        id: 758,
        label: "Caterpillar",
        value: "Caterpillar",
        category: "Insects",
        plural: "Caterpillars",
        quickAdd: []
    },
    {
        id: 759,
        label: "Mopani Worm",
        value: "Mopani Worm",
        category: "Insects",
        plural: "Mopani Worms",
        quickAdd: []
    },
    {
        id: 760,
        label: "Legless Skink",
        value: "Legless Skink",
        category: "Reptile",
        plural: "Legless Skinks",
        quickAdd: []
    }
    ,
    {
        id: 761,
        label: "Wolf",
        value: "Wolf",
        category: "Predator",
        plural: "Wolves",
        quickAdd: []
    },
    {
        id: 762,
        label: "Bison",
        value: "Bison",
        category: "Nonpredator",
        plural: "Bisons",
        quickAdd: []
    },
    {
        id: 763,
        label: "Black bear",
        value: "Black bear",
        category: "Predator",
        plural: "Black bears",
        quickAdd: []
    },
    {
        id: 764,
        label: "Grizzly bear",
        value: "Grizzly bear",
        category: "Predator",
        plural: "Grizzly bears",
        quickAdd: []
    },
    {
        id: 765,
        label: "Elk",
        value: "Elk",
        category: "Nonpredator",
        plural: "Elks",
        quickAdd: []
    },
    {
        id: 766,
        label: "Moose",
        value: "Moose",
        category: "Nonpredator",
        plural: "Mooses",
        quickAdd: []
    },
    {
        id: 767,
        label: "Cougar",
        value: "Cougar",
        category: "Predator",
        plural: "Cougars",
        quickAdd: []
    },
    {
        id: 768,
        label: "Coyote",
        value: "Coyote",
        category: "Predator",
        plural: "Coyotes",
        quickAdd: []
    },
    {
        id: 769,
        label: "Pronghorn",
        value: "Pronghorn",
        category: "Nonpredator",
        plural: "Pronghorns",
        quickAdd: []
    },
    {
        id: 770,
        label: "Bobcat",
        value: "Bobcat",
        category: "Predator",
        plural: "Bobcats",
        quickAdd: []
    },
    {
        id: 771,
        label: "Red fox",
        value: "Red fox",
        category: "Predator",
        plural: "Red foxes",
        quickAdd: []
    },
    {
        id: 772,
        label: "Bighorn sheep",
        value: "Bighorn sheep",
        category: "Nonpredator",
        plural: "Bighorn sheep",
        quickAdd: []
    },
    {
        id: 773,
        label: "Bald eagle",
        value: "Bald eagle",
        category: "BirdsOfPrey",
        plural: "Bald eagles",
        quickAdd: []
    },
    {
        id: 774,
        label: "Lynx",
        value: "Lynx",
        category: "Predator",
        plural: "Lynxes",
        quickAdd: []
    },
    {
        id: 775,
        label: "Trumpeter swan",
        value: "Trumpeter swan",
        category: "NonBirdsOfPrey",
        plural: "Trumpeter swans",
        quickAdd: []
    },
    {
        id: 776,
        label: "Sandhill crane",
        value: "Sandhill crane",
        category: "NonBirdsOfPrey",
        plural: "Sandhill cranes",
        quickAdd: []
    },
    {
        id: 777,
        label: "North American river otter",
        value: "North American river otter",
        category: "Nonpredator",
        plural: "North American river otters",
        quickAdd: []
    },
    {
        id: 778,
        label: "Yellow bellied marmot",
        value: "Yellow bellied marmot",
        category: "Nonpredator",
        plural: "Yellow bellied marmots",
        quickAdd: []
    },
    {
        id: 779,
        label: "Great horned owl",
        value: "Great horned owl",
        category: "BirdsOfPrey",
        plural: "Great horned owls",
        quickAdd: []
    },
    {
        id: 780,
        label: "Snowshoe hare",
        value: "Snowshoe hare",
        category: "Nonpredator",
        plural: "Snowshoe hares",
        quickAdd: []
    },
    {
        id: 781,
        label: "American beaver",
        value: "American beaver",
        category: "Nonpredator",
        plural: "American beavers",
        quickAdd: []
    },
    {
        id: 782,
        label: "Deer",
        value: "Deer",
        category: "Nonpredator",
        plural: "Deers",
        quickAdd: []
    },
    {id:783,label:"Abbott's Starling",value:"Abbott's Starling",category:"NonBirdsOfPrey",plural:"Abbott's Starlings"},{id:784,label:"Aberdare Cisticola",value:"Aberdare Cisticola",category:"NonBirdsOfPrey",plural:"Aberdare Cisticolas"},{id:785,label:"Abyssinian Catbird",value:"Abyssinian Catbird",category:"NonBirdsOfPrey",plural:"Abyssinian Catbirds"},{id:786,label:"Abyssinian Crimsonwing",value:"Abyssinian Crimsonwing",category:"NonBirdsOfPrey",plural:"Abyssinian Crimsonwings"},{id:787,label:"Abyssinian Ground-Hornbill",value:"Abyssinian Ground-Hornbill",category:"NonBirdsOfPrey",plural:"Abyssinian Ground-Hornbills"},{id:788,label:"Abyssinian Ground-Thrush",value:"Abyssinian Ground-Thrush",category:"NonBirdsOfPrey",plural:"Abyssinian Ground-Thrushes"},{id:789,label:"Abyssinian Longclaw",value:"Abyssinian Longclaw",category:"NonBirdsOfPrey",plural:"Abyssinian Longclaws"},{id:790,label:"Abyssinian Nightjar",value:"Abyssinian Nightjar",category:"NonBirdsOfPrey",plural:"Abyssinian Nightjars"},{id:791,label:"Abyssinian Owl",value:"Abyssinian Owl",category:"BirdsOfPrey",plural:"Abyssinian Owls"},{id:792,label:"Abyssinian Roller",value:"Abyssinian Roller",category:"NonBirdsOfPrey",plural:"Abyssinian Rollers"},{id:793,label:"Abyssinian Scimitarbill",value:"Abyssinian Scimitarbill",category:"NonBirdsOfPrey",plural:"Abyssinian Scimitarbills"},{id:794,label:"Abyssinian Slaty-Flycatcher",value:"Abyssinian Slaty-Flycatcher",category:"NonBirdsOfPrey",plural:"Abyssinian Slaty-Flycatchers"},{id:795,label:"Abyssinian Thrush",value:"Abyssinian Thrush",category:"NonBirdsOfPrey",plural:"Abyssinian Thrushes"},{id:796,label:"Abyssinian Wheatear",value:"Abyssinian Wheatear",category:"NonBirdsOfPrey",plural:"Abyssinian Wheatears"},{id:797,label:"Abyssinian White-eye",value:"Abyssinian White-eye",category:"NonBirdsOfPrey",plural:"Abyssinian White-eyes"},{id:798,label:"Abyssinian Woodpecker",value:"Abyssinian Woodpecker",category:"NonBirdsOfPrey",plural:"Abyssinian Woodpeckers"},{id:799,label:"Adamawa Turtle-Dove",value:"Adamawa Turtle-Dove",category:"NonBirdsOfPrey",plural:"Adamawa Turtle-Doves"},{id:800,label:"Adelie Penguin",value:"Adelie Penguin",category:"NonBirdsOfPrey",plural:"Adelie Penguins"},{id:801,label:"Afep Pigeon",value:"Afep Pigeon",category:"NonBirdsOfPrey",plural:"Afep Pigeons"},{id:802,label:"African Bare-eyed Thrush",value:"African Bare-eyed Thrush",category:"NonBirdsOfPrey",plural:"African Bare-eyed Thrushes"},{id:803,label:"African Black Oystercatcher",value:"African Black Oystercatcher",category:"NonBirdsOfPrey",plural:"African Black Oystercatchers"},{id:804,label:"African Black-headed Oriole",value:"African Black-headed Oriole",category:"NonBirdsOfPrey",plural:"African Black-headed Orioles"},{id:805,label:"African Blue Flycatcher",value:"African Blue Flycatcher",category:"NonBirdsOfPrey",plural:"African Blue Flycatchers"},{id:806,label:"African Blue Tit",value:"African Blue Tit",category:"NonBirdsOfPrey",plural:"African Blue Tits"},{id:807,label:"African Broadbill",value:"African Broadbill",category:"NonBirdsOfPrey",plural:"African Broadbills"},{id:808,label:"African Citril",value:"African Citril",category:"NonBirdsOfPrey",plural:"African Citrils"},{id:809,label:"African Collared-Dove",value:"African Collared-Dove",category:"NonBirdsOfPrey",plural:"African Collared-Doves"},{id:810,label:"African Crested-Flycatcher",value:"African Crested-Flycatcher",category:"NonBirdsOfPrey",plural:"African Crested-Flycatchers"},{id:811,label:"African Desert Warbler",value:"African Desert Warbler",category:"NonBirdsOfPrey",plural:"African Desert Warblers"},{id:812,label:"African Dwarf Kingfisher",value:"African Dwarf Kingfisher",category:"NonBirdsOfPrey",plural:"African Dwarf Kingfishers"},{id:813,label:"African Emerald Cuckoo",value:"African Emerald Cuckoo",category:"NonBirdsOfPrey",plural:"African Emerald Cuckoos"},{id:814,label:"African Forest-Flycatcher",value:"African Forest-Flycatcher",category:"NonBirdsOfPrey",plural:"African Forest-Flycatchers"},{id:815,label:"African Golden-Weaver",value:"African Golden-Weaver",category:"NonBirdsOfPrey",plural:"African Golden-Weavers"},{id:816,label:"African Gray Flycatcher",value:"African Gray Flycatcher",category:"NonBirdsOfPrey",plural:"African Gray Flycatchers"},{id:817,label:"African Gray Woodpecker",value:"African Gray Woodpecker",category:"NonBirdsOfPrey",plural:"African Gray Woodpeckers"},{id:818,label:"African Green-Pigeon",value:"African Green-Pigeon",category:"NonBirdsOfPrey",plural:"African Green-Pigeons"},{id:819,label:"African Hill Babbler",value:"African Hill Babbler",category:"NonBirdsOfPrey",plural:"African Hill Babblers"},{id:820,label:"African Hobby",value:"African Hobby",category:"NonBirdsOfPrey",plural:"African Hobbies"},{id:821,label:"African Oystercatcher",value:"African Oystercatcher",category:"NonBirdsOfPrey",plural:"African Oystercatchers"},{id:822,label:"African Penduline-Tit",value:"African Penduline-Tit",category:"NonBirdsOfPrey",plural:"African Penduline-Tits"},{id:823,label:"African Penguin",value:"African Penguin",category:"NonBirdsOfPrey",plural:"African Penguins"},{id:824,label:"African Piculet",value:"African Piculet",category:"NonBirdsOfPrey",plural:"African Piculets"},{id:825,label:"African Pied Hornbill",value:"African Pied Hornbill",category:"NonBirdsOfPrey",plural:"African Pied Hornbills"},{id:826,label:"African Quailfinch",value:"African Quailfinch",category:"NonBirdsOfPrey",plural:"African Quailfinches"},{id:827,label:"African Reed Warbler",value:"African Reed Warbler",category:"NonBirdsOfPrey",plural:"African Reed Warblers"},{id:828,label:"African Reed-Warbler",value:"African Reed-Warbler",category:"NonBirdsOfPrey",plural:"African Reed-Warblers"},{id:829,label:"African River Martin",value:"African River Martin",category:"NonBirdsOfPrey",plural:"African River Martins"},{id:830,label:"African Rock Pipit",value:"African Rock Pipit",category:"NonBirdsOfPrey",plural:"African Rock Pipits"},{id:831,label:"African Shrike-flycatcher",value:"African Shrike-flycatcher",category:"NonBirdsOfPrey",plural:"African Shrike-flycatchers"},{id:832,label:"African Silverbill",value:"African Silverbill",category:"NonBirdsOfPrey",plural:"African Silverbills"},{id:833,label:"African Spotted Creeper",value:"African Spotted Creeper",category:"NonBirdsOfPrey",plural:"African Spotted Creepers"},{id:834,label:"African Swamphen",value:"African Swamphen",category:"NonBirdsOfPrey",plural:"African Swamphens"},{id:835,label:"African Swift",value:"African Swift",category:"NonBirdsOfPrey",plural:"African Swifts"},{id:836,label:"African Tailorbird",value:"African Tailorbird",category:"NonBirdsOfPrey",plural:"African Tailorbirds"},{id:837,label:"African Thrush",value:"African Thrush",category:"NonBirdsOfPrey",plural:"African Thrushes"},{id:838,label:"African Yellow White-eye",value:"African Yellow White-eye",category:"NonBirdsOfPrey",plural:"African Yellow White-eyes"},{id:839,label:"African Yellow-Warbler",value:"African Yellow-Warbler",category:"NonBirdsOfPrey",plural:"African Yellow-Warblers"},{id:840,label:"Agulhas Lark",value:"Agulhas Lark",category:"NonBirdsOfPrey",plural:"Agulhas Larks"},{id:841,label:"Agulhas Long-billed Lark",value:"Agulhas Long-billed Lark",category:"NonBirdsOfPrey",plural:"Agulhas Long-billed Larks"},{id:842,label:"Ahanta Francolin",value:"Ahanta Francolin",category:"NonBirdsOfPrey",plural:"Ahanta Francolins"},{id:843,label:"Akun Eagle-Owl",value:"Akun Eagle-Owl",category:"BirdsOfPrey",plural:"Akun Eagle-Owls"},{id:844,label:"Albertine Boubou",value:"Albertine Boubou",category:"NonBirdsOfPrey",plural:"Albertine Boubous"},{id:845,label:"Albertine Owlet",value:"Albertine Owlet",category:"BirdsOfPrey",plural:"Albertine Owlets"},{id:846,label:"Alexandrine Parakeet",value:"Alexandrine Parakeet",category:"NonBirdsOfPrey",plural:"Alexandrine Parakeets"},{id:847,label:"Algerian Nuthatch",value:"Algerian Nuthatch",category:"NonBirdsOfPrey",plural:"Algerian Nuthatches"},{id:848,label:"Alpine Accentor",value:"Alpine Accentor",category:"NonBirdsOfPrey",plural:"Alpine Accentors"},{id:849,label:"Amani Sunbird",value:"Amani Sunbird",category:"NonBirdsOfPrey",plural:"Amani Sunbirds"},{id:850,label:"American Bittern",value:"American Bittern",category:"NonBirdsOfPrey",plural:"American Bitterns"},{id:851,label:"American Black Duck",value:"American Black Duck",category:"NonBirdsOfPrey",plural:"American Black Ducks"},{id:852,label:"American Golden Plover",value:"American Golden Plover",category:"NonBirdsOfPrey",plural:"American Golden Plovers"},{id:853,label:"American Golden-Plover",value:"American Golden-Plover",category:"NonBirdsOfPrey",plural:"American Golden-Plovers"},{id:854,label:"American Pipit",value:"American Pipit",category:"NonBirdsOfPrey",plural:"American Pipits"},{id:855,label:"American Purple Gallinule",value:"American Purple Gallinule",category:"NonBirdsOfPrey",plural:"American Purple Gallinules"},{id:856,label:"American Wigeon",value:"American Wigeon",category:"NonBirdsOfPrey",plural:"American Wigeons"},{id:857,label:"Amethyst Sunbird",value:"Amethyst Sunbird",category:"NonBirdsOfPrey",plural:"Amethyst Sunbirds"},
    {id:858,label:"Anambra Waxbill",value:"Anambra Waxbill",category:"NonBirdsOfPrey",plural:"Anambra Waxbills"},{id:859,label:"Anchieta's Barbet",value:"Anchieta's Barbet",category:"NonBirdsOfPrey",plural:"Anchieta's Barbets"},{id:860,label:"Anchieta's Sunbird",value:"Anchieta's Sunbird",category:"NonBirdsOfPrey",plural:"Anchieta's Sunbirds"},{id:861,label:"Anchieta's Tchagra",value:"Anchieta's Tchagra",category:"NonBirdsOfPrey",plural:"Anchieta's Tchagras"},{id:862,label:"Angola Batis",value:"Angola Batis",category:"NonBirdsOfPrey",plural:"Angola Batis"},{id:863,label:"Angola Cave-Chat",value:"Angola Cave-Chat",category:"NonBirdsOfPrey",plural:"Angola Cave-Chats"},{id:864,label:"Angola Helmetshrike",value:"Angola Helmetshrike",category:"NonBirdsOfPrey",plural:"Angola Helmetshrikes"},{id:865,label:"Angola Lark",value:"Angola Lark",category:"NonBirdsOfPrey",plural:"Angola Larks"},{id:866,label:"Angola Slaty-Flycatcher",value:"Angola Slaty-Flycatcher",category:"NonBirdsOfPrey",plural:"Angola Slaty-Flycatchers"},{id:867,label:"Angola Swallow",value:"Angola Swallow",category:"NonBirdsOfPrey",plural:"Angola Swallows"},{id:868,label:"Angola Waxbill",value:"Angola Waxbill",category:"NonBirdsOfPrey",plural:"Angola Waxbills"},{id:869,label:"Ankober Serin",value:"Ankober Serin",category:"NonBirdsOfPrey",plural:"Ankober Serins"},{id:870,label:"Annobon White-eye",value:"Annobon White-eye",category:"NonBirdsOfPrey",plural:"Annobon White-eyes"},{id:871,label:"Ansorge's Greenbul",value:"Ansorge's Greenbul",category:"NonBirdsOfPrey",plural:"Ansorge's Greenbuls"},{id:872,label:"Antarctic Petrel",value:"Antarctic Petrel",category:"NonBirdsOfPrey",plural:"Antarctic Petrels"},{id:873,label:"Antarctic Prion",value:"Antarctic Prion",category:"NonBirdsOfPrey",plural:"Antarctic Prions"},{id:874,label:"Antarctic Tern",value:"Antarctic Tern",category:"NonBirdsOfPrey",plural:"Antarctic Terns"},{id:875,label:"Aquatic Warbler",value:"Aquatic Warbler",category:"NonBirdsOfPrey",plural:"Aquatic Warblers"},{id:876,label:"Arabian Babbler",value:"Arabian Babbler",category:"NonBirdsOfPrey",plural:"Arabian Babblers"},{id:877,label:"Arabian Bustard",value:"Arabian Bustard",category:"NonBirdsOfPrey",plural:"Arabian Bustards"},{id:878,label:"Arabian Golden Sparrow",value:"Arabian Golden Sparrow",category:"NonBirdsOfPrey",plural:"Arabian Golden Sparrows"},{id:879,label:"Arabian Partridge",value:"Arabian Partridge",category:"NonBirdsOfPrey",plural:"Arabian Partridges"},{id:880,label:"Arabian Warbler",value:"Arabian Warbler",category:"NonBirdsOfPrey",plural:"Arabian Warblers"},{id:881,label:"Archer's Buzzard",value:"Archer's Buzzard",category:"BirdsOfPrey",plural:"Archer's Buzzards"},{id:882,label:"Archer's Robin-Chat",value:"Archer's Robin-Chat",category:"NonBirdsOfPrey",plural:"Archer's Robin-Chats"},{id:883,label:"Arctic Loon",value:"Arctic Loon",category:"NonBirdsOfPrey",plural:"Arctic Loons"},{id:884,label:"Arctic Tern",value:"Arctic Tern",category:"NonBirdsOfPrey",plural:"Arctic Terns"},{id:885,label:"Arctic Warbler",value:"Arctic Warbler",category:"NonBirdsOfPrey",plural:"Arctic Warblers"},{id:886,label:"Armenian Gull",value:"Armenian Gull",category:"NonBirdsOfPrey",plural:"Armenian Gulls"},{id:887,label:"Ascension Frigatebird",value:"Ascension Frigatebird",category:"NonBirdsOfPrey",plural:"Ascension Frigatebirds"},{id:888,label:"Ash's Lark",value:"Ash's Lark",category:"NonBirdsOfPrey",plural:"Ash's Larks"},{id:889,label:"Ashy Cisticola",value:"Ashy Cisticola",category:"NonBirdsOfPrey",plural:"Ashy Cisticolas"},{id:890,label:"Ashy Tit",value:"Ashy Tit",category:"NonBirdsOfPrey",plural:"Ashy Tits"},{id:891,label:"Asian Desert Warbler",value:"Asian Desert Warbler",category:"NonBirdsOfPrey",plural:"Asian Desert Warblers"},{id:892,label:"Asian Dowitcher",value:"Asian Dowitcher",category:"NonBirdsOfPrey",plural:"Asian Dowitchers"},{id:893,label:"Asiatic Dowitcher",value:"Asiatic Dowitcher",category:"NonBirdsOfPrey",plural:"Asiatic Dowitchers"},{id:894,label:"Atlantic Albatross",value:"Atlantic Albatross",category:"NonBirdsOfPrey",plural:"Atlantic Albatrosses"},{id:895,label:"Atlantic Petrel",value:"Atlantic Petrel",category:"NonBirdsOfPrey",plural:"Atlantic Petrels"},{id:896,label:"Atlantic Puffin",value:"Atlantic Puffin",category:"NonBirdsOfPrey",plural:"Atlantic Puffins"},{id:897,label:"Atlas Flycatcher",value:"Atlas Flycatcher",category:"NonBirdsOfPrey",plural:"Atlas Flycatchers"},{id:898,label:"Audouin's Gull",value:"Audouin's Gull",category:"NonBirdsOfPrey",plural:"Audouin's Gulls"},{id:899,label:"Augur Buzzard",value:"Augur Buzzard",category:"BirdsOfPrey",plural:"Augur Buzzards"},{id:900,label:"Australasian Gannet",value:"Australasian Gannet",category:"NonBirdsOfPrey",plural:"Australasian Gannets"},{id:901,label:"Australian Gannet",value:"Australian Gannet",category:"NonBirdsOfPrey",plural:"Australian Gannets"},{id:902,label:"Babbling Starling",value:"Babbling Starling",category:"NonBirdsOfPrey",plural:"Babbling Starlings"},{id:903,label:"Baglafecht Weaver",value:"Baglafecht Weaver",category:"NonBirdsOfPrey",plural:"Baglafecht Weavers"},{id:904,label:"Baka Indigobird",value:"Baka Indigobird",category:"NonBirdsOfPrey",plural:"Baka Indigobirds"},{id:905,label:"Balearic Shearwater",value:"Balearic Shearwater",category:"NonBirdsOfPrey",plural:"Balearic Shearwaters"},{id:906,label:"Balearic Warbler",value:"Balearic Warbler",category:"NonBirdsOfPrey",plural:"Balearic Warblers"},{id:907,label:"Ballman's Malimbe",value:"Ballman's Malimbe",category:"NonBirdsOfPrey",plural:"Ballman's Malimbes"},{id:908,label:"Bamboo Warbler",value:"Bamboo Warbler",category:"NonBirdsOfPrey",plural:"Bamboo Warblers"},{id:909,label:"Bamenda Apalis",value:"Bamenda Apalis",category:"NonBirdsOfPrey",plural:"Bamenda Apalis"},{id:910,label:"Band-rumped Storm-Petrel",value:"Band-rumped Storm-Petrel",category:"NonBirdsOfPrey",plural:"Band-rumped Storm-Petrels"},{id:911,label:"Banded Barbet",value:"Banded Barbet",category:"NonBirdsOfPrey",plural:"Banded Barbets"},{id:912,label:"Banded Parisoma",value:"Banded Parisoma",category:"NonBirdsOfPrey",plural:"Banded Parisomas"},{id:913,label:"Banded Prinia",value:"Banded Prinia",category:"NonBirdsOfPrey",plural:"Banded Prinias"},{id:914,label:"Banded Sunbird",value:"Banded Sunbird",category:"NonBirdsOfPrey",plural:"Banded Sunbirds"},{id:915,label:"Banded Wattle-eye",value:"Banded Wattle-eye",category:"NonBirdsOfPrey",plural:"Banded Wattle-eyes"},{id:916,label:"Bangwa Warbler",value:"Bangwa Warbler",category:"NonBirdsOfPrey",plural:"Bangwa Warblers"},{id:917,label:"Bank Cormorant",value:"Bank Cormorant",category:"NonBirdsOfPrey",plural:"Bank Cormorants"},{id:918,label:"Bank Swallow",value:"Bank Swallow",category:"NonBirdsOfPrey",plural:"Bank Swallows"},{id:919,label:"Bannerman's Sunbird",value:"Bannerman's Sunbird",category:"NonBirdsOfPrey",plural:"Bannerman's Sunbirds"},{id:920,label:"Bannerman's Turaco",value:"Bannerman's Turaco",category:"NonBirdsOfPrey",plural:"Bannerman's Turacos"},{id:921,label:"Bannerman's Weaver",value:"Bannerman's Weaver",category:"NonBirdsOfPrey",plural:"Bannerman's Weavers"},{id:922,label:"Bar-breasted Firefinch",value:"Bar-breasted Firefinch",category:"NonBirdsOfPrey",plural:"Bar-breasted Firefinches"},{id:923,label:"Bar-headed Goose",value:"Bar-headed Goose",category:"NonBirdsOfPrey",plural:"Bar-headed Geese"},{id:924,label:"Bar-tailed Godwit",value:"Bar-tailed Godwit",category:"NonBirdsOfPrey",plural:"Bar-tailed Godwits"},{id:925,label:"Bar-tailed Lark",value:"Bar-tailed Lark",category:"NonBirdsOfPrey",plural:"Bar-tailed Larks"},{id:926,label:"Bar-tailed Trogon",value:"Bar-tailed Trogon",category:"NonBirdsOfPrey",plural:"Bar-tailed Trogons"},{id:927,label:"Bar-winged Weaver",value:"Bar-winged Weaver",category:"NonBirdsOfPrey",plural:"Bar-winged Weavers"},{id:928,label:"Barau's Petrel",value:"Barau's Petrel",category:"NonBirdsOfPrey",plural:"Barau's Petrels"},{id:929,label:"Barbary Partridge",value:"Barbary Partridge",category:"NonBirdsOfPrey",plural:"Barbary Partridges"},{id:930,label:"Bare-cheeked Babbler",value:"Bare-cheeked Babbler",category:"NonBirdsOfPrey",plural:"Bare-cheeked Babblers"},{id:931,label:"Bare-cheeked Trogon",value:"Bare-cheeked Trogon",category:"NonBirdsOfPrey",plural:"Bare-cheeked Trogons"},{id:932,label:"Bare-faced Go-away-bird",value:"Bare-faced Go-away-bird",category:"NonBirdsOfPrey",plural:"Bare-faced Go-away-birds"},{id:933,label:"Barlow's Lark",value:"Barlow's Lark",category:"NonBirdsOfPrey",plural:"Barlow's Larks"},{id:934,label:"Barnacle Goose",value:"Barnacle Goose",category:"NonBirdsOfPrey",plural:"Barnacle Geese"},{id:935,label:"Barolo Shearwater",value:"Barolo Shearwater",category:"NonBirdsOfPrey",plural:"Barolo Shearwaters"},{id:936,label:"Barratt's Warbler",value:"Barratt's Warbler",category:"NonBirdsOfPrey",plural:"Barratt's Warblers"},{id:937,label:"Barred Long-tailed Cuckoo",value:"Barred Long-tailed Cuckoo",category:"NonBirdsOfPrey",plural:"Barred Long-tailed Cuckoos"},{id:938,label:"Barred Warbler",value:"Barred Warbler",category:"NonBirdsOfPrey",plural:"Barred Warblers"},
    {id:939,label:"Barrow's Korhaan",value:"Barrow's Korhaan",category:"NonBirdsOfPrey",plural:"Barrow's Korhaans"},{id:940,label:"Basra Reed Warbler",value:"Basra Reed Warbler",category:"NonBirdsOfPrey",plural:"Basra Reed Warblers"},{id:941,label:"Basra Reed Warblers",value:"Basra Reed Warblers",category:"NonBirdsOfPrey",plural:"Louisiana Waterthrushes"},{id:942,label:"Basra Reed-Warbler",value:"Basra Reed-Warbler",category:"NonBirdsOfPrey",plural:"Basra Reed-Warblers"},{id:943,label:"Bat-like Spinetail",value:"Bat-like Spinetail",category:"NonBirdsOfPrey",plural:"Bat-like Spinetails"},{id:944,label:"Bates's Nightjar",value:"Bates's Nightjar",category:"NonBirdsOfPrey",plural:"Bates's Nightjars"},{id:945,label:"Bates's Paradise-Flycatcher",value:"Bates's Paradise-Flycatcher",category:"NonBirdsOfPrey",plural:"Bates's Paradise-Flycatchers"},{id:946,label:"Bates's Sunbird",value:"Bates's Sunbird",category:"NonBirdsOfPrey",plural:"Bates's Sunbirds"},{id:947,label:"Bates's Swift",value:"Bates's Swift",category:"NonBirdsOfPrey",plural:"Bates's Swifts"},{id:948,label:"Bates's Weaver",value:"Bates's Weaver",category:"NonBirdsOfPrey",plural:"Bates's Weavers"},{id:949,label:"Baumann's Greenbul",value:"Baumann's Greenbul",category:"NonBirdsOfPrey",plural:"Baumann's Greenbuls"},{id:950,label:"Bearded Barbet",value:"Bearded Barbet",category:"NonBirdsOfPrey",plural:"Bearded Barbets"},{id:951,label:"Bearded Reedling",value:"Bearded Reedling",category:"NonBirdsOfPrey",plural:"Bearded Reedlings"},{id:952,label:"Bearded Vulture",value:"Bearded Vulture",category:"BirdsOfPrey",plural:"Bearded Vultures"},{id:953,label:"Beaudouin's Snake-Eagle",value:"Beaudouin's Snake-Eagle",category:"BirdsOfPrey",plural:"Beaudouin's Snake-Eagles"},{id:954,label:"Beautiful Sunbird",value:"Beautiful Sunbird",category:"NonBirdsOfPrey",plural:"Beautiful Sunbirds"},{id:955,label:"Bedford's Paradise-Flycatcher",value:"Bedford's Paradise-Flycatcher",category:"NonBirdsOfPrey",plural:"Bedford's Paradise-Flycatchers"},{id:956,label:"Beesley's Lark",value:"Beesley's Lark",category:"NonBirdsOfPrey",plural:"Beesley's Larks"},{id:957,label:"Benguela Lark",value:"Benguela Lark",category:"NonBirdsOfPrey",plural:"Benguela Larks"},{id:958,label:"Benguela Long-billed Lark",value:"Benguela Long-billed Lark",category:"NonBirdsOfPrey",plural:"Benguela Long-billed Larks"},{id:959,label:"Berthelot's Pipit",value:"Berthelot's Pipit",category:"NonBirdsOfPrey",plural:"Berthelot's Pipits"},{id:960,label:"Bimaculated Lark",value:"Bimaculated Lark",category:"NonBirdsOfPrey",plural:"Bimaculated Larks"},{id:961,label:"Bioko Batis",value:"Bioko Batis",category:"NonBirdsOfPrey",plural:"Bioko Batis"},{id:962,label:"Bioko Speirops",value:"Bioko Speirops",category:"NonBirdsOfPrey",plural:"Bioko Speirops"},{id:963,label:"Black Bee-eater",value:"Black Bee-eater",category:"NonBirdsOfPrey",plural:"Black Bee-eaters"},{id:964,label:"Black Bishop",value:"Black Bishop",category:"NonBirdsOfPrey",plural:"Black Bishops"},{id:965,label:"Black Bustard",value:"Black Bustard",category:"NonBirdsOfPrey",plural:"Black Bustards"},{id:966,label:"Black Crowned-Crane",value:"Black Crowned-Crane",category:"NonBirdsOfPrey",plural:"Black Crowned-Cranes"},{id:967,label:"Black Dwarf Hornbill",value:"Black Dwarf Hornbill",category:"NonBirdsOfPrey",plural:"Black Dwarf Hornbills"},{id:968,label:"Black Goshawk",value:"Black Goshawk",category:"BirdsOfPrey",plural:"Black Goshawks"},{id:969,label:"Black Guillemot",value:"Black Guillemot",category:"NonBirdsOfPrey",plural:"Black Guillemots"},{id:970,label:"Black Guineafowl",value:"Black Guineafowl",category:"NonBirdsOfPrey",plural:"Black Guineafowls"},{id:971,label:"Black Harrier",value:"Black Harrier",category:"BirdsOfPrey",plural:"Black Harriers"},{id:972,label:"Black necked Eremomela",value:"Black necked Eremomela",category:"NonBirdsOfPrey",plural:"Black necked Eremomelas"},{id:973,label:"Black Noddy",value:"Black Noddy",category:"NonBirdsOfPrey",plural:"Black Noddies"},{id:974,label:"Black Redstart",value:"Black Redstart",category:"NonBirdsOfPrey",plural:"Black Redstarts"},{id:975,label:"Black Saw-wing",value:"Black Saw-wing",category:"NonBirdsOfPrey",plural:"Black Saw-wings"},{id:976,label:"Black Scimitarbill",value:"Black Scimitarbill",category:"NonBirdsOfPrey",plural:"Black Scimitarbills"},{id:977,label:"Black Scrub-Robin",value:"Black Scrub-Robin",category:"NonBirdsOfPrey",plural:"Black Scrub-Robins"},{id:978,label:"Black Skimmer",value:"Black Skimmer",category:"NonBirdsOfPrey",plural:"Black Skimmers"},{id:979,label:"Black Spinetail",value:"Black Spinetail",category:"NonBirdsOfPrey",plural:"Black Spinetails"},{id:980,label:"Black Tern",value:"Black Tern",category:"NonBirdsOfPrey",plural:"Black Terns"},{id:981,label:"Black Wheatear",value:"Black Wheatear",category:"NonBirdsOfPrey",plural:"Black Wheatears"},{id:982,label:"Black-and-rufous Swallow",value:"Black-and-rufous Swallow",category:"NonBirdsOfPrey",plural:"Black-and-rufous Swallows"},{id:983,label:"Black-and-white Flycatcher",value:"Black-and-white Flycatcher",category:"NonBirdsOfPrey",plural:"Black-and-white Flycatchers"},{id:984,label:"Black-and-white Mannikin",value:"Black-and-white Mannikin",category:"NonBirdsOfPrey",plural:"Black-and-white Mannikins"},{id:985,label:"Black-and-white Shrike-flycatcher",value:"Black-and-white Shrike-flycatcher",category:"NonBirdsOfPrey",plural:"Black-and-white Shrike-flycatchers"},{id:986,label:"Black-and-white-casqued Hornbill",value:"Black-and-white-casqued Hornbill",category:"NonBirdsOfPrey",plural:"Black-and-white-casqued Hornbills"},{id:987,label:"Black-backed Barbet",value:"Black-backed Barbet",category:"NonBirdsOfPrey",plural:"Black-backed Barbets"},{id:988,label:"Black-backed Cisticola",value:"Black-backed Cisticola",category:"NonBirdsOfPrey",plural:"Black-backed Cisticolas"},{id:989,label:"Black-bellied Firefinch",value:"Black-bellied Firefinch",category:"NonBirdsOfPrey",plural:"Black-bellied Firefinches"},{id:990,label:"Black-bellied Plover",value:"Black-bellied Plover",category:"NonBirdsOfPrey",plural:"Black-bellied Plovers"},{id:991,label:"Black-bellied Sandgrouse",value:"Black-bellied Sandgrouse",category:"NonBirdsOfPrey",plural:"Black-bellied Sandgrouses"},{id:992,label:"Black-bellied Seedcracker",value:"Black-bellied Seedcracker",category:"NonBirdsOfPrey",plural:"Black-bellied Seedcrackers"},{id:993,label:"Black-bellied Starling",value:"Black-bellied Starling",category:"NonBirdsOfPrey",plural:"Black-bellied Starlings"},{id:994,label:"Black-bellied Storm-Petrel",value:"Black-bellied Storm-Petrel",category:"NonBirdsOfPrey",plural:"Black-bellied Storm-Petrels"},{id:995,label:"Black-bellied Sunbird",value:"Black-bellied Sunbird",category:"NonBirdsOfPrey",plural:"Black-bellied Sunbirds"},{id:996,label:"Black-billed Barbet",value:"Black-billed Barbet",category:"NonBirdsOfPrey",plural:"Black-billed Barbets"},{id:997,label:"Black-billed Turaco",value:"Black-billed Turaco",category:"NonBirdsOfPrey",plural:"Black-billed Turacos"},{id:998,label:"Black-billed Weaver",value:"Black-billed Weaver",category:"NonBirdsOfPrey",plural:"Black-billed Weavers"},{id:999,label:"Black-billed Wood-Dove",value:"Black-billed Wood-Dove",category:"NonBirdsOfPrey",plural:"Black-billed Wood-Doves"},{id:1000,label:"Black-billed Woodhoopoe",value:"Black-billed Woodhoopoe",category:"NonBirdsOfPrey",plural:"Black-billed Woodhoopoes"},{id:1001,label:"Black-breasted Barbet",value:"Black-breasted Barbet",category:"NonBirdsOfPrey",plural:"Black-breasted Barbets"},{id:1002,label:"Black-browed Albatross",value:"Black-browed Albatross",category:"NonBirdsOfPrey",plural:"Black-browed Albatrosses"},{id:1003,label:"Black-browed Mountain Greenbul",value:"Black-browed Mountain Greenbul",category:"NonBirdsOfPrey",plural:"Black-browed Mountain Greenbuls"},{id:1004,label:"Black-capped Apalis",value:"Black-capped Apalis",category:"NonBirdsOfPrey",plural:"Black-capped Apalis"},{id:1005,label:"Black-capped Petrel",value:"Black-capped Petrel",category:"NonBirdsOfPrey",plural:"Black-capped Petrels"},{id:1006,label:"Black-capped Rufous-Warbler",value:"Black-capped Rufous-Warbler",category:"NonBirdsOfPrey",plural:"Black-capped Rufous-Warblers"},{id:1007,label:"Black-capped Social-Weaver",value:"Black-capped Social-Weaver",category:"NonBirdsOfPrey",plural:"Black-capped Social-Weavers"},{id:1008,label:"Black-capped Woodland-Warbler",value:"Black-capped Woodland-Warbler",category:"NonBirdsOfPrey",plural:"Black-capped Woodland-Warblers"},{id:1009,label:"Black-casqued Hornbill",value:"Black-casqued Hornbill",category:"NonBirdsOfPrey",plural:"Black-casqued Hornbills"},{id:1010,label:"Black-cheeked Lovebird",value:"Black-cheeked Lovebird",category:"NonBirdsOfPrey",plural:"Black-cheeked Lovebirds"},{id:1011,label:"Black-chested Snake Eagle",value:"Black-chested Snake Eagle",category:"BirdsOfPrey",plural:"Black-chested Snake Eagles"},{id:1012,label:"Black-chinned Weaver",value:"Black-chinned Weaver",category:"NonBirdsOfPrey",plural:"Black-chinned Weavers"},{id:1013,label:"Black-collared Apalis",value:"Black-collared Apalis",category:"NonBirdsOfPrey",plural:"Black-collared Apalis"},
    {id:1014,label:"Black-collared Bulbul",value:"Black-collared Bulbul",category:"NonBirdsOfPrey",plural:"Black-collared Bulbuls"},{id:1015,label:"Black-collared Lovebird",value:"Black-collared Lovebird",category:"NonBirdsOfPrey",plural:"Black-collared Lovebirds"},{id:1016,label:"Black-crowned Sparrowlark",value:"Black-crowned Sparrowlark",category:"NonBirdsOfPrey",plural:"Black-crowned Sparrowlarks"},{id:1017,label:"Black-crowned Tchagra",value:"Black-crowned Tchagra",category:"NonBirdsOfPrey",plural:"Black-crowned Tchagras"},{id:1018,label:"Black-crowned Waxbill",value:"Black-crowned Waxbill",category:"NonBirdsOfPrey",plural:"Black-crowned Waxbills"},{id:1019,label:"Black-eared Canary",value:"Black-eared Canary",category:"NonBirdsOfPrey",plural:"Black-eared Canaries"},{id:1020,label:"Black-eared Ground-Thrush",value:"Black-eared Ground-Thrush",category:"NonBirdsOfPrey",plural:"Black-eared Ground-Thrushes"},{id:1021,label:"Black-eared Seedeater",value:"Black-eared Seedeater",category:"NonBirdsOfPrey",plural:"Black-eared Seedeaters"},{id:1022,label:"Black-eared Sparrowlark",value:"Black-eared Sparrowlark",category:"NonBirdsOfPrey",plural:"Black-eared Sparrowlarks"},{id:1023,label:"Black-faced Apalis",value:"Black-faced Apalis",category:"NonBirdsOfPrey",plural:"Black-faced Apalis"},{id:1024,label:"Black-faced Babbler",value:"Black-faced Babbler",category:"NonBirdsOfPrey",plural:"Black-faced Babblers"},{id:1025,label:"Black-faced Canary",value:"Black-faced Canary",category:"NonBirdsOfPrey",plural:"Black-faced Canaries"},{id:1026,label:"Black-faced Firefinch",value:"Black-faced Firefinch",category:"NonBirdsOfPrey",plural:"Black-faced Firefinches"},{id:1027,label:"Black-faced Rufous-Warbler",value:"Black-faced Rufous-Warbler",category:"NonBirdsOfPrey",plural:"Black-faced Rufous-Warblers"},{id:1028,label:"Black-faced Sandgrouse",value:"Black-faced Sandgrouse",category:"NonBirdsOfPrey",plural:"Black-faced Sandgrouses"},{id:1029,label:"Black-faced Waxbill",value:"Black-faced Waxbill",category:"NonBirdsOfPrey",plural:"Black-faced Waxbills"},{id:1030,label:"Black-fronted Bulbul",value:"Black-fronted Bulbul",category:"NonBirdsOfPrey",plural:"Black-fronted Bulbuls"},{id:1031,label:"Black-fronted Bush-Shrike",value:"Black-fronted Bush-Shrike",category:"NonBirdsOfPrey",plural:"Black-fronted Bush-Shrikes"},{id:1032,label:"Black-fronted Bushshrike",value:"Black-fronted Bushshrike",category:"NonBirdsOfPrey",plural:"Black-fronted Bushshrikes"},{id:1033,label:"Black-fronted Francolin",value:"Black-fronted Francolin",category:"NonBirdsOfPrey",plural:"Black-fronted Francolins"},{id:1034,label:"Black-headed Apalis",value:"Black-headed Apalis",category:"NonBirdsOfPrey",plural:"Black-headed Apalis"},{id:1035,label:"Black-headed Bee-eater",value:"Black-headed Bee-eater",category:"NonBirdsOfPrey",plural:"Black-headed Bee-eaters"},{id:1036,label:"Black-headed Bunting",value:"Black-headed Bunting",category:"NonBirdsOfPrey",plural:"Black-headed Buntings"},{id:1037,label:"Black-headed Canary",value:"Black-headed Canary",category:"NonBirdsOfPrey",plural:"Black-headed Canaries"},{id:1038,label:"Black-headed Gonolek",value:"Black-headed Gonolek",category:"NonBirdsOfPrey",plural:"Black-headed Gonoleks"},{id:1039,label:"Black-headed Gull",value:"Black-headed Gull",category:"NonBirdsOfPrey",plural:"Black-headed Gulls"},{id:1040,label:"Black-headed Lapwing",value:"Black-headed Lapwing",category:"NonBirdsOfPrey",plural:"Black-headed Lapwings"},{id:1041,label:"Black-headed Paradise-Flycatcher",value:"Black-headed Paradise-Flycatcher",category:"NonBirdsOfPrey",plural:"Black-headed Paradise-Flycatchers"},{id:1042,label:"Black-headed Waxbill",value:"Black-headed Waxbill",category:"NonBirdsOfPrey",plural:"Black-headed Waxbills"},{id:1043,label:"Black-headed Weaver",value:"Black-headed Weaver",category:"NonBirdsOfPrey",plural:"Black-headed Weavers"},{id:1044,label:"Black-legged Kittiwake",value:"Black-legged Kittiwake",category:"NonBirdsOfPrey",plural:"Black-legged Kittiwakes"},{id:1045,label:"Black-lored Babbler",value:"Black-lored Babbler",category:"NonBirdsOfPrey",plural:"Black-lored Babblers"},{id:1046,label:"Black-lored Cisticola",value:"Black-lored Cisticola",category:"NonBirdsOfPrey",plural:"Black-lored Cisticolas"},{id:1047,label:"Black-lored Waxbill",value:"Black-lored Waxbill",category:"NonBirdsOfPrey",plural:"Black-lored Waxbills"},{id:1048,label:"Black-naped Tern",value:"Black-naped Tern",category:"NonBirdsOfPrey",plural:"Black-naped Terns"},{id:1049,label:"Black-napped Tern",value:"Black-napped Tern",category:"NonBirdsOfPrey",plural:"Black-napped Terns"},{id:1050,label:"Black-necked Grebe",value:"Black-necked Grebe",category:"NonBirdsOfPrey",plural:"Black-necked Grebes"},{id:1051,label:"Black-necked Wattle-eye",value:"Black-necked Wattle-eye",category:"NonBirdsOfPrey",plural:"Black-necked Wattle-eyes"},{id:1052,label:"Black-necked Weaver",value:"Black-necked Weaver",category:"NonBirdsOfPrey",plural:"Black-necked Weavers"},{id:1053,label:"Black-rumped Buttonquail",value:"Black-rumped Buttonquail",category:"NonBirdsOfPrey",plural:"Black-rumped Buttonquails"},{id:1054,label:"Black-rumped Waxbill",value:"Black-rumped Waxbill",category:"NonBirdsOfPrey",plural:"Black-rumped Waxbills"},{id:1055,label:"Black-shouldered Nightjar",value:"Black-shouldered Nightjar",category:"NonBirdsOfPrey",plural:"Black-shouldered Nightjars"},{id:1056,label:"Black-tailed Godwit",value:"Black-tailed Godwit",category:"NonBirdsOfPrey",plural:"Black-tailed Godwits"},{id:1057,label:"Black-tailed Oriole",value:"Black-tailed Oriole",category:"NonBirdsOfPrey",plural:"Black-tailed Orioles"},{id:1058,label:"Black-tailed Waxbill",value:"Black-tailed Waxbill",category:"NonBirdsOfPrey",plural:"Black-tailed Waxbills"},{id:1059,label:"Black-throated Apalis",value:"Black-throated Apalis",category:"NonBirdsOfPrey",plural:"Black-throated Apalis"},{id:1060,label:"Black-throated Barbet",value:"Black-throated Barbet",category:"NonBirdsOfPrey",plural:"Black-throated Barbets"},{id:1061,label:"Black-throated Coucal",value:"Black-throated Coucal",category:"NonBirdsOfPrey",plural:"Black-throated Coucals"},{id:1062,label:"Black-throated Malimbe",value:"Black-throated Malimbe",category:"NonBirdsOfPrey",plural:"Black-throated Malimbes"},{id:1063,label:"Black-throated Thrush",value:"Black-throated Thrush",category:"NonBirdsOfPrey",plural:"Black-throated Thrushes"},{id:1064,label:"Black-throated Wattle-eye",value:"Black-throated Wattle-eye",category:"NonBirdsOfPrey",plural:"Black-throated Wattle-eyes"},{id:1065,label:"Black-winged Bishop",value:"Black-winged Bishop",category:"NonBirdsOfPrey",plural:"Black-winged Bishops"},{id:1066,label:"Black-winged Kite",value:"Black-winged Kite",category:"BirdsOfPrey",plural:"Black-winged Kites"},{id:1067,label:"Black-winged Lapwing",value:"Black-winged Lapwing",category:"NonBirdsOfPrey",plural:"Black-winged Lapwings"},{id:1068,label:"Black-winged Lovebird",value:"Black-winged Lovebird",category:"NonBirdsOfPrey",plural:"Black-winged Lovebirds"},{id:1069,label:"Black-winged Oriole",value:"Black-winged Oriole",category:"NonBirdsOfPrey",plural:"Black-winged Orioles"},{id:1070,label:"Black-winged Pratincole",value:"Black-winged Pratincole",category:"NonBirdsOfPrey",plural:"Black-winged Pratincoles"},{id:1071,label:"Blackcap Babbler",value:"Blackcap Babbler",category:"NonBirdsOfPrey",plural:"Blackcap Babblers"},{id:1072,label:"Blackcap Illadopsis",value:"Blackcap Illadopsis",category:"NonBirdsOfPrey",plural:"Blackcap Illadopsis"},{id:1073,label:"Blackstart",value:"Blackstart",category:"NonBirdsOfPrey",plural:"Blackstarts"},{id:1074,label:"Blanford's Lark",value:"Blanford's Lark",category:"NonBirdsOfPrey",plural:"Blanford's Larks"},{id:1075,label:"Blue Bustard",value:"Blue Bustard",category:"NonBirdsOfPrey",plural:"Blue Bustards"},{id:1076,label:"Blue Cuckooshrike",value:"Blue Cuckooshrike",category:"NonBirdsOfPrey",plural:"Blue Cuckooshrikes"},{id:1077,label:"Blue Korhaan",value:"Blue Korhaan",category:"NonBirdsOfPrey",plural:"Blue Korhaans"},{id:1078,label:"Blue Malkoha",value:"Blue Malkoha",category:"NonBirdsOfPrey",plural:"Blue Malkohas"},{id:1079,label:"Blue Petrel",value:"Blue Petrel",category:"NonBirdsOfPrey",plural:"Blue Petrels"},{id:1080,label:"Blue Quail",value:"Blue Quail",category:"NonBirdsOfPrey",plural:"Blue Quails"},{id:1081,label:"Blue Rock-Thrush",value:"Blue Rock-Thrush",category:"NonBirdsOfPrey",plural:"Blue Rock-Thrushes"},{id:1082,label:"Blue Swallow",value:"Blue Swallow",category:"NonBirdsOfPrey",plural:"Blue Swallows"},{id:1083,label:"Blue Vanga",value:"Blue Vanga",category:"NonBirdsOfPrey",plural:"Blue Vangas"},{id:1084,label:"Blue-bellied Roller",value:"Blue-bellied Roller",category:"NonBirdsOfPrey",plural:"Blue-bellied Rollers"},{id:1085,label:"Blue-billed Malimbe",value:"Blue-billed Malimbe",category:"NonBirdsOfPrey",plural:"Blue-billed Malimbes"},{id:1086,label:"Blue-billed Teal",value:"Blue-billed Teal",category:"NonBirdsOfPrey",plural:"Blue-billed Teals"},{id:1087,label:"Blue-breasted Bee-eater",value:"Blue-breasted Bee-eater",category:"NonBirdsOfPrey",plural:"Blue-breasted Bee-eaters"},{id:1088,label:"Blue-breasted Cordon-bleu",value:"Blue-breasted Cordon-bleu",category:"NonBirdsOfPrey",plural:"Blue-breasted Cordon-bleus"},{id:1089,label:"Blue-breasted Kingfisher",value:"Blue-breasted Kingfisher",category:"NonBirdsOfPrey",plural:"Blue-breasted Kingfishers"},{id:1090,label:"Blue-capped Cordonbleu",value:"Blue-capped Cordonbleu",category:"NonBirdsOfPrey",plural:"Blue-capped Cordonbleus"},{id:1091,label:"Blue-headed Bee-eater",value:"Blue-headed Bee-eater",category:"NonBirdsOfPrey",plural:"Blue-headed Bee-eaters"},{id:1092,label:"Blue-headed Coucal",value:"Blue-headed Coucal",category:"NonBirdsOfPrey",plural:"Blue-headed Coucals"},{id:1093,label:"Blue-headed Crested-Flycatcher",value:"Blue-headed Crested-Flycatcher",category:"NonBirdsOfPrey",plural:"Blue-headed Crested-Flycatchers"},{id:1094,label:"Blue-headed Sunbird",value:"Blue-headed Sunbird",category:"NonBirdsOfPrey",plural:"Blue-headed Sunbirds"},{id:1095,label:"Blue-headed Wood-Dove",value:"Blue-headed Wood-Dove",category:"NonBirdsOfPrey",plural:"Blue-headed Wood-Doves"},{id:1096,label:"Blue-moustached Bee-eater",value:"Blue-moustached Bee-eater",category:"NonBirdsOfPrey",plural:"Blue-moustached Bee-eaters"},{id:1097,label:"Blue-naped Mousebird",value:"Blue-naped Mousebird",category:"NonBirdsOfPrey",plural:"Blue-naped Mousebirds"},{id:1098,label:"Blue-shouldered Robin-Chat",value:"Blue-shouldered Robin-Chat",category:"NonBirdsOfPrey",plural:"Blue-shouldered Robin-Chats"},{id:1099,label:"Blue-spotted Wood-Dove",value:"Blue-spotted Wood-Dove",category:"NonBirdsOfPrey",plural:"Blue-spotted Wood-Doves"},{id:1100,label:"Blue-throated Brown Sunbird",value:"Blue-throated Brown Sunbird",category:"NonBirdsOfPrey",plural:"Blue-throated Brown Sunbirds"},{id:1101,label:"Blue-throated Roller",value:"Blue-throated Roller",category:"NonBirdsOfPrey",plural:"Blue-throated Rollers"},{id:1102,label:"Blue-winged Goose",value:"Blue-winged Goose",category:"NonBirdsOfPrey",plural:"Blue-winged Geese"},{id:1103,label:"Blue-winged Teal",value:"Blue-winged Teal",category:"NonBirdsOfPrey",plural:"Blue-winged Teals"},{id:1104,label:"Bluethroat",value:"Bluethroat",category:"NonBirdsOfPrey",plural:"Bluethroats"},{id:1105,label:"Blyth's Reed Warbler",value:"Blyth's Reed Warbler",category:"NonBirdsOfPrey",plural:"Blyth's Reed Warblers"},{id:1106,label:"Bob-tailed Weaver",value:"Bob-tailed Weaver",category:"NonBirdsOfPrey",plural:"Bob-tailed Weavers"},{id:1107,label:"Bocage's Akalat",value:"Bocage's Akalat",category:"NonBirdsOfPrey",plural:"Bocage's Akalats"},{id:1108,label:"Bocage's Weaver",value:"Bocage's Weaver",category:"NonBirdsOfPrey",plural:"Bocage's Weavers"},{id:1109,label:"Bohemian Waxwing",value:"Bohemian Waxwing",category:"NonBirdsOfPrey",plural:"Bohemian Waxwings"},{id:1110,label:"B\u00f6hm's Bee-eater",value:"B\u00f6hm's Bee-eater",category:"NonBirdsOfPrey",plural:"B\u00f6hm's Bee-eaters"},{id:1111,label:"B\u00f6hm's Flycatcher",value:"B\u00f6hm's Flycatcher",category:"NonBirdsOfPrey",plural:"B\u00f6hm's Flycatchers"},{id:1112,label:"Bokmakierie",value:"Bokmakierie",category:"NonBirdsOfPrey",plural:"Bokmakieries"},{id:1113,label:"Bolle's Pigeon",value:"Bolle's Pigeon",category:"NonBirdsOfPrey",plural:"Bolle's Pigeons"},{id:1114,label:"Bonaparte's Gull",value:"Bonaparte's Gull",category:"NonBirdsOfPrey",plural:"Bonaparte's Gulls"},{id:1115,label:"Bonelli's Eagle",value:"Bonelli's Eagle",category:"BirdsOfPrey",plural:"Bonelli's Eagles"},{id:1116,label:"Booted Warbler",value:"Booted Warbler",category:"NonBirdsOfPrey",plural:"Booted Warblers"},{id:1117,label:"Boran Cisticola",value:"Boran Cisticola",category:"NonBirdsOfPrey",plural:"Boran Cisticolas"},{id:1118,label:"Botha's Lark",value:"Botha's Lark",category:"NonBirdsOfPrey",plural:"Botha's Larks"},{id:1119,label:"Boulder Chat",value:"Boulder Chat",category:"NonBirdsOfPrey",plural:"Boulder Chats"},{id:1120,label:"Boulton's Batis",value:"Boulton's Batis",category:"NonBirdsOfPrey",plural:"Boulton's Batis"},{id:1121,label:"Boyd's Shearwater",value:"Boyd's Shearwater",category:"NonBirdsOfPrey",plural:"Boyd's Shearwaters"},{id:1122,label:"Bradfield's Hornbill",value:"Bradfield's Hornbill",category:"NonBirdsOfPrey",plural:"Bradfield's Hornbills"},{id:1123,label:"Bradfield's Swift",value:"Bradfield's Swift",category:"NonBirdsOfPrey",plural:"Bradfield's Swifts"},{id:1124,label:"Brambling",value:"Brambling",category:"NonBirdsOfPrey",plural:"Bramblings"},{id:1125,label:"Brant",value:"Brant",category:"NonBirdsOfPrey",plural:"Brants"},{id:1126,label:"Braun's Bushshrike",value:"Braun's Bushshrike",category:"NonBirdsOfPrey",plural:"Braun's Bushshrikes"},{id:1127,label:"Brazza's Martin",value:"Brazza's Martin",category:"NonBirdsOfPrey",plural:"Brazza's Martins"},{id:1128,label:"Bridled Tern",value:"Bridled Tern",category:"NonBirdsOfPrey",plural:"Bridled Terns"},{id:1129,label:"Bristle-crowned Starling",value:"Bristle-crowned Starling",category:"NonBirdsOfPrey",plural:"Bristle-crowned Starlings"},{id:1130,label:"Bristle-nosed Barbet",value:"Bristle-nosed Barbet",category:"NonBirdsOfPrey",plural:"Bristle-nosed Barbets"},{id:1131,label:"Broad-billed Prion",value:"Broad-billed Prion",category:"NonBirdsOfPrey",plural:"Broad-billed Prions"},{id:1132,label:"Broad-billed Sandpiper",value:"Broad-billed Sandpiper",category:"NonBirdsOfPrey",plural:"Broad-billed Sandpipers"},{id:1133,label:"Broad-tailed Paradise-Whydah",value:"Broad-tailed Paradise-Whydah",category:"NonBirdsOfPrey",plural:"Broad-tailed Paradise-Whydahs"},{id:1134,label:"Broad-tailed Warbler",value:"Broad-tailed Warbler",category:"NonBirdsOfPrey",plural:"Broad-tailed Warblers"},{id:1135,label:"Bronze Sunbird",value:"Bronze Sunbird",category:"NonBirdsOfPrey",plural:"Bronze Sunbirds"},{id:1136,label:"Bronze-tailed Starling",value:"Bronze-tailed Starling",category:"NonBirdsOfPrey",plural:"Bronze-tailed Starlings"},{id:1137,label:"Bronze-winged Courser",value:"Bronze-winged Courser",category:"NonBirdsOfPrey",plural:"Bronze-winged Coursers"},{id:1138,label:"Bronzy Sunbird",value:"Bronzy Sunbird",category:"NonBirdsOfPrey",plural:"Bronzy Sunbirds"},{id:1139,label:"Brown Babbler",value:"Brown Babbler",category:"NonBirdsOfPrey",plural:"Brown Babblers"},{id:1140,label:"Brown Booby",value:"Brown Booby",category:"NonBirdsOfPrey",plural:"Brown Boobies"},{id:1141,label:"Brown Firefinch",value:"Brown Firefinch",category:"NonBirdsOfPrey",plural:"Brown Firefinches"},{id:1142,label:"Brown Illadopsis",value:"Brown Illadopsis",category:"NonBirdsOfPrey",plural:"Brown Illadopsis"},{id:1143,label:"Brown Nightjar",value:"Brown Nightjar",category:"NonBirdsOfPrey",plural:"Brown Nightjars"},{id:1144,label:"Brown Noddy",value:"Brown Noddy",category:"NonBirdsOfPrey",plural:"Brown Noddies"},{id:1145,label:"Brown Parisoma",value:"Brown Parisoma",category:"NonBirdsOfPrey",plural:"Brown Parisomas"},{id:1146,label:"Brown Scrub-Robin",value:"Brown Scrub-Robin",category:"NonBirdsOfPrey",plural:"Brown Scrub-Robins"},{id:1147,label:"Brown Skua",value:"Brown Skua",category:"NonBirdsOfPrey",plural:"Brown Skuas"},{id:1148,label:"Brown Twinspot",value:"Brown Twinspot",category:"NonBirdsOfPrey",plural:"Brown Twinspots"},{id:1149,label:"Brown Woodland-Warbler",value:"Brown Woodland-Warbler",category:"NonBirdsOfPrey",plural:"Brown Woodland-Warblers"},{id:1150,label:"Brown-backed Scrub-Robin",value:"Brown-backed Scrub-Robin",category:"NonBirdsOfPrey",plural:"Brown-backed Scrub-Robins"},{id:1151,label:"Brown-backed Woodpecker",value:"Brown-backed Woodpecker",category:"NonBirdsOfPrey",plural:"Brown-backed Woodpeckers"},{id:1152,label:"Brown-breasted Barbet",value:"Brown-breasted Barbet",category:"NonBirdsOfPrey",plural:"Brown-breasted Barbets"},{id:1153,label:"Brown-capped Weaver",value:"Brown-capped Weaver",category:"NonBirdsOfPrey",plural:"Brown-capped Weavers"},{id:1154,label:"Brown-cheeked Hornbill",value:"Brown-cheeked Hornbill",category:"NonBirdsOfPrey",plural:"Brown-cheeked Hornbills"},{id:1155,label:"Brown-chested Alethe",value:"Brown-chested Alethe",category:"NonBirdsOfPrey",plural:"Brown-chested Alethes"},{id:1156,label:"Brown-chested Lapwing",value:"Brown-chested Lapwing",category:"NonBirdsOfPrey",plural:"Brown-chested Lapwings"},{id:1157,label:"Brown-crowned Tchagra",value:"Brown-crowned Tchagra",category:"NonBirdsOfPrey",plural:"Brown-crowned Tchagras"},{id:1158,label:"Brown-eared Woodpecker",value:"Brown-eared Woodpecker",category:"NonBirdsOfPrey",plural:"Brown-eared Woodpeckers"},{id:1159,label:"Brown-headed Apalis",value:"Brown-headed Apalis",category:"NonBirdsOfPrey",plural:"Brown-headed Apalis"},{id:1160,label:"Brown-necked Parrot",value:"Brown-necked Parrot",category:"NonBirdsOfPrey",plural:"Brown-necked Parrots"},{id:1161,label:"Brown-necked Raven",value:"Brown-necked Raven",category:"NonBirdsOfPrey",plural:"Brown-necked Ravens"},{id:1162,label:"Brown-rumped Bunting",value:"Brown-rumped Bunting",category:"NonBirdsOfPrey",plural:"Brown-rumped Buntings"},{id:1163,label:"Brown-rumped Seedeater",value:"Brown-rumped Seedeater",category:"NonBirdsOfPrey",plural:"Brown-rumped Seedeaters"},{id:1164,label:"Brown-tailed Chat",value:"Brown-tailed Chat",category:"NonBirdsOfPrey",plural:"Brown-tailed Chats"},{id:1165,label:"Brown-throated Martin",value:"Brown-throated Martin",category:"NonBirdsOfPrey",plural:"Brown-throated Martins"},{id:1166,label:"Brown-throated Wattle-eye",value:"Brown-throated Wattle-eye",category:"NonBirdsOfPrey",plural:"Brown-throated Wattle-eyes"},{id:1167,label:"Bruce's Green-Pigeon",value:"Bruce's Green-Pigeon",category:"NonBirdsOfPrey",plural:"Bruce's Green-Pigeons"},{id:1168,label:"Bubbling Cisticola",value:"Bubbling Cisticola",category:"NonBirdsOfPrey",plural:"Bubbling Cisticolas"},{id:1169,label:"Buff-bellied Warbler",value:"Buff-bellied Warbler",category:"NonBirdsOfPrey",plural:"Buff-bellied Warblers"},{id:1170,label:"Buff-breasted Sandpiper",value:"Buff-breasted Sandpiper",category:"NonBirdsOfPrey",plural:"Buff-breasted Sandpipers"},{id:1171,label:"Buff-crested Bustard",value:"Buff-crested Bustard",category:"NonBirdsOfPrey",plural:"Buff-crested Bustards"},{id:1172,label:"Buff-shouldered Widowbird",value:"Buff-shouldered Widowbird",category:"NonBirdsOfPrey",plural:"Buff-shouldered Widowbirds"},{id:1173,label:"Buff-spotted Woodpecker",value:"Buff-spotted Woodpecker",category:"NonBirdsOfPrey",plural:"Buff-spotted Woodpeckers"},{id:1174,label:"Buff-streaked Chat",value:"Buff-streaked Chat",category:"NonBirdsOfPrey",plural:"Buff-streaked Chats"},{id:1175,label:"Buff-throated Apalis",value:"Buff-throated Apalis",category:"NonBirdsOfPrey",plural:"Buff-throated Apalis"},{id:1176,label:"Buff-throated Sunbird",value:"Buff-throated Sunbird",category:"NonBirdsOfPrey",plural:"Buff-throated Sunbirds"},{id:1177,label:"Buller's Albatross",value:"Buller's Albatross",category:"NonBirdsOfPrey",plural:"Buller's Albatrosses"},{id:1178,label:"Bulwer's Petrel",value:"Bulwer's Petrel",category:"NonBirdsOfPrey",plural:"Bulwer's Petrels"},{id:1179,label:"Burchell's Courser",value:"Burchell's Courser",category:"NonBirdsOfPrey",plural:"Burchell's Coursers"},{id:1180,label:"Burnt neck Eremomela",value:"Burnt neck Eremomela",category:"NonBirdsOfPrey",plural:"Burnt neck Eremomelas"},{id:1181,label:"Bush Blackcap",value:"Bush Blackcap",category:"NonBirdsOfPrey",plural:"Bush Blackcaps"},{id:1182,label:"Bush Pipit",value:"Bush Pipit",category:"NonBirdsOfPrey",plural:"Bush Pipits"},{id:1183,label:"Cabanis's Bunting",value:"Cabanis's Bunting",category:"NonBirdsOfPrey",plural:"Cabanis's Buntings"},{id:1184,label:"Cabanis's Greenbul",value:"Cabanis's Greenbul",category:"NonBirdsOfPrey",plural:"Cabanis's Greenbuls"},{id:1185,label:"Calandra Lark",value:"Calandra Lark",category:"NonBirdsOfPrey",plural:"Calandra Larks"},{id:1186,label:"California Quail",value:"California Quail",category:"NonBirdsOfPrey",plural:"California Quails"},{id:1187,label:"Cameroon Francolin",value:"Cameroon Francolin",category:"NonBirdsOfPrey",plural:"Cameroon Francolins"},{id:1188,label:"Cameroon Indigobird",value:"Cameroon Indigobird",category:"NonBirdsOfPrey",plural:"Cameroon Indigobirds"},{id:1189,label:"Cameroon Mountain Greenbul",value:"Cameroon Mountain Greenbul",category:"NonBirdsOfPrey",plural:"Cameroon Mountain Greenbuls"},{id:1190,label:"Cameroon Olive-Greenbul",value:"Cameroon Olive-Greenbul",category:"NonBirdsOfPrey",plural:"Cameroon Olive-Greenbuls"},{id:1191,label:"Cameroon Pigeon",value:"Cameroon Pigeon",category:"NonBirdsOfPrey",plural:"Cameroon Pigeons"},{id:1192,label:"Cameroon Speirops",value:"Cameroon Speirops",category:"NonBirdsOfPrey",plural:"Cameroon Speirops"},{id:1193,label:"Cameroon Sunbird",value:"Cameroon Sunbird",category:"NonBirdsOfPrey",plural:"Cameroon Sunbirds"},{id:1194,label:"Canary Islands Chiffchaff",value:"Canary Islands Chiffchaff",category:"NonBirdsOfPrey",plural:"Canary Islands Chiffchaffs"},{id:1195,label:"Cape Bulbul",value:"Cape Bulbul",category:"NonBirdsOfPrey",plural:"Cape Bulbuls"},{id:1196,label:"Cape Clapper Lark",value:"Cape Clapper Lark",category:"NonBirdsOfPrey",plural:"Cape Clapper Larks"},{id:1197,label:"Cape Cormorant",value:"Cape Cormorant",category:"NonBirdsOfPrey",plural:"Cape Cormorants"},{id:1198,label:"Cape Crombec",value:"Cape Crombec",category:"NonBirdsOfPrey",plural:"Cape Crombecs"},{id:1199,label:"Cape Crow",value:"Cape Crow",category:"NonBirdsOfPrey",plural:"Cape Crows"},{id:1200,label:"Cape Francolin",value:"Cape Francolin",category:"NonBirdsOfPrey",plural:"Cape Francolins"},{id:1201,label:"Cape Gannet",value:"Cape Gannet",category:"NonBirdsOfPrey",plural:"Cape Gannets"},{id:1202,label:"Cape Griffon",value:"Cape Griffon",category:"BirdsOfPrey",plural:"Cape Griffons"},{id:1203,label:"Cape Lark",value:"Cape Lark",category:"NonBirdsOfPrey",plural:"Cape Larks"},{id:1204,label:"Cape Long-billed Lark",value:"Cape Long-billed Lark",category:"NonBirdsOfPrey",plural:"Cape Long-billed Larks"},{id:1205,label:"Cape Parrot",value:"Cape Parrot",category:"NonBirdsOfPrey",plural:"Cape Parrots"},{id:1206,label:"Cape Petrel",value:"Cape Petrel",category:"NonBirdsOfPrey",plural:"Cape Petrels"},{id:1207,label:"Cape Rock-jumper",value:"Cape Rock-jumper",category:"NonBirdsOfPrey",plural:"Cape Rock-jumpers"},{id:1208,label:"Cape Shoveler",value:"Cape Shoveler",category:"NonBirdsOfPrey",plural:"Cape Shovelers"},{id:1209,label:"Cape Siskin",value:"Cape Siskin",category:"NonBirdsOfPrey",plural:"Cape Siskins"},{id:1210,label:"Cape Spurfowl",value:"Cape Spurfowl",category:"NonBirdsOfPrey",plural:"Cape Spurfowls"},{id:1211,label:"Cape Sugarbird",value:"Cape Sugarbird",category:"NonBirdsOfPrey",plural:"Cape Sugarbirds"},{id:1212,label:"Cape Verde Buzzard",value:"Cape Verde Buzzard",category:"BirdsOfPrey",plural:"Cape Verde Buzzards"},{id:1213,label:"Cape Verde Shearwater",value:"Cape Verde Shearwater",category:"NonBirdsOfPrey",plural:"Cape Verde Shearwaters"},{id:1214,label:"Capuchin Babbler",value:"Capuchin Babbler",category:"NonBirdsOfPrey",plural:"Capuchin Babblers"},{id:1215,label:"Cardinal Quelea",value:"Cardinal Quelea",category:"NonBirdsOfPrey",plural:"Cardinal Queleas"},{id:1216,label:"Carmelite Sunbird",value:"Carmelite Sunbird",category:"NonBirdsOfPrey",plural:"Carmelite Sunbirds"},{id:1217,label:"Carp's Tit",value:"Carp's Tit",category:"NonBirdsOfPrey",plural:"Carp's Tits"},{id:1218,label:"Carrion Crow",value:"Carrion Crow",category:"NonBirdsOfPrey",plural:"Carrion Crows"},{id:1219,label:"Carruthers's Cisticola",value:"Carruthers's Cisticola",category:"NonBirdsOfPrey",plural:"Carruthers's Cisticolas"},{id:1220,label:"Caspian Gull",value:"Caspian Gull",category:"NonBirdsOfPrey",plural:"Caspian Gulls"},{id:1221,label:"Caspian Plover",value:"Caspian Plover",category:"NonBirdsOfPrey",plural:"Caspian Plovers"},{id:1222,label:"Caspian Tern",value:"Caspian Tern",category:"NonBirdsOfPrey",plural:"Caspian Terns"},{id:1223,label:"Cassin's Flycatcher",value:"Cassin's Flycatcher",category:"NonBirdsOfPrey",plural:"Cassin's Flycatchers"},{id:1224,label:"Cassin's Hawk-Eagle",value:"Cassin's Hawk-Eagle",category:"BirdsOfPrey",plural:"Cassin's Hawk-Eagles"},{id:1225,label:"Cassin's Honeyguide",value:"Cassin's Honeyguide",category:"NonBirdsOfPrey",plural:"Cassin's Honeyguides"},{id:1226,label:"Cassin's Spinetail",value:"Cassin's Spinetail",category:"NonBirdsOfPrey",plural:"Cassin's Spinetails"},{id:1227,label:"Cetti's Warbler",value:"Cetti's Warbler",category:"NonBirdsOfPrey",plural:"Cetti's Warblers"},{id:1228,label:"Chapin's Apalis",value:"Chapin's Apalis",category:"NonBirdsOfPrey",plural:"Chapin's Apalis"},{id:1229,label:"Chapin's Flycatcher",value:"Chapin's Flycatcher",category:"NonBirdsOfPrey",plural:"Chapin's Flycatchers"},{id:1230,label:"Chapin's Mountain-Babbler",value:"Chapin's Mountain-Babbler",category:"NonBirdsOfPrey",plural:"Chapin's Mountain-Babblers"},{id:1231,label:"Chaplin's Barbet",value:"Chaplin's Barbet",category:"NonBirdsOfPrey",plural:"Chaplin's Barbets"},{id:1232,label:"Chat Flycatcher",value:"Chat Flycatcher",category:"NonBirdsOfPrey",plural:"Chat Flycatchers"},{id:1233,label:"Chatham Albatross",value:"Chatham Albatross",category:"NonBirdsOfPrey",plural:"Chatham Albatrosses"},{id:1234,label:"Chatnam Albatross",value:"Chatnam Albatross",category:"NonBirdsOfPrey",plural:"Chatnam Albatrosses"},{id:1235,label:"Chattering Cisticola",value:"Chattering Cisticola",category:"NonBirdsOfPrey",plural:"Chattering Cisticolas"},{id:1236,label:"Chestnut Owlet",value:"Chestnut Owlet",category:"BirdsOfPrey",plural:"Chestnut Owlets"},{id:1237,label:"Chestnut Sparrow",value:"Chestnut Sparrow",category:"NonBirdsOfPrey",plural:"Chestnut Sparrows"},{id:1238,label:"Chestnut Wattle-eye",value:"Chestnut Wattle-eye",category:"NonBirdsOfPrey",plural:"Chestnut Wattle-eyes"},{id:1239,label:"Chestnut Weaver",value:"Chestnut Weaver",category:"NonBirdsOfPrey",plural:"Chestnut Weavers"},{id:1240,label:"Chestnut-backed Sparrow-Weaver",value:"Chestnut-backed Sparrow-Weaver",category:"NonBirdsOfPrey",plural:"Chestnut-backed Sparrow-Weavers"},{id:1241,label:"Chestnut-backed Sparrowlark",value:"Chestnut-backed Sparrowlark",category:"NonBirdsOfPrey",plural:"Chestnut-backed Sparrowlarks"},{id:1242,label:"Chestnut-bellied Sandgrouse",value:"Chestnut-bellied Sandgrouse",category:"NonBirdsOfPrey",plural:"Chestnut-bellied Sandgrouses"},{id:1243,label:"Chestnut-bellied Starling",value:"Chestnut-bellied Starling",category:"NonBirdsOfPrey",plural:"Chestnut-bellied Starlings"},{id:1244,label:"Chestnut-breasted Nigrita",value:"Chestnut-breasted Nigrita",category:"NonBirdsOfPrey",plural:"Chestnut-breasted Nigritas"},{id:1245,label:"Chestnut-capped Flycatcher",value:"Chestnut-capped Flycatcher",category:"NonBirdsOfPrey",plural:"Chestnut-capped Flycatchers"},{id:1246,label:"Chestnut-crowned Sparrow-Weaver",value:"Chestnut-crowned Sparrow-Weaver",category:"NonBirdsOfPrey",plural:"Chestnut-crowned Sparrow-Weavers"},{id:1247,label:"Chestnut-flanked Sparrowhawk",value:"Chestnut-flanked Sparrowhawk",category:"BirdsOfPrey",plural:"Chestnut-flanked Sparrowhawks"},{id:1248,label:"Chestnut-fronted Helmet-Shrike",value:"Chestnut-fronted Helmet-Shrike",category:"NonBirdsOfPrey",plural:"Chestnut-fronted Helmet-Shrikes"},{id:1249,label:"Chestnut-fronted Helmetshrike",value:"Chestnut-fronted Helmetshrike",category:"NonBirdsOfPrey",plural:"Chestnut-fronted Helmetshrikes"},{id:1250,label:"Chestnut-headed Flufftail",value:"Chestnut-headed Flufftail",category:"NonBirdsOfPrey",plural:"Chestnut-headed Flufftails"},{id:1251,label:"Chestnut-naped Francolin",value:"Chestnut-naped Francolin",category:"NonBirdsOfPrey",plural:"Chestnut-naped Francolins"},{id:1252,label:"Chestnut-throated Apalis",value:"Chestnut-throated Apalis",category:"NonBirdsOfPrey",plural:"Chestnut-throated Apalis"},{id:1253,label:"Chestnut-vented Warbler",value:"Chestnut-vented Warbler",category:"NonBirdsOfPrey",plural:"Chestnut-vented Warblers"},{id:1254,label:"Chestnut-winged Starling",value:"Chestnut-winged Starling",category:"NonBirdsOfPrey",plural:"Chestnut-winged Starlings"},{id:1255,label:"Chimney Swift",value:"Chimney Swift",category:"NonBirdsOfPrey",plural:"Chimney Swifts"},{id:1256,label:"Chinstrap Penguin",value:"Chinstrap Penguin",category:"NonBirdsOfPrey",plural:"Chinstrap Penguins"},{id:1257,label:"Chirinda Apalis",value:"Chirinda Apalis",category:"NonBirdsOfPrey",plural:"Chirinda Apalis"},{id:1258,label:"Chirping Cisticola",value:"Chirping Cisticola",category:"NonBirdsOfPrey",plural:"Chirping Cisticolas"},{id:1259,label:"Chocolate-backed Kingfisher",value:"Chocolate-backed Kingfisher",category:"NonBirdsOfPrey",plural:"Chocolate-backed Kingfishers"},{id:1260,label:"Cholo Alethe",value:"Cholo Alethe",category:"NonBirdsOfPrey",plural:"Cholo Alethes"},{id:1261,label:"Chorister Robin",value:"Chorister Robin",category:"NonBirdsOfPrey",plural:"Chorister Robins"},{id:1262,label:"Chorister Robin-Chat",value:"Chorister Robin-Chat",category:"NonBirdsOfPrey",plural:"Chorister Robin-Chats"},{id:1263,label:"Christmas Island Frigatebird",value:"Christmas Island Frigatebird",category:"NonBirdsOfPrey",plural:"Christmas Island Frigatebirds"},{id:1264,label:"Chubb's Cisticola",value:"Chubb's Cisticola",category:"NonBirdsOfPrey",plural:"Chubb's Cisticolas"},{id:1265,label:"Chukar Partridge",value:"Chukar Partridge",category:"NonBirdsOfPrey",plural:"Chukar Partridges"},{id:1266,label:"Churring Cisticola",value:"Churring Cisticola",category:"NonBirdsOfPrey",plural:"Churring Cisticolas"},{id:1267,label:"Cinderella Waxbill",value:"Cinderella Waxbill",category:"NonBirdsOfPrey",plural:"Cinderella Waxbills"},{id:1268,label:"Cinereous Bunting",value:"Cinereous Bunting",category:"NonBirdsOfPrey",plural:"Cinereous Buntings"},{id:1269,label:"Cinereous Vulture",value:"Cinereous Vulture",category:"BirdsOfPrey",plural:"Cinereous Vultures"},{id:1270,label:"Cinnamon Bracken-Warbler",value:"Cinnamon Bracken-Warbler",category:"NonBirdsOfPrey",plural:"Cinnamon Bracken-Warblers"},{id:1271,label:"Cinnamon Weaver",value:"Cinnamon Weaver",category:"NonBirdsOfPrey",plural:"Cinnamon Weavers"},{id:1272,label:"Cinnamon-breasted Tit",value:"Cinnamon-breasted Tit",category:"NonBirdsOfPrey",plural:"Cinnamon-breasted Tits"},{id:1273,label:"Cinnamon-breasted Warbler",value:"Cinnamon-breasted Warbler",category:"NonBirdsOfPrey",plural:"Cinnamon-breasted Warblers"},{id:1274,label:"Cinnamon-chested Bee-eater",value:"Cinnamon-chested Bee-eater",category:"NonBirdsOfPrey",plural:"Cinnamon-chested Bee-eaters"},{id:1275,label:"Cinnanmon Teal",value:"Cinnanmon Teal",category:"NonBirdsOfPrey",plural:"Cinnanmon Teals"},{id:1276,label:"Cirl Bunting",value:"Cirl Bunting",category:"NonBirdsOfPrey",plural:"Cirl Buntings"},{id:1277,label:"Citril Finch",value:"Citril Finch",category:"NonBirdsOfPrey",plural:"Citril Finches"},{id:1278,label:"Citrine Wagtail",value:"Citrine Wagtail",category:"NonBirdsOfPrey",plural:"Citrine Wagtails"},{id:1279,label:"Clamorous Reed Warbler",value:"Clamorous Reed Warbler",category:"NonBirdsOfPrey",plural:"Clamorous Reed Warblers"},{id:1280,label:"Clapperton's Francolin",value:"Clapperton's Francolin",category:"NonBirdsOfPrey",plural:"Clapperton's Francolins"},{id:1281,label:"Clarke's Weaver",value:"Clarke's Weaver",category:"NonBirdsOfPrey",plural:"Clarke's Weavers"},{id:1282,label:"Cloud Cisticola",value:"Cloud Cisticola",category:"NonBirdsOfPrey",plural:"Cloud Cisticolas"},{id:1283,label:"Cloud-scraping Cisticola",value:"Cloud-scraping Cisticola",category:"NonBirdsOfPrey",plural:"Cloud-scraping Cisticolas"},{id:1284,label:"Coal Tit",value:"Coal Tit",category:"NonBirdsOfPrey",plural:"Coal Tits"},{id:1285,label:"Coastal Boubou",value:"Coastal Boubou",category:"NonBirdsOfPrey",plural:"Coastal Boubous"},{id:1286,label:"Coastal Cisticola",value:"Coastal Cisticola",category:"NonBirdsOfPrey",plural:"Coastal Cisticolas"},{id:1287,label:"Collared Flycatcher",value:"Collared Flycatcher",category:"NonBirdsOfPrey",plural:"Collared Flycatchers"},{id:1288,label:"Collared Kingfisher",value:"Collared Kingfisher",category:"NonBirdsOfPrey",plural:"Collared Kingfishers"},{id:1289,label:"Collared Lark",value:"Collared Lark",category:"NonBirdsOfPrey",plural:"Collared Larks"},{id:1290,label:"Common Bulbul",value:"Common Bulbul",category:"NonBirdsOfPrey",plural:"Common Bulbuls"},{id:1291,label:"Common Buttonquail",value:"Common Buttonquail",category:"NonBirdsOfPrey",plural:"Common Buttonquails"},{id:1292,label:"Common Chaffinch",value:"Common Chaffinch",category:"NonBirdsOfPrey",plural:"Common Chaffinches"},{id:1293,label:"Common Chiffchaff",value:"Common Chiffchaff",category:"NonBirdsOfPrey",plural:"Common Chiffchaffs"},{id:1294,label:"Common Crane",value:"Common Crane",category:"NonBirdsOfPrey",plural:"Common Cranes"},{id:1295,label:"Common Cuckoo",value:"Common Cuckoo",category:"NonBirdsOfPrey",plural:"Common Cuckoos"},{id:1296,label:"Common Diving-Petrel",value:"Common Diving-Petrel",category:"NonBirdsOfPrey",plural:"Common Diving-Petrels"},{id:1297,label:"Common Eider",value:"Common Eider",category:"NonBirdsOfPrey",plural:"Common Eiders"},{id:1298,label:"Common Firecrest",value:"Common Firecrest",category:"NonBirdsOfPrey",plural:"Common Firecrests"},{id:1299,label:"Common Goldeneye",value:"Common Goldeneye",category:"NonBirdsOfPrey",plural:"Common Goldeneyes"},{id:1300,label:"Common Grasshopper-Warbler",value:"Common Grasshopper-Warbler",category:"NonBirdsOfPrey",plural:"Common Grasshopper-Warblers"},{id:1301,label:"Common Gull",value:"Common Gull",category:"NonBirdsOfPrey",plural:"Common Gulls"},{id:1302,label:"Common Hoopoe",value:"Common Hoopoe",category:"NonBirdsOfPrey",plural:"Common Hoopoes"},{id:1303,label:"Common House-Martin",value:"Common House-Martin",category:"NonBirdsOfPrey",plural:"Common House-Martins"},{id:1304,label:"Common Kestrel",value:"Common Kestrel",category:"BirdsOfPrey",plural:"Common Kestrels"},{id:1305,label:"Common Kingfisher",value:"Common Kingfisher",category:"NonBirdsOfPrey",plural:"Common Kingfishers"},{id:1306,label:"Common Loon",value:"Common Loon",category:"NonBirdsOfPrey",plural:"Common Loons"},{id:1307,label:"Common Merganser",value:"Common Merganser",category:"NonBirdsOfPrey",plural:"Common Mergansers"},{id:1308,label:"Common Murre",value:"Common Murre",category:"NonBirdsOfPrey",plural:"Common Murres"},{id:1309,label:"Common Nightingale",value:"Common Nightingale",category:"NonBirdsOfPrey",plural:"Common Nightingales"},{id:1310,label:"Common Peacock",value:"Common Peacock",category:"NonBirdsOfPrey",plural:"Common Peacocks"},{id:1311,label:"Common Pochard",value:"Common Pochard",category:"NonBirdsOfPrey",plural:"Common Pochards"},{id:1312,label:"Common Raven",value:"Common Raven",category:"NonBirdsOfPrey",plural:"Common Ravens"},{id:1313,label:"Common Redpoll",value:"Common Redpoll",category:"NonBirdsOfPrey",plural:"Common Redpolls"},{id:1314,label:"Common Redshank",value:"Common Redshank",category:"NonBirdsOfPrey",plural:"Common Redshanks"},{id:1315,label:"Common Redstart",value:"Common Redstart",category:"NonBirdsOfPrey",plural:"Common Redstarts"},{id:1316,label:"Common Reed-warbler",value:"Common Reed-warbler",category:"NonBirdsOfPrey",plural:"Common Reed-warblers"},{id:1317,label:"Common Rosefinch",value:"Common Rosefinch",category:"NonBirdsOfPrey",plural:"Common Rosefinches"},{id:1318,label:"Common Scimitarbill",value:"Common Scimitarbill",category:"NonBirdsOfPrey",plural:"Common Scimitarbills"},{id:1319,label:"Common Scoter",value:"Common Scoter",category:"NonBirdsOfPrey",plural:"Common Scoters"},{id:1320,label:"Common Shelduck",value:"Common Shelduck",category:"NonBirdsOfPrey",plural:"Common Shelducks"},{id:1321,label:"Common Snipe",value:"Common Snipe",category:"NonBirdsOfPrey",plural:"Common Snipes"},{id:1322,label:"Common Square-tailed Drongo",value:"Common Square-tailed Drongo",category:"NonBirdsOfPrey",plural:"Common Square-tailed Drongos"},{id:1323,label:"Common Starling",value:"Common Starling",category:"NonBirdsOfPrey",plural:"Common Starlings"},{id:1324,label:"Common Tern",value:"Common Tern",category:"NonBirdsOfPrey",plural:"Common Terns"},{id:1325,label:"Common Whimbrel",value:"Common Whimbrel",category:"NonBirdsOfPrey",plural:"Common Whimbrels"},{id:1326,label:"Common Wood-Pigeon",value:"Common Wood-Pigeon",category:"NonBirdsOfPrey",plural:"Common Wood-Pigeons"},{id:1327,label:"Compact Weaver",value:"Compact Weaver",category:"NonBirdsOfPrey",plural:"Compact Weavers"},{id:1328,label:"Congo Bay-Owl",value:"Congo Bay-Owl",category:"BirdsOfPrey",plural:"Congo Bay-Owls"},{id:1329,label:"Congo Martin",value:"Congo Martin",category:"NonBirdsOfPrey",plural:"Congo Martins"},{id:1330,label:"Congo Moor Chat",value:"Congo Moor Chat",category:"NonBirdsOfPrey",plural:"Congo Moor Chats"},{id:1331,label:"Congo Peacock",value:"Congo Peacock",category:"NonBirdsOfPrey",plural:"Congo Peacocks"},{id:1332,label:"Congo Serpent-Eagle",value:"Congo Serpent-Eagle",category:"BirdsOfPrey",plural:"Congo Serpent-Eagles"},{id:1333,label:"Congo Sunbird",value:"Congo Sunbird",category:"NonBirdsOfPrey",plural:"Congo Sunbirds"},{id:1334,label:"Copper Sunbird",value:"Copper Sunbird",category:"NonBirdsOfPrey",plural:"Copper Sunbirds"},{id:1335,label:"Copper-tailed Starling",value:"Copper-tailed Starling",category:"NonBirdsOfPrey",plural:"Copper-tailed Starlings"},{id:1336,label:"Coppery-tailed Coucal",value:"Coppery-tailed Coucal",category:"NonBirdsOfPrey",plural:"Coppery-tailed Coucals"},{id:1337,label:"Coqui Francolin",value:"Coqui Francolin",category:"NonBirdsOfPrey",plural:"Coqui Francolins"},{id:1338,label:"Corn Bunting",value:"Corn Bunting",category:"NonBirdsOfPrey",plural:"Corn Buntings"},{id:1339,label:"Cory's Shearwater",value:"Cory's Shearwater",category:"NonBirdsOfPrey",plural:"Cory's Shearwaters"},{id:1340,label:"Crab-Plover",value:"Crab-Plover",category:"NonBirdsOfPrey",plural:"Crab-Plovers"},{id:1341,label:"Cream-colored Courser",value:"Cream-colored Courser",category:"NonBirdsOfPrey",plural:"Cream-colored Coursers"},{id:1342,label:"Crested Francolin",value:"Crested Francolin",category:"NonBirdsOfPrey",plural:"Crested Francolins"},{id:1343,label:"Crested Lark",value:"Crested Lark",category:"NonBirdsOfPrey",plural:"Crested Larks"},{id:1344,label:"Crested Malimbe",value:"Crested Malimbe",category:"NonBirdsOfPrey",plural:"Crested Malimbes"},{id:1345,label:"Crested Tit",value:"Crested Tit",category:"NonBirdsOfPrey",plural:"Crested Tits"},{id:1346,label:"Cretzschmar's Babbler",value:"Cretzschmar's Babbler",category:"NonBirdsOfPrey",plural:"Cretzschmar's Babblers"},{id:1347,label:"Cretzschmar's Bunting",value:"Cretzschmar's Bunting",category:"NonBirdsOfPrey",plural:"Cretzschmar's Buntings"},{id:1348,label:"Cricket Longtail",value:"Cricket Longtail",category:"NonBirdsOfPrey",plural:"Cricket Longtails"},{id:1349,label:"Crimson Seedcracker",value:"Crimson Seedcracker",category:"NonBirdsOfPrey",plural:"Crimson Seedcrackers"},{id:1350,label:"Crimson-breasted Gonolek",value:"Crimson-breasted Gonolek",category:"NonBirdsOfPrey",plural:"Crimson-breasted Gonoleks"},{id:1351,label:"Crimson-rumped Waxbill",value:"Crimson-rumped Waxbill",category:"NonBirdsOfPrey",plural:"Crimson-rumped Waxbills"},{id:1352,label:"Crimson-winged Finch",value:"Crimson-winged Finch",category:"NonBirdsOfPrey",plural:"Crimson-winged Finches"},{id:1353,label:"Crossley's Ground-Thrush",value:"Crossley's Ground-Thrush",category:"NonBirdsOfPrey",plural:"Crossley's Ground-Thrushes"},{id:1354,label:"Crowned Cormorant",value:"Crowned Cormorant",category:"NonBirdsOfPrey",plural:"Crowned Cormorants"},{id:1355,label:"Crowned Eagle",value:"Crowned Eagle",category:"BirdsOfPrey",plural:"Crowned Eagles"},{id:1356,label:"Crowned Sandgrouse",value:"Crowned Sandgrouse",category:"NonBirdsOfPrey",plural:"Crowned Sandgrouses"},{id:1357,label:"Crozet Shag",value:"Crozet Shag",category:"NonBirdsOfPrey",plural:"Crozet Shags"},{id:1358,label:"Cryptic Warbler",value:"Cryptic Warbler",category:"NonBirdsOfPrey",plural:"Cryptic Warblers"},{id:1359,label:"Cyprus Warbler",value:"Cyprus Warbler",category:"NonBirdsOfPrey",plural:"Cyprus Warblers"},{id:1360,label:"Cyprus Wheatear",value:"Cyprus Wheatear",category:"NonBirdsOfPrey",plural:"Cyprus Wheatears"},{id:1361,label:"D'Arnaud's Barbet",value:"D'Arnaud's Barbet",category:"NonBirdsOfPrey",plural:"D'Arnaud's Barbets"},{id:1362,label:"Dalmatian Pelican",value:"Dalmatian Pelican",category:"NonBirdsOfPrey",plural:"Dalmatian Pelicans"},{id:1363,label:"Damara Canary",value:"Damara Canary",category:"NonBirdsOfPrey",plural:"Damara Canaries"},{id:1364,label:"Damara Hornbill",value:"Damara Hornbill",category:"NonBirdsOfPrey",plural:"Damara Hornbills"},{id:1365,label:"Damara Red-billed Hornbill",value:"Damara Red-billed Hornbill",category:"NonBirdsOfPrey",plural:"Damara Red-billed Hornbills"},{id:1366,label:"Dapple-throat",value:"Dapple-throat",category:"NonBirdsOfPrey",plural:"Dapple-throats"},{id:1367,label:"Dark Batis",value:"Dark Batis",category:"NonBirdsOfPrey",plural:"Dark Batis"},{id:1368,label:"Dark-backed Weaver",value:"Dark-backed Weaver",category:"NonBirdsOfPrey",plural:"Dark-backed Weavers"},{id:1369,label:"Dartford Warbler",value:"Dartford Warbler",category:"NonBirdsOfPrey",plural:"Dartford Warblers"},{id:1370,label:"Dead Sea Sparrow",value:"Dead Sea Sparrow",category:"NonBirdsOfPrey",plural:"Dead Sea Sparrows"},{id:1371,label:"Delegorgue's Pigeon",value:"Delegorgue's Pigeon",category:"NonBirdsOfPrey",plural:"Delegorgue's Pigeons"},{id:1372,label:"Demoiselle Crane",value:"Demoiselle Crane",category:"NonBirdsOfPrey",plural:"Demoiselle Cranes"},{id:1373,label:"Desert Finch",value:"Desert Finch",category:"NonBirdsOfPrey",plural:"Desert Finches"},{id:1374,label:"Desert Lark",value:"Desert Lark",category:"NonBirdsOfPrey",plural:"Desert Larks"},{id:1375,label:"Desert Owl",value:"Desert Owl",category:"BirdsOfPrey",plural:"Desert Owls"},{id:1376,label:"Desert Sparrow",value:"Desert Sparrow",category:"NonBirdsOfPrey",plural:"Desert Sparrows"},{id:1377,label:"Desert Wheatear",value:"Desert Wheatear",category:"NonBirdsOfPrey",plural:"Desert Wheatears"},{id:1378,label:"Dja River Swamp Warbler",value:"Dja River Swamp Warbler",category:"NonBirdsOfPrey",plural:"Dja River Swamp Warblers"},{id:1379,label:"Djibouti Francolin",value:"Djibouti Francolin",category:"NonBirdsOfPrey",plural:"Djibouti Francolins"},{id:1380,label:"Doherty's Bushshrike",value:"Doherty's Bushshrike",category:"NonBirdsOfPrey",plural:"Doherty's Bushshrikes"},{id:1381,label:"Dollarbird",value:"Dollarbird",category:"NonBirdsOfPrey",plural:"Dollarbirds"},{id:1382,label:"Donaldson-Smith's Nightjar",value:"Donaldson-Smith's Nightjar",category:"NonBirdsOfPrey",plural:"Donaldson-Smith's Nightjars"},{id:1383,label:"Donaldson-Smith's Sparrow-Weaver",value:"Donaldson-Smith's Sparrow-Weaver",category:"NonBirdsOfPrey",plural:"Donaldson-Smith's Sparrow-Weavers"},{id:1384,label:"Dorst's Cisticola",value:"Dorst's Cisticola",category:"NonBirdsOfPrey",plural:"Dorst's Cisticolas"},{id:1385,label:"Double-banded Courser",value:"Double-banded Courser",category:"NonBirdsOfPrey",plural:"Double-banded Coursers"},{id:1386,label:"Double-spurred Francolin",value:"Double-spurred Francolin",category:"NonBirdsOfPrey",plural:"Double-spurred Francolins"},{id:1387,label:"Double-toothed Barbet",value:"Double-toothed Barbet",category:"NonBirdsOfPrey",plural:"Double-toothed Barbets"},{id:1388,label:"Dovekie",value:"Dovekie",category:"NonBirdsOfPrey",plural:"Dovekies"},{id:1389,label:"Drakensberg Prinia",value:"Drakensberg Prinia",category:"NonBirdsOfPrey",plural:"Drakensberg Prinias"},{id:1390,label:"Drakensberg Rock-jumper",value:"Drakensberg Rock-jumper",category:"NonBirdsOfPrey",plural:"Drakensberg Rock-jumpers"},{id:1391,label:"Drakensberg Siskin",value:"Drakensberg Siskin",category:"NonBirdsOfPrey",plural:"Drakensberg Siskins"},{id:1392,label:"Dublin Duck",value:"Dublin Duck",category:"NonBirdsOfPrey",plural:"Dublin Ducks"},{id:1393,label:"Dune Lark",value:"Dune Lark",category:"NonBirdsOfPrey",plural:"Dune Larks"},{id:1394,label:"Dunlin",value:"Dunlin",category:"NonBirdsOfPrey",plural:"Dunlins"},{id:1395,label:"Dunn's Lark",value:"Dunn's Lark",category:"NonBirdsOfPrey",plural:"Dunn's Larks"},{id:1396,label:"Dunnock",value:"Dunnock",category:"NonBirdsOfPrey",plural:"Dunnocks"},{id:1397,label:"Dupont's Lark",value:"Dupont's Lark",category:"NonBirdsOfPrey",plural:"Dupont's Larks"},{id:1398,label:"Dusky Babbler",value:"Dusky Babbler",category:"NonBirdsOfPrey",plural:"Dusky Babblers"},{id:1399,label:"Dusky Crested-Flycatcher",value:"Dusky Crested-Flycatcher",category:"NonBirdsOfPrey",plural:"Dusky Crested-Flycatchers"},{id:1400,label:"Dusky Crimsonwing",value:"Dusky Crimsonwing",category:"NonBirdsOfPrey",plural:"Dusky Crimsonwings"},{id:1401,label:"Dusky Long-tailed Cuckoo",value:"Dusky Long-tailed Cuckoo",category:"NonBirdsOfPrey",plural:"Dusky Long-tailed Cuckoos"},{id:1402,label:"Dusky Parrot",value:"Dusky Parrot",category:"NonBirdsOfPrey",plural:"Dusky Parrots"},{id:1403,label:"Dusky Sunbird",value:"Dusky Sunbird",category:"NonBirdsOfPrey",plural:"Dusky Sunbirds"},{id:1404,label:"Dusky Tit",value:"Dusky Tit",category:"NonBirdsOfPrey",plural:"Dusky Tits"},{id:1405,label:"Dusky Turtle-Dove",value:"Dusky Turtle-Dove",category:"NonBirdsOfPrey",plural:"Dusky Turtle-Doves"},{id:1406,label:"Dusky Twinspot",value:"Dusky Twinspot",category:"NonBirdsOfPrey",plural:"Dusky Twinspots"},{id:1407,label:"Dusky Warbler",value:"Dusky Warbler",category:"NonBirdsOfPrey",plural:"Dusky Warblers"},{id:1408,label:"Dusky-blue Flycatcher",value:"Dusky-blue Flycatcher",category:"NonBirdsOfPrey",plural:"Dusky-blue Flycatchers"},{id:1409,label:"Dwarf Honeyguide",value:"Dwarf Honeyguide",category:"NonBirdsOfPrey",plural:"Dwarf Honeyguides"},{id:1410,label:"Dybowski's Twinspot",value:"Dybowski's Twinspot",category:"NonBirdsOfPrey",plural:"Dybowski's Twinspots"},{id:1411,label:"Eared Grebe",value:"Eared Grebe",category:"NonBirdsOfPrey",plural:"Eared Grebes"},{id:1412,label:"East Coast Akalat",value:"East Coast Akalat",category:"NonBirdsOfPrey",plural:"East Coast Akalats"},{id:1413,label:"Eastern Bearded-Greenbul",value:"Eastern Bearded-Greenbul",category:"NonBirdsOfPrey",plural:"Eastern Bearded-Greenbuls"},{id:1414,label:"Eastern Black-eared Wheatear",value:"Eastern Black-eared Wheatear",category:"NonBirdsOfPrey",plural:"Eastern Black-eared Wheatears"},{id:1415,label:"Eastern Black-headed Batis",value:"Eastern Black-headed Batis",category:"NonBirdsOfPrey",plural:"Eastern Black-headed Batis"},{id:1416,label:"Eastern Bonelli's Warbler",value:"Eastern Bonelli's Warbler",category:"NonBirdsOfPrey",plural:"Eastern Bonelli's Warblers"},{id:1417,label:"Eastern Bronze-naped Pigeon",value:"Eastern Bronze-naped Pigeon",category:"NonBirdsOfPrey",plural:"Eastern Bronze-naped Pigeons"},{id:1418,label:"Eastern Chanting-Goshawk",value:"Eastern Chanting-Goshawk",category:"NonBirdsOfPrey",plural:"Eastern Chanting-Goshawks"},{id:1419,label:"Eastern Clapper Lark",value:"Eastern Clapper Lark",category:"NonBirdsOfPrey",plural:"Eastern Clapper Larks"},{id:1420,label:"Eastern Double-collared Sunbird",value:"Eastern Double-collared Sunbird",category:"NonBirdsOfPrey",plural:"Eastern Double-collared Sunbirds"},{id:1421,label:"Eastern Long-billed Lark",value:"Eastern Long-billed Lark",category:"NonBirdsOfPrey",plural:"Eastern Long-billed Larks"},{id:1422,label:"Eastern Miombo Sunbird",value:"Eastern Miombo Sunbird",category:"NonBirdsOfPrey",plural:"Eastern Miombo Sunbirds"},{id:1423,label:"Eastern Mountain Greenbul",value:"Eastern Mountain Greenbul",category:"NonBirdsOfPrey",plural:"Eastern Mountain Greenbuls"},{id:1424,label:"Eastern Nicator",value:"Eastern Nicator",category:"NonBirdsOfPrey",plural:"Eastern Nicators"},{id:1425,label:"Eastern Olivaceous Warbler",value:"Eastern Olivaceous Warbler",category:"NonBirdsOfPrey",plural:"Eastern Olivaceous Warblers"},{id:1426,label:"Eastern Orphean Warbler",value:"Eastern Orphean Warbler",category:"NonBirdsOfPrey",plural:"Eastern Orphean Warblers"},{id:1427,label:"Eastern Paradise-Whydah",value:"Eastern Paradise-Whydah",category:"NonBirdsOfPrey",plural:"Eastern Paradise-Whydahs"},{id:1428,label:"Eastern Plantain-eater",value:"Eastern Plantain-eater",category:"NonBirdsOfPrey",plural:"Eastern Plantain-eaters"},{id:1429,label:"Eastern Saw-wing",value:"Eastern Saw-wing",category:"NonBirdsOfPrey",plural:"Eastern Saw-wings"},{id:1430,label:"Eastern Subalpine Warbler",value:"Eastern Subalpine Warbler",category:"NonBirdsOfPrey",plural:"Eastern Subalpine Warblers"},{id:1431,label:"Eastern Violet-backed Sunbird",value:"Eastern Violet-backed Sunbird",category:"NonBirdsOfPrey",plural:"Eastern Violet-backed Sunbirds"},{id:1432,label:"Eastern Yellow Wagtail",value:"Eastern Yellow Wagtail",category:"NonBirdsOfPrey",plural:"Eastern Yellow Wagtails"},{id:1433,label:"Eastern Yellow-billed Hornbill",value:"Eastern Yellow-billed Hornbill",category:"NonBirdsOfPrey",plural:"Eastern Yellow-billed Hornbills"},{id:1434,label:"Egyptian Nightjar",value:"Egyptian Nightjar",category:"NonBirdsOfPrey",plural:"Egyptian Nightjars"},{id:1435,label:"Egyptian Plover",value:"Egyptian Plover",category:"NonBirdsOfPrey",plural:"Egyptian Plovers"},{id:1436,label:"Elegant Tern",value:"Elegant Tern",category:"NonBirdsOfPrey",plural:"Elegant Terns"},{id:1437,label:"Eleonora's Falcon",value:"Eleonora's Falcon",category:"BirdsOfPrey",plural:"Eleonora's Falcons"},{id:1438,label:"Elliot's Woodpecker",value:"Elliot's Woodpecker",category:"NonBirdsOfPrey",plural:"Elliot's Woodpeckers"},{id:1439,label:"Emerald Starling",value:"Emerald Starling",category:"NonBirdsOfPrey",plural:"Emerald Starlings"},{id:1440,label:"Emin's Shrike",value:"Emin's Shrike",category:"NonBirdsOfPrey",plural:"Emin's Shrikes"},{id:1441,label:"Emperor Penguin",value:"Emperor Penguin",category:"NonBirdsOfPrey",plural:"Emperor Penguins"},{id:1442,label:"Equatorial Akalat",value:"Equatorial Akalat",category:"NonBirdsOfPrey",plural:"Equatorial Akalats"},{id:1443,label:"Erckel's Francolin",value:"Erckel's Francolin",category:"NonBirdsOfPrey",plural:"Erckel's Francolins"},{id:1444,label:"Ethiopian Black-headed Oriole",value:"Ethiopian Black-headed Oriole",category:"NonBirdsOfPrey",plural:"Ethiopian Black-headed Orioles"},{id:1445,label:"Ethiopian Boubou",value:"Ethiopian Boubou",category:"NonBirdsOfPrey",plural:"Ethiopian Boubous"},{id:1446,label:"Ethiopian Cisticola",value:"Ethiopian Cisticola",category:"NonBirdsOfPrey",plural:"Ethiopian Cisticolas"},{id:1447,label:"Ethiopian Siskin",value:"Ethiopian Siskin",category:"NonBirdsOfPrey",plural:"Ethiopian Siskins"},{id:1448,label:"Ethiopian Swallow",value:"Ethiopian Swallow",category:"NonBirdsOfPrey",plural:"Ethiopian Swallows"},{id:1449,label:"Eurasian Bittern",value:"Eurasian Bittern",category:"NonBirdsOfPrey",plural:"Eurasian Bitterns"},{id:1450,label:"Eurasian Blackbird",value:"Eurasian Blackbird",category:"NonBirdsOfPrey",plural:"Eurasian Blackbirds"},{id:1451,label:"Eurasian Blackcap",value:"Eurasian Blackcap",category:"NonBirdsOfPrey",plural:"Eurasian Blackcaps"},{id:1452,label:"Eurasian Bullfinch",value:"Eurasian Bullfinch",category:"NonBirdsOfPrey",plural:"Eurasian Bullfinches"},{id:1453,label:"Eurasian Buzzard",value:"Eurasian Buzzard",category:"BirdsOfPrey",plural:"Eurasian Buzzards"},{id:1454,label:"Eurasian Collared-Dove",value:"Eurasian Collared-Dove",category:"NonBirdsOfPrey",plural:"Eurasian Collared-Doves"},{id:1455,label:"Eurasian Coot",value:"Eurasian Coot",category:"NonBirdsOfPrey",plural:"Eurasian Coots"},{id:1456,label:"Eurasian Crag-Martin",value:"Eurasian Crag-Martin",category:"NonBirdsOfPrey",plural:"Eurasian Crag-Martins"},{id:1457,label:"Eurasian Curlew",value:"Eurasian Curlew",category:"NonBirdsOfPrey",plural:"Eurasian Curlews"},{id:1458,label:"Eurasian Dotterel",value:"Eurasian Dotterel",category:"NonBirdsOfPrey",plural:"Eurasian Dotterels"},{id:1459,label:"Eurasian Eagle-Owl",value:"Eurasian Eagle-Owl",category:"BirdsOfPrey",plural:"Eurasian Eagle-Owls"},{id:1460,label:"Eurasian Golden Oriole",value:"Eurasian Golden Oriole",category:"NonBirdsOfPrey",plural:"Eurasian Golden Orioles"},{id:1461,label:"Eurasian Griffon",value:"Eurasian Griffon",category:"BirdsOfPrey",plural:"Eurasian Griffons"},{id:1462,label:"Eurasian Hoopoe",value:"Eurasian Hoopoe",category:"NonBirdsOfPrey",plural:"Eurasian Hoopoes"},{id:1463,label:"Eurasian Jackdaw",value:"Eurasian Jackdaw",category:"NonBirdsOfPrey",plural:"Eurasian Jackdaws"},{id:1464,label:"Eurasian Jay",value:"Eurasian Jay",category:"NonBirdsOfPrey",plural:"Eurasian Jays"},{id:1465,label:"Eurasian Kestrel",value:"Eurasian Kestrel",category:"BirdsOfPrey",plural:"Eurasian Kestrels"},{id:1466,label:"Eurasian Linnet",value:"Eurasian Linnet",category:"NonBirdsOfPrey",plural:"Eurasian Linnets"},{id:1467,label:"Eurasian Magpie",value:"Eurasian Magpie",category:"NonBirdsOfPrey",plural:"Eurasian Magpies"},{id:1468,label:"Eurasian Moorhen",value:"Eurasian Moorhen",category:"NonBirdsOfPrey",plural:"Eurasian Moorhens"},{id:1469,label:"Eurasian Nightjar",value:"Eurasian Nightjar",category:"NonBirdsOfPrey",plural:"Eurasian Nightjars"},{id:1470,label:"Eurasian Nutcracker",value:"Eurasian Nutcracker",category:"NonBirdsOfPrey",plural:"Eurasian Nutcrackers"},{id:1471,label:"Eurasian Nuthatch",value:"Eurasian Nuthatch",category:"NonBirdsOfPrey",plural:"Eurasian Nuthatches"},{id:1472,label:"Eurasian Oystercatcher",value:"Eurasian Oystercatcher",category:"NonBirdsOfPrey",plural:"Eurasian Oystercatchers"},{id:1473,label:"Eurasian Penduline-Tit",value:"Eurasian Penduline-Tit",category:"NonBirdsOfPrey",plural:"Eurasian Penduline-Tits"},{id:1474,label:"Eurasian Reed Warbler",value:"Eurasian Reed Warbler",category:"NonBirdsOfPrey",plural:"Eurasian Reed Warblers"},{id:1475,label:"Eurasian Reed-Warbler",value:"Eurasian Reed-Warbler",category:"NonBirdsOfPrey",plural:"Eurasian Reed-Warblers"},{id:1476,label:"Eurasian Scops-Owl",value:"Eurasian Scops-Owl",category:"BirdsOfPrey",plural:"Eurasian Scops-Owls"},{id:1477,label:"Eurasian Siskin",value:"Eurasian Siskin",category:"NonBirdsOfPrey",plural:"Eurasian Siskins"},{id:1478,label:"Eurasian Skylark",value:"Eurasian Skylark",category:"NonBirdsOfPrey",plural:"Eurasian Skylarks"},{id:1479,label:"Eurasian Sparrowhawk",value:"Eurasian Sparrowhawk",category:"BirdsOfPrey",plural:"Eurasian Sparrowhawks"},{id:1480,label:"Eurasian Spoonbill",value:"Eurasian Spoonbill",category:"NonBirdsOfPrey",plural:"Eurasian Spoonbills"},{id:1481,label:"Eurasian Thick-knee",value:"Eurasian Thick-knee",category:"NonBirdsOfPrey",plural:"Eurasian Thick-knees"},{id:1482,label:"Eurasian Tree Sparrow",value:"Eurasian Tree Sparrow",category:"NonBirdsOfPrey",plural:"Eurasian Tree Sparrows"},{id:1483,label:"Eurasian Wigeon",value:"Eurasian Wigeon",category:"NonBirdsOfPrey",plural:"Eurasian Wigeons"},{id:1484,label:"Eurasian Woodcock",value:"Eurasian Woodcock",category:"NonBirdsOfPrey",plural:"Eurasian Woodcocks"},{id:1485,label:"Eurasian Wren",value:"Eurasian Wren",category:"NonBirdsOfPrey",plural:"Eurasian Wrens"},{id:1486,label:"Eurasian Wryneck",value:"Eurasian Wryneck",category:"NonBirdsOfPrey",plural:"Eurasian Wrynecks"},{id:1487,label:"European Golden-Plover",value:"European Golden-Plover",category:"NonBirdsOfPrey",plural:"European Golden-Plovers"},{id:1488,label:"European Goldfinch",value:"European Goldfinch",category:"NonBirdsOfPrey",plural:"European Goldfinches"},{id:1489,label:"European Greenfinch",value:"European Greenfinch",category:"NonBirdsOfPrey",plural:"European Greenfinches"},{id:1490,label:"European Pied Flycatcher",value:"European Pied Flycatcher",category:"NonBirdsOfPrey",plural:"European Pied Flycatchers"},{id:1491,label:"European Robin",value:"European Robin",category:"NonBirdsOfPrey",plural:"European Robins"},{id:1492,label:"European Serin",value:"European Serin",category:"NonBirdsOfPrey",plural:"European Serins"},{id:1493,label:"European Shag",value:"European Shag",category:"NonBirdsOfPrey",plural:"European Shags"},{id:1494,label:"European Starling",value:"European Starling",category:"NonBirdsOfPrey",plural:"European Starlings"},{id:1495,label:"European Stonechat",value:"European Stonechat",category:"NonBirdsOfPrey",plural:"European Stonechats"},{id:1496,label:"European Storm-Petrel",value:"European Storm-Petrel",category:"NonBirdsOfPrey",plural:"European Storm-Petrels"},{id:1497,label:"European Turtle-Dove",value:"European Turtle-Dove",category:"NonBirdsOfPrey",plural:"European Turtle-Doves"},{id:1498,label:"Evergreen-forest Warbler",value:"Evergreen-forest Warbler",category:"NonBirdsOfPrey",plural:"Evergreen-forest Warblers"},{id:1499,label:"Exclamatory Paradise-Whydah",value:"Exclamatory Paradise-Whydah",category:"NonBirdsOfPrey",plural:"Exclamatory Paradise-Whydahs"},{id:1500,label:"Eyebrowed Thrush",value:"Eyebrowed Thrush",category:"NonBirdsOfPrey",plural:"Eyebrowed Thrushes"},{id:1501,label:"Fairy Prion",value:"Fairy Prion",category:"NonBirdsOfPrey",plural:"Fairy Prions"},{id:1502,label:"Fan-tailed Grassbird",value:"Fan-tailed Grassbird",category:"NonBirdsOfPrey",plural:"Fan-tailed Grassbirds"},{id:1503,label:"Fan-tailed Raven",value:"Fan-tailed Raven",category:"NonBirdsOfPrey",plural:"Fan-tailed Ravens"},{id:1504,label:"Fan-tailed Widowbird",value:"Fan-tailed Widowbird",category:"NonBirdsOfPrey",plural:"Fan-tailed Widowbirds"},{id:1505,label:"Fanti Drongo",value:"Fanti Drongo",category:"NonBirdsOfPrey",plural:"Fanti Drongos"},{id:1506,label:"Fasciated Snake-Eagle",value:"Fasciated Snake-Eagle",category:"BirdsOfPrey",plural:"Fasciated Snake-Eagles"},{id:1507,label:"Fawn-breasted Waxbill",value:"Fawn-breasted Waxbill",category:"NonBirdsOfPrey",plural:"Fawn-breasted Waxbills"},{id:1508,label:"Fea's Petrel",value:"Fea's Petrel",category:"NonBirdsOfPrey",plural:"Fea's Petrels"},{id:1509,label:"Ferruginous Duck",value:"Ferruginous Duck",category:"NonBirdsOfPrey",plural:"Ferruginous Ducks"},{id:1510,label:"Fieldfare",value:"Fieldfare",category:"NonBirdsOfPrey",plural:"Fieldfares"},{id:1511,label:"Fiery-breasted Bushshrike",value:"Fiery-breasted Bushshrike",category:"NonBirdsOfPrey",plural:"Fiery-breasted Bushshrikes"},{id:1512,label:"Fine-spotted Woodpecker",value:"Fine-spotted Woodpecker",category:"NonBirdsOfPrey",plural:"Fine-spotted Woodpeckers"},{id:1513,label:"Finsch's Flycatcher-Thrush",value:"Finsch's Flycatcher-Thrush",category:"NonBirdsOfPrey",plural:"Finsch's Flycatcher-Thrushes"},{id:1514,label:"Finsch's Francolin",value:"Finsch's Francolin",category:"NonBirdsOfPrey",plural:"Finsch's Francolins"},{id:1515,label:"Finsch's Wheatear",value:"Finsch's Wheatear",category:"NonBirdsOfPrey",plural:"Finsch's Wheatears"},{id:1516,label:"Fire-bellied Woodpecker",value:"Fire-bellied Woodpecker",category:"NonBirdsOfPrey",plural:"Fire-bellied Woodpeckers"},{id:1517,label:"Fire-crested Alethe",value:"Fire-crested Alethe",category:"NonBirdsOfPrey",plural:"Fire-crested Alethes"},{id:1518,label:"Fire-fronted Bishop",value:"Fire-fronted Bishop",category:"NonBirdsOfPrey",plural:"Fire-fronted Bishops"},{id:1519,label:"Fire-fronted Serin",value:"Fire-fronted Serin",category:"NonBirdsOfPrey",plural:"Fire-fronted Serins"},{id:1520,label:"Fischer's Greenbul",value:"Fischer's Greenbul",category:"NonBirdsOfPrey",plural:"Fischer's Greenbuls"},{id:1521,label:"Fischer's Lovebird",value:"Fischer's Lovebird",category:"NonBirdsOfPrey",plural:"Fischer's Lovebirds"},{id:1522,label:"Fischer's Sparrowlark",value:"Fischer's Sparrowlark",category:"NonBirdsOfPrey",plural:"Fischer's Sparrowlarks"},{id:1523,label:"Fischer's Starling",value:"Fischer's Starling",category:"NonBirdsOfPrey",plural:"Fischer's Starlings"},{id:1524,label:"Fischer's Turaco",value:"Fischer's Turaco",category:"NonBirdsOfPrey",plural:"Fischer's Turacos"},{id:1525,label:"Flesh-footed Shearwater",value:"Flesh-footed Shearwater",category:"NonBirdsOfPrey",plural:"Flesh-footed Shearwaters"},{id:1526,label:"Forbes-Watson's Swift",value:"Forbes-Watson's Swift",category:"NonBirdsOfPrey",plural:"Forbes-Watson's Swifts"},{id:1527,label:"Forbes's Plover",value:"Forbes's Plover",category:"NonBirdsOfPrey",plural:"Forbes's Plovers"},{id:1528,label:"Forest Buzzard",value:"Forest Buzzard",category:"BirdsOfPrey",plural:"Forest Buzzards"},{id:1529,label:"Forest Canary",value:"Forest Canary",category:"NonBirdsOfPrey",plural:"Forest Canaries"},{id:1530,label:"Forest Double-collared Sunbird",value:"Forest Double-collared Sunbird",category:"NonBirdsOfPrey",plural:"Forest Double-collared Sunbirds"},{id:1531,label:"Forest Penduline-Tit",value:"Forest Penduline-Tit",category:"NonBirdsOfPrey",plural:"Forest Penduline-Tits"},{id:1532,label:"Forest Robin",value:"Forest Robin",category:"NonBirdsOfPrey",plural:"Forest Robins"},{id:1533,label:"Forest Scrub-Robin",value:"Forest Scrub-Robin",category:"NonBirdsOfPrey",plural:"Forest Scrub-Robins"},{id:1534,label:"Forest Swallow",value:"Forest Swallow",category:"NonBirdsOfPrey",plural:"Forest Swallows"},{id:1535,label:"Forest Weaver",value:"Forest Weaver",category:"NonBirdsOfPrey",plural:"Forest Weavers"},{id:1536,label:"Forest White-eye",value:"Forest White-eye",category:"NonBirdsOfPrey",plural:"Forest White-eyes"},{id:1537,label:"Forest Woodhoopoe",value:"Forest Woodhoopoe",category:"NonBirdsOfPrey",plural:"Forest Woodhoopoes"},{id:1538,label:"Four-banded Sandgrouse",value:"Four-banded Sandgrouse",category:"NonBirdsOfPrey",plural:"Four-banded Sandgrouses"},{id:1539,label:"Four-colored Bushshrike",value:"Four-colored Bushshrike",category:"NonBirdsOfPrey",plural:"Four-colored Bushshrikes"},{id:1540,label:"Fox Kestrel",value:"Fox Kestrel",category:"BirdsOfPrey",plural:"Fox Kestrels"},{id:1541,label:"Fox's Weaver",value:"Fox's Weaver",category:"NonBirdsOfPrey",plural:"Fox's Weavers"},{id:1542,label:"Foxy Cisticola",value:"Foxy Cisticola",category:"NonBirdsOfPrey",plural:"Foxy Cisticolas"},{id:1543,label:"Foxy Lark",value:"Foxy Lark",category:"NonBirdsOfPrey",plural:"Foxy Larks"},{id:1544,label:"Franklin's Gull",value:"Franklin's Gull",category:"NonBirdsOfPrey",plural:"Franklin's Gulls"},{id:1545,label:"Fraser's Eagle-Owl",value:"Fraser's Eagle-Owl",category:"BirdsOfPrey",plural:"Fraser's Eagle-Owls"},{id:1546,label:"Fraser's Sunbird",value:"Fraser's Sunbird",category:"NonBirdsOfPrey",plural:"Fraser's Sunbirds"},{id:1547,label:"Freckled Nightjar",value:"Freckled Nightjar",category:"NonBirdsOfPrey",plural:"Freckled Nightjars"},{id:1548,label:"Friedmann's Lark",value:"Friedmann's Lark",category:"NonBirdsOfPrey",plural:"Friedmann's Larks"},{id:1549,label:"Fuerteventura Stonechat",value:"Fuerteventura Stonechat",category:"NonBirdsOfPrey",plural:"Fuerteventura Stonechats"},{id:1550,label:"F\u00fclleborn's Boubou",value:"F\u00fclleborn's Boubou",category:"NonBirdsOfPrey",plural:"F\u00fclleborn's Boubous"},{id:1551,label:"F\u00fclleborn's Longclaw",value:"F\u00fclleborn's Longclaw",category:"NonBirdsOfPrey",plural:"F\u00fclleborn's Longclaws"},{id:1552,label:"Fulmar Prion",value:"Fulmar Prion",category:"NonBirdsOfPrey",plural:"Fulmar Prions"},{id:1553,label:"Fulvous Chatterer",value:"Fulvous Chatterer",category:"NonBirdsOfPrey",plural:"Fulvous Chatterers"},{id:1554,label:"Fynbos Buttonquail",value:"Fynbos Buttonquail",category:"NonBirdsOfPrey",plural:"Fynbos Buttonquails"},{id:1555,label:"Gabela Akalat",value:"Gabela Akalat",category:"NonBirdsOfPrey",plural:"Gabela Akalats"},{id:1556,label:"Gabela Bushshrike",value:"Gabela Bushshrike",category:"NonBirdsOfPrey",plural:"Gabela Bushshrikes"},{id:1557,label:"Gabon Boubou",value:"Gabon Boubou",category:"NonBirdsOfPrey",plural:"Gabon Boubous"},{id:1558,label:"Gabon Coucal",value:"Gabon Coucal",category:"NonBirdsOfPrey",plural:"Gabon Coucals"},{id:1559,label:"Gabon Woodpecker",value:"Gabon Woodpecker",category:"NonBirdsOfPrey",plural:"Gabon Woodpeckers"},{id:1560,label:"Gadwall",value:"Gadwall",category:"NonBirdsOfPrey",plural:"Gadwalls"},{id:1561,label:"Gambaga Flycatcher",value:"Gambaga Flycatcher",category:"NonBirdsOfPrey",plural:"Gambaga Flycatchers"},{id:1562,label:"Garganey",value:"Garganey",category:"NonBirdsOfPrey",plural:"Garganeys"},{id:1563,label:"Gentoo Penguin",value:"Gentoo Penguin",category:"NonBirdsOfPrey",plural:"Gentoo Penguins"},{id:1564,label:"Ghana Cuckooshrike",value:"Ghana Cuckooshrike",category:"NonBirdsOfPrey",plural:"Ghana Cuckooshrikes"},{id:1565,label:"Gillett's Lark",value:"Gillett's Lark",category:"NonBirdsOfPrey",plural:"Gillett's Larks"},{id:1566,label:"Glaucous Gull",value:"Glaucous Gull",category:"NonBirdsOfPrey",plural:"Glaucous Gulls"},{id:1567,label:"Glaucous-winged Gull",value:"Glaucous-winged Gull",category:"NonBirdsOfPrey",plural:"Glaucous-winged Gulls"},{id:1568,label:"Glossy-backed Drongo",value:"Glossy-backed Drongo",category:"NonBirdsOfPrey",plural:"Glossy-backed Drongos"},{id:1569,label:"Goldcrest",value:"Goldcrest",category:"NonBirdsOfPrey",plural:"Goldcrests"},{id:1570,label:"Golden Eagle",value:"Golden Eagle",category:"BirdsOfPrey",plural:"Golden Eagles"},{id:1571,label:"Golden Greenbul",value:"Golden Greenbul",category:"NonBirdsOfPrey",plural:"Golden Greenbuls"},{id:1572,label:"Golden Nightjar",value:"Golden Nightjar",category:"NonBirdsOfPrey",plural:"Golden Nightjars"},{id:1573,label:"Golden Palm Weaver",value:"Golden Palm Weaver",category:"NonBirdsOfPrey",plural:"Golden Palm Weavers"},{id:1574,label:"Golden Pipit",value:"Golden Pipit",category:"NonBirdsOfPrey",plural:"Golden Pipits"},{id:1575,label:"Golden-backed Bishop",value:"Golden-backed Bishop",category:"NonBirdsOfPrey",plural:"Golden-backed Bishops"},{id:1576,label:"Golden-backed Weaver",value:"Golden-backed Weaver",category:"NonBirdsOfPrey",plural:"Golden-backed Weavers"},{id:1577,label:"Golden-breasted Starling",value:"Golden-breasted Starling",category:"NonBirdsOfPrey",plural:"Golden-breasted Starlings"},{id:1578,label:"Golden-crowned Woodpecker",value:"Golden-crowned Woodpecker",category:"NonBirdsOfPrey",plural:"Golden-crowned Woodpeckers"},{id:1579,label:"Golden-naped Weaver",value:"Golden-naped Weaver",category:"NonBirdsOfPrey",plural:"Golden-naped Weavers"},{id:1580,label:"Golden-winged Sunbird",value:"Golden-winged Sunbird",category:"NonBirdsOfPrey",plural:"Golden-winged Sunbirds"},{id:1581,label:"Gosling's Apalis",value:"Gosling's Apalis",category:"NonBirdsOfPrey",plural:"Gosling's Apalis"},{id:1582,label:"Gosling's Bunting",value:"Gosling's Bunting",category:"NonBirdsOfPrey",plural:"Gosling's Buntings"},{id:1583,label:"Gough Bunting",value:"Gough Bunting",category:"NonBirdsOfPrey",plural:"Gough Buntings"},{id:1584,label:"Gough Moorhen",value:"Gough Moorhen",category:"NonBirdsOfPrey",plural:"Gough Moorhens"},{id:1585,label:"Graceful Prinia",value:"Graceful Prinia",category:"NonBirdsOfPrey",plural:"Graceful Prinias"},{id:1586,label:"Grant's Bluebill",value:"Grant's Bluebill",category:"NonBirdsOfPrey",plural:"Grant's Bluebills"},{id:1587,label:"Grasshopper Buzzard",value:"Grasshopper Buzzard",category:"BirdsOfPrey",plural:"Grasshopper Buzzards"},{id:1588,label:"Grauer's Broadbill",value:"Grauer's Broadbill",category:"NonBirdsOfPrey",plural:"Grauer's Broadbills"},{id:1589,label:"Grauer's Cuckooshrike",value:"Grauer's Cuckooshrike",category:"NonBirdsOfPrey",plural:"Grauer's Cuckooshrikes"},{id:1590,label:"Grauer's Swamp Warbler",value:"Grauer's Swamp Warbler",category:"NonBirdsOfPrey",plural:"Grauer's Swamp Warblers"},{id:1591,label:"Grauer's Warbler",value:"Grauer's Warbler",category:"NonBirdsOfPrey",plural:"Grauer's Warblers"},{id:1592,label:"Gray Apalis",value:"Gray Apalis",category:"NonBirdsOfPrey",plural:"Gray Apalis"},{id:1593,label:"Gray Crowned-Crane",value:"Gray Crowned-Crane",category:"NonBirdsOfPrey",plural:"Gray Crowned-Cranes"},{id:1594,label:"Gray Go-away-bird",value:"Gray Go-away-bird",category:"NonBirdsOfPrey",plural:"Gray Go-away-birds"},{id:1595,label:"Gray Greenbul",value:"Gray Greenbul",category:"NonBirdsOfPrey",plural:"Gray Greenbuls"},{id:1596,label:"Gray Ground-Thrush",value:"Gray Ground-Thrush",category:"NonBirdsOfPrey",plural:"Gray Ground-Thrushes"},{id:1597,label:"Gray Kestrel",value:"Gray Kestrel",category:"NonBirdsOfPrey",plural:"Gray Kestrels"},{id:1598,label:"Gray Longbill",value:"Gray Longbill",category:"NonBirdsOfPrey",plural:"Gray Longbills"},{id:1599,label:"Gray Parrot",value:"Gray Parrot",category:"NonBirdsOfPrey",plural:"Gray Parrots"},{id:1600,label:"Gray Petrel",value:"Gray Petrel",category:"NonBirdsOfPrey",plural:"Gray Petrels"},{id:1601,label:"Gray Pratincole",value:"Gray Pratincole",category:"NonBirdsOfPrey",plural:"Gray Pratincoles"},{id:1602,label:"Gray Tit",value:"Gray Tit",category:"NonBirdsOfPrey",plural:"Gray Tits"},{id:1603,label:"Gray Tit-Flycatcher",value:"Gray Tit-Flycatcher",category:"NonBirdsOfPrey",plural:"Gray Tit-Flycatchers"},{id:1604,label:"Gray Wagtail",value:"Gray Wagtail",category:"NonBirdsOfPrey",plural:"Gray Wagtails"},{id:1605,label:"Gray Wren-Warbler",value:"Gray Wren-Warbler",category:"NonBirdsOfPrey",plural:"Gray Wren-Warblers"},{id:1606,label:"Gray-backed Fiscal",value:"Gray-backed Fiscal",category:"NonBirdsOfPrey",plural:"Grey-backed Fiscals"},{id:1607,label:"Gray-backed Sparrowlark",value:"Gray-backed Sparrowlark",category:"NonBirdsOfPrey",plural:"Gray-backed Sparrowlarks"},{id:1608,label:"Gray-backed Storm-Petrel",value:"Gray-backed Storm-Petrel",category:"NonBirdsOfPrey",plural:"Gray-backed Storm-Petrels"},{id:1609,label:"Gray-breasted Francolin",value:"Gray-breasted Francolin",category:"NonBirdsOfPrey",plural:"Gray-breasted Francolins"},{id:1610,label:"Gray-capped Warbler",value:"Gray-capped Warbler",category:"NonBirdsOfPrey",plural:null},{id:1611,label:"Gray-chested Babbler",value:"Gray-chested Babbler",category:"NonBirdsOfPrey",plural:"Gray-chested Babblers"},{id:1612,label:"Gray-crested Helmetshrike",value:"Gray-crested Helmetshrike",category:"NonBirdsOfPrey",plural:"Gray-crested Helmetshrikes"},{id:1613,label:"Gray-faced Petrel",value:"Gray-faced Petrel",category:"NonBirdsOfPrey",plural:"Gray-faced Petrels"},{id:1614,label:"Gray-green Bushshrike",value:"Gray-green Bushshrike",category:"NonBirdsOfPrey",plural:"Gray-green Bushshrikes"},{id:1615,label:"Gray-headed Albatross",value:"Gray-headed Albatross",category:"NonBirdsOfPrey",plural:"Gray-headed Albatrosses"},{id:1616,label:"Gray-headed Batis",value:"Gray-headed Batis",category:"NonBirdsOfPrey",plural:"Gray-headed Batis"},{id:1617,label:"Gray-headed Bristlebill",value:"Gray-headed Bristlebill",category:"NonBirdsOfPrey",plural:"Gray-headed Bristlebills"},{id:1618,label:"Gray-headed Broadbill",value:"Gray-headed Broadbill",category:"NonBirdsOfPrey",plural:"Gray-headed Broadbills"},{id:1619,label:"Gray-headed Bushshrike",value:"Gray-headed Bushshrike",category:"NonBirdsOfPrey",plural:"Gray-headed Bushshrikes"},{id:1620,label:"Gray-headed Greenbul",value:"Gray-headed Greenbul",category:"NonBirdsOfPrey",plural:"Gray-headed Greenbuls"},{id:1621,label:"Gray-headed Lovebird",value:"Gray-headed Lovebird",category:"NonBirdsOfPrey",plural:"Gray-headed Lovebirds"},{id:1622,label:"Gray-headed Nigrita",value:"Gray-headed Nigrita",category:"NonBirdsOfPrey",plural:"Gray-headed Nigritas"},{id:1623,label:"Gray-headed Oliveback",value:"Gray-headed Oliveback",category:"NonBirdsOfPrey",plural:"Gray-headed Olivebacks"},{id:1624,label:"Gray-headed Silverbill",value:"Gray-headed Silverbill",category:"NonBirdsOfPrey",plural:"Gray-headed Silverbills"},{id:1625,label:"Gray-headed Social-Weaver",value:"Gray-headed Social-Weaver",category:"NonBirdsOfPrey",plural:"Gray-headed Social-Weavers"},{id:1626,label:"Gray-headed Sunbird",value:"Gray-headed Sunbird",category:"NonBirdsOfPrey",plural:"Gray-headed Sunbirds"},{id:1627,label:"Gray-hooded Gull",value:"Gray-hooded Gull",category:"NonBirdsOfPrey",plural:"Gray-hooded Gulls"},{id:1628,label:"Gray-necked Bunting",value:"Gray-necked Bunting",category:"NonBirdsOfPrey",plural:"Gray-necked Buntings"},{id:1629,label:"Gray-necked Rockfowl",value:"Gray-necked Rockfowl",category:"NonBirdsOfPrey",plural:"Gray-necked Rockfowls"},{id:1630,label:"Gray-olive Greenbul",value:"Gray-olive Greenbul",category:"NonBirdsOfPrey",plural:"Gray-olive Greenbuls"},{id:1631,label:"Gray-rumped Swallow",value:"Gray-rumped Swallow",category:"NonBirdsOfPrey",plural:"Gray-rumped Swallows"},{id:1632,label:"Gray-striped Francolin",value:"Gray-striped Francolin",category:"NonBirdsOfPrey",plural:"Gray-striped Francolins"},{id:1633,label:"Gray-throated Barbet",value:"Gray-throated Barbet",category:"NonBirdsOfPrey",plural:"Gray-throated Barbets"},{id:1634,label:"Gray-throated Rail",value:"Gray-throated Rail",category:"NonBirdsOfPrey",plural:"Gray-throated Rails"},{id:1635,label:"Gray-throated Tit-Flycatcher",value:"Gray-throated Tit-Flycatcher",category:"NonBirdsOfPrey",plural:"Gray-throated Tit-Flycatchers"},{id:1636,label:"Gray-winged Francolin",value:"Gray-winged Francolin",category:"NonBirdsOfPrey",plural:"Gray-winged Francolins"},{id:1637,label:"Gray-winged Robin-Chat",value:"Gray-winged Robin-Chat",category:"NonBirdsOfPrey",plural:"Gray-winged Robin-Chats"},{id:1638,label:"Gray's Lark",value:"Gray's Lark",category:"NonBirdsOfPrey",plural:"Gray's Larks"},{id:1639,label:"Grayish Eagle-Owl",value:"Grayish Eagle-Owl",category:"BirdsOfPrey",plural:"Grayish Eagle-Owls"},{id:1640,label:"Graylag Goose",value:"Graylag Goose",category:"NonBirdsOfPrey",plural:"Graylag Geese"},{id:1641,label:"Great Bittern",value:"Great Bittern",category:"NonBirdsOfPrey",plural:"Great Bitterns"},{id:1642,label:"Great Black-backed Gull",value:"Great Black-backed Gull",category:"NonBirdsOfPrey",plural:"Great Black-backed Gulls"},{id:1643,label:"Great Blue Turaco",value:"Great Blue Turaco",category:"NonBirdsOfPrey",plural:"Great Blue Turacos"},{id:1644,label:"Great Bustard",value:"Great Bustard",category:"NonBirdsOfPrey",plural:"Great Bustards"},{id:1645,label:"Great Cormorant",value:"Great Cormorant",category:"NonBirdsOfPrey",plural:"Great Cormorants"},{id:1646,label:"Great Crested Tern",value:"Great Crested Tern",category:"NonBirdsOfPrey",plural:"Great Crested Terns"},{id:1647,label:"Great Frigatebird",value:"Great Frigatebird",category:"NonBirdsOfPrey",plural:"Great Frigatebirds"},{id:1648,label:"Great Gray Shrike",value:"Great Gray Shrike",category:"NonBirdsOfPrey",plural:"Great Gray Shrikes"},{id:1649,label:"Great Knot",value:"Great Knot",category:"NonBirdsOfPrey",plural:"Great Knots"},{id:1650,label:"Great Reed Warbler",value:"Great Reed Warbler",category:"NonBirdsOfPrey",plural:"Great Reed Warblers"},{id:1651,label:"Great Rufous Sparrow",value:"Great Rufous Sparrow",category:"NonBirdsOfPrey",plural:"Great Rufous Sparrows"},{id:1652,label:"Great Shearwater",value:"Great Shearwater",category:"NonBirdsOfPrey",plural:"Great Shearwaters"},{id:1653,label:"Great Skua",value:"Great Skua",category:"NonBirdsOfPrey",plural:"Great Skuas"},{id:1654,label:"Great Snipe",value:"Great Snipe",category:"NonBirdsOfPrey",plural:"Great Snipes"},{id:1655,label:"Great Spotted Cuckoo",value:"Great Spotted Cuckoo",category:"NonBirdsOfPrey",plural:"Great Spotted Cuckoos"},{id:1656,label:"Great Spotted Woodpecker",value:"Great Spotted Woodpecker",category:"NonBirdsOfPrey",plural:"Great Spotted Woodpeckers"},{id:1657,label:"Great Tit",value:"Great Tit",category:"NonBirdsOfPrey",plural:"Great Tits"},{id:1658,label:"Great-winged Petrel",value:"Great-winged Petrel",category:"NonBirdsOfPrey",plural:"Great-winged Petrels"},{id:1659,label:"Greater Hoopoe-Lark",value:"Greater Hoopoe-Lark",category:"NonBirdsOfPrey",plural:"Greater Hoopoe-Larks"},{id:1660,label:"Greater Painted-Snipe",value:"Greater Painted-Snipe",category:"NonBirdsOfPrey",plural:"Greater Painted-Snipes"},{id:1661,label:"Greater Sand Plover",value:"Greater Sand Plover",category:"NonBirdsOfPrey",plural:"Greater Sand Plovers"},{id:1662,label:"Greater Sand-Plover",value:"Greater Sand-Plover",category:"NonBirdsOfPrey",plural:"Greater Sand-Plovers"},{id:1663,label:"Greater Scaup",value:"Greater Scaup",category:"NonBirdsOfPrey",plural:"Greater Scaups"},{id:1664,label:"Greater Sheathbill",value:"Greater Sheathbill",category:"NonBirdsOfPrey",plural:"Greater Sheathbills"},{id:1665,label:"Greater Short-toed Lark",value:"Greater Short-toed Lark",category:"NonBirdsOfPrey",plural:"Greater Short-toed Larks"},{id:1666,label:"Greater Spotted Eagle",value:"Greater Spotted Eagle",category:"BirdsOfPrey",plural:"Greater Spotted Eagles"},{id:1667,label:"Greater Swamp Warbler",value:"Greater Swamp Warbler",category:"NonBirdsOfPrey",plural:"Greater Swamp Warblers"},{id:1668,label:"Greater Swamp-Warbler",value:"Greater Swamp-Warbler",category:"NonBirdsOfPrey",plural:"Greater Swamp-Warblers"},{id:1669,label:"Greater White-fronted Goose",value:"Greater White-fronted Goose",category:"NonBirdsOfPrey",plural:"Greater White-fronted Geese"},{id:1670,label:"Greater Whitethroat",value:"Greater Whitethroat",category:"NonBirdsOfPrey",plural:"Greater Whitethroats"},{id:1671,label:"Greater Yellowlegs",value:"Greater Yellowlegs",category:"NonBirdsOfPrey",plural:"Greater Yellowlegs"},{id:1672,label:"Green Barbet",value:"Green Barbet",category:"NonBirdsOfPrey",plural:"Green Barbets"},{id:1673,label:"Green Bee-eater",value:"Green Bee-eater",category:"NonBirdsOfPrey",plural:"Green Bee-eaters"},{id:1674,label:"Green Hylia",value:"Green Hylia",category:"NonBirdsOfPrey",plural:"Green Hylias"},{id:1675,label:"Green Indigobird",value:"Green Indigobird",category:"NonBirdsOfPrey",plural:"Green Indigobirds"},{id:1676,label:"Green Longtail",value:"Green Longtail",category:"NonBirdsOfPrey",plural:"Green Longtails"},{id:1677,label:"Green Malkoha",value:"Green Malkoha",category:"NonBirdsOfPrey",plural:"Green Malkohas"},{id:1678,label:"Green Sunbird",value:"Green Sunbird",category:"NonBirdsOfPrey",plural:"Green Sunbirds"},{id:1679,label:"Green Tinkerbird",value:"Green Tinkerbird",category:"NonBirdsOfPrey",plural:"Green Tinkerbirds"},{id:1680,label:"Green White-eye",value:"Green White-eye",category:"NonBirdsOfPrey",plural:"Green White-eyes"},{id:1681,label:"Green-backed Camaroptera",value:"Green-backed Camaroptera",category:"NonBirdsOfPrey",plural:"Green-backed Camaropteras"},{id:1682,label:"Green-backed Eremomela",value:"Green-backed Eremomela",category:"NonBirdsOfPrey",plural:"Green-backed Eremomelas"},{id:1683,label:"Green-backed Honeybird",value:"Green-backed Honeybird",category:"NonBirdsOfPrey",plural:"Green-backed Honeybirds"},{id:1684,label:"Green-backed Honeyguide",value:"Green-backed Honeyguide",category:"NonBirdsOfPrey",plural:"Green-backed Honeyguides"},{id:1685,label:"Green-backed Twinspot",value:"Green-backed Twinspot",category:"NonBirdsOfPrey",plural:"Green-backed Twinspots"},{id:1686,label:"Green-backed Woodpecker",value:"Green-backed Woodpecker",category:"NonBirdsOfPrey",plural:"Green-backed Woodpeckers"},{id:1687,label:"Green-breasted Bushshrike",value:"Green-breasted Bushshrike",category:"NonBirdsOfPrey",plural:"Green-breasted Bushshrikes"},{id:1688,label:"Green-breasted Pitta",value:"Green-breasted Pitta",category:"NonBirdsOfPrey",plural:"Green-breasted Pittas"},{id:1689,label:"Green-headed Oriole",value:"Green-headed Oriole",category:"NonBirdsOfPrey",plural:"Green-headed Orioles"},{id:1690,label:"Green-headed Sunbird",value:"Green-headed Sunbird",category:"NonBirdsOfPrey",plural:"Green-headed Sunbirds"},{id:1691,label:"Green-tailed Bristlebill",value:"Green-tailed Bristlebill",category:"NonBirdsOfPrey",plural:"Green-tailed Bristlebills"},{id:1692,label:"Green-throated Sunbird",value:"Green-throated Sunbird",category:"NonBirdsOfPrey",plural:"Green-throated Sunbirds"},{id:1693,label:"Green-winged Teal",value:"Green-winged Teal",category:"NonBirdsOfPrey",plural:"Green-winged Teals"},{id:1694,label:"Greencap Eremomela",value:"Greencap Eremomela",category:"NonBirdsOfPrey",plural:"Greencap Eremomelas"},{id:1695,label:"Greenish Warbler",value:"Greenish Warbler",category:"NonBirdsOfPrey",plural:"Greenish Warblers"},{id:1696,label:"Grey Penduline-Tit",value:"Grey Penduline-Tit",category:"NonBirdsOfPrey",plural:"Grey Penduline-Tits"},{id:1697,label:"Grey Phalarope",value:"Grey Phalarope",category:"NonBirdsOfPrey",plural:"Grey Phalaropes"},{id:1698,label:"Grey Sunbird",value:"Grey Sunbird",category:"NonBirdsOfPrey",plural:"Grey Sunbirds"},{id:1699,label:"Grey Waxbill",value:"Grey Waxbill",category:"NonBirdsOfPrey",plural:null},{id:1700,label:"Grey-backed Cisticola",value:"Grey-backed Cisticola",category:"NonBirdsOfPrey",plural:"Grey-backed Cisticolas"},{id:1701,label:"Grimwood's Longclaw",value:"Grimwood's Longclaw",category:"NonBirdsOfPrey",plural:"Grimwood's Longclaws"},{id:1702,label:"Grosbeak Weaver",value:"Grosbeak Weaver",category:"NonBirdsOfPrey",plural:"Grosbeak Weavers"},{id:1703,label:"Ground Woodpecker",value:"Ground Woodpecker",category:"NonBirdsOfPrey",plural:"Ground Woodpeckers"},{id:1704,label:"Guinea Turaco",value:"Guinea Turaco",category:"NonBirdsOfPrey",plural:"Guinea Turacos"},{id:1705,label:"Gull-billed Tern",value:"Gull-billed Tern",category:"NonBirdsOfPrey",plural:"Gull-billed Terns"},{id:1706,label:"Hair-crested Drongo",value:"Hair-crested Drongo",category:"NonBirdsOfPrey",plural:"Hair-crested Drongos"},{id:1707,label:"Hairy-breasted Barbet",value:"Hairy-breasted Barbet",category:"NonBirdsOfPrey",plural:"Hairy-breasted Barbets"},{id:1708,label:"Hammerkop",value:"Hammerkop",category:"NonBirdsOfPrey",plural:"Hammerkops"},{id:1709,label:"Handsome Francolin",value:"Handsome Francolin",category:"NonBirdsOfPrey",plural:"Handsome Francolins"},{id:1710,label:"Hartert's Camaroptera",value:"Hartert's Camaroptera",category:"NonBirdsOfPrey",plural:"Hartert's Camaropteras"},{id:1711,label:"Hartlaub's Babbler",value:"Hartlaub's Babbler",category:"NonBirdsOfPrey",plural:"Hartlaub's Babblers"},{id:1712,label:"Hartlaub's Bustard",value:"Hartlaub's Bustard",category:"NonBirdsOfPrey",plural:"Hartlaub's Bustards"},{id:1713,label:"Hartlaub's Duck",value:"Hartlaub's Duck",category:"NonBirdsOfPrey",plural:"Hartlaub's Ducks"},{id:1714,label:"Hartlaub's Francolin",value:"Hartlaub's Francolin",category:"NonBirdsOfPrey",plural:"Hartlaub's Francolins"},{id:1715,label:"Hartlaub's Gull",value:"Hartlaub's Gull",category:"NonBirdsOfPrey",plural:"Hartlaub's Gulls"},{id:1716,label:"Hartlaub's Spurfowl",value:"Hartlaub's Spurfowl",category:"NonBirdsOfPrey",plural:"Hartlaub's Spurfowls"},{id:1717,label:"Hartlaub's Turaco",value:"Hartlaub's Turaco",category:"NonBirdsOfPrey",plural:"Hartlaub's Turacos"},{id:1718,label:"Harwood's Francolin",value:"Harwood's Francolin",category:"NonBirdsOfPrey",plural:"Harwood's Francolins"},{id:1719,label:"Hawfinch",value:"Hawfinch",category:"NonBirdsOfPrey",plural:"Hawfinches"},{id:1720,label:"Hemprich's Hornbill",value:"Hemprich's Hornbill",category:"NonBirdsOfPrey",plural:"Hemprich's Hornbills"},{id:1721,label:"Hen Harrier",value:"Hen Harrier",category:"BirdsOfPrey",plural:"Hen Harriers"},{id:1722,label:"Herero Chat",value:"Herero Chat",category:"NonBirdsOfPrey",plural:"Herero Chats"},{id:1723,label:"Herring Gull",value:"Herring Gull",category:"NonBirdsOfPrey",plural:"Herring Gulls"},{id:1724,label:"Heuglin's Bustard",value:"Heuglin's Bustard",category:"NonBirdsOfPrey",plural:"Heuglin's Bustards"},{id:1725,label:"Heuglin's Courser",value:"Heuglin's Courser",category:"NonBirdsOfPrey",plural:"Heuglin's Coursers"},{id:1726,label:"Heuglin's Francolin",value:"Heuglin's Francolin",category:"NonBirdsOfPrey",plural:"Heuglin's Francolins"},{id:1727,label:"Heuglin's Masked-Weaver",value:"Heuglin's Masked-Weaver",category:"NonBirdsOfPrey",plural:"Heuglin's Masked-Weavers"},{id:1728,label:"Heuglin's Wheatear",value:"Heuglin's Wheatear",category:"NonBirdsOfPrey",plural:"Heuglin's Wheatears"},{id:1729,label:"Heuglin's White-eye",value:"Heuglin's White-eye",category:"NonBirdsOfPrey",plural:"Heuglin's White-eyes"},{id:1730,label:"Highland Rush Warbler",value:"Highland Rush Warbler",category:"NonBirdsOfPrey",plural:"Highland Rush Warblers"},{id:1731,label:"Hildebrandt's Francolin",value:"Hildebrandt's Francolin",category:"NonBirdsOfPrey",plural:"Hildebrandt's Francolins"},{id:1732,label:"Hildebrandt's Starling",value:"Hildebrandt's Starling",category:"NonBirdsOfPrey",plural:"Hildebrandt's Starlings"},{id:1733,label:"Himalayan Cuckoo",value:"Himalayan Cuckoo",category:"NonBirdsOfPrey",plural:"Himalayan Cuckoos"},{id:1734,label:"Hinde's Pied-Babbler",value:"Hinde's Pied-Babbler",category:"NonBirdsOfPrey",plural:"Hinde's Pied-Babblers"},{id:1735,label:"Holub's Golden-Weaver",value:"Holub's Golden-Weaver",category:"NonBirdsOfPrey",plural:"Holub's Golden-Weavers"},{id:1736,label:"Honeyguide Greenbul",value:"Honeyguide Greenbul",category:"NonBirdsOfPrey",plural:"Honeyguide Greenbuls"},{id:1737,label:"Hooded Crow",value:"Hooded Crow",category:"NonBirdsOfPrey",plural:"Hooded Crows"},{id:1738,label:"Hooded Wheatear",value:"Hooded Wheatear",category:"NonBirdsOfPrey",plural:"Hooded Wheatears"},{id:1739,label:"Horned Grebe",value:"Horned Grebe",category:"NonBirdsOfPrey",plural:"Horned Grebes"},{id:1740,label:"Horned Lark",value:"Horned Lark",category:"NonBirdsOfPrey",plural:"Horned Larks"},{id:1741,label:"Hottentot Buttonquail",value:"Hottentot Buttonquail",category:"NonBirdsOfPrey",plural:"Hottentot Buttonquails"},{id:1742,label:"Houbara Bustard",value:"Houbara Bustard",category:"NonBirdsOfPrey",plural:"Houbara Bustards"},{id:1743,label:"House Bunting",value:"House Bunting",category:"NonBirdsOfPrey",plural:"House Buntings"},{id:1744,label:"House Crow",value:"House Crow",category:"NonBirdsOfPrey",plural:"House Crows"},{id:1745,label:"Hudsonian Godwit",value:"Hudsonian Godwit",category:"NonBirdsOfPrey",plural:"Hudsonian Godwits"},{id:1746,label:"Hume's Warbler",value:"Hume's Warbler",category:"NonBirdsOfPrey",plural:"Hume's Warblers"},{id:1747,label:"Hunter's Cisticola",value:"Hunter's Cisticola",category:"NonBirdsOfPrey",plural:"Hunter's Cisticolas"},{id:1748,label:"Hypocolius",value:"Hypocolius",category:"NonBirdsOfPrey",plural:"Hypocolius"},{id:1749,label:"Ibadan Malimbe",value:"Ibadan Malimbe",category:"NonBirdsOfPrey",plural:"Ibadan Malimbes"},{id:1750,label:"Iberian Chiffchaff",value:"Iberian Chiffchaff",category:"NonBirdsOfPrey",plural:"Iberian Chiffchaffs"},{id:1751,label:"Iberian Gray Shrike",value:"Iberian Gray Shrike",category:"NonBirdsOfPrey",plural:"Iberian Gray Shrikes"},{id:1752,label:"Ibisbill",value:"Ibisbill",category:"NonBirdsOfPrey",plural:"Ibisbills"},{id:1753,label:"Iceland Gull",value:"Iceland Gull",category:"NonBirdsOfPrey",plural:"Iceland Gulls"},{id:1754,label:"Icterine Greenbul",value:"Icterine Greenbul",category:"NonBirdsOfPrey",plural:"Icterine Greenbuls"},{id:1755,label:"Imperial Eagle",value:"Imperial Eagle",category:"BirdsOfPrey",plural:"Imperial Eagles"},{id:1756,label:"Inaccessible Bunting",value:"Inaccessible Bunting",category:"NonBirdsOfPrey",plural:"Inaccessible Buntings"},{id:1757,label:"Inaccessible Island Rail",value:"Inaccessible Island Rail",category:"NonBirdsOfPrey",plural:"Inaccessible Island Rails"},{id:1758,label:"Indian Peafowl",value:"Indian Peafowl",category:"NonBirdsOfPrey",plural:"Indian Peafowls"},{id:1759,label:"Indian Silverbill",value:"Indian Silverbill",category:"NonBirdsOfPrey",plural:"Indian Silverbills"},{id:1760,label:"Indian Thick-knee",value:"Indian Thick-knee",category:"NonBirdsOfPrey",plural:"Indian Thick-knees"},{id:1761,label:"Indian Yellow-nosed Albatross",value:"Indian Yellow-nosed Albatross",category:"NonBirdsOfPrey",plural:"Indian Yellow-nosed Albatrosses"},{id:1762,label:"Intermediate Egret",value:"Intermediate Egret",category:"NonBirdsOfPrey",plural:"Intermediate Egrets"},{id:1763,label:"Irania",value:"Irania",category:"NonBirdsOfPrey",plural:"Iranias"},{id:1764,label:"Iringa Akalat",value:"Iringa Akalat",category:"NonBirdsOfPrey",plural:"Iringa Akalats"},{id:1765,label:"Isabelline Shrike",value:"Isabelline Shrike",category:"NonBirdsOfPrey",plural:"Isabelline Shrikes"},{id:1766,label:"Isabelline Wheatear",value:"Isabelline Wheatear",category:"NonBirdsOfPrey",plural:"Isabelline Wheatears"},{id:1767,label:"Itombwe Nightjar",value:"Itombwe Nightjar",category:"NonBirdsOfPrey",plural:"Itombwe Nightjars"},{id:1768,label:"Ituri Batis",value:"Ituri Batis",category:"NonBirdsOfPrey",plural:"Ituri Batis"},{id:1769,label:"Jack Snipe",value:"Jack Snipe",category:"NonBirdsOfPrey",plural:"Jack Snipes"},{id:1770,label:"Jackson's Francolin",value:"Jackson's Francolin",category:"NonBirdsOfPrey",plural:"Jackson's Francolins"},{id:1771,label:"Jackson's Hornbill",value:"Jackson's Hornbill",category:"NonBirdsOfPrey",plural:"Jackson's Hornbills"},{id:1772,label:"Jackson's Widowbird",value:"Jackson's Widowbird",category:"NonBirdsOfPrey",plural:"Jackson's Widowbirds"},{id:1773,label:"Jambandu Indigobird",value:"Jambandu Indigobird",category:"NonBirdsOfPrey",plural:"Jambandu Indigobirds"},{id:1774,label:"Jameson's Antpecker",value:"Jameson's Antpecker",category:"NonBirdsOfPrey",plural:"Jameson's Antpeckers"},{id:1775,label:"Jameson's Wattle-eye",value:"Jameson's Wattle-eye",category:"NonBirdsOfPrey",plural:"Jameson's Wattle-eyes"},{id:1776,label:"Java Sparrow",value:"Java Sparrow",category:"NonBirdsOfPrey",plural:"Java Sparrows"},{id:1777,label:"Johanna's Sunbird",value:"Johanna's Sunbird",category:"NonBirdsOfPrey",plural:"Johanna's Sunbirds"},{id:1778,label:"Jos Plateau Indigobird",value:"Jos Plateau Indigobird",category:"NonBirdsOfPrey",plural:"Jos Plateau Indigobirds"},{id:1779,label:"Jouanin's Petrel",value:"Jouanin's Petrel",category:"NonBirdsOfPrey",plural:"Jouanin's Petrels"},{id:1780,label:"Joyful Greenbul",value:"Joyful Greenbul",category:"NonBirdsOfPrey",plural:"Joyful Greenbuls"},{id:1781,label:"Jungle Bush-Quail",value:"Jungle Bush-Quail",category:"NonBirdsOfPrey",plural:"Jungle Bush-Quails"},{id:1782,label:"Kabobo Apalis",value:"Kabobo Apalis",category:"NonBirdsOfPrey",plural:"Kabobo Apalis"},{id:1783,label:"Kandt's Waxbill",value:"Kandt's Waxbill",category:"NonBirdsOfPrey",plural:"Kandt's Waxbills"},{id:1784,label:"Karamoja Apalis",value:"Karamoja Apalis",category:"NonBirdsOfPrey",plural:"Karamoja Apalis"},{id:1785,label:"Karoo Bustard",value:"Karoo Bustard",category:"NonBirdsOfPrey",plural:"Karoo Bustards"},{id:1786,label:"Karoo Chat",value:"Karoo Chat",category:"NonBirdsOfPrey",plural:"Karoo Chats"},{id:1787,label:"Karoo Eremomela",value:"Karoo Eremomela",category:"NonBirdsOfPrey",plural:"Karoo Eremomelas"},{id:1788,label:"Karoo Korhaan",value:"Karoo Korhaan",category:"NonBirdsOfPrey",plural:"Karoo Korhaans"},{id:1789,label:"Karoo Lark",value:"Karoo Lark",category:"NonBirdsOfPrey",plural:"Karoo Larks"},{id:1790,label:"Karoo Long-billed Lark",value:"Karoo Long-billed Lark",category:"NonBirdsOfPrey",plural:"Karoo Long-billed Larks"},{id:1791,label:"Karoo Prinia",value:"Karoo Prinia",category:"NonBirdsOfPrey",plural:"Karoo Prinias"},{id:1792,label:"Karoo Scrub-Robin",value:"Karoo Scrub-Robin",category:"NonBirdsOfPrey",plural:"Karoo Scrub-Robins"},{id:1793,label:"Katanga Masked-Weaver",value:"Katanga Masked-Weaver",category:"NonBirdsOfPrey",plural:"Katanga Masked-Weavers"},{id:1794,label:"Kelp Gull",value:"Kelp Gull",category:"NonBirdsOfPrey",plural:"Kelp Gulls"},{id:1795,label:"Kemp's Longbill",value:"Kemp's Longbill",category:"NonBirdsOfPrey",plural:"Kemp's Longbills"},{id:1796,label:"Kenrick's Starling",value:"Kenrick's Starling",category:"NonBirdsOfPrey",plural:"Kenrick's Starlings"},{id:1797,label:"Kentish Plover",value:"Kentish Plover",category:"NonBirdsOfPrey",plural:"Kentish Plovers"},{id:1798,label:"Kenya Rufous Sparrow",value:"Kenya Rufous Sparrow",category:"NonBirdsOfPrey",plural:"Kenya Rufous Sparrows"},{id:1799,label:"Kerguelen Petrel",value:"Kerguelen Petrel",category:"NonBirdsOfPrey",plural:"Kerguelen Petrels"},{id:1800,label:"Kerguelen Tern",value:"Kerguelen Tern",category:"NonBirdsOfPrey",plural:"Kerguelen Terns"},{id:1801,label:"Kikuyu White-eye",value:"Kikuyu White-eye",category:"NonBirdsOfPrey",plural:"Kikuyu White-eyes"},{id:1802,label:"Kilimanjaro White-eye",value:"Kilimanjaro White-eye",category:"NonBirdsOfPrey",plural:"Kilimanjaro White-eyes"},{id:1803,label:"Kilombero Cisticola",value:"Kilombero Cisticola",category:"NonBirdsOfPrey",plural:"Kilombero Cisticolas"},{id:1804,label:"Kilombero Weaver",value:"Kilombero Weaver",category:"NonBirdsOfPrey",plural:"Kilombero Weavers"},{id:1805,label:"Kimberley Pipit",value:"Kimberley Pipit",category:"NonBirdsOfPrey",plural:"Kimberley Pipits"},{id:1806,label:"King Penguin",value:"King Penguin",category:"NonBirdsOfPrey",plural:"King Penguins"},{id:1807,label:"Knob-billed Duck",value:"Knob-billed Duck",category:"NonBirdsOfPrey",plural:"Knob-billed Ducks"},{id:1808,label:"Knysna Turaco",value:"Knysna Turaco",category:"NonBirdsOfPrey",plural:"Knysna Turacos"},{id:1809,label:"Knysna Warbler",value:"Knysna Warbler",category:"NonBirdsOfPrey",plural:"Knysna Warblers"},{id:1810,label:"Knysna Woodpecker",value:"Knysna Woodpecker",category:"NonBirdsOfPrey",plural:"Knysna Woodpeckers"},{id:1811,label:"Kopje Warbler",value:"Kopje Warbler",category:"NonBirdsOfPrey",plural:"Kopje Warblers"},{id:1812,label:"Kordofan Lark",value:"Kordofan Lark",category:"NonBirdsOfPrey",plural:"Kordofan Larks"},{id:1813,label:"Kordofan Rufous Sparrow",value:"Kordofan Rufous Sparrow",category:"NonBirdsOfPrey",plural:"Kordofan Rufous Sparrows"},{id:1814,label:"Kretschmer's Longbill",value:"Kretschmer's Longbill",category:"NonBirdsOfPrey",plural:"Kretschmer's Longbills"},{id:1815,label:"Kungwe Apalis",value:"Kungwe Apalis",category:"NonBirdsOfPrey",plural:"Kungwe Apalis"},{id:1816,label:"Kurdish Wheatear",value:"Kurdish Wheatear",category:"NonBirdsOfPrey",plural:"Kurdish Wheatears"},{id:1817,label:"Lagden's Bushshrike",value:"Lagden's Bushshrike",category:"NonBirdsOfPrey",plural:"Lagden's Bushshrikes"},{id:1818,label:"Lake Lufira Masked-Weaver",value:"Lake Lufira Masked-Weaver",category:"NonBirdsOfPrey",plural:"Lake Lufira Masked-Weavers"},{id:1819,label:"Lapland Longspur",value:"Lapland Longspur",category:"NonBirdsOfPrey",plural:"Lapland Longspurs"},{id:1820,label:"Large-billed Lark",value:"Large-billed Lark",category:"NonBirdsOfPrey",plural:"Large-billed Larks"},{id:1821,label:"Latakoo Lark",value:"Latakoo Lark",category:"NonBirdsOfPrey",plural:"Latakoo Larks"},{id:1822,label:"Latham's Francolin",value:"Latham's Francolin",category:"NonBirdsOfPrey",plural:"Latham's Francolins"},{id:1823,label:"Laughing Gull",value:"Laughing Gull",category:"NonBirdsOfPrey",plural:"Laughing Gulls"},{id:1824,label:"Laura's Woodland-Warbler",value:"Laura's Woodland-Warbler",category:"NonBirdsOfPrey",plural:"Laura's Woodland-Warblers"},{id:1825,label:"Laurel Pigeon",value:"Laurel Pigeon",category:"NonBirdsOfPrey",plural:"Laurel Pigeons"},{id:1826,label:"Lavender Waxbill",value:"Lavender Waxbill",category:"NonBirdsOfPrey",plural:"Lavender Waxbills"},{id:1827,label:"Layard's Tit-babbler",value:"Layard's Tit-babbler",category:"NonBirdsOfPrey",plural:"Layard's Tit-babblers"},{id:1828,label:"Layard's Warbler",value:"Layard's Warbler",category:"NonBirdsOfPrey",plural:"Layard's Warblers"},{id:1829,label:"Laysan Albatross",value:"Laysan Albatross",category:"NonBirdsOfPrey",plural:"Laysan Albatrosses"},{id:1830,label:"Leach's Storm-Petrel",value:"Leach's Storm-Petrel",category:"NonBirdsOfPrey",plural:"Leach's Storm-Petrels"},{id:1831,label:"Leaf-love",value:"Leaf-love",category:"NonBirdsOfPrey",plural:"Leaf-loves"},{id:1832,label:"Least Bittern",value:"Least Bittern",category:"NonBirdsOfPrey",plural:"Least Bitterns"},{id:1833,label:"Least Honeyguide",value:"Least Honeyguide",category:"NonBirdsOfPrey",plural:"Least Honeyguides"},{id:1834,label:"Lemon (Cinnamon) Dove",value:"Lemon (Cinnamon) Dove",category:"NonBirdsOfPrey",plural:"Lemon (Cinnamon) Doves"},{id:1835,label:"Lemon-bellied Crombec",value:"Lemon-bellied Crombec",category:"NonBirdsOfPrey",plural:"Lemon-bellied Crombecs"},{id:1836,label:"Lemon-breasted Seedeater",value:"Lemon-breasted Seedeater",category:"NonBirdsOfPrey",plural:"Lemon-breasted Seedeaters"},{id:1837,label:"Lesser Black-backed Gull",value:"Lesser Black-backed Gull",category:"NonBirdsOfPrey",plural:"Lesser Black-backed Gulls"},{id:1838,label:"Lesser Blue-eared Starling",value:"Lesser Blue-eared Starling",category:"NonBirdsOfPrey",plural:"Lesser Blue-eared Starlings"},{id:1839,label:"Lesser Bristlebill",value:"Lesser Bristlebill",category:"NonBirdsOfPrey",plural:"Lesser Bristlebills"},{id:1840,label:"Lesser Crested Tern",value:"Lesser Crested Tern",category:"NonBirdsOfPrey",plural:"Lesser Crested Terns"},{id:1841,label:"Lesser Cuckoo",value:"Lesser Cuckoo",category:"NonBirdsOfPrey",plural:"Lesser Cuckoos"},{id:1842,label:"Lesser Frigatebird",value:"Lesser Frigatebird",category:"NonBirdsOfPrey",plural:"Lesser Frigatebirds"},{id:1843,label:"Lesser Gray Shrike",value:"Lesser Gray Shrike",category:"NonBirdsOfPrey",plural:"Lesser Gray Shrikes"},{id:1844,label:"Lesser Hoopoe-Lark",value:"Lesser Hoopoe-Lark",category:"NonBirdsOfPrey",plural:"Lesser Hoopoe-Larks"},{id:1845,label:"Lesser Jacana",value:"Lesser Jacana",category:"NonBirdsOfPrey",plural:"Lesser Jacanas"},{id:1846,label:"Lesser Noddy",value:"Lesser Noddy",category:"NonBirdsOfPrey",plural:"Lesser Noddies"},{id:1847,label:"Lesser Redpoll",value:"Lesser Redpoll",category:"NonBirdsOfPrey",plural:"Lesser Redpolls"},{id:1848,label:"Lesser Sand Plover",value:"Lesser Sand Plover",category:"NonBirdsOfPrey",plural:"Lesser Sand Plovers"},{id:1849,label:"Lesser Sand-Plover",value:"Lesser Sand-Plover",category:"NonBirdsOfPrey",plural:"Lesser Sand-Plovers"},{id:1850,label:"Lesser Scaup",value:"Lesser Scaup",category:"NonBirdsOfPrey",plural:"Lesser Scaups"},{id:1851,label:"Lesser Seedcracker",value:"Lesser Seedcracker",category:"NonBirdsOfPrey",plural:"Lesser Seedcrackers"},{id:1852,label:"Lesser Sheathbill",value:"Lesser Sheathbill",category:"NonBirdsOfPrey",plural:"Lesser Sheathbills"},{id:1853,label:"Lesser Spotted Eagle",value:"Lesser Spotted Eagle",category:"BirdsOfPrey",plural:"Lesser Spotted Eagles"},{id:1854,label:"Lesser Spotted Woodpecker",value:"Lesser Spotted Woodpecker",category:"NonBirdsOfPrey",plural:"Lesser Spotted Woodpeckers"},{id:1855,label:"Lesser Swamp Warbler",value:"Lesser Swamp Warbler",category:"NonBirdsOfPrey",plural:"Lesser Swamp Warblers"},{id:1856,label:"Lesser White-fronted Goose",value:"Lesser White-fronted Goose",category:"NonBirdsOfPrey",plural:"Lesser White-fronted Geese"},{id:1857,label:"Lesser Whitethroat",value:"Lesser Whitethroat",category:"NonBirdsOfPrey",plural:"Lesser Whitethroats"},{id:1858,label:"Lesser Yellowlegs",value:"Lesser Yellowlegs",category:"NonBirdsOfPrey",plural:"Lesser Yellowlegs"},{id:1859,label:"Levaillant's (African Striped) Cuckoo",value:"Levaillant's (African Striped) Cuckoo",category:"NonBirdsOfPrey",plural:"Levaillant's (African Striped) Cuckoos"},{id:1860,label:"Levaillant's Cuckoo",value:"Levaillant's Cuckoo",category:"NonBirdsOfPrey",plural:"Levaillant's Cuckoos"},{id:1861,label:"Levaillant's Woodpecker",value:"Levaillant's Woodpecker",category:"NonBirdsOfPrey",plural:"Levaillant's Woodpeckers"},{id:1862,label:"Levant Sparrowhawk",value:"Levant Sparrowhawk",category:"BirdsOfPrey",plural:"Levant Sparrowhawks"},{id:1863,label:"Liben Lark",value:"Liben Lark",category:"NonBirdsOfPrey",plural:"Liben Larks"},{id:1864,label:"Lichtenstein's Sandgrouse",value:"Lichtenstein's Sandgrouse",category:"NonBirdsOfPrey",plural:"Lichtenstein's Sandgrouses"},{id:1865,label:"Light-mantled Albatross",value:"Light-mantled Albatross",category:"NonBirdsOfPrey",plural:"Light-mantled Albatrosses"},{id:1866,label:"Lilian's Lovebird",value:"Lilian's Lovebird",category:"NonBirdsOfPrey",plural:"Lilian's Lovebirds"},{id:1867,label:"Little Blue Heron",value:"Little Blue Heron",category:"NonBirdsOfPrey",plural:"Little Blue Herons"},{id:1868,label:"Little Brown Bustard",value:"Little Brown Bustard",category:"NonBirdsOfPrey",plural:"Little Brown Bustards"},{id:1869,label:"Little Bunting",value:"Little Bunting",category:"NonBirdsOfPrey",plural:"Little Buntings"},{id:1870,label:"Little Bustard",value:"Little Bustard",category:"NonBirdsOfPrey",plural:"Little Bustards"},{id:1871,label:"Little Crake",value:"Little Crake",category:"NonBirdsOfPrey",plural:"Little Crakes"},{id:1872,label:"Little Gray Woodpecker",value:"Little Gray Woodpecker",category:"NonBirdsOfPrey",plural:"Little Gray Woodpeckers"},{id:1873,label:"Little Green Sunbird",value:"Little Green Sunbird",category:"NonBirdsOfPrey",plural:"Little Green Sunbirds"},{id:1874,label:"Little Green Woodpecker",value:"Little Green Woodpecker",category:"NonBirdsOfPrey",plural:"Little Green Woodpeckers"},{id:1875,label:"Little Greenbul",value:"Little Greenbul",category:"NonBirdsOfPrey",plural:"Little Greenbuls"},{id:1876,label:"Little Gull",value:"Little Gull",category:"NonBirdsOfPrey",plural:"Little Gulls"},{id:1877,label:"Little Owl",value:"Little Owl",category:"BirdsOfPrey",plural:"Little Owls"},{id:1878,label:"Little Penguin",value:"Little Penguin",category:"NonBirdsOfPrey",plural:"Little Penguins"},{id:1879,label:"Little Ringed Plover",value:"Little Ringed Plover",category:"NonBirdsOfPrey",plural:"Little Ringed Plovers"},{id:1880,label:"Little Rock-Thrush",value:"Little Rock-Thrush",category:"NonBirdsOfPrey",plural:"Little Rock-Thrushes"},{id:1881,label:"Little Rush Warbler",value:"Little Rush Warbler",category:"NonBirdsOfPrey",plural:"Little Rush Warblers"},{id:1882,label:"Little Shearwater",value:"Little Shearwater",category:"NonBirdsOfPrey",plural:"Little Shearwaters"},{id:1883,label:"Little Stint",value:"Little Stint",category:"NonBirdsOfPrey",plural:"Little Stints"},{id:1884,label:"Little Tern",value:"Little Tern",category:"NonBirdsOfPrey",plural:"Little Terns"},{id:1885,label:"Little Weaver",value:"Little Weaver",category:"NonBirdsOfPrey",plural:"Little Weavers"},{id:1886,label:"Livingstone's Flycatcher",value:"Livingstone's Flycatcher",category:"NonBirdsOfPrey",plural:"Livingstone's Flycatchers"},{id:1887,label:"Livingstone's Turaco",value:"Livingstone's Turaco",category:"NonBirdsOfPrey",plural:"Livingstone's Turacos"},{id:1888,label:"Loango Weaver",value:"Loango Weaver",category:"NonBirdsOfPrey",plural:"Loango Weavers"},{id:1889,label:"Locustfinch",value:"Locustfinch",category:"NonBirdsOfPrey",plural:"Locustfinches"},{id:1890,label:"Long billed Tailorbird",value:"Long billed Tailorbird",category:"NonBirdsOfPrey",plural:"Long billed Tailorbirds"},{id:1891,label:"Long-billed Dowitcher",value:"Long-billed Dowitcher",category:"NonBirdsOfPrey",plural:"Long-billed Dowitchers"},{id:1892,label:"Long-eared Owl",value:"Long-eared Owl",category:"BirdsOfPrey",plural:"Long-eared Owls"},{id:1893,label:"Long-legged Buzzard",value:"Long-legged Buzzard",category:"BirdsOfPrey",plural:"Long-legged Buzzards"},{id:1894,label:"Long-legged Pipit",value:"Long-legged Pipit",category:"NonBirdsOfPrey",plural:"Long-legged Pipits"},{id:1895,label:"Long-tailed Cormorant",value:"Long-tailed Cormorant",category:"NonBirdsOfPrey",plural:"Long-tailed Cormorants"},{id:1896,label:"Long-tailed Duck",value:"Long-tailed Duck",category:"NonBirdsOfPrey",plural:"Long-tailed Ducks"},{id:1897,label:"Long-tailed Fiscal",value:"Long-tailed Fiscal",category:"NonBirdsOfPrey",plural:"Long-tailed Fiscals"},{id:1898,label:"Long-tailed Glossy Starling",value:"Long-tailed Glossy Starling",category:"NonBirdsOfPrey",plural:"Long-tailed Glossy Starlings"},{id:1899,label:"Long-tailed Hawk",value:"Long-tailed Hawk",category:"BirdsOfPrey",plural:"Long-tailed Hawks"},{id:1900,label:"Long-tailed Jaeger",value:"Long-tailed Jaeger",category:"NonBirdsOfPrey",plural:"Long-tailed Jaegers"},{id:1901,label:"Long-tailed Nightjar",value:"Long-tailed Nightjar",category:"NonBirdsOfPrey",plural:"Long-tailed Nightjars"},{id:1902,label:"Long-tailed Pipit",value:"Long-tailed Pipit",category:"NonBirdsOfPrey",plural:"Long-tailed Pipits"},{id:1903,label:"Long-tailed Skua",value:"Long-tailed Skua",category:"NonBirdsOfPrey",plural:"Long-tailed Skuas"},{id:1904,label:"Long-tailed Tit",value:"Long-tailed Tit",category:"NonBirdsOfPrey",plural:"Long-tailed Tits"},{id:1905,label:"Long-toed Lapwing",value:"Long-toed Lapwing",category:"NonBirdsOfPrey",plural:"Long-toed Lapwings"},{id:1906,label:"Long-toed Stint",value:"Long-toed Stint",category:"NonBirdsOfPrey",plural:"Long-toed Stints"},{id:1907,label:"Loveridge's Sunbird",value:"Loveridge's Sunbird",category:"NonBirdsOfPrey",plural:"Loveridge's Sunbirds"},{id:1908,label:"Lowland Akalat",value:"Lowland Akalat",category:"NonBirdsOfPrey",plural:"Lowland Akalats"},{id:1909,label:"Lowland Sooty Boubou",value:"Lowland Sooty Boubou",category:"NonBirdsOfPrey",plural:"Lowland Sooty Boubous"},{id:1910,label:"Luapula Cisticola",value:"Luapula Cisticola",category:"NonBirdsOfPrey",plural:"Luapula Cisticolas"},{id:1911,label:"Ludwig's Bustard",value:"Ludwig's Bustard",category:"NonBirdsOfPrey",plural:"Ludwig's Bustards"},{id:1912,label:"L\u00fchder's Bushshrike",value:"L\u00fchder's Bushshrike",category:"NonBirdsOfPrey",plural:"L\u00fchder's Bushshrikes"},{id:1913,label:"Lyre-tailed Honeyguide",value:"Lyre-tailed Honeyguide",category:"NonBirdsOfPrey",plural:"Lyre-tailed Honeyguides"},{id:1914,label:"Macaroni Penguin",value:"Macaroni Penguin",category:"NonBirdsOfPrey",plural:"Macaroni Penguins"},{id:1915,label:"Mackinnon's Shrike",value:"Mackinnon's Shrike",category:"NonBirdsOfPrey",plural:"Mackinnon's Shrikes"},{id:1916,label:"Macqueen's Bustard",value:"Macqueen's Bustard",category:"NonBirdsOfPrey",plural:"Macqueen's Bustards"},{id:1917,label:"Madagascar (Olive) Bee-eater",value:"Madagascar (Olive) Bee-eater",category:"NonBirdsOfPrey",plural:"Madagascar (Olive) Bee-eaters"},{id:1918,label:"Madagascar Bee-eater",value:"Madagascar Bee-eater",category:"NonBirdsOfPrey",plural:"Madagascar Bee-eaters"},{id:1919,label:"Madagascar Cuckoo",value:"Madagascar Cuckoo",category:"NonBirdsOfPrey",plural:"Madagascar Cuckoos"},{id:1920,label:"Madagascar Pratincole",value:"Madagascar Pratincole",category:"NonBirdsOfPrey",plural:"Madagascar Pratincoles"},{id:1921,label:"Madeira Firecrest",value:"Madeira Firecrest",category:"NonBirdsOfPrey",plural:"Madeira Firecrests"},{id:1922,label:"Magellanic Penguin",value:"Magellanic Penguin",category:"NonBirdsOfPrey",plural:"Magellanic Penguins"},{id:1923,label:"Maghreb Lark",value:"Maghreb Lark",category:"NonBirdsOfPrey",plural:"Maghreb Larks"},{id:1924,label:"Maghreb Magpie",value:"Maghreb Magpie",category:"NonBirdsOfPrey",plural:"Maghreb Magpies"},{id:1925,label:"Maghreb Owl",value:"Maghreb Owl",category:"BirdsOfPrey",plural:"Maghreb Owls"},{id:1926,label:"Magnificent Frigatebird",value:"Magnificent Frigatebird",category:"NonBirdsOfPrey",plural:"Magnificent Frigatebirds"},{id:1927,label:"Magpie Mannikin",value:"Magpie Mannikin",category:"NonBirdsOfPrey",plural:"Magpie Mannikins"},{id:1928,label:"Magpie Starling",value:"Magpie Starling",category:"NonBirdsOfPrey",plural:"Magpie Starlings"},{id:1929,label:"Malagasy Pond-Heron",value:"Malagasy Pond-Heron",category:"NonBirdsOfPrey",plural:"Malagasy Pond-Herons"},{id:1930,label:"Mali Firefinch",value:"Mali Firefinch",category:"NonBirdsOfPrey",plural:"Mali Firefinches"},{id:1931,label:"Malindi Pipit",value:"Malindi Pipit",category:"NonBirdsOfPrey",plural:"Malindi Pipits"},{id:1932,label:"Mallard",value:"Mallard",category:"NonBirdsOfPrey",plural:"Mallards"},{id:1933,label:"Mandarin Duck",value:"Mandarin Duck",category:"NonBirdsOfPrey",plural:"Mandarin Ducks"},{id:1934,label:"Maned Owl",value:"Maned Owl",category:"BirdsOfPrey",plural:"Maned Owls"},{id:1935,label:"Mangrove Kingfisher",value:"Mangrove Kingfisher",category:"NonBirdsOfPrey",plural:"Mangrove Kingfishers"},{id:1936,label:"Manx Shearwater",value:"Manx Shearwater",category:"NonBirdsOfPrey",plural:"Manx Shearwaters"},{id:1937,label:"Many-colored Bushshrike",value:"Many-colored Bushshrike",category:"NonBirdsOfPrey",plural:"Many-colored Bushshrikes"},{id:1938,label:"Marbled Teal",value:"Marbled Teal",category:"NonBirdsOfPrey",plural:"Marbled Teals"},{id:1939,label:"Mariqua Flycatcher",value:"Mariqua Flycatcher",category:"NonBirdsOfPrey",plural:"Mariqua Flycatchers"},{id:1940,label:"Mariqua Sunbird",value:"Mariqua Sunbird",category:"NonBirdsOfPrey",plural:"Mariqua Sunbirds"},{id:1941,label:"Marmora's Warbler",value:"Marmora's Warbler",category:"NonBirdsOfPrey",plural:"Marmora's Warblers"},{id:1942,label:"Maroon Pigeon",value:"Maroon Pigeon",category:"NonBirdsOfPrey",plural:"Maroon Pigeons"},{id:1943,label:"Marsh Sandpiper",value:"Marsh Sandpiper",category:"NonBirdsOfPrey",plural:"Marsh Sandpipers"},{id:1944,label:"Marsh Tchagra",value:"Marsh Tchagra",category:"NonBirdsOfPrey",plural:"Marsh Tchagras"},{id:1945,label:"Marsh Warbler",value:"Marsh Warbler",category:"NonBirdsOfPrey",plural:"Marsh Warblers"},{id:1946,label:"Marsh Widowbird",value:"Marsh Widowbird",category:"NonBirdsOfPrey",plural:"Marsh Widowbirds"},{id:1947,label:"Mascarene Martin",value:"Mascarene Martin",category:"NonBirdsOfPrey",plural:"Mascarene Martins"},{id:1948,label:"Mascarene Petrel",value:"Mascarene Petrel",category:"NonBirdsOfPrey",plural:"Mascarene Petrels"},{id:1949,label:"Masked Apalis",value:"Masked Apalis",category:"NonBirdsOfPrey",plural:"Masked Apalis"},{id:1950,label:"Masked Booby",value:"Masked Booby",category:"NonBirdsOfPrey",plural:"Masked Boobies"},{id:1951,label:"Masked Lark",value:"Masked Lark",category:"NonBirdsOfPrey",plural:"Masked Larks"},{id:1952,label:"Masked Shrike",value:"Masked Shrike",category:"NonBirdsOfPrey",plural:"Masked Shrikes"},{id:1953,label:"Matsudaira's Storm-Petrel",value:"Matsudaira's Storm-Petrel",category:"NonBirdsOfPrey",plural:"Matsudaira's Storm-Petrels"},{id:1954,label:"Maxwell's Black Weaver",value:"Maxwell's Black Weaver",category:"NonBirdsOfPrey",plural:"Maxwell's Black Weavers"},{id:1955,label:"Mbulu White-eye",value:"Mbulu White-eye",category:"NonBirdsOfPrey",plural:"Mbulu White-eyes"},{id:1956,label:"Meadow Pipit",value:"Meadow Pipit",category:"NonBirdsOfPrey",plural:"Meadow Pipits"},{id:1957,label:"Mediterranean Gull",value:"Mediterranean Gull",category:"NonBirdsOfPrey",plural:"Mediterranean Gulls"},{id:1958,label:"Mediterranean Short-toed Lark",value:"Mediterranean Short-toed Lark",category:"NonBirdsOfPrey",plural:"Mediterranean Short-toed Larks"},{id:1959,label:"Melancholy Woodpecker",value:"Melancholy Woodpecker",category:"NonBirdsOfPrey",plural:"Melancholy Woodpeckers"},{id:1960,label:"Melodious Lark",value:"Melodious Lark",category:"NonBirdsOfPrey",plural:"Melodious Larks"},{id:1961,label:"Melodious Warbler",value:"Melodious Warbler",category:"NonBirdsOfPrey",plural:"Melodious Warblers"},{id:1962,label:"Menetries's Warbler",value:"Menetries's Warbler",category:"NonBirdsOfPrey",plural:"Menetries's Warblers"},{id:1963,label:"Merlin",value:"Merlin",category:"BirdsOfPrey",plural:"Merlins"},{id:1964,label:"Mimbo Blue-eared Starling",value:"Mimbo Blue-eared Starling",category:"NonBirdsOfPrey",plural:"Mimbo Blue-eared Starlings"},{id:1965,label:"Miombo Barbet",value:"Miombo Barbet",category:"NonBirdsOfPrey",plural:"Miombo Barbets"},{id:1966,label:"Miombo Double-collared Sunbird",value:"Miombo Double-collared Sunbird",category:"NonBirdsOfPrey",plural:"Miombo Double-collared Sunbirds"},{id:1967,label:"Miombo Rock-Thrush",value:"Miombo Rock-Thrush",category:"NonBirdsOfPrey",plural:"Miombo Rock-Thrushes"},{id:1968,label:"Miombo Scrub-Robin",value:"Miombo Scrub-Robin",category:"NonBirdsOfPrey",plural:"Miombo Scrub-Robins"},{id:1969,label:"Miombo Tit",value:"Miombo Tit",category:"NonBirdsOfPrey",plural:"Miombo Tits"},{id:1970,label:"Miombo Wren-Warbler",value:"Miombo Wren-Warbler",category:"NonBirdsOfPrey",plural:"Miombo Wren-Warblers"},{id:1971,label:"Mistle Thrush",value:"Mistle Thrush",category:"NonBirdsOfPrey",plural:"Mistle Thrushes"},{id:1972,label:"Moheli Scops-Owl",value:"Moheli Scops-Owl",category:"BirdsOfPrey",plural:"Moheli Scops-Owls"},{id:1973,label:"Moltoni's Warbler",value:"Moltoni's Warbler",category:"NonBirdsOfPrey",plural:"Moltoni's Warblers"},{id:1974,label:"Mombasa Woodpecker",value:"Mombasa Woodpecker",category:"NonBirdsOfPrey",plural:"Mombasa Woodpeckers"},{id:1975,label:"Monk Parakeet",value:"Monk Parakeet",category:"NonBirdsOfPrey",plural:"Monk Parakeets"},{id:1976,label:"Montane Blue Swallow",value:"Montane Blue Swallow",category:"NonBirdsOfPrey",plural:"Montane Blue Swallows"},{id:1977,label:"Montane Double-collared Sunbird",value:"Montane Double-collared Sunbird",category:"NonBirdsOfPrey",plural:"Montane Double-collared Sunbirds"},{id:1978,label:"Monteiro's Bushshrike",value:"Monteiro's Bushshrike",category:"NonBirdsOfPrey",plural:"Monteiro's Bushshrikes"},{id:1979,label:"Monteiro's Hornbill",value:"Monteiro's Hornbill",category:"NonBirdsOfPrey",plural:"Monteiro's Hornbills"},{id:1980,label:"Moorland Chat",value:"Moorland Chat",category:"NonBirdsOfPrey",plural:"Moorland Chats"},{id:1981,label:"Moorland Francolin",value:"Moorland Francolin",category:"NonBirdsOfPrey",plural:"Moorland Francolins"},{id:1982,label:"Moreau's Sunbird",value:"Moreau's Sunbird",category:"NonBirdsOfPrey",plural:"Moreau's Sunbirds"},{id:1983,label:"Moseley's Rockhopper Penguin",value:"Moseley's Rockhopper Penguin",category:"NonBirdsOfPrey",plural:"Moseley's Rockhopper Penguins"},{id:1984,label:"Mottled Swift",value:"Mottled Swift",category:"NonBirdsOfPrey",plural:"Mottled Swifts"},{id:1985,label:"Mount Kupe Bushshrike",value:"Mount Kupe Bushshrike",category:"NonBirdsOfPrey",plural:"Mount Kupe Bushshrikes"},{id:1986,label:"Mountain Buzzard",value:"Mountain Buzzard",category:"BirdsOfPrey",plural:"Mountain Buzzards"},{id:1987,label:"Mountain Chiffchaff",value:"Mountain Chiffchaff",category:"NonBirdsOfPrey",plural:"Mountain Chiffchaffs"},{id:1988,label:"Mountain Gray Woodpecker",value:"Mountain Gray Woodpecker",category:"NonBirdsOfPrey",plural:"Mountain Gray Woodpeckers"},{id:1989,label:"Mountain Illadopsis",value:"Mountain Illadopsis",category:"NonBirdsOfPrey",plural:"Mountain Illadopsis"},{id:1990,label:"Mountain Pipit",value:"Mountain Pipit",category:"NonBirdsOfPrey",plural:"Mountain Pipits"},{id:1991,label:"Mountain Robin-Chat",value:"Mountain Robin-Chat",category:"NonBirdsOfPrey",plural:"Mountain Robin-Chats"},{id:1992,label:"Mountain Sawwing",value:"Mountain Sawwing",category:"NonBirdsOfPrey",plural:"Mountain Sawwings"},{id:1993,label:"Mountain Yellow-Warbler",value:"Mountain Yellow-Warbler",category:"NonBirdsOfPrey",plural:"Mountain Yellow-Warblers"},{id:1994,label:"Mourning Collared-Dove",value:"Mourning Collared-Dove",category:"NonBirdsOfPrey",plural:"Mourning Collared-Doves"},{id:1995,label:"Mourning Wheatear",value:"Mourning Wheatear",category:"NonBirdsOfPrey",plural:"Mourning Wheatears"},{id:1996,label:"Mouse-brown Sunbird",value:"Mouse-brown Sunbird",category:"NonBirdsOfPrey",plural:"Mouse-brown Sunbirds"},{id:1997,label:"Mouse-colored Penduline-Tit",value:"Mouse-colored Penduline-Tit",category:"NonBirdsOfPrey",plural:"Mouse-colored Penduline-Tits"},{id:1998,label:"Mouse-colored Sunbird",value:"Mouse-colored Sunbird",category:"NonBirdsOfPrey",plural:"Mouse-colored Sunbirds"},{id:1999,label:"Moussier's Redstart",value:"Moussier's Redstart",category:"NonBirdsOfPrey",plural:"Moussier's Redstarts"},{id:2000,label:"Moustached Grass-Warbler",value:"Moustached Grass-Warbler",category:"NonBirdsOfPrey",plural:"Moustached Grass-Warblers"},{id:2001,label:"Moustached Tinkerbird",value:"Moustached Tinkerbird",category:"NonBirdsOfPrey",plural:"Moustached Tinkerbirds"},{id:2002,label:"Moustached Warbler",value:"Moustached Warbler",category:"NonBirdsOfPrey",plural:"Moustached Warblers"},{id:2003,label:"Mozambique Nightjar",value:"Mozambique Nightjar",category:"NonBirdsOfPrey",plural:"Mozambique Nightjars"},{id:2004,label:"Mrs. Moreau's Warbler",value:"Mrs. Moreau's Warbler",category:"NonBirdsOfPrey",plural:"Mrs. Moreau's Warblers"},{id:2005,label:"Mute Swan",value:"Mute Swan",category:"NonBirdsOfPrey",plural:"Mute Swans"},{id:2006,label:"Nahan's Francolin",value:"Nahan's Francolin",category:"NonBirdsOfPrey",plural:"Nahan's Francolins"},{id:2007,label:"Naked-faced Barbet",value:"Naked-faced Barbet",category:"NonBirdsOfPrey",plural:"Naked-faced Barbets"},{id:2008,label:"Namaqua Sandgrouse",value:"Namaqua Sandgrouse",category:"NonBirdsOfPrey",plural:"Namaqua Sandgrouses"},{id:2009,label:"Namaqua Warbler",value:"Namaqua Warbler",category:"NonBirdsOfPrey",plural:"Namaqua Warblers"},{id:2010,label:"Namuli Apalis",value:"Namuli Apalis",category:"NonBirdsOfPrey",plural:"Namuli Apalis"},{id:2011,label:"Narina Trogon Tit-Flycatcher",value:"Narina Trogon Tit-Flycatcher",category:"NonBirdsOfPrey",plural:"Narina Trogon Tit-Flycatchers"},{id:2012,label:"Narrow-tailed Starling",value:"Narrow-tailed Starling",category:"NonBirdsOfPrey",plural:"Narrow-tailed Starlings"},{id:2013,label:"Natal Francolin",value:"Natal Francolin",category:"NonBirdsOfPrey",plural:"Natal Francolins"},{id:2014,label:"Nechisar Nightjar",value:"Nechisar Nightjar",category:"NonBirdsOfPrey",plural:"Nechisar Nightjars"},{id:2015,label:"Neergaard's Sunbird",value:"Neergaard's Sunbird",category:"NonBirdsOfPrey",plural:"Neergaard's Sunbirds"},{id:2016,label:"Neumann's Starling",value:"Neumann's Starling",category:"NonBirdsOfPrey",plural:"Neumann's Starlings"},{id:2017,label:"Neumann's Warbler",value:"Neumann's Warbler",category:"NonBirdsOfPrey",plural:"Neumann's Warblers"},{id:2018,label:"Niam-Niam Parrot",value:"Niam-Niam Parrot",category:"NonBirdsOfPrey",plural:"Niam-Niam Parrots"},{id:2019,label:"Nicholson's Pipit",value:"Nicholson's Pipit",category:"NonBirdsOfPrey",plural:"Nicholson's Pipits"},{id:2020,label:"Nightingale Bunting",value:"Nightingale Bunting",category:"NonBirdsOfPrey",plural:"Nightingale Buntings"},{id:2021,label:"Nile Valley Sunbird",value:"Nile Valley Sunbird",category:"NonBirdsOfPrey",plural:"Nile Valley Sunbirds"},{id:2022,label:"Nimba Flycatcher",value:"Nimba Flycatcher",category:"NonBirdsOfPrey",plural:"Nimba Flycatchers"},{id:2023,label:"Nkulengu Rail",value:"Nkulengu Rail",category:"NonBirdsOfPrey",plural:"Nkulengu Rails"},{id:2024,label:"Northern Anteater-Chat",value:"Northern Anteater-Chat",category:"NonBirdsOfPrey",plural:"Northern Anteater-Chats"},{id:2025,label:"Northern Bald Ibis",value:"Northern Bald Ibis",category:"NonBirdsOfPrey",plural:"Northern Bald Ibises"},{id:2026,label:"Northern Black-Flycatcher",value:"Northern Black-Flycatcher",category:"NonBirdsOfPrey",plural:"Northern Black-Flycatchers"},{id:2027,label:"Northern Bobwhite",value:"Northern Bobwhite",category:"NonBirdsOfPrey",plural:"Northern Bobwhites"},{id:2028,label:"Northern Brown-throated Weaver",value:"Northern Brown-throated Weaver",category:"NonBirdsOfPrey",plural:"Northern Brown-throated Weavers"},{id:2029,label:"Northern Brownbul",value:"Northern Brownbul",category:"NonBirdsOfPrey",plural:"Northern Brownbuls"},{id:2030,label:"Northern Carmine Bee-eater",value:"Northern Carmine Bee-eater",category:"NonBirdsOfPrey",plural:"Northern Carmine Bee-eaters"},{id:2031,label:"Northern Crombec",value:"Northern Crombec",category:"NonBirdsOfPrey",plural:"Northern Crombecs"},{id:2032,label:"Northern Double-collared Sunbird",value:"Northern Double-collared Sunbird",category:"NonBirdsOfPrey",plural:"Northern Double-collared Sunbirds"},{id:2033,label:"Northern Fiscal",value:"Northern Fiscal",category:"NonBirdsOfPrey",plural:"Northern Fiscals"},{id:2034,label:"Northern Fulmar",value:"Northern Fulmar",category:"NonBirdsOfPrey",plural:"Northern Fulmars"},{id:2035,label:"Northern Gannet",value:"Northern Gannet",category:"NonBirdsOfPrey",plural:"Northern Gannets"},{id:2036,label:"Northern Giant-Petrel",value:"Northern Giant-Petrel",category:"NonBirdsOfPrey",plural:"Northern Giant-Petrels"},{id:2037,label:"Northern Goshawk",value:"Northern Goshawk",category:"BirdsOfPrey",plural:"Northern Goshawks"},{id:2038,label:"Northern Gray-headed Sparrow",value:"Northern Gray-headed Sparrow",category:"NonBirdsOfPrey",plural:"Northern Gray-headed Sparrows"},{id:2039,label:"Northern Grosbeak-Canary",value:"Northern Grosbeak-Canary",category:"NonBirdsOfPrey",plural:"Northern Grosbeak-Canaries"},{id:2040,label:"Northern House Martin",value:"Northern House Martin",category:"NonBirdsOfPrey",plural:"Northern House Martins"},{id:2041,label:"Northern Lapwing",value:"Northern Lapwing",category:"NonBirdsOfPrey",plural:"Northern Lapwings"},{id:2042,label:"Northern Masked-Weaver",value:"Northern Masked-Weaver",category:"NonBirdsOfPrey",plural:"Northern Masked-Weavers"},{id:2043,label:"Northern Pied-Babbler",value:"Northern Pied-Babbler",category:"NonBirdsOfPrey",plural:"Northern Pied-Babblers"},{id:2044,label:"Northern Pintail",value:"Northern Pintail",category:"NonBirdsOfPrey",plural:"Northern Pintails"},{id:2045,label:"Northern Puffback",value:"Northern Puffback",category:"NonBirdsOfPrey",plural:"Northern Puffbacks"},{id:2046,label:"Northern Red Bishop",value:"Northern Red Bishop",category:"NonBirdsOfPrey",plural:"Northern Red Bishops"},{id:2047,label:"Northern Red-billed Hornbill",value:"Northern Red-billed Hornbill",category:"NonBirdsOfPrey",plural:"Northern Red-billed Hornbills"},{id:2048,label:"Northern Rockhopper Penguin",value:"Northern Rockhopper Penguin",category:"NonBirdsOfPrey",plural:"Northern Rockhopper Penguins"},{id:2049,label:"Northern Royal Albatross",value:"Northern Royal Albatross",category:"NonBirdsOfPrey",plural:"Northern Royal Albatrosses"},
    {id:2051,label:"Northern Wheatear",value:"Northern Wheatear",category:"NonBirdsOfPrey",plural:"Northern Wheatears"},{id:2052,label:"Northern White-faced Owl",value:"Northern White-faced Owl",category:"BirdsOfPrey",plural:"Northern White-faced Owls"},{id:2053,label:"Northern Yellow White-eye",value:"Northern Yellow White-eye",category:"NonBirdsOfPrey",plural:"Northern Yellow White-eyes"},{id:2054,label:"Nubian Bustard",value:"Nubian Bustard",category:"NonBirdsOfPrey",plural:"Nubian Bustards"},{id:2055,label:"Nubian Nightjar",value:"Nubian Nightjar",category:"NonBirdsOfPrey",plural:"Nubian Nightjars"},{id:2056,label:"Nubian Woodpecker",value:"Nubian Woodpecker",category:"NonBirdsOfPrey",plural:"Nubian Woodpeckers"},{id:2057,label:"Nyanza Swift",value:"Nyanza Swift",category:"NonBirdsOfPrey",plural:"Nyanza Swifts"},{id:2058,label:"Obbia Lark",value:"Obbia Lark",category:"NonBirdsOfPrey",plural:"Obbia Larks"},{id:2059,label:"Oberl\u00e4nder's Ground-Thrush",value:"Oberl\u00e4nder's Ground-Thrush",category:"NonBirdsOfPrey",plural:"Oberl\u00e4nder's Ground-Thrushes"},{id:2060,label:"Olivaceous Flycatcher",value:"Olivaceous Flycatcher",category:"NonBirdsOfPrey",plural:"Olivaceous Flycatchers"},{id:2061,label:"Olive Bush-Shrike",value:"Olive Bush-Shrike",category:"NonBirdsOfPrey",plural:"Olive Bush-Shrikes"},{id:2062,label:"Olive Bushshrike",value:"Olive Bushshrike",category:"NonBirdsOfPrey",plural:"Olive Bushshrikes"},{id:2063,label:"Olive Ibis",value:"Olive Ibis",category:"NonBirdsOfPrey",plural:"Olive Ibises"},{id:2064,label:"Olive Long-tailed Cuckoo",value:"Olive Long-tailed Cuckoo",category:"NonBirdsOfPrey",plural:"Olive Long-tailed Cuckoos"},{id:2065,label:"Olive Sunbird",value:"Olive Sunbird",category:"NonBirdsOfPrey",plural:"Olive Sunbirds"},{id:2066,label:"Olive Woodpecker",value:"Olive Woodpecker",category:"NonBirdsOfPrey",plural:"Olive Woodpeckers"},{id:2067,label:"Olive-backed Pipit",value:"Olive-backed Pipit",category:"NonBirdsOfPrey",plural:"Olive-backed Pipits"},{id:2068,label:"Olive-bellied Sunbird",value:"Olive-bellied Sunbird",category:"NonBirdsOfPrey",plural:"Olive-bellied Sunbirds"},{id:2069,label:"Olive-flanked Robin-Chat",value:"Olive-flanked Robin-Chat",category:"NonBirdsOfPrey",plural:"Olive-flanked Robin-Chats"},{id:2070,label:"Olive-green Camaroptera",value:"Olive-green Camaroptera",category:"NonBirdsOfPrey",plural:"Olive-green Camaropteras"},{id:2071,label:"Olive-headed Weaver",value:"Olive-headed Weaver",category:"NonBirdsOfPrey",plural:"Olive-headed Weavers"},{id:2072,label:"Olive-tree Warbler",value:"Olive-tree Warbler",category:"NonBirdsOfPrey",plural:"Olive-tree Warblers"},{id:2073,label:"Omani Owl",value:"Omani Owl",category:"BirdsOfPrey",plural:"Omani Owls"},{id:2074,label:"Orange Ground-Thrush",value:"Orange Ground-Thrush",category:"NonBirdsOfPrey",plural:"Orange Ground-Thrushes"},{id:2075,label:"Orange River Francolin",value:"Orange River Francolin",category:"NonBirdsOfPrey",plural:"Orange River Francolins"},{id:2076,label:"Orange River White-eye",value:"Orange River White-eye",category:"NonBirdsOfPrey",plural:"Orange River White-eyes"},{id:2077,label:"Orange Weaver",value:"Orange Weaver",category:"NonBirdsOfPrey",plural:"Orange Weavers"},{id:2078,label:"Orange-breasted Sunbird",value:"Orange-breasted Sunbird",category:"NonBirdsOfPrey",plural:"Orange-breasted Sunbirds"},{id:2079,label:"Orange-cheeked Waxbill",value:"Orange-cheeked Waxbill",category:"NonBirdsOfPrey",plural:"Orange-cheeked Waxbills"},{id:2080,label:"Orange-throated Longclaw",value:"Orange-throated Longclaw",category:"NonBirdsOfPrey",plural:"Orange-throated Longclaws"},{id:2081,label:"Orange-tufted Sunbird",value:"Orange-tufted Sunbird",category:"NonBirdsOfPrey",plural:"Orange-tufted Sunbirds"},{id:2082,label:"Oriental Darter",value:"Oriental Darter",category:"NonBirdsOfPrey",plural:"Oriental Darters"},{id:2083,label:"Oriental Honey-buzzard",value:"Oriental Honey-buzzard",category:"BirdsOfPrey",plural:"Oriental Honey-buzzards"},{id:2084,label:"Oriental Pratincole",value:"Oriental Pratincole",category:"NonBirdsOfPrey",plural:"Oriental Pratincoles"},{id:2085,label:"Oriental Skylark",value:"Oriental Skylark",category:"NonBirdsOfPrey",plural:"Oriental Skylarks"},{id:2086,label:"Oriental Turtle-Dove",value:"Oriental Turtle-Dove",category:"NonBirdsOfPrey",plural:"Oriental Turtle-Doves"},{id:2087,label:"Oriole Cuckooshrike",value:"Oriole Cuckooshrike",category:"NonBirdsOfPrey",plural:"Oriole Cuckooshrikes"},{id:2088,label:"Oriole Finch",value:"Oriole Finch",category:"NonBirdsOfPrey",plural:"Oriole Finches"},{id:2089,label:"Oriole Warbler",value:"Oriole Warbler",category:"NonBirdsOfPrey",plural:"Oriole Warblers"},{id:2090,label:"Ortolan Bunting",value:"Ortolan Bunting",category:"NonBirdsOfPrey",plural:"Ortolan Buntings"},{id:2091,label:"Oustalet's Sunbird",value:"Oustalet's Sunbird",category:"NonBirdsOfPrey",plural:"Oustalet's Sunbirds"},{id:2092,label:"Pacific Golden Plover",value:"Pacific Golden Plover",category:"NonBirdsOfPrey",plural:"Pacific Golden Plovers"},{id:2093,label:"Pacific Golden-Plover",value:"Pacific Golden-Plover",category:"NonBirdsOfPrey",plural:"Pacific Golden-Plovers"},{id:2094,label:"Pale Batis",value:"Pale Batis",category:"NonBirdsOfPrey",plural:"Pale Batis"},{id:2095,label:"Pale Prinia",value:"Pale Prinia",category:"NonBirdsOfPrey",plural:"Pale Prinias"},{id:2096,label:"Pale Rockfinch",value:"Pale Rockfinch",category:"NonBirdsOfPrey",plural:"Pale Rockfinches"},{id:2097,label:"Pale Sand Martin",value:"Pale Sand Martin",category:"NonBirdsOfPrey",plural:"Pale Sand Martins"},{id:2098,label:"Pale White-eye",value:"Pale White-eye",category:"NonBirdsOfPrey",plural:"Pale White-eyes"},{id:2099,label:"Pale-billed Firefinch",value:"Pale-billed Firefinch",category:"NonBirdsOfPrey",plural:"Pale-billed Firefinches"},{id:2100,label:"Pale-billed Hornbill",value:"Pale-billed Hornbill",category:"NonBirdsOfPrey",plural:"Pale-billed Hornbills"},{id:2101,label:"Pale-breasted Illadopsis",value:"Pale-breasted Illadopsis",category:"NonBirdsOfPrey",plural:"Pale-breasted Illadopsis"},{id:2102,label:"Pale-crowned Cisticola",value:"Pale-crowned Cisticola",category:"NonBirdsOfPrey",plural:"Pale-crowned Cisticolas"},{id:2103,label:"Pale-fronted Nigrita",value:"Pale-fronted Nigrita",category:"NonBirdsOfPrey",plural:"Pale-fronted Nigritas"},{id:2104,label:"Pale-olive Greenbul",value:"Pale-olive Greenbul",category:"NonBirdsOfPrey",plural:"Pale-olive Greenbuls"},{id:2105,label:"Pale-winged Starling",value:"Pale-winged Starling",category:"NonBirdsOfPrey",plural:"Pale-winged Starlings"},{id:2106,label:"Palestine Sunbird",value:"Palestine Sunbird",category:"NonBirdsOfPrey",plural:"Palestine Sunbirds"},{id:2107,label:"Pallas's Grasshopper Warbler",value:"Pallas's Grasshopper Warbler",category:"NonBirdsOfPrey",plural:"Pallas's Grasshopper Warblers"},{id:2108,label:"Pallas's Gull",value:"Pallas's Gull",category:"NonBirdsOfPrey",plural:"Pallas's Gulls"},{id:2109,label:"Pallas's Leaf Warbler",value:"Pallas's Leaf Warbler",category:"NonBirdsOfPrey",plural:"Pallas's Leaf Warblers"},{id:2110,label:"Pallid Cuckoo",value:"Pallid Cuckoo",category:"NonBirdsOfPrey",plural:"Pallid Cuckoos"},{id:2111,label:"Pallid Honeyguide",value:"Pallid Honeyguide",category:"NonBirdsOfPrey",plural:"Pallid Honeyguides"},{id:2112,label:"Pallid Scops-Owl",value:"Pallid Scops-Owl",category:"BirdsOfPrey",plural:"Pallid Scops-Owls"},{id:2113,label:"Pallid Swift",value:"Pallid Swift",category:"NonBirdsOfPrey",plural:"Pallid Swifts"},{id:2114,label:"Palm-nut Vulture",value:"Palm-nut Vulture",category:"BirdsOfPrey",plural:"Palm-nut Vultures"},{id:2115,label:"Pangani Longclaw",value:"Pangani Longclaw",category:"NonBirdsOfPrey",plural:"Pangani Longclaws"},{id:2116,label:"Papyrus Canary",value:"Papyrus Canary",category:"NonBirdsOfPrey",plural:"Papyrus Canaries"},{id:2117,label:"Papyrus Gonolek",value:"Papyrus Gonolek",category:"NonBirdsOfPrey",plural:"Papyrus Gonoleks"},{id:2118,label:"Papyrus Yellow-Warbler",value:"Papyrus Yellow-Warbler",category:"NonBirdsOfPrey",plural:"Papyrus Yellow-Warblers"},{id:2119,label:"Parasitic Jaeger",value:"Parasitic Jaeger",category:"NonBirdsOfPrey",plural:"Parasitic Jaegers"},{id:2120,label:"Parasitic Weaver",value:"Parasitic Weaver",category:"NonBirdsOfPrey",plural:"Parasitic Weavers"},{id:2121,label:"Parrot-billed Sparrow",value:"Parrot-billed Sparrow",category:"NonBirdsOfPrey",plural:"Parrot-billed Sparrows"},{id:2122,label:"Pectoral Sandpiper",value:"Pectoral Sandpiper",category:"NonBirdsOfPrey",plural:"Pectoral Sandpipers"},{id:2123,label:"Pectoral-patch Cisticola",value:"Pectoral-patch Cisticola",category:"NonBirdsOfPrey",plural:"Pectoral-patch Cisticolas"},{id:2124,label:"Pemba Green-Pigeon",value:"Pemba Green-Pigeon",category:"NonBirdsOfPrey",plural:"Pemba Green-Pigeons"},{id:2125,label:"Pemba Scops-Owl",value:"Pemba Scops-Owl",category:"BirdsOfPrey",plural:"Pemba Scops-Owls"},{id:2126,label:"Pemba Sunbird",value:"Pemba Sunbird",category:"NonBirdsOfPrey",plural:"Pemba Sunbirds"},{id:2127,label:"Pemba White-eye",value:"Pemba White-eye",category:"NonBirdsOfPrey",plural:"Pemba White-eyes"},{id:2128,label:"Persian Shearwater",value:"Persian Shearwater",category:"NonBirdsOfPrey",plural:"Persian Shearwaters"},{id:2129,label:"Persian Wheatear",value:"Persian Wheatear",category:"NonBirdsOfPrey",plural:"Persian Wheatears"},{id:2130,label:"Peters's Twinspot",value:"Peters's Twinspot",category:"NonBirdsOfPrey",plural:"Peters's Twinspots"},{id:2131,label:"Petit's Cuckooshrike",value:"Petit's Cuckooshrike",category:"NonBirdsOfPrey",plural:"Petit's Cuckooshrikes"},{id:2132,label:"Pharaoh Eagle-Owl",value:"Pharaoh Eagle-Owl",category:"BirdsOfPrey",plural:"Pharaoh Eagle-Owls"},{id:2133,label:"Piapiac",value:"Piapiac",category:"NonBirdsOfPrey",plural:"Piapiacs"},{id:2134,label:"Pied Bushchat",value:"Pied Bushchat",category:"NonBirdsOfPrey",plural:"Pied Bushchats"},{id:2135,label:"Pied Cuckoo",value:"Pied Cuckoo",category:"NonBirdsOfPrey",plural:"Pied Cuckoos"},{id:2136,label:"Pied Starling",value:"Pied Starling",category:"NonBirdsOfPrey",plural:"Pied Starlings"},{id:2137,label:"Pied Wheatear",value:"Pied Wheatear",category:"NonBirdsOfPrey",plural:"Pied Wheatears"},{id:2138,label:"Pied-winged Swallow",value:"Pied-winged Swallow",category:"NonBirdsOfPrey",plural:"Pied-winged Swallows"},{id:2139,label:"Pin-tailed Sandgrouse",value:"Pin-tailed Sandgrouse",category:"NonBirdsOfPrey",plural:"Pin-tailed Sandgrouses"},{id:2140,label:"Pin-tailed Snipe",value:"Pin-tailed Snipe",category:"NonBirdsOfPrey",plural:"Pin-tailed Snipes"},{id:2141,label:"Pine Bunting",value:"Pine Bunting",category:"NonBirdsOfPrey",plural:"Pine Buntings"},{id:2142,label:"Pink-billed Lark",value:"Pink-billed Lark",category:"NonBirdsOfPrey",plural:"Pink-billed Larks"},{id:2143,label:"Pink-breasted Lark",value:"Pink-breasted Lark",category:"NonBirdsOfPrey",plural:"Pink-breasted Larks"},{id:2144,label:"Pink-footed Puffback",value:"Pink-footed Puffback",category:"NonBirdsOfPrey",plural:"Pink-footed Puffbacks"},{id:2145,label:"Pink-throated Twinspot",value:"Pink-throated Twinspot",category:"NonBirdsOfPrey",plural:"Pink-throated Twinspots"},{id:2146,label:"Pintado Petrel",value:"Pintado Petrel",category:"NonBirdsOfPrey",plural:"Pintado Petrels"},{id:2147,label:"Piping Cisticola",value:"Piping Cisticola",category:"NonBirdsOfPrey",plural:"Piping Cisticolas"},{id:2148,label:"Piping Hornbill",value:"Piping Hornbill",category:"NonBirdsOfPrey",plural:"Piping Hornbills"},{id:2149,label:"Plain Greenbul",value:"Plain Greenbul",category:"NonBirdsOfPrey",plural:"Plain Greenbuls"},{id:2150,label:"Plain Martin",value:"Plain Martin",category:"NonBirdsOfPrey",plural:"Plain Martins"},{id:2151,label:"Plain Nightjar",value:"Plain Nightjar",category:"NonBirdsOfPrey",plural:"Plain Nightjars"},{id:2152,label:"Plain Swift",value:"Plain Swift",category:"NonBirdsOfPrey",plural:"Plain Swifts"},{id:2153,label:"Plain-backed Sunbird",value:"Plain-backed Sunbird",category:"NonBirdsOfPrey",plural:"Plain-backed Sunbirds"},{id:2154,label:"Plumed Guineafowl",value:"Plumed Guineafowl",category:"NonBirdsOfPrey",plural:"Plumed Guineafowls"},{id:2155,label:"Pomarine Jaeger",value:"Pomarine Jaeger",category:"NonBirdsOfPrey",plural:"Pomarine Jaegers"},{id:2156,label:"Preuss's Swallow",value:"Preuss's Swallow",category:"NonBirdsOfPrey",plural:"Preuss's Swallows"},{id:2157,label:"Preuss's Weaver",value:"Preuss's Weaver",category:"NonBirdsOfPrey",plural:"Preuss's Weavers"},{id:2158,label:"Prigogine's Greenbul",value:"Prigogine's Greenbul",category:"NonBirdsOfPrey",plural:"Prigogine's Greenbuls"},{id:2159,label:"Prigogine's Sunbird",value:"Prigogine's Sunbird",category:"NonBirdsOfPrey",plural:"Prigogine's Sunbirds"},{id:2160,label:"Prince Ruspoli's Turaco",value:"Prince Ruspoli's Turaco",category:"NonBirdsOfPrey",plural:"Prince Ruspoli's Turacos"},{id:2161,label:"Pringle's Puffback",value:"Pringle's Puffback",category:"NonBirdsOfPrey",plural:"Pringle's Puffbacks"},{id:2162,label:"Pririt Batis",value:"Pririt Batis",category:"NonBirdsOfPrey",plural:"Pririt Batis"},{id:2163,label:"Protea Canary",value:"Protea Canary",category:"NonBirdsOfPrey",plural:"Protea Canaries"},{id:2164,label:"Protea Seedeater",value:"Protea Seedeater",category:"NonBirdsOfPrey",plural:"Protea Seedeaters"},{id:2165,label:"Pulitzer's Longbill",value:"Pulitzer's Longbill",category:"NonBirdsOfPrey",plural:"Pulitzer's Longbills"},{id:2166,label:"Purple Grenadier",value:"Purple Grenadier",category:"NonBirdsOfPrey",plural:"Purple Grenadiers"},{id:2167,label:"Purple Sandpiper",value:"Purple Sandpiper",category:"NonBirdsOfPrey",plural:"Purple Sandpipers"},{id:2168,label:"Purple Starling",value:"Purple Starling",category:"NonBirdsOfPrey",plural:"Purple Starlings"},{id:2169,label:"Purple-banded Sunbird",value:"Purple-banded Sunbird",category:"NonBirdsOfPrey",plural:"Purple-banded Sunbirds"},{id:2170,label:"Purple-breasted Sunbird",value:"Purple-breasted Sunbird",category:"NonBirdsOfPrey",plural:"Purple-breasted Sunbirds"},{id:2171,label:"Purple-headed Starling",value:"Purple-headed Starling",category:"NonBirdsOfPrey",plural:"Purple-headed Starlings"},{id:2172,label:"Purple-throated Cuckooshrike",value:"Purple-throated Cuckooshrike",category:"NonBirdsOfPrey",plural:"Purple-throated Cuckooshrikes"},{id:2173,label:"Puvel's Illadopsis",value:"Puvel's Illadopsis",category:"NonBirdsOfPrey",plural:"Puvel's Illadopsis"},{id:2174,label:"Pygmy Batis",value:"Pygmy Batis",category:"NonBirdsOfPrey",plural:"Pygmy Batis"},{id:2175,label:"Pygmy Cormorant",value:"Pygmy Cormorant",category:"NonBirdsOfPrey",plural:"Pygmy Cormorants"},{id:2176,label:"Pygmy Sunbird",value:"Pygmy Sunbird",category:"NonBirdsOfPrey",plural:"Pygmy Sunbirds"},{id:2177,label:"Quail-plover",value:"Quail-plover",category:"NonBirdsOfPrey",plural:"Quail-plovers"},{id:2178,label:"Quailfinch",value:"Quailfinch",category:"NonBirdsOfPrey",plural:"Quailfinches"},{id:2179,label:"Quailfinch Indigobird",value:"Quailfinch Indigobird",category:"NonBirdsOfPrey",plural:"Quailfinch Indigobirds"},{id:2180,label:"Rachel's Malimbe",value:"Rachel's Malimbe",category:"NonBirdsOfPrey",plural:"Rachel's Malimbes"},{id:2181,label:"Radde's Warbler",value:"Radde's Warbler",category:"NonBirdsOfPrey",plural:"Radde's Warblers"},{id:2182,label:"Rameron Pigeon",value:"Rameron Pigeon",category:"NonBirdsOfPrey",plural:"Rameron Pigeons"},{id:2183,label:"Razorbill",value:"Razorbill",category:"NonBirdsOfPrey",plural:"Razorbills"},{id:2184,label:"Red Avadavat",value:"Red Avadavat",category:"NonBirdsOfPrey",plural:"Red Avadavats"},{id:2185,label:"Red Crossbill",value:"Red Crossbill",category:"NonBirdsOfPrey",plural:"Red Crossbills"},{id:2186,label:"Red Kite",value:"Red Kite",category:"BirdsOfPrey",plural:"Red Kites"},{id:2187,label:"Red Knot",value:"Red Knot",category:"NonBirdsOfPrey",plural:"Red Knots"},{id:2188,label:"Red Lark",value:"Red Lark",category:"NonBirdsOfPrey",plural:"Red Larks"},{id:2189,label:"Red Phalarope",value:"Red Phalarope",category:"NonBirdsOfPrey",plural:"Red Phalaropes"},{id:2190,label:"Red Sea Swallow",value:"Red Sea Swallow",category:"NonBirdsOfPrey",plural:"Red Sea Swallows"},{id:2191,label:"Red winged Gray Warbler",value:"Red winged Gray Warbler",category:"NonBirdsOfPrey",plural:"Red winged Gray Warblers"},{id:2192,label:"Red-and-yellow Barbet",value:"Red-and-yellow Barbet",category:"NonBirdsOfPrey",plural:"Red-and-yellow Barbets"},{id:2193,label:"Red-backed Mousebird",value:"Red-backed Mousebird",category:"NonBirdsOfPrey",plural:"Red-backed Mousebirds"},{id:2194,label:"Red-backed Scrub-Robin",value:"Red-backed Scrub-Robin",category:"NonBirdsOfPrey",plural:"Red-backed Scrub-Robins"},{id:2195,label:"Red-bellied Malimbe",value:"Red-bellied Malimbe",category:"NonBirdsOfPrey",plural:"Red-bellied Malimbes"},{id:2196,label:"Red-bellied Parrot",value:"Red-bellied Parrot",category:"NonBirdsOfPrey",plural:"Red-bellied Parrots"},{id:2197,label:"Red-billed Chough",value:"Red-billed Chough",category:"NonBirdsOfPrey",plural:"Red-billed Choughs"},{id:2198,label:"Red-billed Duck",value:"Red-billed Duck",category:"NonBirdsOfPrey",plural:"Red-billed Ducks"},{id:2199,label:"Red-billed Dwarf Hornbill",value:"Red-billed Dwarf Hornbill",category:"NonBirdsOfPrey",plural:"Red-billed Dwarf Hornbills"},{id:2200,label:"Red-billed Francolin",value:"Red-billed Francolin",category:"NonBirdsOfPrey",plural:"Red-billed Francolins"},{id:2201,label:"Red-billed Helmetshrike",value:"Red-billed Helmetshrike",category:"NonBirdsOfPrey",plural:"Red-billed Helmetshrikes"},{id:2202,label:"Red-billed Pytilia",value:"Red-billed Pytilia",category:"NonBirdsOfPrey",plural:"Red-billed Pytilias"},{id:2203,label:"Red-billed Spurfowl",value:"Red-billed Spurfowl",category:"NonBirdsOfPrey",plural:"Red-billed Spurfowls"},{id:2204,label:"Red-billed Tropicbird",value:"Red-billed Tropicbird",category:"NonBirdsOfPrey",plural:"Red-billed Tropicbirds"},{id:2205,label:"Red-breasted Flycatcher",value:"Red-breasted Flycatcher",category:"NonBirdsOfPrey",plural:"Red-breasted Flycatchers"},{id:2206,label:"Red-breasted Goose",value:"Red-breasted Goose",category:"NonBirdsOfPrey",plural:"Red-breasted Geese"},{id:2207,label:"Red-breasted Merganser",value:"Red-breasted Merganser",category:"NonBirdsOfPrey",plural:"Red-breasted Mergansers"},{id:2208,label:"Red-breasted Wheatear",value:"Red-breasted Wheatear",category:"NonBirdsOfPrey",plural:"Red-breasted Wheatears"},{id:2209,label:"Red-capped Crombec",value:"Red-capped Crombec",category:"NonBirdsOfPrey",plural:"Red-capped Crombecs"},{id:2210,label:"Red-cheeked Cordonbleu",value:"Red-cheeked Cordonbleu",category:"NonBirdsOfPrey",plural:"Red-cheeked Cordonbleus"},{id:2211,label:"Red-cheeked Wattle-eye",value:"Red-cheeked Wattle-eye",category:"NonBirdsOfPrey",plural:"Red-cheeked Wattle-eyes"},{id:2212,label:"Red-chested Cuckoo",value:"Red-chested Cuckoo",category:"NonBirdsOfPrey",plural:"Red-chested Cuckoos"},{id:2213,label:"Red-chested Goshawk",value:"Red-chested Goshawk",category:"NonBirdsOfPrey",plural:"Red-chested Goshawks"},{id:2214,label:"Red-chested Owlet",value:"Red-chested Owlet",category:"BirdsOfPrey",plural:"Red-chested Owlets"},{id:2215,label:"Red-chested Sunbird",value:"Red-chested Sunbird",category:"NonBirdsOfPrey",plural:"Red-chested Sunbirds"},{id:2216,label:"Red-chested Swallow",value:"Red-chested Swallow",category:"NonBirdsOfPrey",plural:"Red-chested Swallows"},{id:2217,label:"Red-collared Mountain-Babbler",value:"Red-collared Mountain-Babbler",category:"NonBirdsOfPrey",plural:"Red-collared Mountain-Babblers"},{id:2218,label:"Red-collared Widowbird",value:"Red-collared Widowbird",category:"NonBirdsOfPrey",plural:"Red-collared Widowbirds"},{id:2219,label:"Red-crested Bustard",value:"Red-crested Bustard",category:"NonBirdsOfPrey",plural:"Red-crested Bustards"},{id:2220,label:"Red-crested Korhaan",value:"Red-crested Korhaan",category:"NonBirdsOfPrey",plural:"Red-crested Korhaans"},{id:2221,label:"Red-crested Pochard",value:"Red-crested Pochard",category:"NonBirdsOfPrey",plural:"Red-crested Pochards"},{id:2222,label:"Red-crested Turaco",value:"Red-crested Turaco",category:"NonBirdsOfPrey",plural:"Red-crested Turacos"},{id:2223,label:"Red-crowned Malimbe",value:"Red-crowned Malimbe",category:"NonBirdsOfPrey",plural:"Red-crowned Malimbes"},{id:2224,label:"Red-eyed Puffback",value:"Red-eyed Puffback",category:"NonBirdsOfPrey",plural:"Red-eyed Puffbacks"},{id:2225,label:"Red-eyed Vireo",value:"Red-eyed Vireo",category:"NonBirdsOfPrey",plural:"Red-eyed Vireos"},{id:2226,label:"Red-faced Barbet",value:"Red-faced Barbet",category:"NonBirdsOfPrey",plural:"Red-faced Barbets"},{id:2227,label:"Red-faced Crimsonwing",value:"Red-faced Crimsonwing",category:"NonBirdsOfPrey",plural:"Red-faced Crimsonwings"},{id:2228,label:"Red-faced Crombec",value:"Red-faced Crombec",category:"NonBirdsOfPrey",plural:"Red-faced Crombecs"},{id:2229,label:"Red-faced Pytilia",value:"Red-faced Pytilia",category:"NonBirdsOfPrey",plural:"Red-faced Pytilias"},{id:2230,label:"Red-faced Woodland-Warbler",value:"Red-faced Woodland-Warbler",category:"NonBirdsOfPrey",plural:"Red-faced Woodland-Warblers"},{id:2231,label:"Red-footed Booby",value:"Red-footed Booby",category:"NonBirdsOfPrey",plural:"Red-footed Boobies"},{id:2232,label:"Red-fronted Antpecker",value:"Red-fronted Antpecker",category:"NonBirdsOfPrey",plural:"Red-fronted Antpeckers"},{id:2233,label:"Red-fronted Barbet",value:"Red-fronted Barbet",category:"NonBirdsOfPrey",plural:"Red-fronted Barbets"},{id:2234,label:"Red-fronted Parrot",value:"Red-fronted Parrot",category:"NonBirdsOfPrey",plural:"Red-fronted Parrots"},{id:2235,label:"Red-fronted Prinia",value:"Red-fronted Prinia",category:"NonBirdsOfPrey",plural:"Red-fronted Prinias"},{id:2236,label:"Red-fronted Tinkerbird",value:"Red-fronted Tinkerbird",category:"NonBirdsOfPrey",plural:"Red-fronted Tinkerbirds"},{id:2237,label:"Red-headed Bluebill",value:"Red-headed Bluebill",category:"NonBirdsOfPrey",plural:"Red-headed Bluebills"},{id:2238,label:"Red-headed Bunting",value:"Red-headed Bunting",category:"NonBirdsOfPrey",plural:"Red-headed Buntings"},{id:2239,label:"Red-headed Cisticola",value:"Red-headed Cisticola",category:"NonBirdsOfPrey",plural:"Red-headed Cisticolas"},{id:2240,label:"Red-headed Lovebird",value:"Red-headed Lovebird",category:"NonBirdsOfPrey",plural:"Red-headed Lovebirds"},{id:2241,label:"Red-headed Malimbe",value:"Red-headed Malimbe",category:"NonBirdsOfPrey",plural:"Red-headed Malimbes"},{id:2242,label:"Red-headed Quelea",value:"Red-headed Quelea",category:"NonBirdsOfPrey",plural:"Red-headed Queleas"},{id:2243,label:"Red-legged Partridge",value:"Red-legged Partridge",category:"NonBirdsOfPrey",plural:"Red-legged Partridges"},{id:2244,label:"Red-naped Bushshrike",value:"Red-naped Bushshrike",category:"NonBirdsOfPrey",plural:"Red-naped Bushshrikes"},{id:2245,label:"Red-necked Buzzard",value:"Red-necked Buzzard",category:"BirdsOfPrey",plural:"Red-necked Buzzards"},{id:2246,label:"Red-necked Francolin",value:"Red-necked Francolin",category:"NonBirdsOfPrey",plural:"Red-necked Francolins"},{id:2247,label:"Red-necked Grebe",value:"Red-necked Grebe",category:"NonBirdsOfPrey",plural:"Red-necked Grebes"},{id:2248,label:"Red-necked Nightjar",value:"Red-necked Nightjar",category:"NonBirdsOfPrey",plural:"Red-necked Nightjars"},{id:2249,label:"Red-necked Phalarope",value:"Red-necked Phalarope",category:"NonBirdsOfPrey",plural:"Red-necked Phalaropes"},{id:2250,label:"Red-necked Spurfowl",value:"Red-necked Spurfowl",category:"NonBirdsOfPrey",plural:"Red-necked Spurfowls"},{id:2251,label:"Red-necked Stint",value:"Red-necked Stint",category:"NonBirdsOfPrey",plural:"Red-necked Stints"},{id:2252,label:"Red-pate Cisticola",value:"Red-pate Cisticola",category:"NonBirdsOfPrey",plural:"Red-pate Cisticolas"},{id:2253,label:"Red-rumped Swallow",value:"Red-rumped Swallow",category:"NonBirdsOfPrey",plural:"Red-rumped Swallows"},{id:2254,label:"Red-rumped Tinkerbird",value:"Red-rumped Tinkerbird",category:"NonBirdsOfPrey",plural:"Red-rumped Tinkerbirds"},{id:2255,label:"Red-rumped Wheatear",value:"Red-rumped Wheatear",category:"NonBirdsOfPrey",plural:"Red-rumped Wheatears"},{id:2256,label:"Red-shouldered Cuckooshrike",value:"Red-shouldered Cuckooshrike",category:"NonBirdsOfPrey",plural:"Red-shouldered Cuckooshrikes"},{id:2257,label:"Red-shouldered Vanga",value:"Red-shouldered Vanga",category:"NonBirdsOfPrey",plural:"Red-shouldered Vangas"},{id:2258,label:"Red-tailed Ant-Thrush",value:"Red-tailed Ant-Thrush",category:"NonBirdsOfPrey",plural:"Red-tailed Ant-Thrushes"},{id:2259,label:"Red-tailed Bristlebill",value:"Red-tailed Bristlebill",category:"NonBirdsOfPrey",plural:"Red-tailed Bristlebills"},{id:2260,label:"Red-tailed Greenbul",value:"Red-tailed Greenbul",category:"NonBirdsOfPrey",plural:"Red-tailed Greenbuls"},{id:2261,label:"Red-tailed Shrike",value:"Red-tailed Shrike",category:"NonBirdsOfPrey",plural:"Red-tailed Shrikes"},{id:2262,label:"Red-tailed Tropicbird",value:"Red-tailed Tropicbird",category:"NonBirdsOfPrey",plural:"Red-tailed Tropicbirds"},{id:2263,label:"Red-thighed Sparrowhawk",value:"Red-thighed Sparrowhawk",category:"BirdsOfPrey",plural:"Red-thighed Sparrowhawks"},{id:2264,label:"Red-throated Alethe",value:"Red-throated Alethe",category:"NonBirdsOfPrey",plural:"Red-throated Alethes"},{id:2265,label:"Red-throated Bee-eater",value:"Red-throated Bee-eater",category:"NonBirdsOfPrey",plural:"Red-throated Bee-eaters"},{id:2266,label:"Red-throated Loon",value:"Red-throated Loon",category:"NonBirdsOfPrey",plural:"Red-throated Loons"},{id:2267,label:"Red-throated Pipit",value:"Red-throated Pipit",category:"NonBirdsOfPrey",plural:"Red-throated Pipits"},{id:2268,label:"Red-throated Swallow",value:"Red-throated Swallow",category:"NonBirdsOfPrey",plural:"Red-throated Swallows"},{id:2269,label:"Red-throated Tit",value:"Red-throated Tit",category:"NonBirdsOfPrey",plural:"Red-throated Tits"},{id:2270,label:"Red-throated Twinspot",value:"Red-throated Twinspot",category:"NonBirdsOfPrey",plural:"Red-throated Twinspots"},{id:2271,label:"Red-tufted Sunbird",value:"Red-tufted Sunbird",category:"NonBirdsOfPrey",plural:"Red-tufted Sunbirds"},{id:2272,label:"Red-vented Malimbe",value:"Red-vented Malimbe",category:"NonBirdsOfPrey",plural:"Red-vented Malimbes"},{id:2273,label:"Red-whiskered Bulbul",value:"Red-whiskered Bulbul",category:"NonBirdsOfPrey",plural:"Red-whiskered Bulbuls"},{id:2274,label:"Red-winged Francolin",value:"Red-winged Francolin",category:"NonBirdsOfPrey",plural:"Red-winged Francolins"},{id:2275,label:"Red-winged Grey Warbler",value:"Red-winged Grey Warbler",category:"NonBirdsOfPrey",plural:"Red-winged Grey Warblers"},{id:2276,label:"Red-winged Lark",value:"Red-winged Lark",category:"NonBirdsOfPrey",plural:"Red-winged Larks"},{id:2277,label:"Red-winged Prinia",value:"Red-winged Prinia",category:"NonBirdsOfPrey",plural:"Red-winged Prinias"},{id:2278,label:"Red-winged Pytilia",value:"Red-winged Pytilia",category:"NonBirdsOfPrey",plural:"Red-winged Pytilias"},{id:2279,label:"Redwing",value:"Redwing",category:"NonBirdsOfPrey",plural:"Redwings"},{id:2280,label:"Reed Bunting",value:"Reed Bunting",category:"NonBirdsOfPrey",plural:"Reed Buntings"},{id:2281,label:"Reeves's Pheasant",value:"Reeves's Pheasant",category:"NonBirdsOfPrey",plural:"Reeves's Pheasants"},{id:2282,label:"Regal Sunbird",value:"Regal Sunbird",category:"NonBirdsOfPrey",plural:"Regal Sunbirds"},{id:2283,label:"Reichard's Seedeater",value:"Reichard's Seedeater",category:"NonBirdsOfPrey",plural:"Reichard's Seedeaters"},{id:2284,label:"Reichenbach's Sunbird",value:"Reichenbach's Sunbird",category:"NonBirdsOfPrey",plural:"Reichenbach's Sunbirds"},{id:2285,label:"Reichenow's Firefinch",value:"Reichenow's Firefinch",category:"NonBirdsOfPrey",plural:"Reichenow's Firefinches"},{id:2286,label:"Reichenow's Seedeater",value:"Reichenow's Seedeater",category:"NonBirdsOfPrey",plural:"Reichenow's Seedeaters"},{id:2287,label:"Reichenow's Woodpecker",value:"Reichenow's Woodpecker",category:"NonBirdsOfPrey",plural:"Reichenow's Woodpeckers"},{id:2288,label:"Retz's Helmetshrike",value:"Retz's Helmetshrike",category:"NonBirdsOfPrey",plural:"Retz's Helmetshrikes"},{id:2289,label:"Richard's Pipit",value:"Richard's Pipit",category:"NonBirdsOfPrey",plural:"Richard's Pipits"},{id:2290,label:"Ring Ouzel",value:"Ring Ouzel",category:"NonBirdsOfPrey",plural:"Ring Ouzels"},{id:2291,label:"Ring-billed Gull",value:"Ring-billed Gull",category:"NonBirdsOfPrey",plural:"Ring-billed Gulls"},{id:2292,label:"Ring-necked Dove",value:"Ring-necked Dove",category:"NonBirdsOfPrey",plural:"Ring-necked Doves"},{id:2293,label:"Ring-necked Duck",value:"Ring-necked Duck",category:"NonBirdsOfPrey",plural:"Ring-necked Ducks"},{id:2294,label:"Ring-necked Francolin",value:"Ring-necked Francolin",category:"NonBirdsOfPrey",plural:"Ring-necked Francolins"},{id:2295,label:"Ring-necked Pheasant",value:"Ring-necked Pheasant",category:"NonBirdsOfPrey",plural:"Ring-necked Pheasants"},{id:2296,label:"River Prinia",value:"River Prinia",category:"NonBirdsOfPrey",plural:"River Prinias"},{id:2297,label:"Roberts's Warbler",value:"Roberts's Warbler",category:"NonBirdsOfPrey",plural:"Roberts's Warblers"},{id:2298,label:"Rock Bunting",value:"Rock Bunting",category:"NonBirdsOfPrey",plural:"Rock Buntings"},{id:2299,label:"Rock Firefinch",value:"Rock Firefinch",category:"NonBirdsOfPrey",plural:"Rock Firefinches"},{id:2300,label:"Rock Pigeon",value:"Rock Pigeon",category:"NonBirdsOfPrey",plural:"Rock Pigeons"},{id:2301,label:"Rock Pratincole",value:"Rock Pratincole",category:"NonBirdsOfPrey",plural:"Rock Pratincoles"},{id:2302,label:"Rock Ptarmigan",value:"Rock Ptarmigan",category:"NonBirdsOfPrey",plural:"Rock Ptarmigans"},{id:2303,label:"Rock Sparrow",value:"Rock Sparrow",category:"NonBirdsOfPrey",plural:"Rock Sparrows"},{id:2304,label:"Rock-loving Cisticola",value:"Rock-loving Cisticola",category:"NonBirdsOfPrey",plural:"Rock-loving Cisticolas"},{id:2305,label:"Rockefeller's Sunbird",value:"Rockefeller's Sunbird",category:"NonBirdsOfPrey",plural:"Rockefeller's Sunbirds"},{id:2306,label:"Rockrunner",value:"Rockrunner",category:"NonBirdsOfPrey",plural:"Rockrunners"},{id:2307,label:"Rook",value:"Rook",category:"NonBirdsOfPrey",plural:"Rooks"},{id:2308,label:"Rose-coloured Starling",value:"Rose-coloured Starling",category:"NonBirdsOfPrey",plural:"Rose-coloured Starlings"},{id:2309,label:"Rose-ringed Parakeet",value:"Rose-ringed Parakeet",category:"NonBirdsOfPrey",plural:"Rose-ringed Parakeets"},{id:2310,label:"Roseate Tern",value:"Roseate Tern",category:"NonBirdsOfPrey",plural:"Roseate Terns"},{id:2311,label:"Ross's Turaco",value:"Ross's Turaco",category:"NonBirdsOfPrey",plural:"Ross's Turacos"},{id:2312,label:"Rosy Bee-eater",value:"Rosy Bee-eater",category:"NonBirdsOfPrey",plural:"Rosy Bee-eaters"},{id:2313,label:"Rosy-faced Lovebird",value:"Rosy-faced Lovebird",category:"NonBirdsOfPrey",plural:"Rosy-faced Lovebirds"},{id:2314,label:"Rosy-patched Bushshrike",value:"Rosy-patched Bushshrike",category:"NonBirdsOfPrey",plural:"Rosy-patched Bushshrikes"},{id:2315,label:"Rosy-throated Longclaw",value:"Rosy-throated Longclaw",category:"NonBirdsOfPrey",plural:"Rosy-throated Longclaws"},{id:2316,label:"Rouget's Rail",value:"Rouget's Rail",category:"NonBirdsOfPrey",plural:"Rouget's Rails"},{id:2317,label:"Rough-legged Hawk",value:"Rough-legged Hawk",category:"BirdsOfPrey",plural:"Rough-legged Hawks"},{id:2318,label:"Royal Tern",value:"Royal Tern",category:"NonBirdsOfPrey",plural:"Royal Terns"},{id:2319,label:"Ruaha Chat",value:"Ruaha Chat",category:"NonBirdsOfPrey",plural:"Ruaha Chats"},{id:2320,label:"Rubeho Akalat",value:"Rubeho Akalat",category:"NonBirdsOfPrey",plural:"Rubeho Akalats"},{id:2321,label:"Rudd's Lark",value:"Rudd's Lark",category:"NonBirdsOfPrey",plural:"Rudd's Larks"},{id:2322,label:"Ruddy Duck",value:"Ruddy Duck",category:"NonBirdsOfPrey",plural:"Ruddy Ducks"},{id:2323,label:"Ruddy Shelduck",value:"Ruddy Shelduck",category:"NonBirdsOfPrey",plural:"Ruddy Shelducks"},{id:2324,label:"Ruddy Turnstone",value:"Ruddy Turnstone",category:"NonBirdsOfPrey",plural:"Ruddy Turnstones"},{id:2325,label:"Rufous Chatterer",value:"Rufous Chatterer",category:"NonBirdsOfPrey",plural:"Rufous Chatterers"},{id:2326,label:"Rufous Cisticola",value:"Rufous Cisticola",category:"NonBirdsOfPrey",plural:"Rufous Cisticolas"},{id:2327,label:"Rufous Fishing-Owl",value:"Rufous Fishing-Owl",category:"BirdsOfPrey",plural:"Rufous Fishing-Owls"},{id:2328,label:"Rufous Flycatcher-Thrush",value:"Rufous Flycatcher-Thrush",category:"NonBirdsOfPrey",plural:"Rufous Flycatcher-Thrushes"},{id:2329,label:"Rufous-bellied Helmetshrike",value:"Rufous-bellied Helmetshrike",category:"NonBirdsOfPrey",plural:"Rufous-bellied Helmetshrikes"},{id:2330,label:"Rufous-bellied Tit",value:"Rufous-bellied Tit",category:"NonBirdsOfPrey",plural:"Rufous-bellied Tits"},{id:2331,label:"Rufous-breasted Sparrowhawk",value:"Rufous-breasted Sparrowhawk",category:"BirdsOfPrey",plural:"Rufous-breasted Sparrowhawks"},{id:2332,label:"Rufous-capped Lark",value:"Rufous-capped Lark",category:"NonBirdsOfPrey",plural:"Rufous-capped Larks"},{id:2333,label:"Rufous-chested Swallow",value:"Rufous-chested Swallow",category:"NonBirdsOfPrey",plural:"Rufous-chested Swallows"},{id:2334,label:"Rufous-crowned Eremomela",value:"Rufous-crowned Eremomela",category:"NonBirdsOfPrey",plural:"Rufous-crowned Eremomelas"},{id:2335,label:"Rufous-crowned Roller",value:"Rufous-crowned Roller",category:"NonBirdsOfPrey",plural:"Rufous-crowned Rollers"},{id:2336,label:"Rufous-eared Warbler",value:"Rufous-eared Warbler",category:"NonBirdsOfPrey",plural:"Rufous-eared Warblers"},{id:2337,label:"Rufous-necked Wryneck",value:"Rufous-necked Wryneck",category:"NonBirdsOfPrey",plural:"Rufous-necked Wrynecks"},{id:2338,label:"Rufous-rumped Lark",value:"Rufous-rumped Lark",category:"NonBirdsOfPrey",plural:"Rufous-rumped Larks"},{id:2339,label:"Rufous-sided Broadbill",value:"Rufous-sided Broadbill",category:"NonBirdsOfPrey",plural:"Rufous-sided Broadbills"},{id:2340,label:"Rufous-tailed Palm-Thrush",value:"Rufous-tailed Palm-Thrush",category:"NonBirdsOfPrey",plural:"Rufous-tailed Palm-Thrushes"},{id:2341,label:"Rufous-tailed Rock-Thrush",value:"Rufous-tailed Rock-Thrush",category:"NonBirdsOfPrey",plural:"Rufous-tailed Rock-Thrushes"},{id:2342,label:"Rufous-tailed Scrub-Robin",value:"Rufous-tailed Scrub-Robin",category:"NonBirdsOfPrey",plural:"Rufous-tailed Scrub-Robins"},{id:2343,label:"Rufous-tailed Weaver",value:"Rufous-tailed Weaver",category:"NonBirdsOfPrey",plural:"Rufous-tailed Weavers"},{id:2344,label:"Rufous-vented Paradise-Flycatcher",value:"Rufous-vented Paradise-Flycatcher",category:"NonBirdsOfPrey",plural:"Rufous-vented Paradise-Flycatchers"},{id:2345,label:"Rufous-winged Cisticola",value:"Rufous-winged Cisticola",category:"NonBirdsOfPrey",plural:"Rufous-winged Cisticolas"},{id:2346,label:"Rufous-winged Illadopsis",value:"Rufous-winged Illadopsis",category:"NonBirdsOfPrey",plural:"Rufous-winged Illadopsis"},{id:2347,label:"Rufous-winged Sunbird",value:"Rufous-winged Sunbird",category:"NonBirdsOfPrey",plural:"Rufous-winged Sunbirds"},{id:2348,label:"R\u00fcppell's Bustard",value:"R\u00fcppell's Bustard",category:"NonBirdsOfPrey",plural:"R\u00fcppell's Bustards"},{id:2349,label:"R\u00fcppell's Chat",value:"R\u00fcppell's Chat",category:"NonBirdsOfPrey",plural:"R\u00fcppell's Chats"},{id:2350,label:"R\u00fcppell's Griffon",value:"R\u00fcppell's Griffon",category:"BirdsOfPrey",plural:"R\u00fcppell's Griffons"},{id:2351,label:"R\u00fcppell's Korhaan",value:"R\u00fcppell's Korhaan",category:"NonBirdsOfPrey",plural:"R\u00fcppell's Korhaans"},{id:2352,label:"R\u00fcppell's Parrot",value:"R\u00fcppell's Parrot",category:"NonBirdsOfPrey",plural:"R\u00fcppell's Parrots"},{id:2353,label:"R\u00fcppell's Robin-Chat",value:"R\u00fcppell's Robin-Chat",category:"NonBirdsOfPrey",plural:"R\u00fcppell's Robin-Chats"},{id:2354,label:"R\u00fcppell's Starling",value:"R\u00fcppell's Starling",category:"NonBirdsOfPrey",plural:"R\u00fcppell's Starlings"},{id:2355,label:"R\u00fcppell's Warbler",value:"R\u00fcppell's Warbler",category:"NonBirdsOfPrey",plural:"R\u00fcppell's Warblers"},{id:2356,label:"R\u00fcppell's Weaver",value:"R\u00fcppell's Weaver",category:"NonBirdsOfPrey",plural:"R\u00fcppell's Weavers"},{id:2357,label:"Rustic Bunting",value:"Rustic Bunting",category:"NonBirdsOfPrey",plural:"Rustic Buntings"},{id:2358,label:"Rusty Lark",value:"Rusty Lark",category:"NonBirdsOfPrey",plural:"Rusty Larks"},{id:2359,label:"Rwenzori Apalis",value:"Rwenzori Apalis",category:"NonBirdsOfPrey",plural:"Rwenzori Apalis"},{id:2360,label:"Rwenzori Batis",value:"Rwenzori Batis",category:"NonBirdsOfPrey",plural:"Rwenzori Batis"},{id:2361,label:"Rwenzori Hill Babbler",value:"Rwenzori Hill Babbler",category:"NonBirdsOfPrey",plural:"Rwenzori Hill Babblers"},{id:2362,label:"Rwenzori Nightjar",value:"Rwenzori Nightjar",category:"NonBirdsOfPrey",plural:"Rwenzori Nightjars"},{id:2363,label:"Rwenzori Turaco",value:"Rwenzori Turaco",category:"NonBirdsOfPrey",plural:"Rwenzori Turacos"},{id:2364,label:"Sabine's Gull",value:"Sabine's Gull",category:"NonBirdsOfPrey",plural:"Sabine's Gulls"},{id:2365,label:"Sabine's Puffback",value:"Sabine's Puffback",category:"NonBirdsOfPrey",plural:"Sabine's Puffbacks"},{id:2366,label:"Sabine's Spinetail",value:"Sabine's Spinetail",category:"NonBirdsOfPrey",plural:"Sabine's Spinetails"},{id:2367,label:"Sahel Bush Sparrow",value:"Sahel Bush Sparrow",category:"NonBirdsOfPrey",plural:"Sahel Bush Sparrows"},{id:2368,label:"Sahel Paradise-Whydah",value:"Sahel Paradise-Whydah",category:"NonBirdsOfPrey",plural:"Sahel Paradise-Whydahs"},{id:2369,label:"Saker Falcon",value:"Saker Falcon",category:"BirdsOfPrey",plural:"Saker Falcons"},{id:2370,label:"Salvadori's Eremomela",value:"Salvadori's Eremomela",category:"NonBirdsOfPrey",plural:"Salvadori's Eremomelas"},{id:2371,label:"Salvadori's Serin",value:"Salvadori's Serin",category:"NonBirdsOfPrey",plural:"Salvadori's Serins"},{id:2372,label:"Salvadori's Weaver",value:"Salvadori's Weaver",category:"NonBirdsOfPrey",plural:"Salvadori's Weavers"},{id:2373,label:"Salvin's Albatross",value:"Salvin's Albatross",category:"NonBirdsOfPrey",plural:"Salvin's Albatrosses"},{id:2374,label:"Salvin's Prion",value:"Salvin's Prion",category:"NonBirdsOfPrey",plural:"Salvin's Prions"},{id:2375,label:"Sand Partridge",value:"Sand Partridge",category:"NonBirdsOfPrey",plural:"Sand Partridges"},{id:2376,label:"Sandwich Tern",value:"Sandwich Tern",category:"NonBirdsOfPrey",plural:"Sandwich Terns"},{id:2377,label:"Sandy Scops-Owl",value:"Sandy Scops-Owl",category:"BirdsOfPrey",plural:"Sandy Scops-Owls"},{id:2378,label:"Sao Tome Pigeon",value:"Sao Tome Pigeon",category:"NonBirdsOfPrey",plural:"Sao Tome Pigeons"},{id:2379,label:"Sardinian Warbler",value:"Sardinian Warbler",category:"NonBirdsOfPrey",plural:"Sardinian Warblers"},{id:2380,label:"Sassi's Greenbul",value:"Sassi's Greenbul",category:"NonBirdsOfPrey",plural:"Sassi's Greenbuls"},{id:2381,label:"Saunders's Tern",value:"Saunders's Tern",category:"NonBirdsOfPrey",plural:"Saunders's Terns"},{id:2382,label:"Savi's Warbler",value:"Savi's Warbler",category:"NonBirdsOfPrey",plural:"Savi's Warblers"},{id:2383,label:"Savile's Bustard",value:"Savile's Bustard",category:"NonBirdsOfPrey",plural:"Savile's Bustards"},{id:2384,label:"Scaly Babbler",value:"Scaly Babbler",category:"NonBirdsOfPrey",plural:"Scaly Babblers"},{id:2385,label:"Scaly Chatterer",value:"Scaly Chatterer",category:"NonBirdsOfPrey",plural:"Scaly Chatterers"},{id:2386,label:"Scaly Francolin",value:"Scaly Francolin",category:"NonBirdsOfPrey",plural:"Scaly Francolins"},{id:2387,label:"Scaly Weaver",value:"Scaly Weaver",category:"NonBirdsOfPrey",plural:"Scaly Weavers"},{id:2388,label:"Scaly-breasted Illadopsis",value:"Scaly-breasted Illadopsis",category:"NonBirdsOfPrey",plural:"Scaly-breasted Illadopsis"},{id:2389,label:"Scaly-fronted Weaver",value:"Scaly-fronted Weaver",category:"NonBirdsOfPrey",plural:"Scaly-fronted Weavers"},{id:2390,label:"Scarce Swift",value:"Scarce Swift",category:"NonBirdsOfPrey",plural:"Scarce Swifts"},{id:2391,label:"Schalow's Turaco",value:"Schalow's Turaco",category:"NonBirdsOfPrey",plural:"Schalow's Turacos"},{id:2392,label:"Schlegel's Francolin",value:"Schlegel's Francolin",category:"NonBirdsOfPrey",plural:"Schlegel's Francolins"},{id:2393,label:"Schrenck's Bittern",value:"Schrenck's Bittern",category:"NonBirdsOfPrey",plural:"Schrenck's Bitterns"},{id:2394,label:"Scissor-tailed Kite",value:"Scissor-tailed Kite",category:"BirdsOfPrey",plural:"Scissor-tailed Kites"},{id:2395,label:"Sclater's Lark",value:"Sclater's Lark",category:"NonBirdsOfPrey",plural:"Sclater's Larks"},{id:2396,label:"Scrub Warbler",value:"Scrub Warbler",category:"NonBirdsOfPrey",plural:"Scrub Warblers"},{id:2397,label:"Semicollared Flycatcher",value:"Semicollared Flycatcher",category:"NonBirdsOfPrey",plural:"Semicollared Flycatchers"},{id:2398,label:"Semipalmated Sandpiper",value:"Semipalmated Sandpiper",category:"NonBirdsOfPrey",plural:"Semipalmated Sandpipers"},{id:2399,label:"Senegal Batis",value:"Senegal Batis",category:"NonBirdsOfPrey",plural:"Senegal Batis"},{id:2400,label:"Senegal Eremomela",value:"Senegal Eremomela",category:"NonBirdsOfPrey",plural:"Senegal Eremomelas"},{id:2401,label:"Senegal Parrot",value:"Senegal Parrot",category:"NonBirdsOfPrey",plural:"Senegal Parrots"},{id:2402,label:"Senegal Thick-knee",value:"Senegal Thick-knee",category:"NonBirdsOfPrey",plural:"Senegal Thick-knees"},{id:2403,label:"Sennar Penduline-Tit",value:"Sennar Penduline-Tit",category:"NonBirdsOfPrey",plural:"Sennar Penduline-Tits"},{id:2404,label:"Sentinel Rock-Thrush",value:"Sentinel Rock-Thrush",category:"NonBirdsOfPrey",plural:"Sentinel Rock-Thrushes"},{id:2405,label:"Sharp-tailed Sandpiper",value:"Sharp-tailed Sandpiper",category:"NonBirdsOfPrey",plural:"Sharp-tailed Sandpipers"},{id:2406,label:"Sharp-tailed Starling",value:"Sharp-tailed Starling",category:"NonBirdsOfPrey",plural:"Sharp-tailed Starlings"},{id:2407,label:"Sharpe's Akalat",value:"Sharpe's Akalat",category:"NonBirdsOfPrey",plural:"Sharpe's Akalats"},{id:2408,label:"Sharpe's Apalis",value:"Sharpe's Apalis",category:"NonBirdsOfPrey",plural:"Sharpe's Apalis"},{id:2409,label:"Sharpe's Drongo",value:"Sharpe's Drongo",category:"NonBirdsOfPrey",plural:"Sharpe's Drongos"},{id:2410,label:"Sharpe's Longclaw",value:"Sharpe's Longclaw",category:"NonBirdsOfPrey",plural:"Sharpe's Longclaws"},{id:2411,label:"Sharpe's Starling",value:"Sharpe's Starling",category:"NonBirdsOfPrey",plural:"Sharpe's Starlings"},{id:2412,label:"Shelley's Crimsonwing",value:"Shelley's Crimsonwing",category:"NonBirdsOfPrey",plural:"Shelley's Crimsonwings"},{id:2413,label:"Shelley's Eagle-Owl",value:"Shelley's Eagle-Owl",category:"BirdsOfPrey",plural:"Shelley's Eagle-Owls"},{id:2414,label:"Shelley's Greenbul",value:"Shelley's Greenbul",category:"NonBirdsOfPrey",plural:"Shelley's Greenbuls"},{id:2415,label:"Shelley's Oliveback",value:"Shelley's Oliveback",category:"NonBirdsOfPrey",plural:"Shelley's Olivebacks"},{id:2416,label:"Shelley's Rufous Sparrow",value:"Shelley's Rufous Sparrow",category:"NonBirdsOfPrey",plural:"Shelley's Rufous Sparrows"},{id:2417,label:"Shelley's Starling",value:"Shelley's Starling",category:"NonBirdsOfPrey",plural:"Shelley's Starlings"},{id:2418,label:"Shelley's Sunbird",value:"Shelley's Sunbird",category:"NonBirdsOfPrey",plural:"Shelley's Sunbirds"},{id:2419,label:"Shining Drongo",value:"Shining Drongo",category:"NonBirdsOfPrey",plural:"Shining Drongos"},{id:2420,label:"Shining Sunbird",value:"Shining Sunbird",category:"NonBirdsOfPrey",plural:"Shining Sunbirds"},{id:2421,label:"Shining-blue Kingfisher",value:"Shining-blue Kingfisher",category:"NonBirdsOfPrey",plural:"Shining-blue Kingfishers"},{id:2422,label:"Shoebill",value:"Shoebill",category:"NonBirdsOfPrey",plural:"Shoebills"},{id:2423,label:"Short-billed Crombec",value:"Short-billed Crombec",category:"NonBirdsOfPrey",plural:"Green Crombecs"},{id:2424,label:"Short-billed Dowitcher",value:"Short-billed Dowitcher",category:"NonBirdsOfPrey",plural:"Short-billed Dowitchers"},{id:2425,label:"Short-eared Owl",value:"Short-eared Owl",category:"BirdsOfPrey",plural:"Short-eared Owls"},{id:2426,label:"Short-tailed Batis",value:"Short-tailed Batis",category:"NonBirdsOfPrey",plural:"Short-tailed Batis"},{id:2427,label:"Short-tailed Lark",value:"Short-tailed Lark",category:"NonBirdsOfPrey",plural:"Short-tailed Larks"},{id:2428,label:"Short-tailed Pipit",value:"Short-tailed Pipit",category:"NonBirdsOfPrey",plural:"Short-tailed Pipits"},{id:2429,label:"Short-toed Rock-Thrush",value:"Short-toed Rock-Thrush",category:"NonBirdsOfPrey",plural:"Short-toed Rock-Thrushes"},{id:2430,label:"Short-toed Snake-Eagle",value:"Short-toed Snake-Eagle",category:"BirdsOfPrey",plural:"Short-toed Snake-Eagles"},{id:2431,label:"Short-toed Treecreeper",value:"Short-toed Treecreeper",category:"NonBirdsOfPrey",plural:"Short-toed Treecreepers"},{id:2432,label:"Short-winged Cisticola",value:"Short-winged Cisticola",category:"NonBirdsOfPrey",plural:"Short-winged Cisticolas"},{id:2433,label:"Shy Albatross",value:"Shy Albatross",category:"NonBirdsOfPrey",plural:"Shy Albatrosses"},{id:2434,label:"Siberian Rubythroat",value:"Siberian Rubythroat",category:"NonBirdsOfPrey",plural:"Siberian Rubythroats"},{id:2435,label:"Siberian Stonechat",value:"Siberian Stonechat",category:"NonBirdsOfPrey",plural:"Siberian Stonechats"},{id:2436,label:"Sickle-winged Chat",value:"Sickle-winged Chat",category:"NonBirdsOfPrey",plural:"Sickle-winged Chats"},{id:2437,label:"Sierra Leone Prinia",value:"Sierra Leone Prinia",category:"NonBirdsOfPrey",plural:"Sierra Leone Prinias"},{id:2438,label:"Siffling Cisticola",value:"Siffling Cisticola",category:"NonBirdsOfPrey",plural:"Siffling Cisticolas"},{id:2439,label:"Silverbird",value:"Silverbird",category:"NonBirdsOfPrey",plural:"Silverbirds"},{id:2440,label:"Silvery-cheeked Hornbill",value:"Silvery-cheeked Hornbill",category:"NonBirdsOfPrey",plural:"Silvery-cheeked Hornbills"},{id:2441,label:"Simple Greenbul",value:"Simple Greenbul",category:"NonBirdsOfPrey",plural:"Simple Greenbuls"},{id:2442,label:"Sinai Rosefinch",value:"Sinai Rosefinch",category:"NonBirdsOfPrey",plural:"Sinai Rosefinches"},{id:2443,label:"Singing Bushlark",value:"Singing Bushlark",category:"NonBirdsOfPrey",plural:"Singing Bushlarks"},{id:2444,label:"Singing Cisticola",value:"Singing Cisticola",category:"NonBirdsOfPrey",plural:"Singing Cisticolas"},{id:2445,label:"Sj\u00f6stedt's Greenbul",value:"Sj\u00f6stedt's Greenbul",category:"NonBirdsOfPrey",plural:"Sj\u00f6stedt's Greenbuls"},{id:2446,label:"Sj\u00f6stedt's Owlet",value:"Sj\u00f6stedt's Owlet",category:"BirdsOfPrey",plural:"Sj\u00f6stedt's Owlets"},{id:2447,label:"Sladen's Barbet",value:"Sladen's Barbet",category:"NonBirdsOfPrey",plural:"Sladen's Barbets"},{id:2448,label:"Slate-colored Boubou",value:"Slate-colored Boubou",category:"NonBirdsOfPrey",plural:"Slate-colored Boubous"},{id:2449,label:"Slender-billed Curlew",value:"Slender-billed Curlew",category:"NonBirdsOfPrey",plural:"Slender-billed Curlews"},{id:2450,label:"Slender-billed Greenbul",value:"Slender-billed Greenbul",category:"NonBirdsOfPrey",plural:"Slender-billed Greenbuls"},{id:2451,label:"Slender-billed Gull",value:"Slender-billed Gull",category:"NonBirdsOfPrey",plural:"Slender-billed Gulls"},{id:2452,label:"Slender-billed Prion",value:"Slender-billed Prion",category:"NonBirdsOfPrey",plural:"Slender-billed Prions"},{id:2453,label:"Slender-billed Starling",value:"Slender-billed Starling",category:"NonBirdsOfPrey",plural:"Slender-billed Starlings"},{id:2454,label:"Slender-billed Weaver",value:"Slender-billed Weaver",category:"NonBirdsOfPrey",plural:"Slender-billed Weavers"},{id:2455,label:"Slender-tailed Cisticola",value:"Slender-tailed Cisticola",category:"NonBirdsOfPrey",plural:"Slender-tailed Cisticolas"},{id:2456,label:"Slender-tailed Nightjar",value:"Slender-tailed Nightjar",category:"NonBirdsOfPrey",plural:"Slender-tailed Nightjars"},{id:2457,label:"Small Buttonquail",value:"Small Buttonquail",category:"NonBirdsOfPrey",plural:"Small Buttonquails"},{id:2458,label:"Smew",value:"Smew",category:"NonBirdsOfPrey",plural:"Smews"},{id:2459,label:"Smith's Thrush",value:"Smith's Thrush",category:"NonBirdsOfPrey",plural:"Smith's Thrushes"},{id:2460,label:"Snow Bunting",value:"Snow Bunting",category:"NonBirdsOfPrey",plural:"Snow Buntings"},{id:2461,label:"Snow Goose",value:"Snow Goose",category:"NonBirdsOfPrey",plural:"Snow Geese"},{id:2462,label:"Snow Petrel",value:"Snow Petrel",category:"NonBirdsOfPrey",plural:"Snow Petrels"},{id:2463,label:"Snowy Egret",value:"Snowy Egret",category:"NonBirdsOfPrey",plural:"Snowy Egrets"},{id:2464,label:"Snowy Sheathbill",value:"Snowy Sheathbill",category:"NonBirdsOfPrey",plural:"Snowy Sheathbills"},{id:2465,label:"Snowy-crowned Robin-Chat",value:"Snowy-crowned Robin-Chat",category:"NonBirdsOfPrey",plural:"Snowy-crowned Robin-Chats"},{id:2466,label:"Sociable Lapwing",value:"Sociable Lapwing",category:"NonBirdsOfPrey",plural:"Sociable Lapwings"},{id:2467,label:"Sociable Weaver",value:"Sociable Weaver",category:"NonBirdsOfPrey",plural:"Sociable Weavers"},{id:2468,label:"Socotra Cormorant",value:"Socotra Cormorant",category:"NonBirdsOfPrey",plural:"Socotra Cormorants"},{id:2469,label:"Socotra Scops-Owl",value:"Socotra Scops-Owl",category:"BirdsOfPrey",plural:"Socotra Scops-Owls"},{id:2470,label:"Socotra White-eye",value:"Socotra White-eye",category:"NonBirdsOfPrey",plural:"Socotra White-eyes"},{id:2471,label:"Soft-plumaged Petrel",value:"Soft-plumaged Petrel",category:"NonBirdsOfPrey",plural:"Soft-plumaged Petrels"},{id:2472,label:"Sokoke Pipit",value:"Sokoke Pipit",category:"NonBirdsOfPrey",plural:"Sokoke Pipits"},{id:2473,label:"Sokoke Scops-Owl",value:"Sokoke Scops-Owl",category:"BirdsOfPrey",plural:"Sokoke Scops-Owls"},{id:2474,label:"Solitary Sandpiper",value:"Solitary Sandpiper",category:"NonBirdsOfPrey",plural:"Solitary Sandpipers"},{id:2475,label:"Somali Bee-eater",value:"Somali Bee-eater",category:"NonBirdsOfPrey",plural:"Somali Bee-eaters"},{id:2476,label:"Somali Bunting",value:"Somali Bunting",category:"NonBirdsOfPrey",plural:"Somali Buntings"},{id:2477,label:"Somali Courser",value:"Somali Courser",category:"NonBirdsOfPrey",plural:"Somali Coursers"},{id:2478,label:"Somali Crombec",value:"Somali Crombec",category:"NonBirdsOfPrey",plural:"Somali Crombecs"},{id:2479,label:"Somali Crow",value:"Somali Crow",category:"NonBirdsOfPrey",plural:"Somali Crows"},{id:2480,label:"Somali Fiscal",value:"Somali Fiscal",category:"NonBirdsOfPrey",plural:"Somali Fiscals"},{id:2481,label:"Somali Grosbeak",value:"Somali Grosbeak",category:"NonBirdsOfPrey",plural:"Somali Grosbeaks"},{id:2482,label:"Somali Long-billed Lark",value:"Somali Long-billed Lark",category:"NonBirdsOfPrey",plural:"Somali Long-billed Larks"},{id:2483,label:"Somali Ostrich",value:"Somali Ostrich",category:"NonBirdsOfPrey",plural:"Somali Ostriches"},{id:2484,label:"Somali Pigeon",value:"Somali Pigeon",category:"NonBirdsOfPrey",plural:"Somali Pigeons"},{id:2485,label:"Somali Short-toed Lark",value:"Somali Short-toed Lark",category:"NonBirdsOfPrey",plural:"Somali Short-toed Larks"},{id:2486,label:"Somali Sparrow",value:"Somali Sparrow",category:"NonBirdsOfPrey",plural:"Somali Sparrows"},{id:2487,label:"Somali Starling",value:"Somali Starling",category:"NonBirdsOfPrey",plural:"Somali Starlings"},{id:2488,label:"Somali Thrush",value:"Somali Thrush",category:"NonBirdsOfPrey",plural:"Somali Thrushes"},{id:2489,label:"Somali Tit",value:"Somali Tit",category:"NonBirdsOfPrey",plural:"Somali Tits"},{id:2490,label:"Somali Wheatear",value:"Somali Wheatear",category:"NonBirdsOfPrey",plural:"Somali Wheatears"},{id:2491,label:"Sombre Nightjar",value:"Sombre Nightjar",category:"NonBirdsOfPrey",plural:"Sombre Nightjars"},{id:2492,label:"Sombre Rock Chat",value:"Sombre Rock Chat",category:"NonBirdsOfPrey",plural:"Sombre Rock Chats"},{id:2493,label:"Song Thrush",value:"Song Thrush",category:"NonBirdsOfPrey",plural:"Song Thrushes"},{id:2494,label:"Sooty Albatross",value:"Sooty Albatross",category:"NonBirdsOfPrey",plural:"Sooty Albatrosses"},{id:2495,label:"Sooty Chat",value:"Sooty Chat",category:"NonBirdsOfPrey",plural:"Sooty Chats"},{id:2496,label:"Sooty Flycatcher",value:"Sooty Flycatcher",category:"NonBirdsOfPrey",plural:"Sooty Flycatchers"},{id:2497,label:"Sooty Gull",value:"Sooty Gull",category:"NonBirdsOfPrey",plural:"Sooty Gulls"},{id:2498,label:"Sooty Shearwater",value:"Sooty Shearwater",category:"NonBirdsOfPrey",plural:"Sooty Shearwaters"},{id:2499,label:"Sooty Tern",value:"Sooty Tern",category:"NonBirdsOfPrey",plural:"Sooty Terns"},{id:2500,label:"Sora",value:"Sora",category:"NonBirdsOfPrey",plural:"Soras"},{id:2501,label:"South African Swallow",value:"South African Swallow",category:"NonBirdsOfPrey",plural:"South African Swallows"},{id:2502,label:"South Georgian Diving-Petrel",value:"South Georgian Diving-Petrel",category:"NonBirdsOfPrey",plural:"South Georgian Diving-Petrels"},{id:2503,label:"South Pare White-eye",value:"South Pare White-eye",category:"NonBirdsOfPrey",plural:"South Pare White-eyes"},{id:2504,label:"South Polar Skua",value:"South Polar Skua",category:"NonBirdsOfPrey",plural:"South Polar Skuas"},{id:2505,label:"Southern Anteater-Chat",value:"Southern Anteater-Chat",category:"NonBirdsOfPrey",plural:"Southern Anteater-Chats"},{id:2506,label:"Southern Black Korhaan",value:"Southern Black Korhaan",category:"NonBirdsOfPrey",plural:"Southern Black Korhaans"},{id:2507,label:"Southern Black-Flycatcher",value:"Southern Black-Flycatcher",category:"NonBirdsOfPrey",plural:"Southern Black-Flycatchers"},{id:2508,label:"Southern Black-Tit",value:"Southern Black-Tit",category:"NonBirdsOfPrey",plural:"Southern Black-Tits"},{id:2509,label:"Southern Boubou",value:"Southern Boubou",category:"NonBirdsOfPrey",plural:"Southern Boubous"},{id:2510,label:"Southern Brown-throated Weaver",value:"Southern Brown-throated Weaver",category:"NonBirdsOfPrey",plural:"Southern Brown-throated Weavers"},{id:2511,label:"Southern Citril",value:"Southern Citril",category:"NonBirdsOfPrey",plural:"Southern Citrils"},{id:2512,label:"Southern Cordonbleu",value:"Southern Cordonbleu",category:"NonBirdsOfPrey",plural:"Southern Cordonbleus"},{id:2513,label:"Southern Fiscal",value:"Southern Fiscal",category:"NonBirdsOfPrey",plural:"Southern Fiscals"},{id:2514,label:"Southern Fulmar",value:"Southern Fulmar",category:"NonBirdsOfPrey",plural:"Southern Fulmars"},{id:2515,label:"Southern Giant-Petrel",value:"Southern Giant-Petrel",category:"NonBirdsOfPrey",plural:"Southern Giant-Petrels"},{id:2516,label:"Southern Grosbeak-Canary",value:"Southern Grosbeak-Canary",category:"NonBirdsOfPrey",plural:"Southern Grosbeak-Canaries"},{id:2517,label:"Southern Hyliota",value:"Southern Hyliota",category:"NonBirdsOfPrey",plural:"Southern Hyliotas"},{id:2518,label:"Southern Penduline-Tit",value:"Southern Penduline-Tit",category:"NonBirdsOfPrey",plural:"Southern Penduline-Tits"},{id:2519,label:"Southern Pied-Babbler",value:"Southern Pied-Babbler",category:"NonBirdsOfPrey",plural:"Southern Pied-Babblers"},{id:2520,label:"Southern Rockhopper Penguin",value:"Southern Rockhopper Penguin",category:"NonBirdsOfPrey",plural:"Southern Rockhopper Penguins"},{id:2521,label:"Southern Royal Albatross",value:"Southern Royal Albatross",category:"NonBirdsOfPrey",plural:"Southern Royal Albatrosses"},{id:2522,label:"Southern Tchagra",value:"Southern Tchagra",category:"NonBirdsOfPrey",plural:"Southern Tchagras"},{id:2523,label:"Southern White-faced Owl",value:"Southern White-faced Owl",category:"BirdsOfPrey",plural:"Southern White-faced Owls"},{id:2524,label:"Southern White-faced Scops-Owl",value:"Southern White-faced Scops-Owl",category:"BirdsOfPrey",plural:"Southern White-faced Scops-Owls"},{id:2525,label:"Southern Yellow White-eye",value:"Southern Yellow White-eye",category:"NonBirdsOfPrey",plural:"Southern Yellow White-eyes"},{id:2526,label:"Souza's Shrike",value:"Souza's Shrike",category:"NonBirdsOfPrey",plural:"Souza's Shrikes"},{id:2527,label:"Spanish Eagle",value:"Spanish Eagle",category:"BirdsOfPrey",plural:"Spanish Eagles"},{id:2528,label:"Spanish Sparrow",value:"Spanish Sparrow",category:"NonBirdsOfPrey",plural:"Spanish Sparrows"},{id:2529,label:"Speckle-breasted Woodpecker",value:"Speckle-breasted Woodpecker",category:"NonBirdsOfPrey",plural:"Speckle-breasted Woodpeckers"},{id:2530,label:"Speckle-fronted Weaver",value:"Speckle-fronted Weaver",category:"NonBirdsOfPrey",plural:"Speckle-fronted Weavers"},{id:2531,label:"Speckle-throated Woodpecker",value:"Speckle-throated Woodpecker",category:"NonBirdsOfPrey",plural:"Speckle-throated Woodpeckers"},{id:2532,label:"Speckled Tinkerbird",value:"Speckled Tinkerbird",category:"NonBirdsOfPrey",plural:"Speckled Tinkerbirds"},{id:2533,label:"Spectacled Petrel",value:"Spectacled Petrel",category:"NonBirdsOfPrey",plural:"Spectacled Petrels"},{id:2534,label:"Spectacled Warbler",value:"Spectacled Warbler",category:"NonBirdsOfPrey",plural:"Spectacled Warblers"},{id:2535,label:"Speke's Weaver",value:"Speke's Weaver",category:"NonBirdsOfPrey",plural:"Speke's Weavers"},{id:2536,label:"Spike-heeled Lark",value:"Spike-heeled Lark",category:"NonBirdsOfPrey",plural:"Spike-heeled Larks"},{id:2537,label:"Splendid Starling",value:"Splendid Starling",category:"NonBirdsOfPrey",plural:"Splendid Starlings"},{id:2538,label:"Splendid Sunbird",value:"Splendid Sunbird",category:"NonBirdsOfPrey",plural:"Splendid Sunbirds"},{id:2539,label:"Spot-breasted Ibis",value:"Spot-breasted Ibis",category:"NonBirdsOfPrey",plural:"Spot-breasted Ibises"},{id:2540,label:"Spot-breasted Lapwing",value:"Spot-breasted Lapwing",category:"NonBirdsOfPrey",plural:"Spot-breasted Lapwings"},{id:2541,label:"Spot-flanked Barbet",value:"Spot-flanked Barbet",category:"NonBirdsOfPrey",plural:"Spot-flanked Barbets"},{id:2542,label:"Spot-throat",value:"Spot-throat",category:"NonBirdsOfPrey",plural:"Spot-throats"},{id:2543,label:"Spotless Starling",value:"Spotless Starling",category:"NonBirdsOfPrey",plural:"Spotless Starlings"},{id:2544,label:"Spotted Crake",value:"Spotted Crake",category:"NonBirdsOfPrey",plural:"Spotted Crakes"},{id:2545,label:"Spotted Greenbul",value:"Spotted Greenbul",category:"NonBirdsOfPrey",plural:"Spotted Greenbuls"},{id:2546,label:"Spotted Ground-Thrush",value:"Spotted Ground-Thrush",category:"NonBirdsOfPrey",plural:"Spotted Ground-Thrushes"},{id:2547,label:"Spotted Honeyguide",value:"Spotted Honeyguide",category:"NonBirdsOfPrey",plural:"Spotted Honeyguides"},{id:2548,label:"Spotted Morning-Thrush",value:"Spotted Morning-Thrush",category:"NonBirdsOfPrey",plural:"Spotted Morning-Thrushes"},{id:2549,label:"Spotted Redshank",value:"Spotted Redshank",category:"NonBirdsOfPrey",plural:"Spotted Redshanks"},{id:2550,label:"Spotted Sandgrouse",value:"Spotted Sandgrouse",category:"NonBirdsOfPrey",plural:"Spotted Sandgrouses"},{id:2551,label:"Spotted Sandpiper",value:"Spotted Sandpiper",category:"NonBirdsOfPrey",plural:"Spotted Sandpipers"},{id:2552,label:"Spur-winged Lapwing",value:"Spur-winged Lapwing",category:"NonBirdsOfPrey",plural:"Spur-winged Lapwings"},{id:2553,label:"Square-tailed Drongo",value:"Square-tailed Drongo",category:"NonBirdsOfPrey",plural:"Square-tailed Drongos"},{id:2554,label:"Square-tailed Sawwing",value:"Square-tailed Sawwing",category:"NonBirdsOfPrey",plural:"Square-tailed Sawwings"},{id:2555,label:"Standard-winged Nightjar",value:"Standard-winged Nightjar",category:"NonBirdsOfPrey",plural:"Standard-winged Nightjars"},{id:2556,label:"Star-spotted Nightjar",value:"Star-spotted Nightjar",category:"NonBirdsOfPrey",plural:"Star-spotted Nightjars"},{id:2557,label:"Stark's Lark",value:"Stark's Lark",category:"NonBirdsOfPrey",plural:"Stark's Larks"},{id:2558,label:"Steel-blue Whydah",value:"Steel-blue Whydah",category:"NonBirdsOfPrey",plural:"Steel-blue Whydahs"},{id:2559,label:"Steppe Eagle",value:"Steppe Eagle",category:"BirdsOfPrey",plural:"Steppe Eagles"},{id:2560,label:"Stierling's Woodpecker",value:"Stierling's Woodpecker",category:"NonBirdsOfPrey",plural:"Stierling's Woodpeckers"},{id:2561,label:"Stilt Sandpiper",value:"Stilt Sandpiper",category:"NonBirdsOfPrey",plural:"Stilt Sandpipers"},{id:2562,label:"Stock Dove",value:"Stock Dove",category:"NonBirdsOfPrey",plural:"Stock Doves"},{id:2563,label:"Stone Partridge",value:"Stone Partridge",category:"NonBirdsOfPrey",plural:"Stone Partridges"},{id:2564,label:"Stout Cisticola",value:"Stout Cisticola",category:"NonBirdsOfPrey",plural:"Stout Cisticolas"},{id:2565,label:"Strange Weaver",value:"Strange Weaver",category:"NonBirdsOfPrey",plural:"Strange Weavers"},{id:2566,label:"Straw-tailed Whydah",value:"Straw-tailed Whydah",category:"NonBirdsOfPrey",plural:"Straw-tailed Whydahs"},{id:2567,label:"Streak-throated Swallow",value:"Streak-throated Swallow",category:"NonBirdsOfPrey",plural:"Streak-throated Swallows"},{id:2568,label:"Streaked Shearwater",value:"Streaked Shearwater",category:"NonBirdsOfPrey",plural:"Streaked Shearwaters"},{id:2569,label:"Streaked Weaver",value:"Streaked Weaver",category:"NonBirdsOfPrey",plural:"Streaked Weavers"},{id:2570,label:"Streaky Seedeater",value:"Streaky Seedeater",category:"NonBirdsOfPrey",plural:"Streaky Seedeaters"},{id:2571,label:"Streaky-breasted Flufftail",value:"Streaky-breasted Flufftail",category:"NonBirdsOfPrey",plural:"Streaky-breasted Flufftails"},{id:2572,label:"Streaky-headed Canary",value:"Streaky-headed Canary",category:"NonBirdsOfPrey",plural:"Streaky-headed Canaries"},{id:2573,label:"Stresemann's Bush-Crow",value:"Stresemann's Bush-Crow",category:"NonBirdsOfPrey",plural:"Stresemann's Bush-Crows"},{id:2574,label:"Striated Heron",value:"Striated Heron",category:"NonBirdsOfPrey",plural:"Striated Herons"},{id:2575,label:"Striolated Bunting",value:"Striolated Bunting",category:"NonBirdsOfPrey",plural:"Striolated Buntings"},{id:2576,label:"Stripe-breasted Tit",value:"Stripe-breasted Tit",category:"NonBirdsOfPrey",plural:"Stripe-breasted Tits"},{id:2577,label:"Stripe-cheeked Greenbul",value:"Stripe-cheeked Greenbul",category:"NonBirdsOfPrey",plural:"Stripe-cheeked Greenbuls"},{id:2578,label:"Striped Flufftail",value:"Striped Flufftail",category:"NonBirdsOfPrey",plural:"Striped Flufftails"},{id:2579,label:"Stuhlmann's Starling",value:"Stuhlmann's Starling",category:"NonBirdsOfPrey",plural:"Stuhlmann's Starlings"},{id:2580,label:"Stuhlmann's Sunbird",value:"Stuhlmann's Sunbird",category:"NonBirdsOfPrey",plural:"Stuhlmann's Sunbirds"},{id:2581,label:"Subantarctic Shearwater",value:"Subantarctic Shearwater",category:"NonBirdsOfPrey",plural:"Subantarctic Shearwaters"},{id:2582,label:"Subantarctic Skua",value:"Subantarctic Skua",category:"NonBirdsOfPrey",plural:"Subantarctic Skuas"},{id:2583,label:"Sudan Golden Sparrow",value:"Sudan Golden Sparrow",category:"NonBirdsOfPrey",plural:"Sudan Golden Sparrows"},{id:2584,label:"Sulphur-breasted Bushshrike",value:"Sulphur-breasted Bushshrike",category:"NonBirdsOfPrey",plural:"Sulphur-breasted Bushshrikes"},{id:2585,label:"Sun Lark",value:"Sun Lark",category:"NonBirdsOfPrey",plural:"Sun Larks"},{id:2586,label:"Superb Starling",value:"Superb Starling",category:"NonBirdsOfPrey",plural:"Superb Starlings"},{id:2587,label:"Superb Sunbird",value:"Superb Sunbird",category:"NonBirdsOfPrey",plural:"Superb Sunbirds"},{id:2588,label:"Swahili Sparrow",value:"Swahili Sparrow",category:"NonBirdsOfPrey",plural:"Swahili Sparrows"},{id:2589,label:"Swainson's Francolin",value:"Swainson's Francolin",category:"NonBirdsOfPrey",plural:"Swainson's Francolins"},{id:2590,label:"Swainson's Sparrow",value:"Swainson's Sparrow",category:"NonBirdsOfPrey",plural:"Swainson's Sparrows"},{id:2591,label:"Swamp Boubou",value:"Swamp Boubou",category:"NonBirdsOfPrey",plural:"Swamp Boubous"},{id:2592,label:"Swamp Flycatcher",value:"Swamp Flycatcher",category:"NonBirdsOfPrey",plural:"Swamp Flycatchers"},{id:2593,label:"Swamp Greenbul",value:"Swamp Greenbul",category:"NonBirdsOfPrey",plural:"Swamp Greenbuls"},{id:2594,label:"Swamp Nightjar",value:"Swamp Nightjar",category:"NonBirdsOfPrey",plural:"Swamp Nightjars"},{id:2595,label:"Swierstra's Francolin",value:"Swierstra's Francolin",category:"NonBirdsOfPrey",plural:"Swierstra's Francolins"},{id:2596,label:"Swift Tern",value:"Swift Tern",category:"NonBirdsOfPrey",plural:"Swift Terns"},{id:2597,label:"Swinhoe's Storm-Petrel",value:"Swinhoe's Storm-Petrel",category:"NonBirdsOfPrey",plural:"Swinhoe's Storm-Petrels"},{id:2598,label:"Swynnerton's Robin",value:"Swynnerton's Robin",category:"NonBirdsOfPrey",plural:"Swynnerton's Robins"},{id:2599,label:"Sykes's Warbler",value:"Sykes's Warbler",category:"NonBirdsOfPrey",plural:"Sykes's Warblers"},{id:2600,label:"Syrian Serin",value:"Syrian Serin",category:"NonBirdsOfPrey",plural:"Syrian Serins"},{id:2601,label:"Syrian Woodpecker",value:"Syrian Woodpecker",category:"NonBirdsOfPrey",plural:"Syrian Woodpeckers"},{id:2602,label:"Tabora Cisticola",value:"Tabora Cisticola",category:"NonBirdsOfPrey",plural:"Tabora Cisticolas"},{id:2603,label:"Tacazze Sunbird",value:"Tacazze Sunbird",category:"NonBirdsOfPrey",plural:"Tacazze Sunbirds"},{id:2604,label:"Tahiti Petrel",value:"Tahiti Petrel",category:"NonBirdsOfPrey",plural:"Tahiti Petrels"},{id:2605,label:"Taiga Bean-Goose",value:"Taiga Bean-Goose",category:"NonBirdsOfPrey",plural:"Taiga Bean-Geese"},{id:2606,label:"Taita Apalis",value:"Taita Apalis",category:"NonBirdsOfPrey",plural:"Taita Apalis"},{id:2607,label:"Taita Falcon",value:"Taita Falcon",category:"BirdsOfPrey",plural:"Taita Falcons"},{id:2608,label:"Taita Fiscal",value:"Taita Fiscal",category:"NonBirdsOfPrey",plural:"Taita Fiscals"},{id:2609,label:"Taita Thrush",value:"Taita Thrush",category:"NonBirdsOfPrey",plural:"Taita Thrushes"},{id:2610,label:"Taita White-eye",value:"Taita White-eye",category:"NonBirdsOfPrey",plural:"Taita White-eyes"},{id:2611,label:"Tana River Cisticola",value:"Tana River Cisticola",category:"NonBirdsOfPrey",plural:"Tana River Cisticolas"},{id:2612,label:"Tanganyika Masked-Weaver",value:"Tanganyika Masked-Weaver",category:"NonBirdsOfPrey",plural:"Tanganyika Masked-Weavers"},{id:2613,label:"Tanzania Seedeater",value:"Tanzania Seedeater",category:"NonBirdsOfPrey",plural:"Tanzania Seedeaters"},{id:2614,label:"Tanzanian Red-billed Hornbill",value:"Tanzanian Red-billed Hornbill",category:"NonBirdsOfPrey",plural:"Tanzanian Red-billed Hornbills"},{id:2615,label:"Taveta Golden-Weaver",value:"Taveta Golden-Weaver",category:"NonBirdsOfPrey",plural:"Taveta Golden-Weavers"},{id:2616,label:"Tawny Owl",value:"Tawny Owl",category:"BirdsOfPrey",plural:"Tawny Owls"},{id:2617,label:"Tawny Pipit",value:"Tawny Pipit",category:"NonBirdsOfPrey",plural:"Tawny Pipits"},{id:2618,label:"Temminck's Lark",value:"Temminck's Lark",category:"NonBirdsOfPrey",plural:"Temminck's Larks"},{id:2619,label:"Temminck's Stint",value:"Temminck's Stint",category:"NonBirdsOfPrey",plural:"Temminck's Stints"},{id:2620,label:"Terek Sandpiper",value:"Terek Sandpiper",category:"NonBirdsOfPrey",plural:"Terek Sandpipers"},{id:2621,label:"Tessmann's Flycatcher",value:"Tessmann's Flycatcher",category:"NonBirdsOfPrey",plural:"Tessmann's Flycatchers"},{id:2622,label:"Thekla's Lark",value:"Thekla's Lark",category:"NonBirdsOfPrey",plural:"Thekla's Larks"},{id:2623,label:"Thick-billed Honeyguide",value:"Thick-billed Honeyguide",category:"NonBirdsOfPrey",plural:"Thick-billed Honeyguides"},{id:2624,label:"Thick-billed Lark",value:"Thick-billed Lark",category:"NonBirdsOfPrey",plural:"Thick-billed Larks"},{id:2625,label:"Thick-billed Raven",value:"Thick-billed Raven",category:"NonBirdsOfPrey",plural:"Thick-billed Ravens"},{id:2626,label:"Thick-billed Seedeater",value:"Thick-billed Seedeater",category:"NonBirdsOfPrey",plural:"Thick-billed Seedeaters"},{id:2627,label:"Thick-billed Warbler",value:"Thick-billed Warbler",category:"NonBirdsOfPrey",plural:"Thick-billed Warblers"},{id:2628,label:"Three-streaked Tchagra",value:"Three-streaked Tchagra",category:"NonBirdsOfPrey",plural:"Three-streaked Tchagras"},{id:2629,label:"Thrush Babbler",value:"Thrush Babbler",category:"NonBirdsOfPrey",plural:"Thrush Babblers"},{id:2630,label:"Thrush Nightingale",value:"Thrush Nightingale",category:"NonBirdsOfPrey",plural:"Thrush Nightingales"},{id:2631,label:"Tiny Cisticola",value:"Tiny Cisticola",category:"NonBirdsOfPrey",plural:"Tiny Cisticolas"},{id:2632,label:"Tiny Greenbul",value:"Tiny Greenbul",category:"NonBirdsOfPrey",plural:"Tiny Greenbuls"},{id:2633,label:"Tiny Sunbird",value:"Tiny Sunbird",category:"NonBirdsOfPrey",plural:"Tiny Sunbirds"},{id:2634,label:"Tit-hylia",value:"Tit-hylia",category:"NonBirdsOfPrey",plural:"Tit-hylias"},{id:2635,label:"Togo Paradise-Whydah",value:"Togo Paradise-Whydah",category:"NonBirdsOfPrey",plural:"Togo Paradise-Whydahs"},{id:2636,label:"Toro Olive-Greenbul",value:"Toro Olive-Greenbul",category:"NonBirdsOfPrey",plural:"Toro Olive-Greenbuls"},{id:2637,label:"Tractrac Chat",value:"Tractrac Chat",category:"NonBirdsOfPrey",plural:"Tractrac Chats"},{id:2638,label:"Trilling Cisticola",value:"Trilling Cisticola",category:"NonBirdsOfPrey",plural:"Trilling Cisticolas"},{id:2639,label:"Trindade Petrel",value:"Trindade Petrel",category:"NonBirdsOfPrey",plural:"Trindade Petrels"},{id:2640,label:"Tristan Albatross",value:"Tristan Albatross",category:"NonBirdsOfPrey",plural:"Tristan Albatrosses"},{id:2641,label:"Tristan Thrush",value:"Tristan Thrush",category:"NonBirdsOfPrey",plural:"Tristan Thrushes"},{id:2642,label:"Tristram's Starling",value:"Tristram's Starling",category:"NonBirdsOfPrey",plural:"Tristram's Starlings"},{id:2643,label:"Tristram's Warbler",value:"Tristram's Warbler",category:"NonBirdsOfPrey",plural:"Tristram's Warblers"},{id:2644,label:"Tropical Shearwater",value:"Tropical Shearwater",category:"NonBirdsOfPrey",plural:"Tropical Shearwaters"},{id:2645,label:"Trumpeter Finch",value:"Trumpeter Finch",category:"NonBirdsOfPrey",plural:"Trumpeter Finches"},{id:2646,label:"Tsavo Sunbird",value:"Tsavo Sunbird",category:"NonBirdsOfPrey",plural:"Tsavo Sunbirds"},{id:2647,label:"Tufted Duck",value:"Tufted Duck",category:"NonBirdsOfPrey",plural:"Tufted Ducks"},{id:2648,label:"Tullberg's Woodpecker",value:"Tullberg's Woodpecker",category:"NonBirdsOfPrey",plural:"Tullberg's Woodpeckers"},{id:2649,label:"Tundra Bean-Goose",value:"Tundra Bean-Goose",category:"NonBirdsOfPrey",plural:"Tundra Bean-Geese"},{id:2650,label:"Tundra Swan",value:"Tundra Swan",category:"NonBirdsOfPrey",plural:"Tundra Swans"},{id:2651,label:"Turati's Boubou",value:"Turati's Boubou",category:"NonBirdsOfPrey",plural:"Turati's Boubous"},{id:2652,label:"Turkestan Short-toed Lark",value:"Turkestan Short-toed Lark",category:"NonBirdsOfPrey",plural:"Turkestan Short-toed Larks"},{id:2653,label:"Turner's Eremomela",value:"Turner's Eremomela",category:"NonBirdsOfPrey",plural:"Turner's Eremomelas"},{id:2654,label:"Twinspot Indigobird",value:"Twinspot Indigobird",category:"NonBirdsOfPrey",plural:"Twinspot Indigobirds"},{id:2655,label:"Udzungwa Partridge",value:"Udzungwa Partridge",category:"NonBirdsOfPrey",plural:"Udzungwa Partridges"},{id:2656,label:"Uganda Woodland-Warbler",value:"Uganda Woodland-Warbler",category:"NonBirdsOfPrey",plural:"Uganda Woodland-Warblers"},{id:2657,label:"Uluguru Bushshrike",value:"Uluguru Bushshrike",category:"NonBirdsOfPrey",plural:"Uluguru Bushshrikes"},{id:2658,label:"Uluguru Mountain Greenbul",value:"Uluguru Mountain Greenbul",category:"NonBirdsOfPrey",plural:"Uluguru Mountain Greenbuls"},{id:2659,label:"Uluguru Violet-backed Sunbird",value:"Uluguru Violet-backed Sunbird",category:"NonBirdsOfPrey",plural:"Uluguru Violet-backed Sunbirds"},{id:2660,label:"Upcher's Warbler",value:"Upcher's Warbler",category:"NonBirdsOfPrey",plural:"Upcher's Warblers"},{id:2661,label:"Upland Sandpiper",value:"Upland Sandpiper",category:"NonBirdsOfPrey",plural:"Upland Sandpipers"},{id:2662,label:"Ursula's Sunbird",value:"Ursula's Sunbird",category:"NonBirdsOfPrey",plural:"Ursula's Sunbirds"},{id:2663,label:"Usambara Akalat",value:"Usambara Akalat",category:"NonBirdsOfPrey",plural:"Usambara Akalats"},{id:2664,label:"Usambara Double-collared Sunbird",value:"Usambara Double-collared Sunbird",category:"NonBirdsOfPrey",plural:"Usambara Double-collared Sunbirds"},{id:2665,label:"Usambara Eagle-Owl",value:"Usambara Eagle-Owl",category:"BirdsOfPrey",plural:"Usambara Eagle-Owls"},{id:2666,label:"Usambara Greenbul",value:"Usambara Greenbul",category:"NonBirdsOfPrey",plural:"Usambara Greenbuls"},{id:2667,label:"Usambara Hyliota",value:"Usambara Hyliota",category:"NonBirdsOfPrey",plural:"Usambara Hyliotas"},{id:2668,label:"Usambara Thrush",value:"Usambara Thrush",category:"NonBirdsOfPrey",plural:"Usambara Thrushes"},{id:2669,label:"Usambara Weaver",value:"Usambara Weaver",category:"NonBirdsOfPrey",plural:"Usambara Weavers"},{id:2670,label:"Ussher's Flycatcher",value:"Ussher's Flycatcher",category:"NonBirdsOfPrey",plural:"Ussher's Flycatchers"},{id:2671,label:"Variable Indigobird",value:"Variable Indigobird",category:"NonBirdsOfPrey",plural:"Variable Indigobirds"},{id:2672,label:"Variable Sunbird",value:"Variable Sunbird",category:"NonBirdsOfPrey",plural:"Variable Sunbirds"},{id:2673,label:"Velvet Scoter",value:"Velvet Scoter",category:"NonBirdsOfPrey",plural:"Velvet Scoters"},{id:2674,label:"Velvet-mantled Drongo",value:"Velvet-mantled Drongo",category:"NonBirdsOfPrey",plural:"Velvet-mantled Drongos"},{id:2675,label:"Vermiculated Fishing-Owl",value:"Vermiculated Fishing-Owl",category:"BirdsOfPrey",plural:"Vermiculated Fishing-Owls"},{id:2676,label:"Verreaux's (Black) Eagle",value:"Verreaux's (Black) Eagle",category:"BirdsOfPrey",plural:"Verreaux's (Black) Eagles"},{id:2677,label:"Verreaux's Batis",value:"Verreaux's Batis",category:"NonBirdsOfPrey",plural:"Verreaux's Batis"},{id:2678,label:"Victorin's Warbler",value:"Victorin's Warbler",category:"NonBirdsOfPrey",plural:"Victorin's Warblers"},{id:2679,label:"Vieillot's Barbet",value:"Vieillot's Barbet",category:"NonBirdsOfPrey",plural:"Vieillot's Barbets"},{id:2680,label:"Vieillot's Weaver",value:"Vieillot's Weaver",category:"NonBirdsOfPrey",plural:"Vieillot's Weavers"},{id:2681,label:"Village Weaver",value:"Village Weaver",category:"NonBirdsOfPrey",plural:"Village Weavers"},{id:2682,label:"Vinaceous Dove",value:"Vinaceous Dove",category:"NonBirdsOfPrey",plural:"Vinaceous Doves"},{id:2683,label:"Vincent's Bunting",value:"Vincent's Bunting",category:"NonBirdsOfPrey",plural:"Vincent's Buntings"},{id:2684,label:"Violet Turaco",value:"Violet Turaco",category:"NonBirdsOfPrey",plural:"Violet Turacos"},{id:2685,label:"Violet Woodhoopoe",value:"Violet Woodhoopoe",category:"NonBirdsOfPrey",plural:"Violet Woodhoopoes"},{id:2686,label:"Violet-backed Hyliota",value:"Violet-backed Hyliota",category:"NonBirdsOfPrey",plural:"Violet-backed Hyliotas"},{id:2687,label:"Violet-breasted Sunbird",value:"Violet-breasted Sunbird",category:"NonBirdsOfPrey",plural:"Violet-breasted Sunbirds"},{id:2688,label:"Violet-tailed Sunbird",value:"Violet-tailed Sunbird",category:"NonBirdsOfPrey",plural:"Violet-tailed Sunbirds"},{id:2689,label:"Vitelline Masked-Weaver",value:"Vitelline Masked-Weaver",category:"NonBirdsOfPrey",plural:"Vitelline Masked-Weavers"},{id:2690,label:"Von der Decken's Hornbill",value:"Von der Decken's Hornbill",category:"NonBirdsOfPrey",plural:"Von der Decken's Hornbills"},{id:2691,label:"Vulturine Guineafowl",value:"Vulturine Guineafowl",category:"NonBirdsOfPrey",plural:"Vulturine Guineafowls"},{id:2692,label:"Wahlberg's Honeyguide",value:"Wahlberg's Honeyguide",category:"NonBirdsOfPrey",plural:"Wahlberg's Honeyguides"},{id:2693,label:"Wallcreeper",value:"Wallcreeper",category:"NonBirdsOfPrey",plural:"Wallcreepers"},{id:2694,label:"Waller's Starling",value:"Waller's Starling",category:"NonBirdsOfPrey",plural:"Waller's Starlings"},{id:2695,label:"Wandering Albatross",value:"Wandering Albatross",category:"NonBirdsOfPrey",plural:"Wandering Albatrosses"},{id:2696,label:"Warsangli Linnet",value:"Warsangli Linnet",category:"NonBirdsOfPrey",plural:"Warsangli Linnets"},{id:2697,label:"Water Pipit",value:"Water Pipit",category:"NonBirdsOfPrey",plural:"Water Pipits"},{id:2698,label:"Water Rail",value:"Water Rail",category:"NonBirdsOfPrey",plural:"Water Rails"},{id:2699,label:"Wattled Crane",value:"Wattled Crane",category:"NonBirdsOfPrey",plural:"Wattled Cranes"},{id:2700,label:"Wattled Ibis",value:"Wattled Ibis",category:"NonBirdsOfPrey",plural:"Wattled Ibises"},{id:2701,label:"Wedge-tailed Shearwater",value:"Wedge-tailed Shearwater",category:"NonBirdsOfPrey",plural:"Wedge-tailed Shearwaters"},{id:2702,label:"West African Batis",value:"West African Batis",category:"NonBirdsOfPrey",plural:"West African Batis"},{id:2703,label:"West African Crested Tern",value:"West African Crested Tern",category:"NonBirdsOfPrey",plural:"West African Crested Terns"},{id:2704,label:"West African Seedeater",value:"West African Seedeater",category:"NonBirdsOfPrey",plural:"West African Seedeaters"},{id:2705,label:"West African Wattle-eye",value:"West African Wattle-eye",category:"NonBirdsOfPrey",plural:"West African Wattle-eyes"},{id:2706,label:"Western Banded Snake Eagle",value:"Western Banded Snake Eagle",category:"BirdsOfPrey",plural:"Western Banded Snake Eagles"},{id:2707,label:"Western Bearded-Greenbul",value:"Western Bearded-Greenbul",category:"NonBirdsOfPrey",plural:"Western Bearded-Greenbuls"},{id:2708,label:"Western Black-eared Wheatear",value:"Western Black-eared Wheatear",category:"NonBirdsOfPrey",plural:"Western Black-eared Wheatears"},{id:2709,label:"Western Black-headed Batis",value:"Western Black-headed Batis",category:"NonBirdsOfPrey",plural:"Western Black-headed Batis"},{id:2710,label:"Western Black-headed Oriole",value:"Western Black-headed Oriole",category:"NonBirdsOfPrey",plural:"Western Black-headed Orioles"},{id:2711,label:"Western Bluebill",value:"Western Bluebill",category:"NonBirdsOfPrey",plural:"Western Bluebills"},{id:2712,label:"Western Bonelli's Warbler",value:"Western Bonelli's Warbler",category:"NonBirdsOfPrey",plural:"Western Bonelli's Warblers"},{id:2713,label:"Western Boubou",value:"Western Boubou",category:"NonBirdsOfPrey",plural:"Western Boubous"},{id:2714,label:"Western Citril",value:"Western Citril",category:"NonBirdsOfPrey",plural:"Western Citrils"},{id:2715,label:"Western Marsh Harrier",value:"Western Marsh Harrier",category:"BirdsOfPrey",plural:"Western Marsh Harriers"},{id:2716,label:"Western Miombo Sunbird",value:"Western Miombo Sunbird",category:"NonBirdsOfPrey",plural:"Western Miombo Sunbirds"},{id:2717,label:"Western Mountain Greenbul",value:"Western Mountain Greenbul",category:"NonBirdsOfPrey",plural:"Western Mountain Greenbuls"},{id:2718,label:"Western Nicator",value:"Western Nicator",category:"NonBirdsOfPrey",plural:"Western Nicators"},{id:2719,label:"Western Olivaceous Warbler",value:"Western Olivaceous Warbler",category:"NonBirdsOfPrey",plural:"Western Olivaceous Warblers"},{id:2720,label:"Western Orphean Warbler",value:"Western Orphean Warbler",category:"NonBirdsOfPrey",plural:"Western Orphean Warblers"},{id:2721,label:"Western Plantain-eater",value:"Western Plantain-eater",category:"NonBirdsOfPrey",plural:"Western Plantain-eaters"},{id:2722,label:"Western Reef-Heron",value:"Western Reef-Heron",category:"NonBirdsOfPrey",plural:"Western Reef-Herons"},{id:2723,label:"Western Sandpiper",value:"Western Sandpiper",category:"NonBirdsOfPrey",plural:"Western Sandpipers"},{id:2724,label:"Western Square-tailed Drongo",value:"Western Square-tailed Drongo",category:"NonBirdsOfPrey",plural:"Western Square-tailed Drongos"},{id:2725,label:"Western Subalpine Warbler",value:"Western Subalpine Warbler",category:"NonBirdsOfPrey",plural:"Western Subalpine Warblers"},{id:2726,label:"Western Swamphen",value:"Western Swamphen",category:"NonBirdsOfPrey",plural:"Western Swamphens"},{id:2727,label:"Western Tinkerbird",value:"Western Tinkerbird",category:"NonBirdsOfPrey",plural:"Western Tinkerbirds"},{id:2728,label:"Western Violet-backed Sunbird",value:"Western Violet-backed Sunbird",category:"NonBirdsOfPrey",plural:"Western Violet-backed Sunbirds"},{id:2729,label:"Western Yellow Wagtail",value:"Western Yellow Wagtail",category:"NonBirdsOfPrey",plural:"Western Yellow Wagtails"},{id:2730,label:"Weyns's Weaver",value:"Weyns's Weaver",category:"NonBirdsOfPrey",plural:"Weyns's Weavers"},{id:2731,label:"Whinchat",value:"Whinchat",category:"NonBirdsOfPrey",plural:"Whinchats"},{id:2732,label:"Whistling Cisticola",value:"Whistling Cisticola",category:"NonBirdsOfPrey",plural:"Whistling Cisticolas"},{id:2733,label:"White Helmetshrike",value:"White Helmetshrike",category:"NonBirdsOfPrey",plural:"White Helmetshrikes"},{id:2734,label:"White tailed Warbler",value:"White tailed Warbler",category:"NonBirdsOfPrey",plural:"White tailed Warblers"},{id:2735,label:"White Tern",value:"White Tern",category:"NonBirdsOfPrey",plural:"White Terns"},{id:2736,label:"White Wagtail",value:"White Wagtail",category:"NonBirdsOfPrey",plural:"White Wagtails"},{id:2737,label:"White-backed Black-Tit",value:"White-backed Black-Tit",category:"NonBirdsOfPrey",plural:"White-backed Black-Tits"},{id:2738,label:"White-bearded Greenbul",value:"White-bearded Greenbul",category:"NonBirdsOfPrey",plural:"White-bearded Greenbuls"},{id:2739,label:"White-bellied Bustard",value:"White-bellied Bustard",category:"NonBirdsOfPrey",plural:"White-bellied Bustards"},{id:2740,label:"White-bellied Canary",value:"White-bellied Canary",category:"NonBirdsOfPrey",plural:"White-bellied Canaries"},{id:2741,label:"White-bellied Crested-Flycatcher",value:"White-bellied Crested-Flycatcher",category:"NonBirdsOfPrey",plural:"White-bellied Crested-Flycatchers"},{id:2742,label:"White-bellied Go-away-bird",value:"White-bellied Go-away-bird",category:"NonBirdsOfPrey",plural:"White-bellied Go-away-birds"},{id:2743,label:"White-bellied Kingfisher",value:"White-bellied Kingfisher",category:"NonBirdsOfPrey",plural:"White-bellied Kingfishers"},{id:2744,label:"White-bellied Robin-Chat",value:"White-bellied Robin-Chat",category:"NonBirdsOfPrey",plural:"White-bellied Robin-Chats"},{id:2745,label:"White-bellied Storm-Petrel",value:"White-bellied Storm-Petrel",category:"NonBirdsOfPrey",plural:"White-bellied Storm-Petrels"},{id:2746,label:"White-bellied Tit",value:"White-bellied Tit",category:"NonBirdsOfPrey",plural:"White-bellied Tits"},{id:2747,label:"White-billed Buffalo-Weaver",value:"White-billed Buffalo-Weaver",category:"NonBirdsOfPrey",plural:"White-billed Buffalo-Weavers"},{id:2748,label:"White-billed Starling",value:"White-billed Starling",category:"NonBirdsOfPrey",plural:"White-billed Starlings"},{id:2749,label:"White-breasted Guineafowl",value:"White-breasted Guineafowl",category:"NonBirdsOfPrey",plural:"White-breasted Guineafowls"},{id:2750,label:"White-breasted Nigrita",value:"White-breasted Nigrita",category:"NonBirdsOfPrey",plural:"White-breasted Nigritas"},{id:2751,label:"White-breasted Sunbird",value:"White-breasted Sunbird",category:"NonBirdsOfPrey",plural:"White-breasted Sunbirds"},{id:2752,label:"White-browed Coucal",value:"White-browed Coucal",category:"NonBirdsOfPrey",plural:"White-browed Coucals"},{id:2753,label:"White-browed Crombec",value:"White-browed Crombec",category:"NonBirdsOfPrey",plural:"White-browed Crombecs"},{id:2754,label:"White-browed Forest-Flycatcher",value:"White-browed Forest-Flycatcher",category:"NonBirdsOfPrey",plural:"White-browed Forest-Flycatchers"},{id:2755,label:"White-browed Robin-Chat",value:"White-browed Robin-Chat",category:"NonBirdsOfPrey",plural:"White-browed Robin-Chats"},{id:2756,label:"White-capped Albatross",value:"White-capped Albatross",category:"NonBirdsOfPrey",plural:"White-capped Albatrosses"},{id:2757,label:"White-cheeked Tern",value:"White-cheeked Tern",category:"NonBirdsOfPrey",plural:"White-cheeked Terns"},{id:2758,label:"White-cheeked Turaco",value:"White-cheeked Turaco",category:"NonBirdsOfPrey",plural:"White-cheeked Turacos"},{id:2759,label:"White-chested Alethe",value:"White-chested Alethe",category:"NonBirdsOfPrey",plural:"White-chested Alethes"},{id:2760,label:"White-chinned Petrel",value:"White-chinned Petrel",category:"NonBirdsOfPrey",plural:"White-chinned Petrels"},{id:2761,label:"White-chinned Prinia",value:"White-chinned Prinia",category:"NonBirdsOfPrey",plural:"White-chinned Prinias"},{id:2762,label:"White-collared Oliveback",value:"White-collared Oliveback",category:"NonBirdsOfPrey",plural:"White-collared Olivebacks"},{id:2763,label:"White-collared Pigeon",value:"White-collared Pigeon",category:"NonBirdsOfPrey",plural:"White-collared Pigeons"},{id:2764,label:"White-collared Starling",value:"White-collared Starling",category:"NonBirdsOfPrey",plural:"White-collared Starlings"},{id:2765,label:"White-crested Bittern",value:"White-crested Bittern",category:"NonBirdsOfPrey",plural:"White-crested Bitterns"},{id:2766,label:"White-crested Hornbill",value:"White-crested Hornbill",category:"NonBirdsOfPrey",plural:"White-crested Hornbills"},{id:2767,label:"White-crested Turaco",value:"White-crested Turaco",category:"NonBirdsOfPrey",plural:"White-crested Turacos"},{id:2768,label:"White-crowned Lapwing",value:"White-crowned Lapwing",category:"NonBirdsOfPrey",plural:"White-crowned Lapwings"},{id:2769,label:"White-crowned Robin-Chat",value:"White-crowned Robin-Chat",category:"NonBirdsOfPrey",plural:"White-crowned Robin-Chats"},{id:2770,label:"White-crowned Starling",value:"White-crowned Starling",category:"NonBirdsOfPrey",plural:"White-crowned Starlings"},{id:2771,label:"White-crowned Wheatear",value:"White-crowned Wheatear",category:"NonBirdsOfPrey",plural:"White-crowned Wheatears"},{id:2772,label:"White-eared Barbet",value:"White-eared Barbet",category:"NonBirdsOfPrey",plural:"White-eared Barbets"},{id:2773,label:"White-eyed Gull",value:"White-eyed Gull",category:"NonBirdsOfPrey",plural:"White-eyed Gulls"},{id:2774,label:"White-eyed Slaty-Flycatcher",value:"White-eyed Slaty-Flycatcher",category:"NonBirdsOfPrey",plural:"White-eyed Slaty-Flycatchers"},{id:2775,label:"White-faced Storm-Petrel",value:"White-faced Storm-Petrel",category:"NonBirdsOfPrey",plural:"White-faced Storm-Petrels"},{id:2776,label:"White-faced Whistling-Duck",value:"White-faced Whistling-Duck",category:"NonBirdsOfPrey",plural:"White-faced Whistling-Ducks"},{id:2777,label:"White-fronted Black-Chat",value:"White-fronted Black-Chat",category:"NonBirdsOfPrey",plural:"White-fronted Black-Chats"},{id:2778,label:"White-fronted Wattle-eye",value:"White-fronted Wattle-eye",category:"NonBirdsOfPrey",plural:"White-fronted Wattle-eyes"},{id:2779,label:"White-headed Barbet",value:"White-headed Barbet",category:"NonBirdsOfPrey",plural:"White-headed Barbets"},{id:2780,label:"White-headed Buffalo-Weaver",value:"White-headed Buffalo-Weaver",category:"NonBirdsOfPrey",plural:"White-headed Buffalo-Weavers"},{id:2781,label:"White-headed Duck",value:"White-headed Duck",category:"NonBirdsOfPrey",plural:"White-headed Ducks"},{id:2782,label:"White-headed Lapwing",value:"White-headed Lapwing",category:"NonBirdsOfPrey",plural:"White-headed Lapwings"},{id:2783,label:"White-headed Mousebird",value:"White-headed Mousebird",category:"NonBirdsOfPrey",plural:"White-headed Mousebirds"},{id:2784,label:"White-headed Petrel",value:"White-headed Petrel",category:"NonBirdsOfPrey",plural:"White-headed Petrels"},{id:2785,label:"White-headed Robin-Chat",value:"White-headed Robin-Chat",category:"NonBirdsOfPrey",plural:"White-headed Robin-Chats"},{id:2786,label:"White-headed Saw-wing",value:"White-headed Saw-wing",category:"NonBirdsOfPrey",plural:"White-headed Saw-wings"},{id:2787,label:"White-headed Woodhoopoe",value:"White-headed Woodhoopoe",category:"NonBirdsOfPrey",plural:"White-headed Woodhoopoes"},{id:2788,label:"White-naped Pigeon",value:"White-naped Pigeon",category:"NonBirdsOfPrey",plural:"White-naped Pigeons"},{id:2789,label:"White-necked Rockfowl",value:"White-necked Rockfowl",category:"NonBirdsOfPrey",plural:"White-necked Rockfowls"},{id:2790,label:"White-quilled Bustard",value:"White-quilled Bustard",category:"NonBirdsOfPrey",plural:"White-quilled Bustards"},{id:2791,label:"White-rumped Babbler",value:"White-rumped Babbler",category:"NonBirdsOfPrey",plural:"White-rumped Babblers"},{id:2792,label:"White-rumped Sandpiper",value:"White-rumped Sandpiper",category:"NonBirdsOfPrey",plural:"White-rumped Sandpipers"},{id:2793,label:"White-rumped Seedeater",value:"White-rumped Seedeater",category:"NonBirdsOfPrey",plural:"White-rumped Seedeaters"},{id:2794,label:"White-rumped Shrike",value:"White-rumped Shrike",category:"NonBirdsOfPrey",plural:"White-rumped Shrikes"},{id:2795,label:"White-shouldered Black-Tit",value:"White-shouldered Black-Tit",category:"NonBirdsOfPrey",plural:"White-shouldered Black-Tits"},{id:2796,label:"White-spectacled Bulbul",value:"White-spectacled Bulbul",category:"NonBirdsOfPrey",plural:"White-spectacled Bulbuls"},{id:2797,label:"White-spotted Flufftail",value:"White-spotted Flufftail",category:"NonBirdsOfPrey",plural:"White-spotted Flufftails"},{id:2798,label:"White-spotted Wattle-eye",value:"White-spotted Wattle-eye",category:"NonBirdsOfPrey",plural:"White-spotted Wattle-eyes"},{id:2799,label:"White-starred Robin",value:"White-starred Robin",category:"NonBirdsOfPrey",plural:"White-starred Robins"},{id:2800,label:"White-tailed Alethe",value:"White-tailed Alethe",category:"NonBirdsOfPrey",plural:"White-tailed Alethes"},{id:2801,label:"White-tailed Ant-Thrush",value:"White-tailed Ant-Thrush",category:"NonBirdsOfPrey",plural:"White-tailed Ant-Thrushes"},{id:2802,label:"White-tailed Blue Flycatcher",value:"White-tailed Blue Flycatcher",category:"NonBirdsOfPrey",plural:"White-tailed Blue Flycatchers"},{id:2803,label:"White-tailed Cisticola",value:"White-tailed Cisticola",category:"NonBirdsOfPrey",plural:"White-tailed Cisticolas"},{id:2804,label:"White-tailed Crested-Flycatcher",value:"White-tailed Crested-Flycatcher",category:"NonBirdsOfPrey",plural:"White-tailed Crested-Flycatcher"},{id:2805,label:"White-tailed Eagle",value:"White-tailed Eagle",category:"BirdsOfPrey",plural:"White-tailed Eagles"},{id:2806,label:"White-tailed Lapwing",value:"White-tailed Lapwing",category:"NonBirdsOfPrey",plural:"White-tailed Lapwings"},{id:2807,label:"White-tailed Lark",value:"White-tailed Lark",category:"NonBirdsOfPrey",plural:"White-tailed Larks"},{id:2808,label:"White-tailed Shrike",value:"White-tailed Shrike",category:"NonBirdsOfPrey",plural:"White-tailed Shrikes"},{id:2809,label:"White-tailed Swallow",value:"White-tailed Swallow",category:"NonBirdsOfPrey",plural:"White-tailed Swallows"},{id:2810,label:"White-tailed Tropicbird",value:"White-tailed Tropicbird",category:"NonBirdsOfPrey",plural:"White-tailed Tropicbirds"},{id:2811,label:"White-thighed Hornbill",value:"White-thighed Hornbill",category:"NonBirdsOfPrey",plural:"White-thighed Hornbills"},{id:2812,label:"White-throated Bee-eater",value:"White-throated Bee-eater",category:"NonBirdsOfPrey",plural:"White-throated Bee-eaters"},{id:2813,label:"White-throated Blue Swallow",value:"White-throated Blue Swallow",category:"NonBirdsOfPrey",plural:"White-throated Blue Swallows"},{id:2814,label:"White-throated Canary",value:"White-throated Canary",category:"NonBirdsOfPrey",plural:"White-throated Canaries"},{id:2815,label:"White-throated Dipper",value:"White-throated Dipper",category:"NonBirdsOfPrey",plural:"White-throated Dippers"},{id:2816,label:"White-throated Francolin",value:"White-throated Francolin",category:"NonBirdsOfPrey",plural:"White-throated Francolins"},{id:2817,label:"White-throated Greenbul",value:"White-throated Greenbul",category:"NonBirdsOfPrey",plural:"White-throated Greenbuls"},{id:2818,label:"White-throated Kingfisher",value:"White-throated Kingfisher",category:"NonBirdsOfPrey",plural:"White-throated Kingfishers"},{id:2819,label:"White-throated Mountain-Babbler",value:"White-throated Mountain-Babbler",category:"NonBirdsOfPrey",plural:"White-throated Mountain-Babblers"},{id:2820,label:"White-winged Apalis",value:"White-winged Apalis",category:"NonBirdsOfPrey",plural:"White-winged Apalis"},{id:2821,label:"White-winged Black-Tit",value:"White-winged Black-Tit",category:"NonBirdsOfPrey",plural:"White-winged Black-Tits"},{id:2822,label:"White-winged Cliff-Chat",value:"White-winged Cliff-Chat",category:"NonBirdsOfPrey",plural:"White-winged Cliff-Chats"},{id:2823,label:"White-winged Collared-Dove",value:"White-winged Collared-Dove",category:"NonBirdsOfPrey",plural:"White-winged Collared-Doves"},{id:2824,label:"White-winged Flufftail",value:"White-winged Flufftail",category:"NonBirdsOfPrey",plural:"White-winged Flufftails"},{id:2825,label:"White-winged Redstart",value:"White-winged Redstart",category:"NonBirdsOfPrey",plural:"White-winged Redstarts"},{id:2826,label:"White-winged Scoter",value:"White-winged Scoter",category:"NonBirdsOfPrey",plural:"White-winged Scoters"},{id:2827,label:"White-winged Snowfinch",value:"White-winged Snowfinch",category:"NonBirdsOfPrey",plural:"White-winged Snowfinches"},{id:2828,label:"White-winged Swamp Warbler",value:"White-winged Swamp Warbler",category:"NonBirdsOfPrey",plural:"White-winged Swamp Warblers"},{id:2829,label:"Whooper Swan",value:"Whooper Swan",category:"NonBirdsOfPrey",plural:"Whooper Swans"},{id:2830,label:"Whyte's Barbet",value:"Whyte's Barbet",category:"NonBirdsOfPrey",plural:"Whyte's Barbets"},{id:2831,label:"Wilkins' Bunting",value:"Wilkins' Bunting",category:"NonBirdsOfPrey",plural:"Wilkins' Buntings"},{id:2832,label:"Willard's Sooty Boubou",value:"Willard's Sooty Boubou",category:"NonBirdsOfPrey",plural:"Willard's Sooty Boubous"},{id:2833,label:"Willcocks's Honeyguide",value:"Willcocks's Honeyguide",category:"NonBirdsOfPrey",plural:"Willcocks's Honeyguides"},{id:2834,label:"Williams's Lark",value:"Williams's Lark",category:"NonBirdsOfPrey",plural:"Williams's Larks"},{id:2835,label:"Wilson's Indigobird",value:"Wilson's Indigobird",category:"NonBirdsOfPrey",plural:"Wilson's Indigobirds"},{id:2836,label:"Wilson's Phalarope",value:"Wilson's Phalarope",category:"NonBirdsOfPrey",plural:"Wilson's Phalaropes"},{id:2837,label:"Wilson's Storm-Petrel",value:"Wilson's Storm-Petrel",category:"NonBirdsOfPrey",plural:"Wilson's Storm-Petrels"},{id:2838,label:"Winding Cisticola",value:"Winding Cisticola",category:"NonBirdsOfPrey",plural:"Winding Cisticolas"},{id:2839,label:"Wing-snapping Cisticola",value:"Wing-snapping Cisticola",category:"NonBirdsOfPrey",plural:"Wing-snapping Cisticolas"},{id:2840,label:"Wood Lark",value:"Wood Lark",category:"NonBirdsOfPrey",plural:"Wood Larks"},{id:2841,label:"Wood Pipit",value:"Wood Pipit",category:"NonBirdsOfPrey",plural:"Wood Pipits"},{id:2842,label:"Wood Warbler",value:"Wood Warbler",category:"NonBirdsOfPrey",plural:"Wood Warblers"},{id:2843,label:"Woodchat Shrike",value:"Woodchat Shrike",category:"NonBirdsOfPrey",plural:"Woodchat Shrikes"},{id:2844,label:"Woodhouse's Antpecker",value:"Woodhouse's Antpecker",category:"NonBirdsOfPrey",plural:"Woodhouse's Antpeckers"},{id:2845,label:"Woodland Pipit",value:"Woodland Pipit",category:"NonBirdsOfPrey",plural:"Woodland Pipits"},{id:2846,label:"Woodward's Batis",value:"Woodward's Batis",category:"NonBirdsOfPrey",plural:"Woodward's Batis"},{id:2847,label:"Xavier's Greenbul",value:"Xavier's Greenbul",category:"NonBirdsOfPrey",plural:"Xavier's Greenbuls"},{id:2848,label:"Yelkouan Shearwater",value:"Yelkouan Shearwater",category:"NonBirdsOfPrey",plural:"Yelkouan Shearwaters"},{id:2849,label:"Yellow bellied Eremomela",value:"Yellow bellied Eremomela",category:"NonBirdsOfPrey",plural:"Yellow bellied Eremomelas"},{id:2850,label:"Yellow Bittern",value:"Yellow Bittern",category:"NonBirdsOfPrey",plural:"Yellow Bitterns"},{id:2851,label:"Yellow Flycatcher",value:"Yellow Flycatcher",category:"NonBirdsOfPrey",plural:"Yellow Flycatchers"},{id:2852,label:"Yellow Longbill",value:"Yellow Longbill",category:"NonBirdsOfPrey",plural:"Yellow Longbills"},{id:2853,label:"Yellow Penduline-Tit",value:"Yellow Penduline-Tit",category:"NonBirdsOfPrey",plural:"Yellow Penduline-Tits"},{id:2854,label:"Yellow rumped Eremomela",value:"Yellow rumped Eremomela",category:"NonBirdsOfPrey",plural:"Yellow rumped Eremomelas"},{id:2855,label:"Yellow throated Apalis",value:"Yellow throated Apalis",category:"NonBirdsOfPrey",plural:"Yellow throated Apalis"},{id:2856,label:"Yellow Weaver",value:"Yellow Weaver",category:"NonBirdsOfPrey",plural:"Yellow Weavers"},{id:2857,label:"Yellow-bearded Greenbul",value:"Yellow-bearded Greenbul",category:"NonBirdsOfPrey",plural:"Yellow-bearded Greenbuls"},{id:2858,label:"Yellow-bellied Hyliota",value:"Yellow-bellied Hyliota",category:"NonBirdsOfPrey",plural:"Yellow-bellied Hyliotas"},{id:2859,label:"Yellow-bellied Wattle-eye",value:"Yellow-bellied Wattle-eye",category:"NonBirdsOfPrey",plural:"Yellow-bellied Wattle-eyes"},{id:2860,label:"Yellow-bellied Waxbill",value:"Yellow-bellied Waxbill",category:"NonBirdsOfPrey",plural:"Yellow-bellied Waxbills"},{id:2861,label:"Yellow-billed Barbet",value:"Yellow-billed Barbet",category:"NonBirdsOfPrey",plural:"Yellow-billed Barbets"},{id:2862,label:"Yellow-billed Chough",value:"Yellow-billed Chough",category:"NonBirdsOfPrey",plural:"Yellow-billed Choughs"},{id:2863,label:"Yellow-billed Cuckoo",value:"Yellow-billed Cuckoo",category:"NonBirdsOfPrey",plural:"Yellow-billed Cuckoos"},{id:2864,label:"Yellow-billed Loon",value:"Yellow-billed Loon",category:"NonBirdsOfPrey",plural:"Yellow-billed Loons"},{id:2865,label:"Yellow-billed Shrike",value:"Yellow-billed Shrike",category:"NonBirdsOfPrey",plural:"Yellow-billed Shrikes"},{id:2866,label:"Yellow-billed Turaco",value:"Yellow-billed Turaco",category:"NonBirdsOfPrey",plural:"Yellow-billed Turacos"},{id:2867,label:"Yellow-breasted Barbet",value:"Yellow-breasted Barbet",category:"NonBirdsOfPrey",plural:"Yellow-breasted Barbets"},{id:2868,label:"Yellow-breasted Boubou",value:"Yellow-breasted Boubou",category:"NonBirdsOfPrey",plural:"Yellow-breasted Boubous"},{id:2869,label:"Yellow-breasted Bunting",value:"Yellow-breasted Bunting",category:"NonBirdsOfPrey",plural:"Yellow-breasted Buntings"},{id:2870,label:"Yellow-breasted Pipit",value:"Yellow-breasted Pipit",category:"NonBirdsOfPrey",plural:"Yellow-breasted Pipits"},{id:2871,label:"Yellow-browed Camaroptera",value:"Yellow-browed Camaroptera",category:"NonBirdsOfPrey",plural:"Yellow-browed Camaropteras"},{id:2872,label:"Yellow-browed Seedeater",value:"Yellow-browed Seedeater",category:"NonBirdsOfPrey",plural:"Yellow-browed Seedeaters"},{id:2873,label:"Yellow-browed Warbler",value:"Yellow-browed Warbler",category:"NonBirdsOfPrey",plural:"Yellow-browed Warblers"},{id:2874,label:"Yellow-capped Weaver",value:"Yellow-capped Weaver",category:"NonBirdsOfPrey",plural:"Yellow-capped Weavers"},{id:2875,label:"Yellow-casqued Hornbill",value:"Yellow-casqued Hornbill",category:"NonBirdsOfPrey",plural:"Yellow-casqued Hornbills"},{id:2876,label:"Yellow-collared Lovebird",value:"Yellow-collared Lovebird",category:"NonBirdsOfPrey",plural:"Yellow-collared Lovebirds"},{id:2877,label:"Yellow-crested Helmetshrike",value:"Yellow-crested Helmetshrike",category:"NonBirdsOfPrey",plural:"Yellow-crested Helmetshrikes"},{id:2878,label:"Yellow-crowned Bishop",value:"Yellow-crowned Bishop",category:"NonBirdsOfPrey",plural:"Yellow-crowned Bishops"},{id:2879,label:"Yellow-crowned Canary",value:"Yellow-crowned Canary",category:"NonBirdsOfPrey",plural:"Yellow-crowned Canaries"},{id:2880,label:"Yellow-crowned Gonolek",value:"Yellow-crowned Gonolek",category:"NonBirdsOfPrey",plural:"Yellow-crowned Gonoleks"},{id:2881,label:"Yellow-eyed Black-Flycatcher",value:"Yellow-eyed Black-Flycatcher",category:"NonBirdsOfPrey",plural:"Yellow-eyed Black-Flycatchers"},{id:2882,label:"Yellow-footed Flycatcher",value:"Yellow-footed Flycatcher",category:"NonBirdsOfPrey",plural:"Yellow-footed Flycatchers"},{id:2883,label:"Yellow-footed Honeyguide",value:"Yellow-footed Honeyguide",category:"NonBirdsOfPrey",plural:"Yellow-footed Honeyguides"},{id:2884,label:"Yellow-fronted Canary",value:"Yellow-fronted Canary",category:"NonBirdsOfPrey",plural:"Yellow-fronted Canaries"},{id:2885,label:"Yellow-fronted Parrot",value:"Yellow-fronted Parrot",category:"NonBirdsOfPrey",plural:"Yellow-fronted Parrots"},{id:2886,label:"Yellow-legged Gull",value:"Yellow-legged Gull",category:"NonBirdsOfPrey",plural:"Yellow-legged Gulls"},{id:2887,label:"Yellow-mantled Weaver",value:"Yellow-mantled Weaver",category:"NonBirdsOfPrey",plural:"Yellow-mantled Weavers"},{id:2888,label:"Yellow-mantled Widowbird",value:"Yellow-mantled Widowbird",category:"NonBirdsOfPrey",plural:"Yellow-mantled Widowbirds"},{id:2889,label:"Yellow-necked Francolin",value:"Yellow-necked Francolin",category:"NonBirdsOfPrey",plural:"Yellow-necked Francolins"},{id:2890,label:"Yellow-necked Greenbul",value:"Yellow-necked Greenbul",category:"NonBirdsOfPrey",plural:"Yellow-necked Greenbuls"},{id:2891,label:"Yellow-nosed Albatross",value:"Yellow-nosed Albatross",category:"NonBirdsOfPrey",plural:"Yellow-nosed Albatrosses"},{id:2892,label:"Yellow-rumped Serin",value:"Yellow-rumped Serin",category:"NonBirdsOfPrey",plural:"Yellow-rumped Serins"},{id:2893,label:"Yellow-rumped Tinkerbird",value:"Yellow-rumped Tinkerbird",category:"NonBirdsOfPrey",plural:"Yellow-rumped Tinkerbirds"},{id:2894,label:"Yellow-spotted Barbet",value:"Yellow-spotted Barbet",category:"NonBirdsOfPrey",plural:"Yellow-spotted Barbets"},{id:2895,label:"Yellow-spotted Bush Sparrow",value:"Yellow-spotted Bush Sparrow",category:"NonBirdsOfPrey",plural:"Yellow-spotted Bush Sparrows"},{id:2896,label:"Yellow-streaked Greenbul",value:"Yellow-streaked Greenbul",category:"NonBirdsOfPrey",plural:"Yellow-streaked Greenbuls"},{id:2897,label:"Yellow-throated Bush Sparrow",value:"Yellow-throated Bush Sparrow",category:"NonBirdsOfPrey",plural:"Yellow-throated Bush Sparrows"},{id:2898,label:"Yellow-throated Cuckoo",value:"Yellow-throated Cuckoo",category:"NonBirdsOfPrey",plural:"Yellow-throated Cuckoos"},{id:2899,label:"Yellow-throated Greenbul",value:"Yellow-throated Greenbul",category:"NonBirdsOfPrey",plural:"Yellow-throated Greenbuls"},{id:2900,label:"Yellow-throated Mountain Greenbul",value:"Yellow-throated Mountain Greenbul",category:"NonBirdsOfPrey",plural:"Yellow-throated Mountain Greenbuls"},{id:2901,label:"Yellow-throated Nicator",value:"Yellow-throated Nicator",category:"NonBirdsOfPrey",plural:"Yellow-throated Nicators"},{id:2902,label:"Yellow-throated Serin",value:"Yellow-throated Serin",category:"NonBirdsOfPrey",plural:"Yellow-throated Serins"},{id:2903,label:"Yellow-throated Sparrow",value:"Yellow-throated Sparrow",category:"NonBirdsOfPrey",plural:"Yellow-throated Sparrows"},{id:2904,label:"Yellow-throated Tinkerbird",value:"Yellow-throated Tinkerbird",category:"NonBirdsOfPrey",plural:"Yellow-throated Tinkerbirds"},{id:2905,label:"Yellow-throated Woodland-Warbler",value:"Yellow-throated Woodland-Warbler",category:"NonBirdsOfPrey",plural:"Yellow-throated Woodland-Warblers"},{id:2906,label:"Yellow-tufted Pipit",value:"Yellow-tufted Pipit",category:"NonBirdsOfPrey",plural:"Yellow-tufted Pipits"},{id:2907,label:"Yellow-vented Eremomela",value:"Yellow-vented Eremomela",category:"NonBirdsOfPrey",plural:"Yellow-vented Eremomelas"},{id:2908,label:"Yellow-whiskered Greenbul",value:"Yellow-whiskered Greenbul",category:"NonBirdsOfPrey",plural:"Yellow-whiskered Greenbuls"},{id:2909,label:"Yellowhammer",value:"Yellowhammer",category:"NonBirdsOfPrey",plural:"Yellowhammers"},{id:2910,label:"Zanzibar Boubou",value:"Zanzibar Boubou",category:"NonBirdsOfPrey",plural:"Zanzibar Boubous"},{id:2911,label:"Zanzibar Red Bishop",value:"Zanzibar Red Bishop",category:"NonBirdsOfPrey",plural:"Zanzibar Red Bishops"},{id:2912,label:"Zebra Waxbill",value:"Zebra Waxbill",category:"NonBirdsOfPrey",plural:"Zebra Waxbills"},{id:2913,label:"Zenker's Honeyguide",value:"Zenker's Honeyguide",category:"NonBirdsOfPrey",plural:"Zenker's Honeyguides"},{id:2914,label:"Zino's Petrel",value:"Zino's Petrel",category:"NonBirdsOfPrey",plural:"Zino's Petrels"}

]

export { fullAnimalList, predatorList, nonPredatorList, birdsOfPreyList, sceneryList, nonBirdsOfPreyList, reptileList }